// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3E%3Cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 4%27%3E%3Cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3E%3Ccircle r=%273%27 fill=%27%23fff%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 5%27%3E%3Cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 8 8%27%3E%3Cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 8 8%27%3E%3Cpath d=%27M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap v4.0.0 (https://getbootstrap.com)
 * Copyright 2011-2018 The Bootstrap Authors
 * Copyright 2011-2018 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
:root {
  --blue: #007bff;
  --indigo: #6610f2;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #dc3545;
  --orange: #fd7e14;
  --yellow: #ffc107;
  --green: #28a745;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #3f51b5;
  --secondary: #E91E63;
  --success: #4caf50;
  --info: #00bcd4;
  --warning: #ff9800;
  --danger: #f44336;
  --light: #e8eaf6;
  --dark: #343a40;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: "Roboto", sans-serif;
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

@-ms-viewport {
  width: device-width;
}
article, aside, dialog, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

body {
  margin: 0;
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.5;
  color: #5c5c5c;
  text-align: left;
  background-color: #fff;
}

[tabindex="-1"]:focus {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 12px;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

dfn {
  font-style: italic;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #3f51b5;
  text-decoration: none;
  background-color: transparent;
  -webkit-text-decoration-skip: objects;
}
a:hover {
  color: rgb(49.8319672131, 64.0696721311, 143.1680327869);
  text-decoration: underline;
}

a:not([href]):not([tabindex]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([tabindex]):focus {
  outline: 0;
}

pre,
code,
kbd,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg:not(:root) {
  overflow: hidden;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

button,
html [type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

input[type=date],
input[type=time],
input[type=datetime-local],
input[type=month] {
  -webkit-appearance: listbox;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-cancel-button,
[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 12px;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.2;
  color: inherit;
}

h1, .h1 {
  font-size: 24px;
}

h2, .h2 {
  font-size: 18px;
}

h3, .h3 {
  font-size: 16px;
}

h4, .h4 {
  font-size: 15px;
}

h5, .h5 {
  font-size: 13px;
}

h6, .h6 {
  font-size: 12px;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

small,
.small {
  font-size: 80%;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.075);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #6c757d;
}

code,
kbd,
pre,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-break: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 2px;
  box-shadow: inset 0 -0.1rem 0 rgba(0, 0, 0, 0.25);
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
  box-shadow: none;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container {
  width: 100%;
  padding-right: 17px;
  padding-left: 17px;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

.container-fluid {
  width: 100%;
  padding-right: 17px;
  padding-left: 17px;
  margin-right: auto;
  margin-left: auto;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -17px;
  margin-left: -17px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 17px;
  padding-left: 17px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: none;
}

.col-1 {
  flex: 0 0 8.3333333333%;
  max-width: 8.3333333333%;
}

.col-2 {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.col-5 {
  flex: 0 0 41.6666666667%;
  max-width: 41.6666666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.3333333333%;
  max-width: 58.3333333333%;
}

.col-8 {
  flex: 0 0 66.6666666667%;
  max-width: 66.6666666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.3333333333%;
  max-width: 83.3333333333%;
}

.col-11 {
  flex: 0 0 91.6666666667%;
  max-width: 91.6666666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.3333333333%;
}

.offset-2 {
  margin-left: 16.6666666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.3333333333%;
}

.offset-5 {
  margin-left: 41.6666666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.3333333333%;
}

.offset-8 {
  margin-left: 66.6666666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.3333333333%;
}

.offset-11 {
  margin-left: 91.6666666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .col-sm-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.3333333333%;
  }
  .offset-sm-2 {
    margin-left: 16.6666666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.3333333333%;
  }
  .offset-sm-5 {
    margin-left: 41.6666666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.3333333333%;
  }
  .offset-sm-8 {
    margin-left: 66.6666666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.3333333333%;
  }
  .offset-sm-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .col-md-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-md-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-md-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-md-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-md-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.3333333333%;
  }
  .offset-md-2 {
    margin-left: 16.6666666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.3333333333%;
  }
  .offset-md-5 {
    margin-left: 41.6666666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.3333333333%;
  }
  .offset-md-8 {
    margin-left: 66.6666666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.3333333333%;
  }
  .offset-md-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .col-lg-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.3333333333%;
  }
  .offset-lg-2 {
    margin-left: 16.6666666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.3333333333%;
  }
  .offset-lg-5 {
    margin-left: 41.6666666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.3333333333%;
  }
  .offset-lg-8 {
    margin-left: 66.6666666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.3333333333%;
  }
  .offset-lg-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .col-xl-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.3333333333%;
  }
  .offset-xl-2 {
    margin-left: 16.6666666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.3333333333%;
  }
  .offset-xl-5 {
    margin-left: 41.6666666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.3333333333%;
  }
  .offset-xl-8 {
    margin-left: 66.6666666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.3333333333%;
  }
  .offset-xl-11 {
    margin-left: 91.6666666667%;
  }
}
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}
.table tbody + tbody {
  border-top: 2px solid #dee2e6;
}
.table .table {
  background-color: #fff;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #dee2e6;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #dee2e6;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: rgb(201.24, 206.28, 234.28);
}

.table-hover .table-primary:hover {
  background-color: rgb(182.8339849624, 189.5995488722, 227.1860150376);
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: rgb(182.8339849624, 189.5995488722, 227.1860150376);
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: rgb(248.84, 192, 211.32);
}

.table-hover .table-secondary:hover {
  background-color: rgb(246.5687449393, 168.7712550607, 195.2147368421);
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: rgb(246.5687449393, 168.7712550607, 195.2147368421);
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: rgb(204.88, 232.6, 206);
}

.table-hover .table-success:hover {
  background-color: rgb(187.2564478764, 224.7235521236, 188.7702702703);
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: rgb(187.2564478764, 224.7235521236, 188.7702702703);
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: rgb(183.6, 236.24, 242.96);
}

.table-hover .table-info:hover {
  background-color: rgb(161.7795302013, 230.5067785235, 239.2804697987);
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: rgb(161.7795302013, 230.5067785235, 239.2804697987);
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: rgb(255, 226.16, 183.6);
}

.table-hover .table-warning:hover {
  background-color: rgb(255, 215.86, 158.1);
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: rgb(255, 215.86, 158.1);
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: rgb(251.92, 202.36, 198.72);
}

.table-hover .table-danger:hover {
  background-color: rgb(250.5968867925, 179.7467924528, 174.5431132075);
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: rgb(250.5968867925, 179.7467924528, 174.5431132075);
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: rgb(248.56, 249.12, 252.48);
}

.table-hover .table-light:hover {
  background-color: rgb(230.231875, 232.385625, 245.308125);
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: rgb(230.231875, 232.385625, 245.308125);
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: rgb(198.16, 199.84, 201.52);
}

.table-hover .table-dark:hover {
  background-color: rgb(185.0216751269, 187.09, 189.1583248731);
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: rgb(185.0216751269, 187.09, 189.1583248731);
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075);
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgba(0, 0, 0, 0.075);
}

.table .thead-dark th {
  color: #fff;
  background-color: #212529;
  border-color: rgb(50.0574324324, 56.125, 62.1925675676);
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.table-dark {
  color: #fff;
  background-color: #212529;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: rgb(50.0574324324, 56.125, 62.1925675676);
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}
.table-dark.table-hover tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
.table-responsive > .table-bordered {
  border: 0;
}

.table-middle td,
.table-middle thead th {
  vertical-align: middle;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 13px;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: rgb(127.5, 189, 255);
  outline: 0;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

select.form-control:not([size]):not([multiple]) {
  height: calc(2.25rem + 2px);
}
select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 17px;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 13px;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  margin-bottom: 0;
  line-height: 1.5;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .input-group-sm > .form-control-plaintext.form-control,
.input-group-sm > .input-group-prepend > .form-control-plaintext.input-group-text,
.input-group-sm > .input-group-append > .form-control-plaintext.input-group-text,
.input-group-sm > .input-group-prepend > .form-control-plaintext.btn,
.input-group-sm > .input-group-append > .form-control-plaintext.btn, .form-control-plaintext.form-control-lg, .input-group-lg > .form-control-plaintext.form-control,
.input-group-lg > .input-group-prepend > .form-control-plaintext.input-group-text,
.input-group-lg > .input-group-append > .form-control-plaintext.input-group-text,
.input-group-lg > .input-group-prepend > .form-control-plaintext.btn,
.input-group-lg > .input-group-append > .form-control-plaintext.btn {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm, .input-group-sm > .form-control,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 13px;
  line-height: 1.5;
  border-radius: 0.2rem;
}

select.form-control-sm:not([size]):not([multiple]), .input-group-sm > select.form-control:not([size]):not([multiple]),
.input-group-sm > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),
.input-group-sm > .input-group-append > select.input-group-text:not([size]):not([multiple]),
.input-group-sm > .input-group-prepend > select.btn:not([size]):not([multiple]),
.input-group-sm > .input-group-append > select.btn:not([size]):not([multiple]) {
  height: calc(1.8125rem + 2px);
}

.form-control-lg, .input-group-lg > .form-control,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.5rem 1rem;
  font-size: 17px;
  line-height: 1.5;
  border-radius: 0.3rem;
}

select.form-control-lg:not([size]):not([multiple]), .input-group-lg > select.form-control:not([size]):not([multiple]),
.input-group-lg > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),
.input-group-lg > .input-group-append > select.input-group-text:not([size]):not([multiple]),
.input-group-lg > .input-group-prepend > select.btn:not([size]):not([multiple]),
.input-group-lg > .input-group-append > select.btn:not([size]):not([multiple]) {
  height: calc(2.875rem + 2px);
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input:disabled ~ .form-check-label {
  color: #6c757d;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #28a745;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1;
  color: #fff;
  background-color: rgba(40, 167, 69, 0.8);
  border-radius: 0.2rem;
}

.was-validated .form-control:valid, .form-control.is-valid,
.was-validated .custom-select:valid,
.custom-select.is-valid {
  border-color: #28a745;
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus,
.was-validated .custom-select:valid:focus,
.custom-select.is-valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
.was-validated .form-control:valid ~ .valid-feedback,
.was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,
.form-control.is-valid ~ .valid-tooltip,
.was-validated .custom-select:valid ~ .valid-feedback,
.was-validated .custom-select:valid ~ .valid-tooltip,
.custom-select.is-valid ~ .valid-feedback,
.custom-select.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #28a745;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #28a745;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  background-color: rgb(113.4130434783, 221.0869565217, 138);
}
.was-validated .custom-control-input:valid ~ .valid-feedback,
.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,
.custom-control-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  background-color: rgb(51.6956521739, 206.3043478261, 87);
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #28a745;
}
.was-validated .custom-file-input:valid ~ .custom-file-label::before, .custom-file-input.is-valid ~ .custom-file-label::before {
  border-color: inherit;
}
.was-validated .custom-file-input:valid ~ .valid-feedback,
.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,
.custom-file-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1;
  color: #fff;
  background-color: rgba(220, 53, 69, 0.8);
  border-radius: 0.2rem;
}

.was-validated .form-control:invalid, .form-control.is-invalid,
.was-validated .custom-select:invalid,
.custom-select.is-invalid {
  border-color: #dc3545;
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus,
.was-validated .custom-select:invalid:focus,
.custom-select.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.was-validated .form-control:invalid ~ .invalid-feedback,
.was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,
.form-control.is-invalid ~ .invalid-tooltip,
.was-validated .custom-select:invalid ~ .invalid-feedback,
.was-validated .custom-select:invalid ~ .invalid-tooltip,
.custom-select.is-invalid ~ .invalid-feedback,
.custom-select.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #dc3545;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #dc3545;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  background-color: rgb(238.8291139241, 161.6708860759, 169.0632911392);
}
.was-validated .custom-control-input:invalid ~ .invalid-feedback,
.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,
.custom-control-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  background-color: rgb(227.5316455696, 96.4683544304, 109.0253164557);
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #dc3545;
}
.was-validated .custom-file-input:invalid ~ .custom-file-label::before, .custom-file-input.is-invalid ~ .custom-file-label::before {
  border-color: inherit;
}
.was-validated .custom-file-input:invalid ~ .invalid-feedback,
.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,
.custom-file-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 13px;
  line-height: 1.2;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn:hover, .btn:focus {
  text-decoration: none;
}
.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.btn.disabled, .btn:disabled {
  opacity: 0.65;
  box-shadow: none;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
.btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {
  background-image: none;
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25), inset 0 3px 5px rgba(0, 0, 0, 0.125);
}

a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #fff;
  background-color: #3f51b5;
  border-color: #3f51b5;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.btn-primary:hover {
  color: #fff;
  background-color: rgb(53.1239754098, 68.3022540984, 152.6260245902);
  border-color: rgb(49.8319672131, 64.0696721311, 143.1680327869);
}
.btn-primary:focus, .btn-primary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(63, 81, 181, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #3f51b5;
  border-color: #3f51b5;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: rgb(49.8319672131, 64.0696721311, 143.1680327869);
  border-color: rgb(46.5399590164, 59.8370901639, 133.7100409836);
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(63, 81, 181, 0.5);
}

.btn-secondary {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.btn-secondary:hover {
  color: #fff;
  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);
  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}
.btn-secondary:focus, .btn-secondary.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.btn-success {
  color: #fff;
  background-color: #4caf50;
  border-color: #4caf50;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.btn-success:hover {
  color: #fff;
  background-color: rgb(64.4183266932, 148.3316733068, 67.8087649402);
  border-color: rgb(60.5577689243, 139.4422310757, 63.7450199203);
}
.btn-success:focus, .btn-success.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(76, 175, 80, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #4caf50;
  border-color: #4caf50;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(60.5577689243, 139.4422310757, 63.7450199203);
  border-color: rgb(56.6972111554, 130.5527888446, 59.6812749004);
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(76, 175, 80, 0.5);
}

.btn-info {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.btn-info:hover {
  color: #fff;
  background-color: rgb(0, 154.0801886792, 173.75);
  border-color: rgb(0, 142.7735849057, 161);
}
.btn-info:focus, .btn-info.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(0, 142.7735849057, 161);
  border-color: rgb(0, 131.4669811321, 148.25);
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.btn-warning {
  color: #212529;
  background-color: #ff9800;
  border-color: #ff9800;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.btn-warning:hover {
  color: #fff;
  background-color: rgb(216.75, 129.2, 0);
  border-color: rgb(204, 121.6, 0);
}
.btn-warning:focus, .btn-warning.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(255, 152, 0, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #212529;
  background-color: #ff9800;
  border-color: #ff9800;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(204, 121.6, 0);
  border-color: rgb(191.25, 114, 0);
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(255, 152, 0, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.btn-danger:focus, .btn-danger.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.btn-light {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.btn-light:hover {
  color: #212529;
  background-color: rgb(204.5078125, 208.8984375, 235.2421875);
  border-color: rgb(195.34375, 200.53125, 231.65625);
}
.btn-light:focus, .btn-light.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(195.34375, 200.53125, 231.65625);
  border-color: rgb(186.1796875, 192.1640625, 228.0703125);
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
}
.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.btn-dark:focus, .btn-dark.focus {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.btn-outline-primary {
  color: #3f51b5;
  background-color: transparent;
  background-image: none;
  border-color: #3f51b5;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #3f51b5;
  border-color: #3f51b5;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(63, 81, 181, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #3f51b5;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #3f51b5;
  border-color: #3f51b5;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(63, 81, 181, 0.5);
}

.btn-outline-secondary {
  color: #E91E63;
  background-color: transparent;
  background-image: none;
  border-color: #E91E63;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #E91E63;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #E91E63;
  border-color: #E91E63;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);
}

.btn-outline-success {
  color: #4caf50;
  background-color: transparent;
  background-image: none;
  border-color: #4caf50;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: #4caf50;
  border-color: #4caf50;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(76, 175, 80, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #4caf50;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #4caf50;
  border-color: #4caf50;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(76, 175, 80, 0.5);
}

.btn-outline-info {
  color: #00bcd4;
  background-color: transparent;
  background-image: none;
  border-color: #00bcd4;
}
.btn-outline-info:hover {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #00bcd4;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #00bcd4;
  border-color: #00bcd4;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);
}

.btn-outline-warning {
  color: #ff9800;
  background-color: transparent;
  background-image: none;
  border-color: #ff9800;
}
.btn-outline-warning:hover {
  color: #212529;
  background-color: #ff9800;
  border-color: #ff9800;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 152, 0, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #ff9800;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #ff9800;
  border-color: #ff9800;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(255, 152, 0, 0.5);
}

.btn-outline-danger {
  color: #f44336;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}

.btn-outline-light {
  color: #e8eaf6;
  background-color: transparent;
  background-image: none;
  border-color: #e8eaf6;
}
.btn-outline-light:hover {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #e8eaf6;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #e8eaf6;
  border-color: #e8eaf6;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);
}

.btn-outline-dark {
  color: #343a40;
  background-color: transparent;
  background-image: none;
  border-color: #343a40;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #3f51b5;
  background-color: transparent;
}
.btn-link:hover {
  color: rgb(49.8319672131, 64.0696721311, 143.1680327869);
  text-decoration: underline;
  background-color: transparent;
  border-color: transparent;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: underline;
  border-color: transparent;
  box-shadow: none;
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 17px;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 13px;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}

.fade {
  opacity: 0;
  transition: opacity 0.15s linear;
}
.fade.show {
  opacity: 1;
}

.collapse {
  display: none;
}
.collapse.show {
  display: block;
}

tr.collapse.show {
  display: table-row;
}

tbody.collapse.show {
  display: table-row-group;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}

.dropup,
.dropdown {
  position: relative;
}

.dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 13px;
  color: #5c5c5c;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
}

.dropup .dropdown-menu {
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropright .dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropleft .dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropleft .dropdown-toggle::after {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: inline-block;
  width: 0;
  height: 0;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: rgb(21.6283783784, 24.25, 26.8716216216);
  text-decoration: none;
  background-color: #f8f9fa;
}
.dropdown-item.active, .dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #007bff;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #6c757d;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 13px;
  color: #6c757d;
  white-space: nowrap;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 0 1 auto;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}
.btn-group .btn + .btn,
.btn-group .btn + .btn-group,
.btn-group .btn-group + .btn,
.btn-group .btn-group + .btn-group,
.btn-group-vertical .btn + .btn,
.btn-group-vertical .btn + .btn-group,
.btn-group-vertical .btn-group + .btn,
.btn-group-vertical .btn-group + .btn-group {
  margin-left: -1px;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:first-child {
  margin-left: 0;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after {
  margin-left: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group.show .dropdown-toggle {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.btn-group.show .dropdown-toggle.btn-link {
  box-shadow: none;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical .btn,
.btn-group-vertical .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn + .btn,
.btn-group-vertical > .btn + .btn-group,
.btn-group-vertical > .btn-group + .btn,
.btn-group-vertical > .btn-group + .btn-group {
  margin-top: -1px;
  margin-left: 0;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}
.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file:focus {
  z-index: 3;
}
.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:not(:last-child),
.input-group > .custom-select:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::before {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-file:not(:first-child) .custom-file-label, .input-group > .custom-file:not(:first-child) .custom-file-label::before {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group > .input-group-append:not(:last-child) > .btn,
.input-group > .input-group-append:not(:last-child) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  background-color: #007bff;
  box-shadow: none;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-control-input:active ~ .custom-control-label::before {
  color: #fff;
  background-color: rgb(178.5, 215.4, 255);
  box-shadow: none;
}
.custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
}
.custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  margin-bottom: 0;
}
.custom-control-label::before {
  position: absolute;
  top: 0.25rem;
  left: 0;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  user-select: none;
  background-color: #dee2e6;
  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);
}
.custom-control-label::after {
  position: absolute;
  top: 0.25rem;
  left: 0;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50% 50%;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #007bff;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  background-color: #007bff;
  box-shadow: none;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #007bff;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(0, 123, 255, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat right 0.75rem center;
  background-size: 8px 10px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  appearance: none;
}
.custom-select:focus {
  border-color: rgb(127.5, 189, 255);
  outline: 0;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 5px rgba(127.5, 189, 255, 0.5);
}
.custom-select:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}
.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}
.custom-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}
.custom-select::-ms-expand {
  opacity: 0;
}

.custom-select-sm {
  height: calc(1.8125rem + 2px);
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 75%;
}

.custom-select-lg {
  height: calc(2.875rem + 2px);
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 125%;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(2.25rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(2.25rem + 2px);
  margin: 0;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-control {
  border-color: rgb(127.5, 189, 255);
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.custom-file-input:focus ~ .custom-file-control::before {
  border-color: rgb(127.5, 189, 255);
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(calc(2.25rem + 2px) - 1px * 2);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #495057;
  content: "Browse";
  background-color: #e9ecef;
  border-left: 1px solid #ced4da;
  border-radius: 0 0.25rem 0.25rem 0;
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #6c757d;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.nav-tabs .nav-item {
  margin-bottom: -1px;
}
.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  border-color: #e9ecef #e9ecef #dee2e6;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  border-radius: 0.25rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #007bff;
}

.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}
.navbar > .container,
.navbar > .container-fluid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}
.navbar-toggler:not(:disabled):not(.disabled) {
  cursor: pointer;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: no-repeat center center;
  background-size: 100% 100%;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu-right {
    right: 0;
    left: auto;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .dropup .dropdown-menu {
    top: auto;
    bottom: 100%;
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu-right {
    right: 0;
    left: auto;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .dropup .dropdown-menu {
    top: auto;
    bottom: 100%;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu-right {
    right: 0;
    left: auto;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .dropup .dropdown-menu {
    top: auto;
    bottom: 100%;
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu-right {
    right: 0;
    left: auto;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .dropup .dropdown-menu {
    top: auto;
    bottom: 100%;
  }
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .dropdown-menu-right {
  right: 0;
  left: auto;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: #fff;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-text a {
  color: #fff;
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #dee2e6;
  border-radius: 8px;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group:first-child .list-group-item:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.card > .list-group:last-child .list-group-item:last-child {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}

.card-body {
  flex: 1 1 auto;
  padding: 30px;
}

.card-title {
  margin-bottom: 24px;
}

.card-subtitle {
  margin-top: -12px;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 30px;
}

.card-header {
  padding: 24px 30px;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid #dee2e6;
}
.card-header:first-child {
  border-radius: 8px 8px 0 0;
}
.card-header + .list-group .list-group-item:first-child {
  border-top: 0;
}

.card-footer {
  padding: 24px 30px;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid #dee2e6;
}
.card-footer:last-child {
  border-radius: 0 0 8px 8px;
}

.card-header-tabs {
  margin-right: -15px;
  margin-bottom: -24px;
  margin-left: -15px;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -15px;
  margin-left: -15px;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
}

.card-img {
  width: 100%;
  border-radius: 8px;
}

.card-img-top {
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.card-img-bottom {
  width: 100%;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}

.card-deck {
  display: flex;
  flex-direction: column;
}
.card-deck .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-deck {
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .card-deck .card {
    display: flex;
    flex: 1 0 0%;
    flex-direction: column;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group {
  display: flex;
  flex-direction: column;
}
.card-group > .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-group {
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:first-child .card-img-top,
  .card-group > .card:first-child .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:first-child .card-img-bottom,
  .card-group > .card:first-child .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:last-child .card-img-top,
  .card-group > .card:last-child .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:last-child .card-img-bottom,
  .card-group > .card:last-child .card-footer {
    border-bottom-left-radius: 0;
  }
  .card-group > .card:only-child {
    border-radius: 8px;
  }
  .card-group > .card:only-child .card-img-top,
  .card-group > .card:only-child .card-header {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .card-group > .card:only-child .card-img-bottom,
  .card-group > .card:only-child .card-footer {
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) {
    border-radius: 0;
  }
  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-top,
  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,
  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-header,
  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-footer {
    border-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 0.75rem;
}
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 4px;
}

.breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  color: #6c757d;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #6c757d;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 4px;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #007bff;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  color: rgb(0, 86.1, 178.5);
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 2;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.page-link:not(:disabled):not(.disabled) {
  cursor: pointer;
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.page-item:last-child .page-link {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 17px;
  line-height: 1.5;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 13px;
  line-height: 1.5;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}

.badge-primary {
  color: #fff;
  background-color: #3f51b5;
}
.badge-primary[href]:hover, .badge-primary[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: rgb(49.8319672131, 64.0696721311, 143.1680327869);
}

.badge-secondary {
  color: #fff;
  background-color: #E91E63;
}
.badge-secondary[href]:hover, .badge-secondary[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);
}

.badge-success {
  color: #fff;
  background-color: #4caf50;
}
.badge-success[href]:hover, .badge-success[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: rgb(60.5577689243, 139.4422310757, 63.7450199203);
}

.badge-info {
  color: #fff;
  background-color: #00bcd4;
}
.badge-info[href]:hover, .badge-info[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: rgb(0, 142.7735849057, 161);
}

.badge-warning {
  color: #212529;
  background-color: #ff9800;
}
.badge-warning[href]:hover, .badge-warning[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: rgb(204, 121.6, 0);
}

.badge-danger {
  color: #fff;
  background-color: #f44336;
}
.badge-danger[href]:hover, .badge-danger[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}

.badge-light {
  color: #212529;
  background-color: #e8eaf6;
}
.badge-light[href]:hover, .badge-light[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: rgb(195.34375, 200.53125, 231.65625);
}

.badge-dark {
  color: #fff;
  background-color: #343a40;
}
.badge-dark[href]:hover, .badge-dark[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 8px;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 4rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.75rem 1.25rem;
  color: inherit;
}

.alert-primary {
  color: rgb(32.76, 42.12, 94.12);
  background-color: rgb(216.6, 220.2, 240.2);
  border-color: rgb(201.24, 206.28, 234.28);
}
.alert-primary hr {
  border-top-color: rgb(182.8339849624, 189.5995488722, 227.1860150376);
}
.alert-primary .alert-link {
  color: rgb(19.5919672131, 25.1896721311, 56.2880327869);
}

.alert-secondary {
  color: rgb(121.16, 15.6, 51.48);
  background-color: rgb(250.6, 210, 223.8);
  border-color: rgb(248.84, 192, 211.32);
}
.alert-secondary hr {
  border-top-color: rgb(246.5687449393, 168.7712550607, 195.2147368421);
}
.alert-secondary .alert-link {
  color: rgb(75.9774904943, 9.7825095057, 32.2822813688);
}

.alert-success {
  color: rgb(39.52, 91, 41.6);
  background-color: rgb(219.2, 239, 220);
  border-color: rgb(204.88, 232.6, 206);
}
.alert-success hr {
  border-top-color: rgb(187.2564478764, 224.7235521236, 188.7702702703);
}
.alert-success .alert-link {
  color: rgb(24.0777689243, 55.4422310757, 25.3450199203);
}

.alert-info {
  color: rgb(0, 97.76, 110.24);
  background-color: rgb(204, 241.6, 246.4);
  border-color: rgb(183.6, 236.24, 242.96);
}
.alert-info hr {
  border-top-color: rgb(161.7795302013, 230.5067785235, 239.2804697987);
}
.alert-info .alert-link {
  color: rgb(0, 52.5335849057, 59.24);
}

.alert-warning {
  color: rgb(132.6, 79.04, 0);
  background-color: rgb(255, 234.4, 204);
  border-color: rgb(255, 226.16, 183.6);
}
.alert-warning hr {
  border-top-color: rgb(255, 215.86, 158.1);
}
.alert-warning .alert-link {
  color: rgb(81.6, 48.64, 0);
}

.alert-danger {
  color: rgb(126.88, 34.84, 28.08);
  background-color: rgb(252.8, 217.4, 214.8);
  border-color: rgb(251.92, 202.36, 198.72);
}
.alert-danger hr {
  border-top-color: rgb(250.5968867925, 179.7467924528, 174.5431132075);
}
.alert-danger .alert-link {
  color: rgb(85.1216107383, 23.373557047, 18.8383892617);
}

.alert-light {
  color: rgb(120.64, 121.68, 127.92);
  background-color: rgb(250.4, 250.8, 253.2);
  border-color: rgb(248.56, 249.12, 252.48);
}
.alert-light hr {
  border-top-color: rgb(230.231875, 232.385625, 245.308125);
}
.alert-light .alert-link {
  color: rgb(95.8868619247, 96.7134728033, 101.6731380753);
}

.alert-dark {
  color: rgb(27.04, 30.16, 33.28);
  background-color: rgb(214.4, 215.6, 216.8);
  border-color: rgb(198.16, 199.84, 201.52);
}
.alert-dark hr {
  border-top-color: rgb(185.0216751269, 187.09, 189.1583248731);
}
.alert-dark .alert-link {
  color: rgb(4.1779310345, 4.66, 5.1420689655);
}

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
  box-shadow: inset 0 0.1rem 0.1rem rgba(0, 0, 0, 0.1);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  text-align: center;
  background-color: #007bff;
  transition: width 0.6s ease;
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite;
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1;
}

.social-list-line:not(:last-child) {
  padding-bottom: 25px;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}
.list-group-item-action:active {
  color: #212529;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.list-group-item:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.list-group-item:last-child {
  margin-bottom: 0;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
.list-group-item:hover, .list-group-item:focus {
  z-index: 1;
  text-decoration: none;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  background-color: #fff;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.list-group-flush .list-group-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.list-group-flush:first-child .list-group-item:first-child {
  border-top: 0;
}
.list-group-flush:last-child .list-group-item:last-child {
  border-bottom: 0;
}

.list-group-item-primary {
  color: rgb(32.76, 42.12, 94.12);
  background-color: rgb(201.24, 206.28, 234.28);
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: rgb(32.76, 42.12, 94.12);
  background-color: rgb(182.8339849624, 189.5995488722, 227.1860150376);
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(32.76, 42.12, 94.12);
  border-color: rgb(32.76, 42.12, 94.12);
}

.list-group-item-secondary {
  color: rgb(121.16, 15.6, 51.48);
  background-color: rgb(248.84, 192, 211.32);
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: rgb(121.16, 15.6, 51.48);
  background-color: rgb(246.5687449393, 168.7712550607, 195.2147368421);
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(121.16, 15.6, 51.48);
  border-color: rgb(121.16, 15.6, 51.48);
}

.list-group-item-success {
  color: rgb(39.52, 91, 41.6);
  background-color: rgb(204.88, 232.6, 206);
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: rgb(39.52, 91, 41.6);
  background-color: rgb(187.2564478764, 224.7235521236, 188.7702702703);
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: rgb(39.52, 91, 41.6);
  border-color: rgb(39.52, 91, 41.6);
}

.list-group-item-info {
  color: rgb(0, 97.76, 110.24);
  background-color: rgb(183.6, 236.24, 242.96);
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: rgb(0, 97.76, 110.24);
  background-color: rgb(161.7795302013, 230.5067785235, 239.2804697987);
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: rgb(0, 97.76, 110.24);
  border-color: rgb(0, 97.76, 110.24);
}

.list-group-item-warning {
  color: rgb(132.6, 79.04, 0);
  background-color: rgb(255, 226.16, 183.6);
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: rgb(132.6, 79.04, 0);
  background-color: rgb(255, 215.86, 158.1);
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: rgb(132.6, 79.04, 0);
  border-color: rgb(132.6, 79.04, 0);
}

.list-group-item-danger {
  color: rgb(126.88, 34.84, 28.08);
  background-color: rgb(251.92, 202.36, 198.72);
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: rgb(126.88, 34.84, 28.08);
  background-color: rgb(250.5968867925, 179.7467924528, 174.5431132075);
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: rgb(126.88, 34.84, 28.08);
  border-color: rgb(126.88, 34.84, 28.08);
}

.list-group-item-light {
  color: rgb(120.64, 121.68, 127.92);
  background-color: rgb(248.56, 249.12, 252.48);
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: rgb(120.64, 121.68, 127.92);
  background-color: rgb(230.231875, 232.385625, 245.308125);
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: rgb(120.64, 121.68, 127.92);
  border-color: rgb(120.64, 121.68, 127.92);
}

.list-group-item-dark {
  color: rgb(27.04, 30.16, 33.28);
  background-color: rgb(198.16, 199.84, 201.52);
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: rgb(27.04, 30.16, 33.28);
  background-color: rgb(185.0216751269, 187.09, 189.1583248731);
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: rgb(27.04, 30.16, 33.28);
  border-color: rgb(27.04, 30.16, 33.28);
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  opacity: 0.5;
}
.close:hover, .close:focus {
  text-decoration: none;
  opacity: 0.75;
}
.close:not(:disabled):not(.disabled) {
  cursor: pointer;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
  -webkit-appearance: none;
}

.modal-open {
  overflow: hidden;
}

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  outline: 0;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -25%);
}
.modal.show .modal-dialog {
  transform: translate(0, 0);
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 0.5rem * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.5);
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.modal-header .close {
  padding: 1rem;
  margin: -1rem -1rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
}
.modal-footer > :not(:first-child) {
  margin-left: 0.25rem;
}
.modal-footer > :not(:last-child) {
  margin-right: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-centered {
    min-height: calc(100% - 1.75rem * 2);
  }
  .modal-content {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5);
  }
  .modal-sm {
    max-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg {
    max-width: 800px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.2);
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 8px;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.5rem;
}
.bs-popover-top .arrow, .bs-popover-auto[x-placement^=top] .arrow {
  bottom: calc((0.5rem + 1px) * -1);
}
.bs-popover-top .arrow::before, .bs-popover-auto[x-placement^=top] .arrow::before,
.bs-popover-top .arrow::after,
.bs-popover-auto[x-placement^=top] .arrow::after {
  border-width: 0.5rem 0.5rem 0;
}
.bs-popover-top .arrow::before, .bs-popover-auto[x-placement^=top] .arrow::before {
  bottom: 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-top .arrow::after, .bs-popover-auto[x-placement^=top] .arrow::after {
  bottom: 1px;
  border-top-color: #fff;
}

.bs-popover-right, .bs-popover-auto[x-placement^=right] {
  margin-left: 0.5rem;
}
.bs-popover-right .arrow, .bs-popover-auto[x-placement^=right] .arrow {
  left: calc((0.5rem + 1px) * -1);
  width: 0.5rem;
  height: 1rem;
  margin: 8px 0;
}
.bs-popover-right .arrow::before, .bs-popover-auto[x-placement^=right] .arrow::before,
.bs-popover-right .arrow::after,
.bs-popover-auto[x-placement^=right] .arrow::after {
  border-width: 0.5rem 0.5rem 0.5rem 0;
}
.bs-popover-right .arrow::before, .bs-popover-auto[x-placement^=right] .arrow::before {
  left: 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-right .arrow::after, .bs-popover-auto[x-placement^=right] .arrow::after {
  left: 1px;
  border-right-color: #fff;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.5rem;
}
.bs-popover-bottom .arrow, .bs-popover-auto[x-placement^=bottom] .arrow {
  top: calc((0.5rem + 1px) * -1);
}
.bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^=bottom] .arrow::before,
.bs-popover-bottom .arrow::after,
.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-width: 0 0.5rem 0.5rem 0.5rem;
}
.bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^=bottom] .arrow::before {
  top: 0;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-bottom .arrow::after, .bs-popover-auto[x-placement^=bottom] .arrow::after {
  top: 1px;
  border-bottom-color: #fff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid rgb(247.35, 247.35, 247.35);
}

.bs-popover-left, .bs-popover-auto[x-placement^=left] {
  margin-right: 0.5rem;
}
.bs-popover-left .arrow, .bs-popover-auto[x-placement^=left] .arrow {
  right: calc((0.5rem + 1px) * -1);
  width: 0.5rem;
  height: 1rem;
  margin: 8px 0;
}
.bs-popover-left .arrow::before, .bs-popover-auto[x-placement^=left] .arrow::before,
.bs-popover-left .arrow::after,
.bs-popover-auto[x-placement^=left] .arrow::after {
  border-width: 0.5rem 0 0.5rem 0.5rem;
}
.bs-popover-left .arrow::before, .bs-popover-auto[x-placement^=left] .arrow::before {
  right: 0;
  border-left-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-left .arrow::after, .bs-popover-auto[x-placement^=left] .arrow::after {
  right: 1px;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 13px;
  color: inherit;
  background-color: rgb(247.35, 247.35, 247.35);
  border-bottom: 1px solid rgb(234.6, 234.6, 234.6);
  border-top-left-radius: calc(8px - 1px);
  border-top-right-radius: calc(8px - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #212529;
}

.carousel {
  position: relative;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-item {
  position: relative;
  display: none;
  align-items: center;
  width: 100%;
  transition: transform 0.6s ease;
  backface-visibility: hidden;
  perspective: 1000px;
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next,
.carousel-item-prev {
  position: absolute;
  top: 0;
}

.carousel-item-next.carousel-item-left,
.carousel-item-prev.carousel-item-right {
  transform: translateX(0);
}
@supports (transform-style: preserve-3d) {
  .carousel-item-next.carousel-item-left,
  .carousel-item-prev.carousel-item-right {
    transform: translate3d(0, 0, 0);
  }
}

.carousel-item-next,
.active.carousel-item-right {
  transform: translateX(100%);
}
@supports (transform-style: preserve-3d) {
  .carousel-item-next,
  .active.carousel-item-right {
    transform: translate3d(100%, 0, 0);
  }
}

.carousel-item-prev,
.active.carousel-item-left {
  transform: translateX(-100%);
}
@supports (transform-style: preserve-3d) {
  .carousel-item-prev,
  .active.carousel-item-left {
    transform: translate3d(-100%, 0, 0);
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #fff;
  text-align: center;
  opacity: 0.5;
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: transparent no-repeat center center;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 10px;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators li {
  position: relative;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  background-color: rgba(255, 255, 255, 0.5);
}
.carousel-indicators li::before {
  position: absolute;
  top: -10px;
  left: 0;
  display: inline-block;
  width: 100%;
  height: 10px;
  content: "";
}
.carousel-indicators li::after {
  position: absolute;
  bottom: -10px;
  left: 0;
  display: inline-block;
  width: 100%;
  height: 10px;
  content: "";
}
.carousel-indicators .active {
  background-color: #fff;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #3f51b5 !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: rgb(49.8319672131, 64.0696721311, 143.1680327869) !important;
}

.bg-secondary {
  background-color: #E91E63 !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579) !important;
}

.bg-success {
  background-color: #4caf50 !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: rgb(60.5577689243, 139.4422310757, 63.7450199203) !important;
}

.bg-info {
  background-color: #00bcd4 !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: rgb(0, 142.7735849057, 161) !important;
}

.bg-warning {
  background-color: #ff9800 !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: rgb(204, 121.6, 0) !important;
}

.bg-danger {
  background-color: #f44336 !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358) !important;
}

.bg-light {
  background-color: #e8eaf6 !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: rgb(195.34375, 200.53125, 231.65625) !important;
}

.bg-dark {
  background-color: #343a40 !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: rgb(29.1379310345, 32.5, 35.8620689655) !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #dee2e6 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
}

.border-right {
  border-right: 1px solid #dee2e6 !important;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}

.border-left {
  border-left: 1px solid #dee2e6 !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #3f51b5 !important;
}

.border-secondary {
  border-color: #E91E63 !important;
}

.border-success {
  border-color: #4caf50 !important;
}

.border-info {
  border-color: #00bcd4 !important;
}

.border-warning {
  border-color: #ff9800 !important;
}

.border-danger {
  border-color: #f44336 !important;
}

.border-light {
  border-color: #e8eaf6 !important;
}

.border-dark {
  border-color: #343a40 !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded {
  border-radius: 4px !important;
}

.rounded-top {
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important;
}

.rounded-right {
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}

.rounded-bottom {
  border-bottom-right-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

.rounded-left {
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.8571428571%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  clip-path: inset(50%);
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
  clip-path: none;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}
.text-justify {
  text-align: justify !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: #3f51b5 !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: rgb(49.8319672131, 64.0696721311, 143.1680327869) !important;
}

.text-secondary {
  color: #E91E63 !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: rgb(193.1174089069, 18.8825910931, 78.1052631579) !important;
}

.text-success {
  color: #4caf50 !important;
}

a.text-success:hover, a.text-success:focus {
  color: rgb(60.5577689243, 139.4422310757, 63.7450199203) !important;
}

.text-info {
  color: #00bcd4 !important;
}

a.text-info:hover, a.text-info:focus {
  color: rgb(0, 142.7735849057, 161) !important;
}

.text-warning {
  color: #ff9800 !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: rgb(204, 121.6, 0) !important;
}

.text-danger {
  color: #f44336 !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: rgb(234.1839622642, 27.9622641509, 12.8160377358) !important;
}

.text-light {
  color: #e8eaf6 !important;
}

a.text-light:hover, a.text-light:focus {
  color: rgb(195.34375, 200.53125, 231.65625) !important;
}

.text-dark {
  color: #343a40 !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: rgb(29.1379310345, 32.5, 35.8620689655) !important;
}

.text-muted {
  color: #6c757d !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  abbr[title]::after {
    content: " (" attr(title) ")";
  }
  pre {
    white-space: pre-wrap !important;
  }
  pre,
  blockquote {
    border: 1px solid #999;
    page-break-inside: avoid;
  }
  thead {
    display: table-header-group;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
  .badge {
    border: 1px solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
  .table th {
    background-color: #fff !important;
  }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #ddd !important;
  }
}`, "",{"version":3,"sources":["webpack://./styles/bootstrap.scss","webpack://./styles/bootstrap/bootstrap.scss","webpack://./styles/bootstrap/_root.scss","webpack://./styles/bootstrap/_reboot.scss","webpack://./styles/global/_variables.scss","webpack://./styles/bootstrap/_variables.scss","webpack://./styles/bootstrap/mixins/_hover.scss","webpack://./styles/bootstrap/_type.scss","webpack://./styles/bootstrap/mixins/_lists.scss","webpack://./styles/bootstrap/_images.scss","webpack://./styles/bootstrap/mixins/_image.scss","webpack://./styles/bootstrap/mixins/_border-radius.scss","webpack://./styles/bootstrap/mixins/_box-shadow.scss","webpack://./styles/bootstrap/_code.scss","webpack://./styles/bootstrap/_grid.scss","webpack://./styles/bootstrap/mixins/_grid.scss","webpack://./styles/bootstrap/mixins/_breakpoints.scss","webpack://./styles/bootstrap/mixins/_grid-framework.scss","webpack://./styles/bootstrap/_tables.scss","webpack://./styles/bootstrap/mixins/_table-row.scss","webpack://./styles/bootstrap/_forms.scss","webpack://./styles/bootstrap/mixins/_transition.scss","webpack://./styles/bootstrap/mixins/_forms.scss","webpack://./styles/bootstrap/mixins/_gradients.scss","webpack://./styles/bootstrap/_buttons.scss","webpack://./styles/bootstrap/mixins/_buttons.scss","webpack://./styles/bootstrap/_transitions.scss","webpack://./styles/bootstrap/_dropdown.scss","webpack://./styles/bootstrap/mixins/_caret.scss","webpack://./styles/bootstrap/mixins/_nav-divider.scss","webpack://./styles/bootstrap/_button-group.scss","webpack://./styles/bootstrap/_input-group.scss","webpack://./styles/bootstrap/_custom-forms.scss","webpack://./styles/bootstrap/_nav.scss","webpack://./styles/bootstrap/_navbar.scss","webpack://./styles/bootstrap/_card.scss","webpack://./styles/bootstrap/_breadcrumb.scss","webpack://./styles/bootstrap/_pagination.scss","webpack://./styles/bootstrap/mixins/_pagination.scss","webpack://./styles/bootstrap/_badge.scss","webpack://./styles/bootstrap/mixins/_badge.scss","webpack://./styles/bootstrap/_jumbotron.scss","webpack://./styles/bootstrap/_alert.scss","webpack://./styles/bootstrap/mixins/_alert.scss","webpack://./styles/bootstrap/_progress.scss","webpack://./styles/bootstrap/_media.scss","webpack://./styles/bootstrap/_list-group.scss","webpack://./styles/bootstrap/mixins/_list-group.scss","webpack://./styles/bootstrap/_close.scss","webpack://./styles/bootstrap/_modal.scss","webpack://./styles/bootstrap/_tooltip.scss","webpack://./styles/bootstrap/mixins/_reset-text.scss","webpack://./styles/bootstrap/_popover.scss","webpack://./styles/bootstrap/_carousel.scss","webpack://./styles/bootstrap/utilities/_align.scss","webpack://./styles/bootstrap/mixins/_background-variant.scss","webpack://./styles/bootstrap/utilities/_background.scss","webpack://./styles/bootstrap/utilities/_borders.scss","webpack://./styles/bootstrap/mixins/_clearfix.scss","webpack://./styles/bootstrap/utilities/_display.scss","webpack://./styles/bootstrap/utilities/_embed.scss","webpack://./styles/bootstrap/utilities/_flex.scss","webpack://./styles/bootstrap/utilities/_float.scss","webpack://./styles/bootstrap/mixins/_float.scss","webpack://./styles/bootstrap/utilities/_position.scss","webpack://./styles/bootstrap/utilities/_screenreaders.scss","webpack://./styles/bootstrap/mixins/_screen-reader.scss","webpack://./styles/bootstrap/utilities/_sizing.scss","webpack://./styles/bootstrap/utilities/_spacing.scss","webpack://./styles/bootstrap/utilities/_text.scss","webpack://./styles/bootstrap/mixins/_text-truncate.scss","webpack://./styles/bootstrap/mixins/_text-emphasis.scss","webpack://./styles/bootstrap/mixins/_text-hide.scss","webpack://./styles/bootstrap/utilities/_visibility.scss","webpack://./styles/bootstrap/mixins/_visibility.scss","webpack://./styles/bootstrap/_print.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;EAAA;ACAA;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,eAAA;EAAA,oBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAIA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAKF,8CAAA;EACA,6GAAA;AFsBF;;AGpBA;;;EAGE,sBAAA;AHuBF;;AGpBA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6BAAA;EACA,6CAAA;AHuBF;;AGlBE;EACE,mBAAA;AHqBJ;AGfA;EACE,cAAA;AHiBF;;AGLA;EACE,SAAA;EACA,iCC1CuB;ED2CvB,eCvCe;EDwCf,gBE4KmB;EF3KnB,gBE+KiB;EF9KjB,cCiCW;EDhCX,gBAAA;EACA,sBC8BQ;AJtBV;;AGAA;EACE,qBAAA;AHGF;;AGKA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AHFF;;AGcA;EACE,aAAA;EACA,mBCnEuB;AJwDzB;;AGoBA;EACE,aAAA;EACA,mBE+CwB;ALhE1B;;AG2BA;;EAEE,0BAAA;EACA,iCAAA;EACA,YAAA;EACA,gBAAA;AHxBF;;AG2BA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AHxBF;;AG2BA;;;EAGE,aAAA;EACA,mBAAA;AHxBF;;AG2BA;;;;EAIE,gBAAA;AHxBF;;AG2BA;EACE,gBEqFiB;AL7GnB;;AG2BA;EACE,qBAAA;EACA,cAAA;AHxBF;;AG2BA;EACE,gBAAA;AHxBF;;AG2BA;EACE,kBAAA;AHxBF;;AG4BA;;EAEE,mBAAA;AHzBF;;AG8BA;EACE,cAAA;AH3BF;;AGmCA;;EAEE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,wBAAA;AHhCF;;AGmCA;EACE,eAAA;AHhCF;;AGmCA;EACE,WAAA;AHhCF;;AGuCA;EACE,cChJY;EDiJZ,qBEvDgB;EFwDhB,6BAAA;EACA,qCAAA;AHpCF;AM3JE;EHkME,wDC3He;ED4Hf,0BE3DoB;ALuBxB;;AG8CA;EACE,cAAA;EACA,qBAAA;AH3CF;AM9JE;EH4ME,cAAA;EACA,qBAAA;AH3CJ;AG8CE;EACE,UAAA;AH5CJ;;AGqDA;;;;EAIE,iCAAA;EACA,cAAA;AHlDF;;AGuDA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;AHzDF;;AGgEA;EAEE,gBAAA;AH9DF;;AGqEA;EACE,sBAAA;EACA,kBAAA;AHlEF;;AGqEA;EACE,gBAAA;AHlEF;;AGyEA;EACE,yBAAA;AHtEF;;AGyEA;EACE,oBECmB;EFAnB,uBAAA;EACA,cErRS;EFsRT,gBAAA;EACA,oBAAA;AHtEF;;AGyEA;EAGE,mBAAA;AHxEF;;AG+EA;EAEE,qBAAA;EACA,qBAAA;AH7EF;;AGmFA;EACE,gBAAA;AHhFF;;AGuFA;EACE,mBAAA;EACA,0CAAA;AHpFF;;AGuFA;;;;;EAKE,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;AHpFF;;AGuFA;;EAEE,iBAAA;AHpFF;;AGuFA;;EAEE,oBAAA;AHpFF;;AG0FA;;;;EAIE,0BAAA;AHvFF;;AG2FA;;;;EAIE,UAAA;EACA,kBAAA;AHxFF;;AG2FA;;EAEE,sBAAA;EACA,UAAA;AHxFF;;AG2FA;;;;EASE,2BAAA;AH7FF;;AGgGA;EACE,cAAA;EAEA,gBAAA;AH9FF;;AGiGA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AHpGF;;AGyGA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;AHtGF;;AGyGA;EACE,wBAAA;AHtGF;;AG0GA;;EAEE,YAAA;AHvGF;;AG0GA;EAKE,oBAAA;EACA,wBAAA;AH3GF;;AGkHA;;EAEE,wBAAA;AH/GF;;AGuHA;EACE,aAAA;EACA,0BAAA;AHpHF;;AG2HA;EACE,qBAAA;AHxHF;;AG2HA;EACE,kBAAA;EACA,eAAA;AHxHF;;AG2HA;EACE,aAAA;AHxHF;;AG6HA;EACE,wBAAA;AH1HF;;AO/VA;;EAEE,mBHuBuB;EGtBvB,oBHuBqB;EGtBrB,gBHuBqB;EGtBrB,gBHuBqB;EGtBrB,cHuBe;AJ2UjB;;AO/VA;EACE,eHQa;AJ0Vf;;AO/VA;EACE,eHKa;AJ6Vf;;AO/VA;EACE,eHEa;AJgWf;;AO/VA;EACE,eHDa;AJmWf;;AO/VA;EACE,eHJa;AJsWf;;AO/VA;EACE,eHPa;AJyWf;;AO/VA;EACE,kBF8Ne;EE7Nf,gBF8NiB;ALoInB;;AO9VA;EACE,eF6Mc;EE5Md,gBFiNgB;EEhNhB,gBFwMqB;ALyJvB;;AO9VA;EACE,iBFwMc;EEvMd,gBF4MgB;EE3MhB,gBFkMqB;AL+JvB;;AO9VA;EACE,iBFmMc;EElMd,gBFuMgB;EEtMhB,gBF4LqB;ALqKvB;;AO9VA;EACE,iBF8Lc;EE7Ld,gBFkMgB;EEjMhB,gBFsLqB;AL2KvB;;AO1VA;EACE,gBFyCO;EExCP,mBFwCO;EEvCP,SAAA;EACA,wCAAA;AP6VF;;AOtVA;;EAEE,cFmLgB;EElLhB,gBFiJmB;ALwMrB;;AOtVA;;EAEE,cFuLa;EEtLb,yBF+LQ;AL0JV;;AOlVA;EChGE,eAAA;EACA,gBAAA;ARsbF;;AOlVA;ECrGE,eAAA;EACA,gBAAA;AR2bF;;AOnVA;EACE,qBAAA;APsVF;AOpVE;EACE,oBFyKkB;AL6KtB;;AO7UA;EACE,cAAA;EACA,yBAAA;APgVF;;AO5UA;EACE,mBFdO;EEeP,kBF4IqB;ALmMvB;;AO5UA;EACE,cAAA;EACA,cAAA;EACA,cFxHS;ALucX;AO7UE;EACE,aAAA;AP+UJ;;ASndA;ECGE,eAAA;EAGA,YAAA;AVkdF;;ASndA;EACE,gBJgxBkB;EI/wBlB,sBJJM;EIKN,yBAAA;EEXE,sBNwMY;EO1MZ,0CHeF;ECPA,eAAA;EAGA,YAAA;AV4dF;;AS9cA;EAEE,qBAAA;ATgdF;;AS7cA;EACE,qBAAA;EACA,cAAA;ATgdF;;AS7cA;EACE,cJgwByB;EI/vBzB,cJvBS;ALueX;;AatfA;;;;EAIE,iGR0NsB;AL+RxB;;AarfA;EACE,gBR00Be;EQz0Bf,cR2BK;EQ1BL,sBAAA;AbwfF;AarfE;EACE,cAAA;AbufJ;;AalfA;EACE,sBAAA;EACA,gBR6zBe;EQ5zBf,WRdM;EQeN,yBRNS;EMfP,kBPkCe;EQpCf,iDCyBF;AbqfF;AanfE;EACE,UAAA;EACA,eAAA;EACA,gBRyMe;EOvOf,gBC+BA;AbqfJ;;AahfA;EACE,cAAA;EACA,gBR4yBe;EQ3yBf,cRtBS;ALygBX;AahfE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AbkfJ;;Aa7eA;EACE,iBRyyB0B;EQxyB1B,kBAAA;AbgfF;;AcjiBE;ECAA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AfqiBF;AgBlfI;EFvDF;ICWI,gBVkKiB;ELgYrB;AACF;AgBvfI;EFvDF;ICWI,gBVkKiB;ELqYrB;AACF;AgB5fI;EFvDF;ICWI,gBVkKiB;EL0YrB;AACF;AgBjgBI;EFvDF;ICWI,iBVkKiB;EL+YrB;AACF;;AcjjBE;ECZA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AfikBF;;Ac/iBE;ECLA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AfwjBF;;AchjBE;EACE,eAAA;EACA,cAAA;AdmjBJ;AcjjBI;;EAEE,gBAAA;EACA,eAAA;AdmjBN;;AiBplBE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AjB4lBJ;;AiBzkBM;EACE,aAAA;EACA,YAAA;EACA,eAAA;AjB4kBR;;AiB1kBM;EACE,cAAA;EACA,WAAA;EACA,eAAA;AjB6kBR;;AiBzkBQ;EFHN,uBAAA;EAIA,wBAAA;Af6kBF;;AiB9kBQ;EFHN,wBAAA;EAIA,yBAAA;AfklBF;;AiBnlBQ;EFHN,aAAA;EAIA,cAAA;AfulBF;;AiBxlBQ;EFHN,wBAAA;EAIA,yBAAA;Af4lBF;;AiB7lBQ;EFHN,wBAAA;EAIA,yBAAA;AfimBF;;AiBlmBQ;EFHN,aAAA;EAIA,cAAA;AfsmBF;;AiBvmBQ;EFHN,wBAAA;EAIA,yBAAA;Af2mBF;;AiB5mBQ;EFHN,wBAAA;EAIA,yBAAA;AfgnBF;;AiBjnBQ;EFHN,aAAA;EAIA,cAAA;AfqnBF;;AiBtnBQ;EFHN,wBAAA;EAIA,yBAAA;Af0nBF;;AiB3nBQ;EFHN,wBAAA;EAIA,yBAAA;Af+nBF;;AiBhoBQ;EFHN,cAAA;EAIA,eAAA;AfooBF;;AiBhoBM;EACE,SAAA;AjBmoBR;;AiBhoBM;EACE,SAAA;AjBmoBR;;AiB/nBQ;EACE,QAFS;AjBooBnB;;AiBnoBQ;EACE,QAFS;AjBwoBnB;;AiBvoBQ;EACE,QAFS;AjB4oBnB;;AiB3oBQ;EACE,QAFS;AjBgpBnB;;AiB/oBQ;EACE,QAFS;AjBopBnB;;AiBnpBQ;EACE,QAFS;AjBwpBnB;;AiBvpBQ;EACE,QAFS;AjB4pBnB;;AiB3pBQ;EACE,QAFS;AjBgqBnB;;AiB/pBQ;EACE,QAFS;AjBoqBnB;;AiBnqBQ;EACE,QAFS;AjBwqBnB;;AiBvqBQ;EACE,SAFS;AjB4qBnB;;AiB3qBQ;EACE,SAFS;AjBgrBnB;;AiB/qBQ;EACE,SAFS;AjBorBnB;;AiB3qBU;EFhBR,0BAAA;Af+rBF;;AiB/qBU;EFhBR,2BAAA;AfmsBF;;AiBnrBU;EFhBR,gBAAA;AfusBF;;AiBvrBU;EFhBR,2BAAA;Af2sBF;;AiB3rBU;EFhBR,2BAAA;Af+sBF;;AiB/rBU;EFhBR,gBAAA;AfmtBF;;AiBnsBU;EFhBR,2BAAA;AfutBF;;AiBvsBU;EFhBR,2BAAA;Af2tBF;;AiB3sBU;EFhBR,gBAAA;Af+tBF;;AiB/sBU;EFhBR,2BAAA;AfmuBF;;AiBntBU;EFhBR,2BAAA;AfuuBF;;AgB5tBI;EC7BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjB6vBN;EiB3vBI;IACE,cAAA;IACA,WAAA;IACA,eAAA;EjB6vBN;EiBzvBM;IFHN,uBAAA;IAIA,wBAAA;Ef4vBA;EiB7vBM;IFHN,wBAAA;IAIA,yBAAA;EfgwBA;EiBjwBM;IFHN,aAAA;IAIA,cAAA;EfowBA;EiBrwBM;IFHN,wBAAA;IAIA,yBAAA;EfwwBA;EiBzwBM;IFHN,wBAAA;IAIA,yBAAA;Ef4wBA;EiB7wBM;IFHN,aAAA;IAIA,cAAA;EfgxBA;EiBjxBM;IFHN,wBAAA;IAIA,yBAAA;EfoxBA;EiBrxBM;IFHN,wBAAA;IAIA,yBAAA;EfwxBA;EiBzxBM;IFHN,aAAA;IAIA,cAAA;Ef4xBA;EiB7xBM;IFHN,wBAAA;IAIA,yBAAA;EfgyBA;EiBjyBM;IFHN,wBAAA;IAIA,yBAAA;EfoyBA;EiBryBM;IFHN,cAAA;IAIA,eAAA;EfwyBA;EiBpyBI;IACE,SAAA;EjBsyBN;EiBnyBI;IACE,SAAA;EjBqyBN;EiBjyBM;IACE,QAFS;EjBqyBjB;EiBpyBM;IACE,QAFS;EjBwyBjB;EiBvyBM;IACE,QAFS;EjB2yBjB;EiB1yBM;IACE,QAFS;EjB8yBjB;EiB7yBM;IACE,QAFS;EjBizBjB;EiBhzBM;IACE,QAFS;EjBozBjB;EiBnzBM;IACE,QAFS;EjBuzBjB;EiBtzBM;IACE,QAFS;EjB0zBjB;EiBzzBM;IACE,QAFS;EjB6zBjB;EiB5zBM;IACE,QAFS;EjBg0BjB;EiB/zBM;IACE,SAFS;EjBm0BjB;EiBl0BM;IACE,SAFS;EjBs0BjB;EiBr0BM;IACE,SAFS;EjBy0BjB;EiBh0BQ;IFhBR,cAAA;Efm1BA;EiBn0BQ;IFhBR,0BAAA;Efs1BA;EiBt0BQ;IFhBR,2BAAA;Efy1BA;EiBz0BQ;IFhBR,gBAAA;Ef41BA;EiB50BQ;IFhBR,2BAAA;Ef+1BA;EiB/0BQ;IFhBR,2BAAA;Efk2BA;EiBl1BQ;IFhBR,gBAAA;Efq2BA;EiBr1BQ;IFhBR,2BAAA;Efw2BA;EiBx1BQ;IFhBR,2BAAA;Ef22BA;EiB31BQ;IFhBR,gBAAA;Ef82BA;EiB91BQ;IFhBR,2BAAA;Efi3BA;EiBj2BQ;IFhBR,2BAAA;Efo3BA;AACF;AgB12BI;EC7BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjB04BN;EiBx4BI;IACE,cAAA;IACA,WAAA;IACA,eAAA;EjB04BN;EiBt4BM;IFHN,uBAAA;IAIA,wBAAA;Efy4BA;EiB14BM;IFHN,wBAAA;IAIA,yBAAA;Ef64BA;EiB94BM;IFHN,aAAA;IAIA,cAAA;Efi5BA;EiBl5BM;IFHN,wBAAA;IAIA,yBAAA;Efq5BA;EiBt5BM;IFHN,wBAAA;IAIA,yBAAA;Efy5BA;EiB15BM;IFHN,aAAA;IAIA,cAAA;Ef65BA;EiB95BM;IFHN,wBAAA;IAIA,yBAAA;Efi6BA;EiBl6BM;IFHN,wBAAA;IAIA,yBAAA;Efq6BA;EiBt6BM;IFHN,aAAA;IAIA,cAAA;Efy6BA;EiB16BM;IFHN,wBAAA;IAIA,yBAAA;Ef66BA;EiB96BM;IFHN,wBAAA;IAIA,yBAAA;Efi7BA;EiBl7BM;IFHN,cAAA;IAIA,eAAA;Efq7BA;EiBj7BI;IACE,SAAA;EjBm7BN;EiBh7BI;IACE,SAAA;EjBk7BN;EiB96BM;IACE,QAFS;EjBk7BjB;EiBj7BM;IACE,QAFS;EjBq7BjB;EiBp7BM;IACE,QAFS;EjBw7BjB;EiBv7BM;IACE,QAFS;EjB27BjB;EiB17BM;IACE,QAFS;EjB87BjB;EiB77BM;IACE,QAFS;EjBi8BjB;EiBh8BM;IACE,QAFS;EjBo8BjB;EiBn8BM;IACE,QAFS;EjBu8BjB;EiBt8BM;IACE,QAFS;EjB08BjB;EiBz8BM;IACE,QAFS;EjB68BjB;EiB58BM;IACE,SAFS;EjBg9BjB;EiB/8BM;IACE,SAFS;EjBm9BjB;EiBl9BM;IACE,SAFS;EjBs9BjB;EiB78BQ;IFhBR,cAAA;Efg+BA;EiBh9BQ;IFhBR,0BAAA;Efm+BA;EiBn9BQ;IFhBR,2BAAA;Efs+BA;EiBt9BQ;IFhBR,gBAAA;Efy+BA;EiBz9BQ;IFhBR,2BAAA;Ef4+BA;EiB59BQ;IFhBR,2BAAA;Ef++BA;EiB/9BQ;IFhBR,gBAAA;Efk/BA;EiBl+BQ;IFhBR,2BAAA;Efq/BA;EiBr+BQ;IFhBR,2BAAA;Efw/BA;EiBx+BQ;IFhBR,gBAAA;Ef2/BA;EiB3+BQ;IFhBR,2BAAA;Ef8/BA;EiB9+BQ;IFhBR,2BAAA;EfigCA;AACF;AgBv/BI;EC7BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjBuhCN;EiBrhCI;IACE,cAAA;IACA,WAAA;IACA,eAAA;EjBuhCN;EiBnhCM;IFHN,uBAAA;IAIA,wBAAA;EfshCA;EiBvhCM;IFHN,wBAAA;IAIA,yBAAA;Ef0hCA;EiB3hCM;IFHN,aAAA;IAIA,cAAA;Ef8hCA;EiB/hCM;IFHN,wBAAA;IAIA,yBAAA;EfkiCA;EiBniCM;IFHN,wBAAA;IAIA,yBAAA;EfsiCA;EiBviCM;IFHN,aAAA;IAIA,cAAA;Ef0iCA;EiB3iCM;IFHN,wBAAA;IAIA,yBAAA;Ef8iCA;EiB/iCM;IFHN,wBAAA;IAIA,yBAAA;EfkjCA;EiBnjCM;IFHN,aAAA;IAIA,cAAA;EfsjCA;EiBvjCM;IFHN,wBAAA;IAIA,yBAAA;Ef0jCA;EiB3jCM;IFHN,wBAAA;IAIA,yBAAA;Ef8jCA;EiB/jCM;IFHN,cAAA;IAIA,eAAA;EfkkCA;EiB9jCI;IACE,SAAA;EjBgkCN;EiB7jCI;IACE,SAAA;EjB+jCN;EiB3jCM;IACE,QAFS;EjB+jCjB;EiB9jCM;IACE,QAFS;EjBkkCjB;EiBjkCM;IACE,QAFS;EjBqkCjB;EiBpkCM;IACE,QAFS;EjBwkCjB;EiBvkCM;IACE,QAFS;EjB2kCjB;EiB1kCM;IACE,QAFS;EjB8kCjB;EiB7kCM;IACE,QAFS;EjBilCjB;EiBhlCM;IACE,QAFS;EjBolCjB;EiBnlCM;IACE,QAFS;EjBulCjB;EiBtlCM;IACE,QAFS;EjB0lCjB;EiBzlCM;IACE,SAFS;EjB6lCjB;EiB5lCM;IACE,SAFS;EjBgmCjB;EiB/lCM;IACE,SAFS;EjBmmCjB;EiB1lCQ;IFhBR,cAAA;Ef6mCA;EiB7lCQ;IFhBR,0BAAA;EfgnCA;EiBhmCQ;IFhBR,2BAAA;EfmnCA;EiBnmCQ;IFhBR,gBAAA;EfsnCA;EiBtmCQ;IFhBR,2BAAA;EfynCA;EiBzmCQ;IFhBR,2BAAA;Ef4nCA;EiB5mCQ;IFhBR,gBAAA;Ef+nCA;EiB/mCQ;IFhBR,2BAAA;EfkoCA;EiBlnCQ;IFhBR,2BAAA;EfqoCA;EiBrnCQ;IFhBR,gBAAA;EfwoCA;EiBxnCQ;IFhBR,2BAAA;Ef2oCA;EiB3nCQ;IFhBR,2BAAA;Ef8oCA;AACF;AgBpoCI;EC7BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjBoqCN;EiBlqCI;IACE,cAAA;IACA,WAAA;IACA,eAAA;EjBoqCN;EiBhqCM;IFHN,uBAAA;IAIA,wBAAA;EfmqCA;EiBpqCM;IFHN,wBAAA;IAIA,yBAAA;EfuqCA;EiBxqCM;IFHN,aAAA;IAIA,cAAA;Ef2qCA;EiB5qCM;IFHN,wBAAA;IAIA,yBAAA;Ef+qCA;EiBhrCM;IFHN,wBAAA;IAIA,yBAAA;EfmrCA;EiBprCM;IFHN,aAAA;IAIA,cAAA;EfurCA;EiBxrCM;IFHN,wBAAA;IAIA,yBAAA;Ef2rCA;EiB5rCM;IFHN,wBAAA;IAIA,yBAAA;Ef+rCA;EiBhsCM;IFHN,aAAA;IAIA,cAAA;EfmsCA;EiBpsCM;IFHN,wBAAA;IAIA,yBAAA;EfusCA;EiBxsCM;IFHN,wBAAA;IAIA,yBAAA;Ef2sCA;EiB5sCM;IFHN,cAAA;IAIA,eAAA;Ef+sCA;EiB3sCI;IACE,SAAA;EjB6sCN;EiB1sCI;IACE,SAAA;EjB4sCN;EiBxsCM;IACE,QAFS;EjB4sCjB;EiB3sCM;IACE,QAFS;EjB+sCjB;EiB9sCM;IACE,QAFS;EjBktCjB;EiBjtCM;IACE,QAFS;EjBqtCjB;EiBptCM;IACE,QAFS;EjBwtCjB;EiBvtCM;IACE,QAFS;EjB2tCjB;EiB1tCM;IACE,QAFS;EjB8tCjB;EiB7tCM;IACE,QAFS;EjBiuCjB;EiBhuCM;IACE,QAFS;EjBouCjB;EiBnuCM;IACE,QAFS;EjBuuCjB;EiBtuCM;IACE,SAFS;EjB0uCjB;EiBzuCM;IACE,SAFS;EjB6uCjB;EiB5uCM;IACE,SAFS;EjBgvCjB;EiBvuCQ;IFhBR,cAAA;Ef0vCA;EiB1uCQ;IFhBR,0BAAA;Ef6vCA;EiB7uCQ;IFhBR,2BAAA;EfgwCA;EiBhvCQ;IFhBR,gBAAA;EfmwCA;EiBnvCQ;IFhBR,2BAAA;EfswCA;EiBtvCQ;IFhBR,2BAAA;EfywCA;EiBzvCQ;IFhBR,gBAAA;Ef4wCA;EiB5vCQ;IFhBR,2BAAA;Ef+wCA;EiB/vCQ;IFhBR,2BAAA;EfkxCA;EiBlwCQ;IFhBR,gBAAA;EfqxCA;EiBrwCQ;IFhBR,2BAAA;EfwxCA;EiBxwCQ;IFhBR,2BAAA;Ef2xCA;AACF;AkBz0CA;EACE,WAAA;EACA,eAAA;EACA,mBb4GO;Ea3GP,6Bb+RS;AL4iCX;AkBz0CE;;EAEE,gBbwRiB;EavRjB,mBAAA;EACA,6BAAA;AlB20CJ;AkBx0CE;EACE,sBAAA;EACA,gCAAA;AlB00CJ;AkBv0CE;EACE,6BAAA;AlBy0CJ;AkBt0CE;EACE,sBdmEM;AJqwCV;;AkB/zCE;;EAEE,eb+PoB;ALmkCxB;;AkB1zCA;EACE,yBAAA;AlB6zCF;AkB3zCE;;EAEE,yBAAA;AlB6zCJ;AkBzzCI;;EAEE,wBAAA;AlB2zCN;;AkBjzCE;EACE,qCboOc;ALglClB;;AM12CE;EYiEI,sCb0NW;ALmlCjB;;AmBt3CI;;;EAGE,6CDiF+B;AlBwyCrC;;AMp3CE;EaMM,qEAJe;AnBs3CvB;AmBh3CQ;;EAEE,qEARa;AnB03CvB;;AmBp4CI;;;EAGE,0CDiF+B;AlBszCrC;;AMl4CE;EaMM,qEAJe;AnBo4CvB;AmB93CQ;;EAEE,qEARa;AnBw4CvB;;AmBl5CI;;;EAGE,yCDiF+B;AlBo0CrC;;AMh5CE;EaMM,qEAJe;AnBk5CvB;AmB54CQ;;EAEE,qEARa;AnBs5CvB;;AmBh6CI;;;EAGE,4CDiF+B;AlBk1CrC;;AM95CE;EaMM,qEAJe;AnBg6CvB;AmB15CQ;;EAEE,qEARa;AnBo6CvB;;AmB96CI;;;EAGE,yCDiF+B;AlBg2CrC;;AM56CE;EaMM,yCAJe;AnB86CvB;AmBx6CQ;;EAEE,yCARa;AnBk7CvB;;AmB57CI;;;EAGE,6CDiF+B;AlB82CrC;;AM17CE;EaMM,qEAJe;AnB47CvB;AmBt7CQ;;EAEE,qEARa;AnBg8CvB;;AmB18CI;;;EAGE,6CDiF+B;AlB43CrC;;AMx8CE;EaMM,yDAJe;AnB08CvB;AmBp8CQ;;EAEE,yDARa;AnB88CvB;;AmBx9CI;;;EAGE,6CDiF+B;AlB04CrC;;AMt9CE;EaMM,6DAJe;AnBw9CvB;AmBl9CQ;;EAEE,6DARa;AnB49CvB;;AmBt+CI;;;EAGE,sCdgSW;ALysCjB;;AMp+CE;EaMM,sCAJe;AnBs+CvB;AmBh+CQ;;EAEE,sCARa;AnB0+CvB;;AkBp5CI;EACE,Wb7FE;Ea8FF,yBbrFK;EasFL,uDb4MoB;AL2sC1B;AkBl5CI;EACE,cb9FK;Ea+FL,yBbpGK;EaqGL,qBbpGK;ALw/CX;;AkB/4CA;EACE,Wb7GM;Ea8GN,yBbrGS;ALu/CX;AkBh5CE;;;EAGE,uDbwLsB;AL0tC1B;AkB/4CE;EACE,SAAA;AlBi5CJ;AkB74CI;EACE,2Cb6KiB;ALkuCvB;AMvgDE;EY+HM,4CbuKc;ALouCtB;;AgB/8CI;EEoFA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;IACA,4CAAA;ElB83CN;EkB33CM;IACE,SAAA;ElB63CR;AACF;AgB59CI;EEoFA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;IACA,4CAAA;ElB04CN;EkBv4CM;IACE,SAAA;ElBy4CR;AACF;AgBx+CI;EEoFA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;IACA,4CAAA;ElBs5CN;EkBn5CM;IACE,SAAA;ElBq5CR;AACF;AgBp/CI;EEoFA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;IACA,4CAAA;ElBk6CN;EkB/5CM;IACE,SAAA;ElBi6CR;AACF;AkB56CI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;EACA,4CAAA;AlB66CR;AkB16CQ;EACE,SAAA;AlB46CV;;AkBr6CA;;EAEE,sBAAA;AlBw6CF;;AoBllDA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;EACA,ehBUe;EgBTf,gBfiOiB;EehOjB,cfKS;EeJT,sBfHM;EeIN,4BAAA;EACA,yBAAA;EAKE,sBfwLY;EO1MZ,gDQwBF;ECrBI,wEDsBJ;ApB4kDF;AoBzkDE;EACE,6BAAA;EACA,SAAA;ApB2kDJ;AsB9lDE;EACE,cjBGO;EiBFP,sBjBLI;EiBMJ,kCjB6XuB;EiB5XvB,UAAA;EAGE,sFAAA;AtB8lDN;AoB3kDE;EACE,cfxBO;Ee0BP,UAAA;ApB4kDJ;AoBpkDE;EAEE,yBfxCO;Ee0CP,UAAA;ApBokDJ;;AoB/jDE;EACE,2Bf2VW;ALuuCf;AoB/jDE;EAME,cfpDO;EeqDP,sBf5DI;ALwnDR;;AoBvjDA;;EAEE,cAAA;EACA,WAAA;ApB0jDF;;AoBjjDA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBfgJiB;ALo6CnB;;AoBjjDA;EACE,+BAAA;EACA,kCAAA;EACA,ehB7Ea;EgB8Eb,gBfmGe;ALi9CjB;;AoBjjDA;EACE,gCAAA;EACA,mCAAA;EACA,ehBrFe;EgBsFf,gBf6Fe;ALu9CjB;;AoB5iDA;EACE,cAAA;EACA,WAAA;EACA,qBfuMoB;EetMpB,wBfsMoB;EerMpB,gBAAA;EACA,gBfoHiB;EenHjB,6BAAA;EACA,yBAAA;EACA,mBAAA;ApB+iDF;AoB7iDE;;;;;;;;;EAEE,gBAAA;EACA,eAAA;ApBsjDJ;;AoB1iDA;;;;;EACE,uBAAA;EACA,ehB1He;EgB2Hf,gBfwDe;EMnMb,qBN0Me;ALm/CnB;;AoB7iDE;;;;;EACE,6BfqQc;AL+yClB;;AoBhjDA;;;;;EACE,oBAAA;EACA,ehBtIa;EgBuIb,gBf0Ce;EMlMb,qBNyMe;ALugDnB;;AoBnjDE;;;;;EACE,4Bf2Pc;AL+zClB;;AoBjjDA;EACE,mBf8PyB;ALszC3B;;AoBjjDA;EACE,cAAA;EACA,mBfgPqB;ALo0CvB;;AoB7iDA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;ApBgjDF;AoB9iDE;;EAEE,kBAAA;EACA,iBAAA;ApBgjDJ;;AoBxiDA;EACE,kBAAA;EACA,cAAA;EACA,qBfuNwB;ALo1C1B;;AoBxiDA;EACE,kBAAA;EACA,kBfmN0B;EelN1B,qBAAA;ApB2iDF;AoBziDE;EACE,cfrMO;ALgvDX;;AoBviDA;EACE,gBAAA;ApB0iDF;;AoBviDA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBfsM2B;ALo2C7B;AoBviDE;EACE,gBAAA;EACA,aAAA;EACA,uBfiM+B;EehM/B,cAAA;ApByiDJ;;AsBrvDE;EACE,aAAA;EACA,WAAA;EACA,mBjBkYmB;EiBjYnB,cjByOc;EiBxOd,cjB+dwB;ALyxC5B;;AsBrvDE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,wCAAA;EACA,qBAAA;AtBwvDJ;;AsBnvDI;;;EAEE,qBjBycsB;AL8yC5B;AsBrvDM;;;EACE,qBjBscoB;EiBrcpB,gDAAA;AtByvDR;AsBtvDM;;;;;;;EAEE,cAAA;AtB6vDR;;AsBrvDM;EACE,cjBuboB;ALi0C5B;AsBrvDM;;;EAEE,cAAA;AtBwvDR;;AsBhvDM;EACE,cjByaoB;AL00C5B;AsBjvDQ;EACE,0DAAA;AtBmvDV;AsB/uDM;;;EAEE,cAAA;AtBkvDR;AsB9uDQ;EC9FJ,wDD+F2B;AtBgvD/B;AsB3uDQ;EACE,gEAAA;AtB6uDV;;AsBnuDM;EACE,qBjB0YoB;AL41C5B;AsBpuDQ;EACE,qBAAA;AtBsuDV;AsBluDM;;;EAEE,cAAA;AtBquDR;AsBjuDQ;EACE,gDAAA;AtBmuDV;;AsB30DE;EACE,aAAA;EACA,WAAA;EACA,mBjBkYmB;EiBjYnB,cjByOc;EiBxOd,cjBge0B;AL82C9B;;AsB30DE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,wCAAA;EACA,qBAAA;AtB80DJ;;AsBz0DI;;;EAEE,qBjB0cwB;ALm4C9B;AsB30DM;;;EACE,qBjBucsB;EiBtctB,gDAAA;AtB+0DR;AsB50DM;;;;;;;EAEE,cAAA;AtBm1DR;;AsB30DM;EACE,cjBwbsB;ALs5C9B;AsB30DM;;;EAEE,cAAA;AtB80DR;;AsBt0DM;EACE,cjB0asB;AL+5C9B;AsBv0DQ;EACE,qEAAA;AtBy0DV;AsBr0DM;;;EAEE,cAAA;AtBw0DR;AsBp0DQ;EC9FJ,oED+F2B;AtBs0D/B;AsBj0DQ;EACE,gEAAA;AtBm0DV;;AsBzzDM;EACE,qBjB2YsB;ALi7C9B;AsB1zDQ;EACE,qBAAA;AtB4zDV;AsBxzDM;;;EAEE,cAAA;AtB2zDR;AsBvzDQ;EACE,gDAAA;AtByzDV;;AoB9rDA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;ApBisDF;AoB5rDE;EACE,WAAA;ApB8rDJ;AgB14DI;EIiNA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;EpB4rDJ;EoBxrDE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;EpB0rDJ;EoBtrDE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;EpBwrDJ;EoBprDE;IACE,qBAAA;EpBsrDJ;EoBnrDE;IACE,WAAA;EpBqrDJ;EoBhrDE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;EpBkrDJ;EoBhrDE;IACE,kBAAA;IACA,aAAA;IACA,qBf4GsB;Ie3GtB,cAAA;EpBkrDJ;EoB/qDE;IACE,mBAAA;IACA,uBAAA;EpBirDJ;EoB/qDE;IACE,gBAAA;EpBirDJ;AACF;;AwB9+DA;EACE,qBAAA;EACA,gBnBgOmB;EmB/NnB,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,6BAAA;ECsFA,yBAAA;EACA,erBhFe;EqBiFf,gBrBgDgB;EqB7Cd,sBpBoGY;EgBvMV,qIGUJ;AxBo/DF;AM/+DE;EkBDE,qBAAA;AxBm/DJ;AwBh/DE;EAEE,UAAA;EACA,gDnBySyB;ALwsD7B;AwB7+DE;EAEE,anBqUmB;EOlWnB,gBY8BA;AxB8+DJ;AwB1+DE;EACE,eAAA;AxB4+DJ;AwBz+DE;EAEE,sBAAA;EZxCA,gDYyCA;AxB0+DJ;AwBx+DI;EZ3CA,sFY4CE;AxB0+DN;;AwBp+DA;;EAEE,oBAAA;AxBu+DF;;AwB/9DE;ECxDA,WAAA;EFAE,yBlBmEW;EoBjEb,qBpBiEa;EOvEX,mFaOF;AzB2hEF;AMthEE;EmBFE,WAAA;EFNA,mEED2D;EAS3D,+DATqG;AzBoiEzG;AyBxhEE;EAII,wHAAA;AzBuhEN;AyBhhEE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ALw+Df;AyB9gEE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;AzBijE7L;AyBzgEI;EAGI,qFAAA;AzBygER;;AwB3/DE;ECxDA,WAAA;EFAE,yBlBmEW;EoBjEb,qBpBiEa;EOvEX,mFaOF;AzBujEF;AMljEE;EmBFE,WAAA;EFNA,mEED2D;EAS3D,+DATqG;AzBgkEzG;AyBpjEE;EAII,wHAAA;AzBmjEN;AyB5iEE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ALogEf;AyB1iEE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;AzB6kE7L;AyBriEI;EAGI,qFAAA;AzBqiER;;AwBvhEE;ECxDA,WAAA;EFAE,yBlBmEW;EoBjEb,qBpBiEa;EOvEX,mFaOF;AzBmlEF;AM9kEE;EmBFE,WAAA;EFNA,mEED2D;EAS3D,+DATqG;AzB4lEzG;AyBhlEE;EAII,wHAAA;AzB+kEN;AyBxkEE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ALgiEf;AyBtkEE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;AzBymE7L;AyBjkEI;EAGI,qFAAA;AzBikER;;AwBnjEE;ECxDA,WAAA;EFAE,yBlBmEW;EoBjEb,qBpBiEa;EOvEX,mFaOF;AzB+mEF;AM1mEE;EmBFE,WAAA;EFNA,gDED2D;EAS3D,yCATqG;AzBwnEzG;AyB5mEE;EAII,wHAAA;AzB2mEN;AyBpmEE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AL4jEf;AyBlmEE;EAGE,WAAA;EACA,6CAlC+I;EAsC/I,4CAtCyL;AzBqoE7L;AyB7lEI;EAGI,qFAAA;AzB6lER;;AwB/kEE;ECxDA,cAAA;EFAE,yBlBmEW;EoBjEb,qBpBiEa;EOvEX,mFaOF;AzB2oEF;AMtoEE;EmBFE,WAAA;EFNA,uCED2D;EAS3D,gCATqG;AzBopEzG;AyBxoEE;EAII,wHAAA;AzBuoEN;AyBhoEE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ALwlEf;AyB9nEE;EAGE,WAAA;EACA,oCAlC+I;EAsC/I,iCAtCyL;AzBiqE7L;AyBznEI;EAGI,qFAAA;AzBynER;;AwB3mEE;ECxDA,WAAA;EFAE,yBlBmEW;EoBjEb,qBpBiEa;EOvEX,mFaOF;AzBuqEF;AMlqEE;EmBFE,WAAA;EFNA,mEED2D;EAS3D,+DATqG;AzBgrEzG;AyBpqEE;EAII,wHAAA;AzBmqEN;AyB5pEE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ALonEf;AyB1pEE;EAGE,WAAA;EACA,mEAlC+I;EAsC/I,+DAtCyL;AzB6rE7L;AyBrpEI;EAGI,qFAAA;AzBqpER;;AwBvoEE;ECxDA,cAAA;EFAE,yBlBmEW;EoBjEb,qBpBiEa;EOvEX,mFaOF;AzBmsEF;AM9rEE;EmBFE,cAAA;EFNA,4DED2D;EAS3D,kDATqG;AzB4sEzG;AyBhsEE;EAII,0HAAA;AzB+rEN;AyBxrEE;EAEE,cAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;ALgpEf;AyBtrEE;EAGE,cAAA;EACA,sDAlC+I;EAsC/I,wDAtCyL;AzBytE7L;AyBjrEI;EAGI,uFAAA;AzBirER;;AwBnqEE;ECxDA,WAAA;EFAE,yBlBmEW;EoBjEb,qBpBiEa;EOvEX,mFaOF;AzB+tEF;AM1tEE;EmBFE,WAAA;EFNA,2DED2D;EAS3D,qDATqG;AzBwuEzG;AyB5tEE;EAII,uHAAA;AzB2tEN;AyBptEE;EAEE,WAAA;EACA,yBpB0CW;EoBzCX,qBpByCW;AL4qEf;AyBltEE;EAGE,WAAA;EACA,yDAlC+I;EAsC/I,uDAtCyL;AzBqvE7L;AyB7sEI;EAGI,oFAAA;AzB6sER;;AwBzrEE;ECXA,cpBgBa;EoBfb,6BAAA;EACA,sBAAA;EACA,qBpBaa;AL2rEf;AyBtsEE;EACE,WAPgD;EAQhD,yBpBSW;EoBRX,qBpBQW;ALgsEf;AyBrsEE;EAEE,+CAAA;AzBssEJ;AyBnsEE;EAEE,cpBFW;EoBGX,6BAAA;AzBosEJ;AyBjsEE;EAGE,WAAA;EACA,yBpBVW;EoBWX,qBpBXW;AL4sEf;AyB/rEI;EAGI,qFAAA;AzB+rER;;AwBptEE;ECXA,cpBgBa;EoBfb,6BAAA;EACA,sBAAA;EACA,qBpBaa;ALstEf;AyBjuEE;EACE,WAPgD;EAQhD,yBpBSW;EoBRX,qBpBQW;AL2tEf;AyBhuEE;EAEE,+CAAA;AzBiuEJ;AyB9tEE;EAEE,cpBFW;EoBGX,6BAAA;AzB+tEJ;AyB5tEE;EAGE,WAAA;EACA,yBpBVW;EoBWX,qBpBXW;ALuuEf;AyB1tEI;EAGI,qFAAA;AzB0tER;;AwB/uEE;ECXA,cpBgBa;EoBfb,6BAAA;EACA,sBAAA;EACA,qBpBaa;ALivEf;AyB5vEE;EACE,WAPgD;EAQhD,yBpBSW;EoBRX,qBpBQW;ALsvEf;AyB3vEE;EAEE,+CAAA;AzB4vEJ;AyBzvEE;EAEE,cpBFW;EoBGX,6BAAA;AzB0vEJ;AyBvvEE;EAGE,WAAA;EACA,yBpBVW;EoBWX,qBpBXW;ALkwEf;AyBrvEI;EAGI,qFAAA;AzBqvER;;AwB1wEE;ECXA,cpBgBa;EoBfb,6BAAA;EACA,sBAAA;EACA,qBpBaa;AL4wEf;AyBvxEE;EACE,WAPgD;EAQhD,yBpBSW;EoBRX,qBpBQW;ALixEf;AyBtxEE;EAEE,+CAAA;AzBuxEJ;AyBpxEE;EAEE,cpBFW;EoBGX,6BAAA;AzBqxEJ;AyBlxEE;EAGE,WAAA;EACA,yBpBVW;EoBWX,qBpBXW;AL6xEf;AyBhxEI;EAGI,qFAAA;AzBgxER;;AwBryEE;ECXA,cpBgBa;EoBfb,6BAAA;EACA,sBAAA;EACA,qBpBaa;ALuyEf;AyBlzEE;EACE,cAPgD;EAQhD,yBpBSW;EoBRX,qBpBQW;AL4yEf;AyBjzEE;EAEE,+CAAA;AzBkzEJ;AyB/yEE;EAEE,cpBFW;EoBGX,6BAAA;AzBgzEJ;AyB7yEE;EAGE,cAAA;EACA,yBpBVW;EoBWX,qBpBXW;ALwzEf;AyB3yEI;EAGI,qFAAA;AzB2yER;;AwBh0EE;ECXA,cpBgBa;EoBfb,6BAAA;EACA,sBAAA;EACA,qBpBaa;ALk0Ef;AyB70EE;EACE,WAPgD;EAQhD,yBpBSW;EoBRX,qBpBQW;ALu0Ef;AyB50EE;EAEE,+CAAA;AzB60EJ;AyB10EE;EAEE,cpBFW;EoBGX,6BAAA;AzB20EJ;AyBx0EE;EAGE,WAAA;EACA,yBpBVW;EoBWX,qBpBXW;ALm1Ef;AyBt0EI;EAGI,qFAAA;AzBs0ER;;AwB31EE;ECXA,cpBgBa;EoBfb,6BAAA;EACA,sBAAA;EACA,qBpBaa;AL61Ef;AyBx2EE;EACE,cAPgD;EAQhD,yBpBSW;EoBRX,qBpBQW;ALk2Ef;AyBv2EE;EAEE,iDAAA;AzBw2EJ;AyBr2EE;EAEE,cpBFW;EoBGX,6BAAA;AzBs2EJ;AyBn2EE;EAGE,cAAA;EACA,yBpBVW;EoBWX,qBpBXW;AL82Ef;AyBj2EI;EAGI,uFAAA;AzBi2ER;;AwBt3EE;ECXA,cpBgBa;EoBfb,6BAAA;EACA,sBAAA;EACA,qBpBaa;ALw3Ef;AyBn4EE;EACE,WAPgD;EAQhD,yBpBSW;EoBRX,qBpBQW;AL63Ef;AyBl4EE;EAEE,8CAAA;AzBm4EJ;AyBh4EE;EAEE,cpBFW;EoBGX,6BAAA;AzBi4EJ;AyB93EE;EAGE,WAAA;EACA,yBpBVW;EoBWX,qBpBXW;ALy4Ef;AyB53EI;EAGI,oFAAA;AzB43ER;;AwBv4EA;EACE,gBnByJmB;EmBxJnB,cpBtBY;EoBuBZ,6BAAA;AxB04EF;AM78EE;EkBsEE,wDpBCe;EoBAf,0BnBiEoB;EmBhEpB,6BAAA;EACA,yBAAA;AxB04EJ;AwBv4EE;EAEE,0BnB0DoB;EmBzDpB,yBAAA;EACA,gBAAA;AxBw4EJ;AwBr4EE;EAEE,cnBnFO;ALy9EX;;AwB53EA;ECVE,oBAAA;EACA,erB/Ea;EqBgFb,gBpBiGe;EoB9Fb,qBpBqGe;ALmyEnB;;AwB/3EA;ECdE,uBAAA;EACA,erBhFe;EqBiFf,gBpBkGe;EoB/Fb,qBpBsGe;ALyyEnB;;AwB93EA;EACE,cAAA;EACA,WAAA;AxBi4EF;AwB93EE;EACE,kBnB0OkB;ALspEtB;;AwBx3EE;;;EACE,WAAA;AxB63EJ;;A0BngFA;EACE,UAAA;ELEI,gCKDJ;A1BsgFF;A0BpgFE;EACE,UAAA;A1BsgFJ;;A0BlgFA;EACE,aAAA;A1BqgFF;A0BpgFE;EACE,cAAA;A1BsgFJ;;A0BjgFE;EACE,kBAAA;A1BogFJ;;A0B//EE;EACE,wBAAA;A1BkgFJ;;A0B9/EA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;EL5BI,6BK6BJ;A1BigFF;;A2BliFA;;EAEE,kBAAA;A3BqiFF;;A4B5gFI;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EAjCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;A5BijFF;A4Bz/EI;EACE,cAAA;A5B2/EN;;A2B5iFA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,atBohBgB;EsBnhBhB,aAAA;EACA,WAAA;EACA,gBtBofmB;EsBnfnB,iBAAA;EACA,oBAAA;EACA,evBFe;EuBGf,cvBwEW;EuBvEX,gBAAA;EACA,gBAAA;EACA,sBtBhBM;EsBiBN,4BAAA;EACA,qCAAA;EhBxBE,sBNwMY;EO1MZ,8Ce4BF;A3B+iFF;;A2BziFE;EACE,aAAA;EACA,uBtBmec;ALykElB;A4BtjFI;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EA1BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;A5BmlFF;A4BliFI;EACE,cAAA;A5BoiFN;;A2BljFE;EACE,aAAA;EACA,qBtBwdc;AL6lElB;A4B1kFI;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EAnBJ,mCAAA;EACA,sCAAA;EACA,wBAAA;A5BgmFF;A4BrjFI;EACE,cAAA;A5BujFN;A2B9jFI;EACE,iBAAA;A3BgkFN;;A2B1jFE;EACE,aAAA;EACA,sBtB0cc;ALmnElB;A4BhmFI;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;A5BkmFN;A4BvlFM;EACE,aAAA;A5BylFR;A4BtlFM;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;EACA,uBAAA;EACA,WAAA;EAlCN,mCAAA;EACA,yBAAA;EACA,sCAAA;A5B2nFF;A4BtlFI;EACE,cAAA;A5BwlFN;A2BjlFI;EACE,iBAAA;A3BmlFN;;A2B7kFA;EEtEE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;A7BupFF;;A2B7kFA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gBtBiJmB;EsBhJnB,ctBrES;EsBsET,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;A3BglFF;AMxpFE;EqB2EE,+CtBmbwB;EsBlbxB,qBAAA;EJ1FA,yBlBKO;ALsqFX;A2B7kFE;EAEE,WtB5FI;EsB6FJ,qBAAA;EJjGA,yBlB2MkB;ALq+EtB;A2B3kFE;EAEE,ctB7FO;EsB8FP,6BAAA;A3B4kFJ;;A2BpkFA;EACE,cAAA;A3BukFF;;A2BnkFA;EACE,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,evB3Ge;EuB4Gf,ctBhHS;EsBiHT,mBAAA;A3BskFF;;A8BpsFA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A9BusFF;A8BrsFE;;EACE,kBAAA;EACA,cAAA;A9BwsFJ;AMrsFE;;EwBEI,UAAA;A9BusFN;A8BrsFI;;;;EAGE,UAAA;A9BwsFN;A8BnsFE;;;;;;;;EAIE,iBAAA;A9BysFJ;;A8BpsFA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A9BusFF;A8BrsFE;EACE,WAAA;A9BusFJ;;A8BlsFE;EACE,cAAA;A9BqsFJ;A8BjsFE;;EnBlCE,0BmBoC6B;EnBnC7B,6BmBmC6B;A9BosFjC;A8BjsFE;;EnBzBE,yBmB2B4B;EnB1B5B,4BmB0B4B;A9BosFhC;;A8BhrFA;EACE,wBAAA;EACA,uBAAA;A9BmrFF;A8BjrFE;EACE,cAAA;A9BmrFJ;;A8B/qFA;EACE,uBAAA;EACA,sBAAA;A9BkrFF;;A8B/qFA;EACE,sBAAA;EACA,qBAAA;A9BkrFF;;A8B7qFA;ElBjGI,gDkBkGF;A9BgrFF;A8B7qFE;ElBrGE,gBkBsGA;A9B+qFJ;;A8BvqFA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A9B0qFF;A8BxqFE;;EAEE,WAAA;A9B0qFJ;A8BvqFE;;;;EAIE,gBAAA;EACA,cAAA;A9ByqFJ;A8BrqFE;;EnB3GE,6BmB6G8B;EnB5G9B,4BmB4G8B;A9BwqFlC;A8BrqFE;;EnB9HE,yBmBgI2B;EnB/H3B,0BmB+H2B;A9BwqF/B;;A8BvpFE;;EAEE,gBAAA;A9B0pFJ;A8BxpFI;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;A9B4pFN;;A+BzzFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A/B4zFF;A+B1zFE;;;EAGE,kBAAA;EACA,cAAA;EAGA,SAAA;EACA,gBAAA;A/B0zFJ;A+BvzFI;;;EACE,UAAA;A/B2zFN;A+BxzFI;;;;;;;;;EAGE,iBAAA;A/Bg0FN;A+B1zFI;;EpBpBA,0BoBqB+B;EpBpB/B,6BoBoB+B;A/B8zFnC;A+B5zFI;;EpBTA,yBoBU8B;EpBT9B,4BoBS8B;A/Bg0FlC;A+B1zFE;EACE,aAAA;EACA,mBAAA;A/B4zFJ;A+B1zFI;EpBlCA,0BoBoC+B;EpBnC/B,6BoBmC+B;A/B4zFnC;A+B1zFI;EpBxBA,yBoB0B8B;EpBzB9B,4BoByB8B;A/B4zFlC;;A+BjzFA;;EAEE,aAAA;A/BozFF;A+B/yFE;;EACE,kBAAA;EACA,UAAA;A/BkzFJ;A+B/yFE;;;;;;;;EAIE,iBAAA;A/BqzFJ;;A+BjzFA;EACE,kBAAA;A/BozFF;;A+BjzFA;EACE,iBAAA;A/BozFF;;A+B5yFA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,e3BtFe;E2BuFf,gB1B6HmB;E0B5HnB,gB1BgIiB;E0B/HjB,c1B5FS;E0B6FT,kBAAA;EACA,mBAAA;EACA,yB1BpGS;E0BqGT,yBAAA;EpB7GE,sBNwMY;ALqtFhB;A+B5yFE;;EAEE,aAAA;A/B8yFJ;;A+B/wFA;;;;;;EpBrII,0BoB2I2B;EpB1I3B,6BoB0I2B;A/BmxF/B;;A+BhxFA;;;;;;EpBhII,yBoBsI0B;EpBrI1B,4BoBqI0B;A/BoxF9B;;AgCj7FA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,oB3BoasB;ALghFxB;;AgCj7FA;EACE,oBAAA;EACA,kB3BgawB;ALohF1B;;AgCj7FA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AhCo7FF;AgCl7FE;EACE,W3BhBI;EkBJJ,yBlB2MkB;EO/MlB,gBoB0BA;AhCo7FJ;AgCj7FE;EAEE,gE3B+ZwC;ALmhF5C;AgC/6FE;EACE,W3B3BI;E2B4BJ,wC3B6ZiC;EOjcjC,gBoBqCA;AhCi7FJ;AgC76FI;EACE,c3B5BK;AL28FX;AgC76FM;EACE,yB3BnCG;ALk9FX;;AgCr6FA;EACE,gBAAA;AhCw6FF;AgCr6FE;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,cAAA;EACA,W3BiX4B;E2BhX5B,Y3BgX4B;E2B/W5B,oBAAA;EACA,WAAA;EACA,iBAAA;EACA,yB3B1DO;EOXP,sDoBsEA;AhCu6FJ;AgCn6FE;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,cAAA;EACA,W3BkW4B;E2BjW5B,Y3BiW4B;E2BhW5B,WAAA;EACA,4BAAA;EACA,kCAAA;EACA,wB3B+V+B;ALskFnC;;AgC55FE;ErB3FE,sBNwMY;ALmzFhB;AgC35FI;ET9FA,yBlB2MkB;ALizFtB;AgC35FI;EACE,yD3B+VmC;AL8jFzC;AgCx5FI;ETvGA,yBlB2MkB;EO/MlB,gBoB6GE;AhC05FN;AgCx5FI;EACE,yD3ByVyC;ALikF/C;AgCr5FI;EACE,wC3BqUyC;ALklF/C;AgCr5FI;EACE,wC3BkUyC;ALqlF/C;;AgC74FE;EACE,kB3BwUmC;ALwkFvC;AgC54FI;ETpIA,yBlB2MkB;ALw0FtB;AgC54FI;EACE,yD3BiUgC;AL6kFtC;AgCz4FI;EACE,wC3BySyC;ALkmF/C;;AgCh4FA;EACE,qBAAA;EACA,WAAA;EACA,2B3BqPa;E2BpPb,0CAAA;EACA,gB3BwEiB;E2BvEjB,c3BpJS;E2BqJT,sBAAA;EACA,uFAAA;EACA,yB3BkTsB;E2BjTtB,yBAAA;EAEE,sB3BiCY;E2B7Bd,gBAAA;AhC+3FF;AgC73FE;EACE,kC3B2NuB;E2B1NvB,UAAA;EACA,oF3B8S6B;ALilFjC;AgC73FI;EAME,c3B3KK;E2B4KL,sB3BnLE;AL6iGR;AgCt3FE;EAEE,YAAA;EACA,sB3B8QsB;E2B7QtB,sBAAA;AhCu3FJ;AgCp3FE;EACE,c3BzLO;E2B0LP,yB3B9LO;ALojGX;AgCl3FE;EACE,UAAA;AhCo3FJ;;AgCh3FA;EACE,6B3BsMgB;E2BrMhB,qB3B4PwB;E2B3PxB,wB3B2PwB;E2B1PxB,c3B6Q2B;ALsmF7B;;AgCh3FA;EACE,4B3BkMgB;E2BjMhB,qB3BqPwB;E2BpPxB,wB3BoPwB;E2BnPxB,e3ByQ2B;AL0mF7B;;AgC52FA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,2B3B8Ka;E2B7Kb,gBAAA;AhC+2FF;;AgC52FA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,2B3BsKa;E2BrKb,SAAA;EACA,UAAA;AhC+2FF;AgC72FE;EACE,kC3BuJuB;E2BtJvB,gD3B2EyB;ALoyF7B;AgC72FI;EACE,kC3BmJqB;AL4tF3B;AgC12FI;EACE,iB3ByPa;ALmnFnB;;AgCv2FA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,2B3B4Ia;E2B3Ib,yBAAA;EACA,gB3BjCiB;E2BkCjB,c3B7PS;E2B8PT,sB3BrQM;E2BsQN,yBAAA;ErB5QE,sBNwMY;EO1MZ,gDoBgRF;AhC02FF;AgCx2FE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,2CAAA;EACA,yBAAA;EACA,gB3BjDe;E2BkDf,c3B7QO;E2B8QP,iBAAA;ETzRA,yBlBMO;E2BqRP,8BAAA;ErB7RA,kCqB8RuB;AhC02F3B;;AiCvoGA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AjC0oGF;;AiCvoGA;EACE,cAAA;EACA,oBAAA;AjC0oGF;AMroGE;E2BFE,qBAAA;AjC0oGJ;AiCtoGE;EACE,c5BPO;AL+oGX;;AiChoGA;EACE,gCAAA;AjCmoGF;AiCjoGE;EACE,mBAAA;AjCmoGJ;AiChoGE;EACE,6BAAA;EtB7BA,+BNkMY;EMjMZ,gCNiMY;AL+9FhB;AMvpGE;E2BuBI,qC5B0gB6B;ALynFnC;AiChoGI;EACE,c5B/BK;E4BgCL,6BAAA;EACA,yBAAA;AjCkoGN;AiC9nGE;;EAEE,c5BtCO;E4BuCP,sB5B9CI;E4B+CJ,kC5B+fgC;ALioFpC;AiC7nGE;EAEE,gBAAA;EtBpDA,yBsBsD2B;EtBrD3B,0BsBqD2B;AjC8nG/B;;AiCrnGE;EtBrEE,sBNwMY;ALs/FhB;AiCrnGE;;EAEE,W5BrEI;E4BsEJ,yB5BiIkB;ALs/FtB;;AiC9mGE;EACE,cAAA;EACA,kBAAA;AjCinGJ;;AiC5mGE;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AjC+mGJ;;AiCtmGE;EACE,aAAA;AjCymGJ;AiCvmGE;EACE,cAAA;AjCymGJ;;AkCzsGA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AlC4sGF;AkCxsGE;;EAEE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AlC0sGJ;;AkClsGA;EACE,qBAAA;EACA,sB7BgiBuB;E6B/hBvB,yB7B+hBuB;E6B9hBvB,kB7BwEO;E6BvEP,kB7BwLa;E6BvLb,oBAAA;EACA,mBAAA;AlCqsGF;AM/tGE;E4B6BE,qBAAA;AlCqsGJ;;AkC7rGA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AlCgsGF;AkC9rGE;EACE,gBAAA;EACA,eAAA;AlCgsGJ;AkC7rGE;EACE,gBAAA;EACA,WAAA;AlC+rGJ;;AkCvrGA;EACE,qBAAA;EACA,mB7B6dmB;E6B5dnB,sB7B4dmB;AL8tFrB;;AkC/qGA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AlCgrGF;;AkC5qGA;EACE,wBAAA;EACA,kB7B4Ha;E6B3Hb,cAAA;EACA,6BAAA;EACA,6BAAA;EvBvGE,sBNwMY;AL+kGhB;AMvwGE;E4B2FE,qBAAA;AlC+qGJ;AkC3qGE;EACE,eAAA;AlC6qGJ;;AkCvqGA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;EACA,0BAAA;AlC0qGF;;AgBluGI;EkBoEI;;IAEE,gBAAA;IACA,eAAA;ElCkqGR;AACF;AgBvvGI;EkB+EA;IAUI,qBAAA;IACA,2BAAA;ElCkqGN;EkChqGM;IACE,mBAAA;ElCkqGR;EkChqGQ;IACE,kBAAA;ElCkqGV;EkC/pGQ;IACE,QAAA;IACA,UAAA;ElCiqGV;EkC9pGQ;IACE,qB7B8ZgB;I6B7ZhB,oB7B6ZgB;ELmwF1B;EkC3pGM;;IAEE,iBAAA;ElC6pGR;EkC1pGM;IACE,wBAAA;IAGA,gBAAA;ElC0pGR;EkCvpGM;IACE,aAAA;ElCypGR;EkCrpGQ;IACE,SAAA;IACA,YAAA;ElCupGV;AACF;AgB7wGI;EkBoEI;;IAEE,gBAAA;IACA,eAAA;ElC4sGR;AACF;AgBjyGI;EkB+EA;IAUI,qBAAA;IACA,2BAAA;ElC4sGN;EkC1sGM;IACE,mBAAA;ElC4sGR;EkC1sGQ;IACE,kBAAA;ElC4sGV;EkCzsGQ;IACE,QAAA;IACA,UAAA;ElC2sGV;EkCxsGQ;IACE,qB7B8ZgB;I6B7ZhB,oB7B6ZgB;EL6yF1B;EkCrsGM;;IAEE,iBAAA;ElCusGR;EkCpsGM;IACE,wBAAA;IAGA,gBAAA;ElCosGR;EkCjsGM;IACE,aAAA;ElCmsGR;EkC/rGQ;IACE,SAAA;IACA,YAAA;ElCisGV;AACF;AgBvzGI;EkBoEI;;IAEE,gBAAA;IACA,eAAA;ElCsvGR;AACF;AgB30GI;EkB+EA;IAUI,qBAAA;IACA,2BAAA;ElCsvGN;EkCpvGM;IACE,mBAAA;ElCsvGR;EkCpvGQ;IACE,kBAAA;ElCsvGV;EkCnvGQ;IACE,QAAA;IACA,UAAA;ElCqvGV;EkClvGQ;IACE,qB7B8ZgB;I6B7ZhB,oB7B6ZgB;ELu1F1B;EkC/uGM;;IAEE,iBAAA;ElCivGR;EkC9uGM;IACE,wBAAA;IAGA,gBAAA;ElC8uGR;EkC3uGM;IACE,aAAA;ElC6uGR;EkCzuGQ;IACE,SAAA;IACA,YAAA;ElC2uGV;AACF;AgBj2GI;EkBoEI;;IAEE,gBAAA;IACA,eAAA;ElCgyGR;AACF;AgBr3GI;EkB+EA;IAUI,qBAAA;IACA,2BAAA;ElCgyGN;EkC9xGM;IACE,mBAAA;ElCgyGR;EkC9xGQ;IACE,kBAAA;ElCgyGV;EkC7xGQ;IACE,QAAA;IACA,UAAA;ElC+xGV;EkC5xGQ;IACE,qB7B8ZgB;I6B7ZhB,oB7B6ZgB;ELi4F1B;EkCzxGM;;IAEE,iBAAA;ElC2xGR;EkCxxGM;IACE,wBAAA;IAGA,gBAAA;ElCwxGR;EkCrxGM;IACE,aAAA;ElCuxGR;EkCnxGQ;IACE,SAAA;IACA,YAAA;ElCqxGV;AACF;AkCz0GI;EAUI,qBAAA;EACA,2BAAA;AlCk0GR;AkC30GQ;;EAEE,gBAAA;EACA,eAAA;AlC60GV;AkCr0GQ;EACE,mBAAA;AlCu0GV;AkCr0GU;EACE,kBAAA;AlCu0GZ;AkCp0GU;EACE,QAAA;EACA,UAAA;AlCs0GZ;AkCn0GU;EACE,qB7B8ZgB;E6B7ZhB,oB7B6ZgB;ALw6F5B;AkCh0GQ;;EAEE,iBAAA;AlCk0GV;AkC/zGQ;EACE,wBAAA;EAGA,gBAAA;AlC+zGV;AkC5zGQ;EACE,aAAA;AlC8zGV;AkC1zGU;EACE,SAAA;EACA,YAAA;AlC4zGZ;;AkC9yGE;EACE,yB7B4YwB;ALq6F5B;AM1+GE;E4B4LI,yB7ByYsB;ALw6F5B;AkC5yGI;EACE,yB7BiYe;AL66FrB;AMh/GE;E4BqMM,yB7B+XmB;AL+6F3B;AkC3yGM;EACE,yB7B6XsB;ALg7F9B;AkCzyGI;;;;EAIE,yB7BoXsB;ALu7F5B;AkCvyGE;EACE,yB7B6WiB;E6B5WjB,gC7BiXgC;ALw7FpC;AkCtyGE;EACE,yD7B4W2B;AL47F/B;AkCryGE;EACE,yB7BoWiB;ALm8FrB;AkCtyGI;EACE,yB7BoWsB;ALo8F5B;AMzgHE;E4BoOM,yB7BiWoB;ALu8F5B;;AkChyGE;EACE,W7BvPI;AL0hHR;AMhhHE;E4BgPI,W7B1PE;AL6hHR;AkC9xGI;EACE,+B7BsUc;AL09FpB;AMthHE;E4ByPM,gC7BoUkB;AL49F1B;AkC7xGM;EACE,gC7BkUqB;AL69F7B;AkC3xGI;;;;EAIE,W7B/QE;AL4iHR;AkCzxGE;EACE,+B7BkTgB;E6BjThB,sC7BsT+B;ALq+FnC;AkCxxGE;EACE,yD7BiT0B;ALy+F9B;AkCvxGE;EACE,+B7BySgB;ALg/FpB;AkCxxGI;EACE,W7B/RE;ALyjHR;AM/iHE;E4BwRM,W7BlSA;AL4jHR;;AmClkHA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,2BAAA;EACA,yBAAA;ExBRE,kBPoCe;AJ0iHnB;AmCnkHE;EACE,eAAA;EACA,cAAA;AnCqkHJ;AmCjkHI;ExBXA,2BP8Be;EO7Bf,4BP6Be;AJkjHnB;AmC/jHI;ExBHA,+BPgBe;EOff,8BPee;AJsjHnB;;AmC7jHA;EAGE,cAAA;EACA,a/BSc;AJqjHhB;;AmC3jHA;EACE,mB/BIc;AJ0jHhB;;AmC3jHA;EACE,iBAAA;EACA,gBAAA;AnC8jHF;;AmC3jHA;EACE,gBAAA;AnC8jHF;;AMlmHE;E6ByCE,qBAAA;AnC6jHJ;AmC1jHE;EACE,iB/BbY;AJykHhB;;AmCpjHA;EACE,kBAAA;EACA,gBAAA;EACA,qC9BkkBY;E8BjkBZ,gCAAA;AnCujHF;AmCrjHE;ExBrEE,0BwBsEuB;AnCujH3B;AmCnjHI;EACE,aAAA;AnCqjHN;;AmChjHA;EACE,kBAAA;EACA,qC9BkjBY;E8BjjBZ,6BAAA;AnCmjHF;AmCjjHE;ExBrFE,0BwBsFuB;AnCmjH3B;;AmC3iHA;EACE,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AnC8iHF;;AmC3iHA;EACE,mBAAA;EACA,kBAAA;AnC8iHF;;AmC1iHA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gB9BshByB;ALuhG3B;;AmC1iHA;EACE,WAAA;ExBrHE,kBPoCe;AJ+nHnB;;AmCziHA;EACE,WAAA;ExBrHE,2BP8Be;EO7Bf,4BP6Be;AJqoHnB;;AmC1iHA;EACE,WAAA;ExB5GE,+BPgBe;EOff,8BPee;AJ2oHnB;;AmCziHA;EACE,aAAA;EACA,sBAAA;AnC4iHF;AmC1iHE;EACE,mB9B8fgB;AL8iGpB;AgB/nHI;EmB8EJ;IASI,mBAAA;IACA,mBAAA;IACA,kBAAA;EnC4iHF;EmC1iHE;IACE,aAAA;IAEA,YAAA;IACA,sBAAA;IACA,kB9Bifc;I8Bhfd,gBAAA;IACA,iB9B+ec;EL4jGlB;AACF;;AmCniHA;EACE,aAAA;EACA,sBAAA;AnCsiHF;AmCliHE;EACE,mB9B+dgB;ALqkGpB;AgBtpHI;EmB2GJ;IAWI,mBAAA;EnCoiHF;EmCjiHE;IAEE,YAAA;IACA,gBAAA;EnCkiHJ;EmChiHI;IACE,cAAA;IACA,cAAA;EnCkiHN;EmC7hHM;IxBhLJ,0BwBiLmC;IxBhLnC,6BwBgLmC;EnCgiHrC;EmC9hHQ;;IAEE,0BAAA;EnCgiHV;EmC9hHQ;;IAEE,6BAAA;EnCgiHV;EmC5hHM;IxB/KJ,yBwBgLkC;IxB/KlC,4BwB+KkC;EnC+hHpC;EmC7hHQ;;IAEE,yBAAA;EnC+hHV;EmC7hHQ;;IAEE,4BAAA;EnC+hHV;EmC3hHM;IxBvNJ,kBPoCe;EJitHjB;EmC3hHQ;;IxBpNN,2BP8Be;IO7Bf,4BP6Be;EJstHjB;EmC5hHQ;;IxB1MN,+BPgBe;IOff,8BPee;EJ2tHjB;EmC3hHM;IxBpOJ,gBwBqO6B;EnC6hH/B;EmC3hHQ;;;;IxBvON,gBwB2O+B;EnC6hHjC;AACF;;AmCjhHE;EACE,sB9BqYY;AL+oGhB;AgBrtHI;EmB+LJ;IAMI,e9B+YiB;I8B9YjB,mB9B+Ye;ELqoGjB;EmClhHE;IACE,qBAAA;IACA,WAAA;EnCohHJ;AACF;;AoC3xHA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mB/B2yByB;E+B1yBzB,gBAAA;EACA,yB/BMS;EMRP,kBPmCY;AJ8vHhB;;AoCzxHE;EACE,qBAAA;EACA,qB/B+xBsB;E+B9xBtB,oB/B8xBsB;E+B7xBtB,cAAA;EACA,YAAA;ApC4xHJ;AoCnxHE;EACE,0BAAA;ApCqxHJ;AoClxHE;EACE,qBAAA;ApCoxHJ;AoCjxHE;EACE,c/BnBO;ALsyHX;;AqCtzHA;EACE,aAAA;E7BGA,eAAA;EACA,gBAAA;EGDE,kBPmCY;AJsxHhB;;AqCvzHA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBhC2lBuB;EgC1lBvB,chCuIW;EgCtIX,sBhCHM;EgCIN,yBAAA;ArC0zHF;AqCxzHE;EACE,0BhCoIe;EgCnIf,qBAAA;EACA,yBhCPO;EgCQP,qBhCPO;ALi0HX;AqCvzHE;EACE,UAAA;EACA,UAAA;EACA,gDhCwSyB;ALihH7B;AqCrzHE;EACE,eAAA;ArCuzHJ;;AqCjzHI;EACE,cAAA;E1BPF,2BPQY;EOPZ,8BPOY;AJqzHhB;AqCjzHI;E1B1BA,4BPsBY;EOrBZ,+BPqBY;AJyzHhB;AqChzHE;EACE,UAAA;EACA,WhCxCI;EgCyCJ,yBhC8JkB;EgC7JlB,qBhC6JkB;ALqpHtB;AqC/yHE;EACE,chCxCO;EgCyCP,oBAAA;EAEA,YAAA;EACA,sBhClDI;EgCmDJ,qBhChDO;ALg2HX;;AsC12HE;EACE,uBAAA;EACA,elCgBW;EkCfX,gBjCgMa;AL6qHjB;AsCx2HM;E3BoBF,2BPSe;EORf,8BPQe;AJ+0HnB;AsCv2HM;E3BCF,4BPuBe;EOtBf,+BPsBe;AJm1HnB;;AsCx3HE;EACE,uBAAA;EACA,elCea;EkCdb,gBjCiMa;AL0rHjB;AsCt3HM;E3BoBF,2BPOe;EONf,8BPMe;AJ+1HnB;AsCr3HM;E3BCF,4BPqBe;EOpBf,+BPoBe;AJm2HnB;;AuCp4HA;EACE,qBAAA;EACA,qBAAA;EACA,clCurBgB;EkCtrBhB,gBlCgOiB;EkC/NjB,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E5BTE,sBNwMY;ALysHhB;AuCp4HE;EACE,aAAA;AvCs4HJ;;AuCj4HA;EACE,kBAAA;EACA,SAAA;AvCo4HF;;AuC73HA;EACE,oBlCoqBqB;EkCnqBrB,mBlCmqBqB;EMjsBnB,oBNosBuB;AL2tG3B;;AuCx3HE;EC1CA,WAAA;EACA,yBnCuEa;AL+1Hf;AMp5HE;EkCdI,WAAA;EACA,qBAAA;EACA,mEAAA;AxCq6HN;;AuCl4HE;EC1CA,WAAA;EACA,yBnCuEa;ALy2Hf;AM95HE;EkCdI,WAAA;EACA,qBAAA;EACA,mEAAA;AxC+6HN;;AuC54HE;EC1CA,WAAA;EACA,yBnCuEa;ALm3Hf;AMx6HE;EkCdI,WAAA;EACA,qBAAA;EACA,mEAAA;AxCy7HN;;AuCt5HE;EC1CA,WAAA;EACA,yBnCuEa;AL63Hf;AMl7HE;EkCdI,WAAA;EACA,qBAAA;EACA,6CAAA;AxCm8HN;;AuCh6HE;EC1CA,cAAA;EACA,yBnCuEa;ALu4Hf;AM57HE;EkCdI,cAAA;EACA,qBAAA;EACA,oCAAA;AxC68HN;;AuC16HE;EC1CA,WAAA;EACA,yBnCuEa;ALi5Hf;AMt8HE;EkCdI,WAAA;EACA,qBAAA;EACA,mEAAA;AxCu9HN;;AuCp7HE;EC1CA,cAAA;EACA,yBnCuEa;AL25Hf;AMh9HE;EkCdI,cAAA;EACA,qBAAA;EACA,sDAAA;AxCi+HN;;AuC97HE;EC1CA,WAAA;EACA,yBnCuEa;ALq6Hf;AM19HE;EkCdI,WAAA;EACA,qBAAA;EACA,yDAAA;AxC2+HN;;AyCn/HA;EACE,kBAAA;EACA,mBpC2nBkB;EoC1nBlB,yBpCSS;EMRP,kBPoCe;AJk9HnB;AgB97HI;EyB5DJ;IAOI,kBAAA;EzCu/HF;AACF;;AyCp/HA;EACE,gBAAA;EACA,eAAA;E9BTE,gB8BUqB;AzCu/HzB;;A0CjgIA;EACE,kBAAA;EACA,wBAAA;EACA,mBrCuuBoB;EqCtuBpB,6BAAA;E/BJE,sBNwMY;ALi0HhB;;A0ChgIA;EAEE,cAAA;A1CkgIF;;A0C9/HA;EACE,gBrCqNiB;AL4yHnB;;A0C1/HA;EACE,mBAAA;A1C6/HF;A0C1/HE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,wBAAA;EACA,cAAA;A1C4/HJ;;A0Cn/HE;EC5CA,+BD6CqH;EnBxCnH,0CmBwCuB;EC3CzB,yCD2CqE;A1Cw/HvE;A2CjiIE;EACE,qEAAA;A3CmiIJ;A2ChiIE;EACE,uDAAA;A3CkiIJ;;A0C//HE;EC5CA,+BD6CqH;EnBxCnH,wCmBwCuB;EC3CzB,sCD2CqE;A1CogIvE;A2C7iIE;EACE,qEAAA;A3C+iIJ;A2C5iIE;EACE,sDAAA;A3C8iIJ;;A0C3gIE;EC5CA,2BD6CqH;EnBxCnH,sCmBwCuB;EC3CzB,qCD2CqE;A1CghIvE;A2CzjIE;EACE,qEAAA;A3C2jIJ;A2CxjIE;EACE,uDAAA;A3C0jIJ;;A0CvhIE;EC5CA,4BD6CqH;EnBxCnH,wCmBwCuB;EC3CzB,wCD2CqE;A1C4hIvE;A2CrkIE;EACE,qEAAA;A3CukIJ;A2CpkIE;EACE,mCAAA;A3CskIJ;;A0CniIE;EC5CA,2BD6CqH;EnBxCnH,sCmBwCuB;EC3CzB,qCD2CqE;A1CwiIvE;A2CjlIE;EACE,yCAAA;A3CmlIJ;A2ChlIE;EACE,0BAAA;A3CklIJ;;A0C/iIE;EC5CA,gCD6CqH;EnBxCnH,0CmBwCuB;EC3CzB,yCD2CqE;A1CojIvE;A2C7lIE;EACE,qEAAA;A3C+lIJ;A2C5lIE;EACE,sDAAA;A3C8lIJ;;A0C3jIE;EC5CA,kCD6CqH;EnBxCnH,0CmBwCuB;EC3CzB,yCD2CqE;A1CgkIvE;A2CzmIE;EACE,yDAAA;A3C2mIJ;A2CxmIE;EACE,wDAAA;A3C0mIJ;;A0CvkIE;EC5CA,+BD6CqH;EnBxCnH,0CmBwCuB;EC3CzB,yCD2CqE;A1C4kIvE;A2CrnIE;EACE,6DAAA;A3CunIJ;A2CpnIE;EACE,4CAAA;A3CsnIJ;;A4ChoIA;EACE;IACE,2BAAA;E5CmoIF;E4CjoIA;IACE,wBAAA;E5CmoIF;AACF;A4ChoIA;EACE,aAAA;EACA,YvC8uBgB;EuC7uBhB,gBAAA;EACA,kBvC6uBmB;EuC5uBnB,yBvCFS;EMRP,sBNwMY;EO1MZ,oDgCcF;A5CkoIF;;A4C/nIA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WvCbM;EuCcN,kBAAA;EACA,yBvCsuBgB;EgB1vBZ,2BuBqBJ;A5CkoIF;;A4C/nIA;ErBkBE,qMAAA;EqBhBA,0BAAA;A5CkoIF;;A4C/nIA;EACE,kDAAA;A5CkoIF;;A6CrqIA;EACE,aAAA;EACA,uBAAA;A7CwqIF;;A6CrqIA;EACE,OAAA;A7CwqIF;;A6CrqIA;EACE,oBAAA;A7CwqIF;;A8C9qIA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;A9C+qIF;;A8CvqIA;EACE,WAAA;EACA,czCHS;EyCIT,mBAAA;A9C0qIF;AM3qIE;EwCKE,czCRO;EyCSP,qBAAA;EACA,yBzChBO;ALyrIX;A8CtqIE;EACE,czCZO;EyCaP,yBzCpBO;AL4rIX;;A8ChqIA;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EAEA,mBAAA;EACA,sBzCpCM;EyCqCN,sCAAA;A9CkqIF;A8ChqIE;EnCvCE,2BP8Be;EO7Bf,4BP6Be;AJ6qInB;A8ChqIE;EACE,gBAAA;EnC9BA,+BPgBe;EOff,8BPee;AJkrInB;AMtsIE;EwCuCE,UAAA;EACA,qBAAA;A9CkqIJ;A8C/pIE;EAEE,czCjDO;EyCkDP,sBzCxDI;ALwtIR;A8C5pIE;EACE,UAAA;EACA,WzC9DI;EyC+DJ,yBzCwIkB;EyCvIlB,qBzCuIkB;ALuhItB;;A8CppIE;EACE,eAAA;EACA,cAAA;EnClFA,gBmCmFuB;A9CupI3B;A8CnpII;EACE,aAAA;A9CqpIN;A8ChpII;EACE,gBAAA;A9CkpIN;;A+CjvIE;EACE,+BDyGsE;ECxGtE,6CDwGuC;A9C4oI3C;AMruIE;EyCXM,+BDoGkE;ECnGlE,qEAAA;A/CmvIR;A+ChvIM;EACE,WAAA;EACA,0CD8FkE;EC7FlE,sCD6FkE;A9CqpI1E;;A+C/vIE;EACE,+BDyGsE;ECxGtE,0CDwGuC;A9C0pI3C;AMnvIE;EyCXM,+BDoGkE;ECnGlE,qEAAA;A/CiwIR;A+C9vIM;EACE,WAAA;EACA,0CD8FkE;EC7FlE,sCD6FkE;A9CmqI1E;;A+C7wIE;EACE,2BDyGsE;ECxGtE,yCDwGuC;A9CwqI3C;AMjwIE;EyCXM,2BDoGkE;ECnGlE,qEAAA;A/C+wIR;A+C5wIM;EACE,WAAA;EACA,sCD8FkE;EC7FlE,kCD6FkE;A9CirI1E;;A+C3xIE;EACE,4BDyGsE;ECxGtE,4CDwGuC;A9CsrI3C;AM/wIE;EyCXM,4BDoGkE;ECnGlE,qEAAA;A/C6xIR;A+C1xIM;EACE,WAAA;EACA,uCD8FkE;EC7FlE,mCD6FkE;A9C+rI1E;;A+CzyIE;EACE,2BDyGsE;ECxGtE,yCDwGuC;A9CosI3C;AM7xIE;EyCXM,2BDoGkE;ECnGlE,yCAAA;A/C2yIR;A+CxyIM;EACE,WAAA;EACA,sCD8FkE;EC7FlE,kCD6FkE;A9C6sI1E;;A+CvzIE;EACE,gCDyGsE;ECxGtE,6CDwGuC;A9CktI3C;AM3yIE;EyCXM,gCDoGkE;ECnGlE,qEAAA;A/CyzIR;A+CtzIM;EACE,WAAA;EACA,2CD8FkE;EC7FlE,uCD6FkE;A9C2tI1E;;A+Cr0IE;EACE,kCDyGsE;ECxGtE,6CDwGuC;A9CguI3C;AMzzIE;EyCXM,kCDoGkE;ECnGlE,yDAAA;A/Cu0IR;A+Cp0IM;EACE,WAAA;EACA,6CD8FkE;EC7FlE,yCD6FkE;A9CyuI1E;;A+Cn1IE;EACE,+BDyGsE;ECxGtE,6CDwGuC;A9C8uI3C;AMv0IE;EyCXM,+BDoGkE;ECnGlE,6DAAA;A/Cq1IR;A+Cl1IM;EACE,WAAA;EACA,0CD8FkE;EC7FlE,sCD6FkE;A9CuvI1E;;AgDp2IA;EACE,YAAA;EACA,iB3C20BgB;E2C10BhB,gB3CsOiB;E2CrOjB,cAAA;EAGA,YAAA;AhDq2IF;AMx1IE;E0CTE,qBAAA;EACA,aAAA;AhDo2IJ;AgDh2IE;EACE,eAAA;AhDk2IJ;;AgDx1IA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;EACA,wBAAA;AhD21IF;;AiDp3IA;EACE,gBAAA;AjDu3IF;;AiDn3IA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a5CuhBa;E4CthBb,aAAA;EACA,gBAAA;EAGA,UAAA;AjDo3IF;AiD/2IE;EACE,kBAAA;EACA,gBAAA;AjDi3IJ;;AiD52IA;EACE,kBAAA;EACA,WAAA;EACA,c5C0qBoB;E4CxqBpB,oBAAA;AjD82IF;AiD32IE;E5BrCI,mC4BsCF;EACA,6BAAA;AjD62IJ;AiD32IE;EACE,0BAAA;AjD62IJ;;AiDz2IA;EACE,aAAA;EACA,mBAAA;EACA,mCAAA;AjD42IF;;AiDx2IA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,oBAAA;EACA,sB5CvDM;E4CwDN,4BAAA;EACA,oCAAA;EtC/DE,kBPoCe;EQtCf,+CqCmEF;EAEA,UAAA;AjDy2IF;;AiDr2IA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a5CsdsB;E4CrdtB,sB5C9DM;ALs6IR;AiDr2IE;EACE,UAAA;AjDu2IJ;AiDr2IE;EACE,Y5CkoBqB;ALquHzB;;AiDj2IA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,a5C6nBqB;E4C5nBrB,gCAAA;EtC1FE,2BP8Be;EO7Bf,4BP6Be;AJk6InB;AiDn2IE;EACE,a5CwnBmB;E4CtnBnB,8BAAA;AjDo2IJ;;AiD/1IA;EACE,gBAAA;EACA,gB5C2HiB;ALuuInB;;AiD71IA;EACE,kBAAA;EAGA,cAAA;EACA,a5CklBoB;AL4wHtB;;AiD11IA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,a5C0kBoB;E4CzkBpB,6BAAA;AjD61IF;AiD11IE;EACE,oBAAA;AjD41IJ;AiD11IE;EACE,qBAAA;AjD41IJ;;AiDv1IA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AjD01IF;;AgBn7II;EiC+FF;IACE,gB5CukBO;I4CtkBP,oBAAA;EjDw1IF;EiDr1IA;IACE,oCAAA;EjDu1IF;EiDp1IA;IrClKE,4CqCmKA;EjDs1IF;EiDn1IA;IACE,gB5C2jBO;EL0xHT;AACF;AgBn8II;EiCmHF;IACE,gB5CkjBO;ELiyHT;AACF;AkDngJA;EACE,kBAAA;EACA,a7CuiBe;E6CtiBf,cAAA;EACA,S7CypBe;E8C7pBf,iC/CeuB;E+CbvB,kBAAA;EACA,gB9CoOmB;E8CnOnB,gB9CuOiB;E8CtOjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EDNA,mB7C4Na;E6C1Nb,qBAAA;EACA,UAAA;AlD+gJF;AkD7gJE;EACE,Y7C4oBc;ALm4HlB;AkD5gJE;EACE,kBAAA;EACA,cAAA;EACA,a7C2oBkB;E6C1oBlB,c7C2oBmB;ALm4HvB;AkD5gJI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AlD8gJN;;AkDzgJA;EACE,iBAAA;AlD4gJF;AkD1gJE;EACE,SAAA;AlD4gJJ;AkD1gJI;EACE,MAAA;EACA,6BAAA;EACA,sB7CtBE;ALkiJR;;AkDvgJA;EACE,iBAAA;AlD0gJF;AkDxgJE;EACE,OAAA;EACA,a7C6mBmB;E6C5mBnB,c7C2mBkB;AL+5HtB;AkDxgJI;EACE,QAAA;EACA,oCAAA;EACA,wB7CtCE;ALgjJR;;AkDrgJA;EACE,iBAAA;AlDwgJF;AkDtgJE;EACE,MAAA;AlDwgJJ;AkDtgJI;EACE,SAAA;EACA,6BAAA;EACA,yB7CpDE;AL4jJR;;AkDngJA;EACE,iBAAA;AlDsgJF;AkDpgJE;EACE,QAAA;EACA,a7C+kBmB;E6C9kBnB,c7C6kBkB;ALy7HtB;AkDpgJI;EACE,OAAA;EACA,oCAAA;EACA,uB7CpEE;AL0kJR;;AkDj/IA;EACE,gB7CyiBkB;E6CxiBlB,uBAAA;EACA,W7CtGM;E6CuGN,kBAAA;EACA,sB7C9FM;EMhBJ,sBNwMY;AL25IhB;;AoDvmJA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,a/CqiBe;E+CpiBf,cAAA;EACA,gB/CkqBkB;E8CvqBlB,iC/CeuB;E+CbvB,kBAAA;EACA,gB9CoOmB;E8CnOnB,gB9CuOiB;E8CtOjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;ECLA,mB/C2Na;E+CzNb,qBAAA;EACA,sB/CHM;E+CIN,4BAAA;EACA,oCAAA;EzCXE,qBNyMe;EO3Mf,+CwCeF;ApDonJF;AoDlnJE;EACE,kBAAA;EACA,cAAA;EACA,W/CiqBkB;E+ChqBlB,c/CiqBmB;E+ChqBnB,aAAA;ApDonJJ;AoDlnJI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ApDmnJN;;AoD9mJA;EACE,qB/CkpBqB;AL+9HvB;AoD/mJE;EACE,iCAAA;ApDinJJ;AoD9mJE;;;EAEE,6BAAA;ApDinJJ;AoD9mJE;EACE,SAAA;EACA,qC/CwoBwB;ALw+H5B;AoD7mJE;EACE,W/CkJW;E+CjJX,sB/C9CI;AL6pJR;;AoD3mJA;EACE,mB/C2nBqB;ALm/HvB;AoD5mJE;EACE,+BAAA;EACA,a/CunBmB;E+CtnBnB,Y/CqnBkB;E+CpnBlB,aAAA;ApD8mJJ;AoD3mJE;;;EAEE,oCAAA;ApD8mJJ;AoD3mJE;EACE,OAAA;EACA,uC/C8mBwB;AL+/H5B;AoD1mJE;EACE,S/CwHW;E+CvHX,wB/CxEI;ALorJR;;AoDxmJA;EACE,kB/CimBqB;AL0gIvB;AoDzmJE;EACE,8BAAA;ApD2mJJ;AoDxmJE;;;EAEE,oCAAA;ApD2mJJ;AoDxmJE;EACE,MAAA;EACA,wC/CulBwB;ALmhI5B;AoDvmJE;EACE,Q/CiGW;E+ChGX,yB/C/FI;ALwsJR;AoDrmJE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,W/CqkBkB;E+CpkBlB,oBAAA;EACA,WAAA;EACA,oDAAA;ApDumJJ;;AoDnmJA;EACE,oB/C8jBqB;ALwiIvB;AoDpmJE;EACE,gCAAA;EACA,a/C0jBmB;E+CzjBnB,Y/CwjBkB;E+CvjBlB,aAAA;ApDsmJJ;AoDnmJE;;;EAEE,oCAAA;ApDsmJJ;AoDnmJE;EACE,QAAA;EACA,sC/CijBwB;ALojI5B;AoDlmJE;EACE,U/C2DW;E+C1DX,uB/CrII;ALyuJR;;AoDhlJA;EACE,uBAAA;EACA,gBAAA;EACA,ehDlJe;EgDmJf,c/CkFe;E+CjFf,6C/CsgBkB;E+CrgBlB,iDAAA;EzC/JE,uCyCgKoB;EzC/JpB,wCyC+JoB;ApDolJxB;AoDjlJE;EACE,aAAA;ApDmlJJ;;AoD/kJA;EACE,uBAAA;EACA,c/CjKS;ALmvJX;;AqDrwJA;EACE,kBAAA;ArDwwJF;;AqDrwJA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;ArDwwJF;;AqDrwJA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EhCVI,+BgCWJ;EACA,2BAAA;EACA,mBAAA;ArDwwJF;;AqDrwJA;;;EAGE,cAAA;ArDwwJF;;AqDrwJA;;EAEE,kBAAA;EACA,MAAA;ArDwwJF;;AqDpwJA;;EAEE,wBAAA;ArDuwJF;AqDrwJE;EAJF;;IAKI,+BAAA;ErDywJF;AACF;;AqDtwJA;;EAEE,2BAAA;ArDywJF;AqDvwJE;EAJF;;IAKI,kCAAA;ErD2wJF;AACF;;AqDxwJA;;EAEE,4BAAA;ArD2wJF;AqDzwJE;EAJF;;IAKI,mCAAA;ErD6wJF;AACF;;AqDtwJA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhD+uBuB;EgD9uBvB,WhDjEM;EgDkEN,kBAAA;EACA,YhD6uByB;AL2hI3B;AMj0JE;;;E+C+DE,WhDzEI;EgD0EJ,qBAAA;EACA,UAAA;EACA,YAAA;ArDuwJJ;;AqDnwJA;EACE,OAAA;ArDswJF;;AqDhwJA;EACE,QAAA;ArDmwJF;;AqD5vJA;;EAEE,qBAAA;EACA,WhDwtB4B;EgDvtB5B,YhDutB4B;EgDttB5B,+CAAA;EACA,0BAAA;ArD+vJF;;AqD5vJA;EACE,yDhDmtB8B;AL4iIhC;;AqD5vJA;EACE,yDhDgtB8B;AL+iIhC;;AqDvvJA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,iBhDgrBuB;EgD/qBvB,gBhD+qBuB;EgD9qBvB,gBAAA;ArDyvJF;AqDvvJE;EACE,kBAAA;EACA,cAAA;EACA,WhD4qBuB;EgD3qBvB,WhD4qBwB;EgD3qBxB,iBhD4qBwB;EgD3qBxB,gBhD2qBwB;EgD1qBxB,mBAAA;EACA,0CAAA;ArDyvJJ;AqDtvJI;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;ArDwvJN;AqDtvJI;EACE,kBAAA;EACA,aAAA;EACA,OAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;ArDwvJN;AqDpvJE;EACE,sBhDnKI;ALy5JR;;AqD9uJA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,WhDnLM;EgDoLN,kBAAA;ArDivJF;;AsD76JA;EACE,mCAAA;AtDg7JF;;AsD56JA;EACE,8BAAA;AtD+6JF;;AsD56JA;EACE,iCAAA;AtD+6JF;;AsD56JA;EACE,iCAAA;AtD+6JF;;AsD56JA;EACE,sCAAA;AtD+6JF;;AsD56JA;EACE,mCAAA;AtD+6JF;;AuDl8JE;EACE,oCAAA;AvDq8JJ;;AMv7JE;;;EiDTI,8EAAA;AvDs8JN;;AuD58JE;EACE,oCAAA;AvD+8JJ;;AMj8JE;;;EiDTI,8EAAA;AvDg9JN;;AuDt9JE;EACE,oCAAA;AvDy9JJ;;AM38JE;;;EiDTI,8EAAA;AvD09JN;;AuDh+JE;EACE,oCAAA;AvDm+JJ;;AMr9JE;;;EiDTI,wDAAA;AvDo+JN;;AuD1+JE;EACE,oCAAA;AvD6+JJ;;AM/9JE;;;EiDTI,+CAAA;AvD8+JN;;AuDp/JE;EACE,oCAAA;AvDu/JJ;;AMz+JE;;;EiDTI,8EAAA;AvDw/JN;;AuD9/JE;EACE,oCAAA;AvDigKJ;;AMn/JE;;;EiDTI,iEAAA;AvDkgKN;;AuDxgKE;EACE,oCAAA;AvD2gKJ;;AM7/JE;;;EiDTI,oEAAA;AvD4gKN;;AwD3gKA;EACE,iCAAA;AxD8gKF;;AwD3gKA;EACE,wCAAA;AxD8gKF;;AyDzhKA;EACE,oCAAA;AzD4hKF;;AyDzhKA;EACE,wCAAA;AzD4hKF;;AyDzhKA;EACE,0CAAA;AzD4hKF;;AyDzhKA;EACE,2CAAA;AzD4hKF;;AyDzhKA;EACE,yCAAA;AzD4hKF;;AyDzhKA;EACE,oBAAA;AzD4hKF;;AyDzhKA;EACE,wBAAA;AzD4hKF;;AyDzhKA;EACE,0BAAA;AzD4hKF;;AyDzhKA;EACE,2BAAA;AzD4hKF;;AyDzhKA;EACE,yBAAA;AzD4hKF;;AyDxhKE;EACE,gCAAA;AzD2hKJ;;AyD5hKE;EACE,gCAAA;AzD+hKJ;;AyDhiKE;EACE,gCAAA;AzDmiKJ;;AyDpiKE;EACE,gCAAA;AzDuiKJ;;AyDxiKE;EACE,gCAAA;AzD2iKJ;;AyD5iKE;EACE,gCAAA;AzD+iKJ;;AyDhjKE;EACE,gCAAA;AzDmjKJ;;AyDpjKE;EACE,gCAAA;AzDujKJ;;AyDnjKA;EACE,6BAAA;AzDsjKF;;AyD/iKA;EACE,6BAAA;AzDkjKF;;AyD/iKA;EACE,sCAAA;EACA,uCAAA;AzDkjKF;;AyD/iKA;EACE,uCAAA;EACA,0CAAA;AzDkjKF;;AyD/iKA;EACE,0CAAA;EACA,yCAAA;AzDkjKF;;AyD/iKA;EACE,sCAAA;EACA,yCAAA;AzDkjKF;;AyD/iKA;EACE,6BAAA;AzDkjKF;;AyD/iKA;EACE,2BAAA;AzDkjKF;;A0D1oKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A1D6oKJ;;A2DvoKI;EACE,wBAAA;A3D0oKN;;A2DxoKI;EACE,0BAAA;A3D2oKN;;A2DzoKI;EACE,gCAAA;A3D4oKN;;A2D1oKI;EACE,yBAAA;A3D6oKN;;A2D3oKI;EACE,yBAAA;A3D8oKN;;A2D5oKI;EACE,6BAAA;A3D+oKN;;A2D7oKI;EACE,8BAAA;A3DgpKN;;A2D9oKI;EACE,wBAAA;A3DipKN;;A2D/oKI;EACE,+BAAA;A3DkpKN;;AgBznKI;E2ClDA;IACE,wBAAA;E3D+qKJ;E2D7qKE;IACE,0BAAA;E3D+qKJ;E2D7qKE;IACE,gCAAA;E3D+qKJ;E2D7qKE;IACE,yBAAA;E3D+qKJ;E2D7qKE;IACE,yBAAA;E3D+qKJ;E2D7qKE;IACE,6BAAA;E3D+qKJ;E2D7qKE;IACE,8BAAA;E3D+qKJ;E2D7qKE;IACE,wBAAA;E3D+qKJ;E2D7qKE;IACE,+BAAA;E3D+qKJ;AACF;AgBvpKI;E2ClDA;IACE,wBAAA;E3D4sKJ;E2D1sKE;IACE,0BAAA;E3D4sKJ;E2D1sKE;IACE,gCAAA;E3D4sKJ;E2D1sKE;IACE,yBAAA;E3D4sKJ;E2D1sKE;IACE,yBAAA;E3D4sKJ;E2D1sKE;IACE,6BAAA;E3D4sKJ;E2D1sKE;IACE,8BAAA;E3D4sKJ;E2D1sKE;IACE,wBAAA;E3D4sKJ;E2D1sKE;IACE,+BAAA;E3D4sKJ;AACF;AgBprKI;E2ClDA;IACE,wBAAA;E3DyuKJ;E2DvuKE;IACE,0BAAA;E3DyuKJ;E2DvuKE;IACE,gCAAA;E3DyuKJ;E2DvuKE;IACE,yBAAA;E3DyuKJ;E2DvuKE;IACE,yBAAA;E3DyuKJ;E2DvuKE;IACE,6BAAA;E3DyuKJ;E2DvuKE;IACE,8BAAA;E3DyuKJ;E2DvuKE;IACE,wBAAA;E3DyuKJ;E2DvuKE;IACE,+BAAA;E3DyuKJ;AACF;AgBjtKI;E2ClDA;IACE,wBAAA;E3DswKJ;E2DpwKE;IACE,0BAAA;E3DswKJ;E2DpwKE;IACE,gCAAA;E3DswKJ;E2DpwKE;IACE,yBAAA;E3DswKJ;E2DpwKE;IACE,yBAAA;E3DswKJ;E2DpwKE;IACE,6BAAA;E3DswKJ;E2DpwKE;IACE,8BAAA;E3DswKJ;E2DpwKE;IACE,wBAAA;E3DswKJ;E2DpwKE;IACE,+BAAA;E3DswKJ;AACF;A2D9vKA;EACE;IACE,wBAAA;E3DgwKF;E2D9vKA;IACE,0BAAA;E3DgwKF;E2D9vKA;IACE,gCAAA;E3DgwKF;E2D9vKA;IACE,yBAAA;E3DgwKF;E2D9vKA;IACE,yBAAA;E3DgwKF;E2D9vKA;IACE,6BAAA;E3DgwKF;E2D9vKA;IACE,8BAAA;E3DgwKF;E2D9vKA;IACE,wBAAA;E3DgwKF;E2D9vKA;IACE,+BAAA;E3DgwKF;AACF;A4Dr0KA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;A5Du0KF;A4Dr0KE;EACE,cAAA;EACA,WAAA;A5Du0KJ;A4Dp0KE;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;A5Ds0KJ;;A4Dj0KE;EACE,2BAAA;A5Do0KJ;;A4D/zKE;EACE,mBAAA;A5Dk0KJ;;A4D7zKE;EACE,gBAAA;A5Dg0KJ;;A4D3zKE;EACE,iBAAA;A5D8zKJ;;A6Dr2KI;EACE,8BAAA;A7Dw2KN;;A6Dt2KI;EACE,iCAAA;A7Dy2KN;;A6Dv2KI;EACE,sCAAA;A7D02KN;;A6Dx2KI;EACE,yCAAA;A7D22KN;;A6Dx2KI;EACE,0BAAA;A7D22KN;;A6Dz2KI;EACE,4BAAA;A7D42KN;;A6D12KI;EACE,kCAAA;A7D62KN;;A6D12KI;EACE,sCAAA;A7D62KN;;A6D32KI;EACE,oCAAA;A7D82KN;;A6D52KI;EACE,kCAAA;A7D+2KN;;A6D72KI;EACE,yCAAA;A7Dg3KN;;A6D92KI;EACE,wCAAA;A7Di3KN;;A6D92KI;EACE,kCAAA;A7Di3KN;;A6D/2KI;EACE,gCAAA;A7Dk3KN;;A6Dh3KI;EACE,8BAAA;A7Dm3KN;;A6Dj3KI;EACE,gCAAA;A7Do3KN;;A6Dl3KI;EACE,+BAAA;A7Dq3KN;;A6Dl3KI;EACE,oCAAA;A7Dq3KN;;A6Dn3KI;EACE,kCAAA;A7Ds3KN;;A6Dp3KI;EACE,gCAAA;A7Du3KN;;A6Dr3KI;EACE,uCAAA;A7Dw3KN;;A6Dt3KI;EACE,sCAAA;A7Dy3KN;;A6Dv3KI;EACE,iCAAA;A7D03KN;;A6Dv3KI;EACE,2BAAA;A7D03KN;;A6Dx3KI;EACE,iCAAA;A7D23KN;;A6Dz3KI;EACE,+BAAA;A7D43KN;;A6D13KI;EACE,6BAAA;A7D63KN;;A6D33KI;EACE,+BAAA;A7D83KN;;A6D53KI;EACE,8BAAA;A7D+3KN;;AgBv6KI;E6ClDA;IACE,8BAAA;E7D69KJ;E6D39KE;IACE,iCAAA;E7D69KJ;E6D39KE;IACE,sCAAA;E7D69KJ;E6D39KE;IACE,yCAAA;E7D69KJ;E6D19KE;IACE,0BAAA;E7D49KJ;E6D19KE;IACE,4BAAA;E7D49KJ;E6D19KE;IACE,kCAAA;E7D49KJ;E6Dz9KE;IACE,sCAAA;E7D29KJ;E6Dz9KE;IACE,oCAAA;E7D29KJ;E6Dz9KE;IACE,kCAAA;E7D29KJ;E6Dz9KE;IACE,yCAAA;E7D29KJ;E6Dz9KE;IACE,wCAAA;E7D29KJ;E6Dx9KE;IACE,kCAAA;E7D09KJ;E6Dx9KE;IACE,gCAAA;E7D09KJ;E6Dx9KE;IACE,8BAAA;E7D09KJ;E6Dx9KE;IACE,gCAAA;E7D09KJ;E6Dx9KE;IACE,+BAAA;E7D09KJ;E6Dv9KE;IACE,oCAAA;E7Dy9KJ;E6Dv9KE;IACE,kCAAA;E7Dy9KJ;E6Dv9KE;IACE,gCAAA;E7Dy9KJ;E6Dv9KE;IACE,uCAAA;E7Dy9KJ;E6Dv9KE;IACE,sCAAA;E7Dy9KJ;E6Dv9KE;IACE,iCAAA;E7Dy9KJ;E6Dt9KE;IACE,2BAAA;E7Dw9KJ;E6Dt9KE;IACE,iCAAA;E7Dw9KJ;E6Dt9KE;IACE,+BAAA;E7Dw9KJ;E6Dt9KE;IACE,6BAAA;E7Dw9KJ;E6Dt9KE;IACE,+BAAA;E7Dw9KJ;E6Dt9KE;IACE,8BAAA;E7Dw9KJ;AACF;AgBjgLI;E6ClDA;IACE,8BAAA;E7DsjLJ;E6DpjLE;IACE,iCAAA;E7DsjLJ;E6DpjLE;IACE,sCAAA;E7DsjLJ;E6DpjLE;IACE,yCAAA;E7DsjLJ;E6DnjLE;IACE,0BAAA;E7DqjLJ;E6DnjLE;IACE,4BAAA;E7DqjLJ;E6DnjLE;IACE,kCAAA;E7DqjLJ;E6DljLE;IACE,sCAAA;E7DojLJ;E6DljLE;IACE,oCAAA;E7DojLJ;E6DljLE;IACE,kCAAA;E7DojLJ;E6DljLE;IACE,yCAAA;E7DojLJ;E6DljLE;IACE,wCAAA;E7DojLJ;E6DjjLE;IACE,kCAAA;E7DmjLJ;E6DjjLE;IACE,gCAAA;E7DmjLJ;E6DjjLE;IACE,8BAAA;E7DmjLJ;E6DjjLE;IACE,gCAAA;E7DmjLJ;E6DjjLE;IACE,+BAAA;E7DmjLJ;E6DhjLE;IACE,oCAAA;E7DkjLJ;E6DhjLE;IACE,kCAAA;E7DkjLJ;E6DhjLE;IACE,gCAAA;E7DkjLJ;E6DhjLE;IACE,uCAAA;E7DkjLJ;E6DhjLE;IACE,sCAAA;E7DkjLJ;E6DhjLE;IACE,iCAAA;E7DkjLJ;E6D/iLE;IACE,2BAAA;E7DijLJ;E6D/iLE;IACE,iCAAA;E7DijLJ;E6D/iLE;IACE,+BAAA;E7DijLJ;E6D/iLE;IACE,6BAAA;E7DijLJ;E6D/iLE;IACE,+BAAA;E7DijLJ;E6D/iLE;IACE,8BAAA;E7DijLJ;AACF;AgB1lLI;E6ClDA;IACE,8BAAA;E7D+oLJ;E6D7oLE;IACE,iCAAA;E7D+oLJ;E6D7oLE;IACE,sCAAA;E7D+oLJ;E6D7oLE;IACE,yCAAA;E7D+oLJ;E6D5oLE;IACE,0BAAA;E7D8oLJ;E6D5oLE;IACE,4BAAA;E7D8oLJ;E6D5oLE;IACE,kCAAA;E7D8oLJ;E6D3oLE;IACE,sCAAA;E7D6oLJ;E6D3oLE;IACE,oCAAA;E7D6oLJ;E6D3oLE;IACE,kCAAA;E7D6oLJ;E6D3oLE;IACE,yCAAA;E7D6oLJ;E6D3oLE;IACE,wCAAA;E7D6oLJ;E6D1oLE;IACE,kCAAA;E7D4oLJ;E6D1oLE;IACE,gCAAA;E7D4oLJ;E6D1oLE;IACE,8BAAA;E7D4oLJ;E6D1oLE;IACE,gCAAA;E7D4oLJ;E6D1oLE;IACE,+BAAA;E7D4oLJ;E6DzoLE;IACE,oCAAA;E7D2oLJ;E6DzoLE;IACE,kCAAA;E7D2oLJ;E6DzoLE;IACE,gCAAA;E7D2oLJ;E6DzoLE;IACE,uCAAA;E7D2oLJ;E6DzoLE;IACE,sCAAA;E7D2oLJ;E6DzoLE;IACE,iCAAA;E7D2oLJ;E6DxoLE;IACE,2BAAA;E7D0oLJ;E6DxoLE;IACE,iCAAA;E7D0oLJ;E6DxoLE;IACE,+BAAA;E7D0oLJ;E6DxoLE;IACE,6BAAA;E7D0oLJ;E6DxoLE;IACE,+BAAA;E7D0oLJ;E6DxoLE;IACE,8BAAA;E7D0oLJ;AACF;AgBnrLI;E6ClDA;IACE,8BAAA;E7DwuLJ;E6DtuLE;IACE,iCAAA;E7DwuLJ;E6DtuLE;IACE,sCAAA;E7DwuLJ;E6DtuLE;IACE,yCAAA;E7DwuLJ;E6DruLE;IACE,0BAAA;E7DuuLJ;E6DruLE;IACE,4BAAA;E7DuuLJ;E6DruLE;IACE,kCAAA;E7DuuLJ;E6DpuLE;IACE,sCAAA;E7DsuLJ;E6DpuLE;IACE,oCAAA;E7DsuLJ;E6DpuLE;IACE,kCAAA;E7DsuLJ;E6DpuLE;IACE,yCAAA;E7DsuLJ;E6DpuLE;IACE,wCAAA;E7DsuLJ;E6DnuLE;IACE,kCAAA;E7DquLJ;E6DnuLE;IACE,gCAAA;E7DquLJ;E6DnuLE;IACE,8BAAA;E7DquLJ;E6DnuLE;IACE,gCAAA;E7DquLJ;E6DnuLE;IACE,+BAAA;E7DquLJ;E6DluLE;IACE,oCAAA;E7DouLJ;E6DluLE;IACE,kCAAA;E7DouLJ;E6DluLE;IACE,gCAAA;E7DouLJ;E6DluLE;IACE,uCAAA;E7DouLJ;E6DluLE;IACE,sCAAA;E7DouLJ;E6DluLE;IACE,iCAAA;E7DouLJ;E6DjuLE;IACE,2BAAA;E7DmuLJ;E6DjuLE;IACE,iCAAA;E7DmuLJ;E6DjuLE;IACE,+BAAA;E7DmuLJ;E6DjuLE;IACE,6BAAA;E7DmuLJ;E6DjuLE;IACE,+BAAA;E7DmuLJ;E6DjuLE;IACE,8BAAA;E7DmuLJ;AACF;A8Dp0LI;ECDF,sBAAA;A/Dw0LF;;A8Dp0LI;ECAF,uBAAA;A/Dw0LF;;A8Dr0LI;ECCF,sBAAA;A/Dw0LF;;AgBvxLI;E8CxDA;ICDF,sBAAA;E/Dq1LA;E8Dj1LE;ICAF,uBAAA;E/Do1LA;E8Dj1LE;ICCF,sBAAA;E/Dm1LA;AACF;AgBnyLI;E8CxDA;ICDF,sBAAA;E/Dg2LA;E8D51LE;ICAF,uBAAA;E/D+1LA;E8D51LE;ICCF,sBAAA;E/D81LA;AACF;AgB9yLI;E8CxDA;ICDF,sBAAA;E/D22LA;E8Dv2LE;ICAF,uBAAA;E/D02LA;E8Dv2LE;ICCF,sBAAA;E/Dy2LA;AACF;AgBzzLI;E8CxDA;ICDF,sBAAA;E/Ds3LA;E8Dl3LE;ICAF,uBAAA;E/Dq3LA;E8Dl3LE;ICCF,sBAAA;E/Do3LA;AACF;AgEx3LE;EACE,2BAAA;AhE03LJ;;AgE33LE;EACE,6BAAA;AhE83LJ;;AgE/3LE;EACE,6BAAA;AhEk4LJ;;AgEn4LE;EACE,0BAAA;AhEs4LJ;;AgEv4LE;EACE,2BAAA;AhE04LJ;;AgEp4LA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a3DkhBa;ALq3Kf;;AgEp4LA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a3D0gBa;AL63Kf;;AgEn4LE;EADF;IAEI,gBAAA;IACA,MAAA;IACA,a3DkgBY;ELq4Kd;AACF;;AiEv6LA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;AlEy6LF;;AkE/5LE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,eAAA;AlEi6LJ;;AmE37LI;EACE,qBAAA;AnE87LN;;AmE/7LI;EACE,qBAAA;AnEk8LN;;AmEn8LI;EACE,qBAAA;AnEs8LN;;AmEv8LI;EACE,sBAAA;AnE08LN;;AmE38LI;EACE,sBAAA;AnE88LN;;AmE/8LI;EACE,sBAAA;AnEk9LN;;AmEn9LI;EACE,sBAAA;AnEs9LN;;AmEv9LI;EACE,uBAAA;AnE09LN;;AmEr9LA;EACE,0BAAA;AnEw9LF;;AmEr9LA;EACE,2BAAA;AnEw9LF;;AoE99LQ;EACE,oBAAA;ApEi+LV;;AoE/9LQ;;EAEE,wBAAA;ApEk+LV;;AoEh+LQ;;EAEE,0BAAA;ApEm+LV;;AoEj+LQ;;EAEE,2BAAA;ApEo+LV;;AoEl+LQ;;EAEE,yBAAA;ApEq+LV;;AoEt/LQ;EACE,0BAAA;ApEy/LV;;AoEv/LQ;;EAEE,8BAAA;ApE0/LV;;AoEx/LQ;;EAEE,gCAAA;ApE2/LV;;AoEz/LQ;;EAEE,iCAAA;ApE4/LV;;AoE1/LQ;;EAEE,+BAAA;ApE6/LV;;AoE9gMQ;EACE,yBAAA;ApEihMV;;AoE/gMQ;;EAEE,6BAAA;ApEkhMV;;AoEhhMQ;;EAEE,+BAAA;ApEmhMV;;AoEjhMQ;;EAEE,gCAAA;ApEohMV;;AoElhMQ;;EAEE,8BAAA;ApEqhMV;;AoEtiMQ;EACE,uBAAA;ApEyiMV;;AoEviMQ;;EAEE,2BAAA;ApE0iMV;;AoExiMQ;;EAEE,6BAAA;ApE2iMV;;AoEziMQ;;EAEE,8BAAA;ApE4iMV;;AoE1iMQ;;EAEE,4BAAA;ApE6iMV;;AoE9jMQ;EACE,yBAAA;ApEikMV;;AoE/jMQ;;EAEE,6BAAA;ApEkkMV;;AoEhkMQ;;EAEE,+BAAA;ApEmkMV;;AoEjkMQ;;EAEE,gCAAA;ApEokMV;;AoElkMQ;;EAEE,8BAAA;ApEqkMV;;AoEtlMQ;EACE,uBAAA;ApEylMV;;AoEvlMQ;;EAEE,2BAAA;ApE0lMV;;AoExlMQ;;EAEE,6BAAA;ApE2lMV;;AoEzlMQ;;EAEE,8BAAA;ApE4lMV;;AoE1lMQ;;EAEE,4BAAA;ApE6lMV;;AoE9mMQ;EACE,qBAAA;ApEinMV;;AoE/mMQ;;EAEE,yBAAA;ApEknMV;;AoEhnMQ;;EAEE,2BAAA;ApEmnMV;;AoEjnMQ;;EAEE,4BAAA;ApEonMV;;AoElnMQ;;EAEE,0BAAA;ApEqnMV;;AoEtoMQ;EACE,2BAAA;ApEyoMV;;AoEvoMQ;;EAEE,+BAAA;ApE0oMV;;AoExoMQ;;EAEE,iCAAA;ApE2oMV;;AoEzoMQ;;EAEE,kCAAA;ApE4oMV;;AoE1oMQ;;EAEE,gCAAA;ApE6oMV;;AoE9pMQ;EACE,0BAAA;ApEiqMV;;AoE/pMQ;;EAEE,8BAAA;ApEkqMV;;AoEhqMQ;;EAEE,gCAAA;ApEmqMV;;AoEjqMQ;;EAEE,iCAAA;ApEoqMV;;AoElqMQ;;EAEE,+BAAA;ApEqqMV;;AoEtrMQ;EACE,wBAAA;ApEyrMV;;AoEvrMQ;;EAEE,4BAAA;ApE0rMV;;AoExrMQ;;EAEE,8BAAA;ApE2rMV;;AoEzrMQ;;EAEE,+BAAA;ApE4rMV;;AoE1rMQ;;EAEE,6BAAA;ApE6rMV;;AoE9sMQ;EACE,0BAAA;ApEitMV;;AoE/sMQ;;EAEE,8BAAA;ApEktMV;;AoEhtMQ;;EAEE,gCAAA;ApEmtMV;;AoEjtMQ;;EAEE,iCAAA;ApEotMV;;AoEltMQ;;EAEE,+BAAA;ApEqtMV;;AoEtuMQ;EACE,wBAAA;ApEyuMV;;AoEvuMQ;;EAEE,4BAAA;ApE0uMV;;AoExuMQ;;EAEE,8BAAA;ApE2uMV;;AoEzuMQ;;EAEE,+BAAA;ApE4uMV;;AoE1uMQ;;EAEE,6BAAA;ApE6uMV;;AoEvuMI;EACE,uBAAA;ApE0uMN;;AoExuMI;;EAEE,2BAAA;ApE2uMN;;AoEzuMI;;EAEE,6BAAA;ApE4uMN;;AoE1uMI;;EAEE,8BAAA;ApE6uMN;;AoE3uMI;;EAEE,4BAAA;ApE8uMN;;AgBruMI;EoDjDI;IACE,oBAAA;EpE0xMR;EoExxMM;;IAEE,wBAAA;EpE0xMR;EoExxMM;;IAEE,0BAAA;EpE0xMR;EoExxMM;;IAEE,2BAAA;EpE0xMR;EoExxMM;;IAEE,yBAAA;EpE0xMR;EoE3yMM;IACE,0BAAA;EpE6yMR;EoE3yMM;;IAEE,8BAAA;EpE6yMR;EoE3yMM;;IAEE,gCAAA;EpE6yMR;EoE3yMM;;IAEE,iCAAA;EpE6yMR;EoE3yMM;;IAEE,+BAAA;EpE6yMR;EoE9zMM;IACE,yBAAA;EpEg0MR;EoE9zMM;;IAEE,6BAAA;EpEg0MR;EoE9zMM;;IAEE,+BAAA;EpEg0MR;EoE9zMM;;IAEE,gCAAA;EpEg0MR;EoE9zMM;;IAEE,8BAAA;EpEg0MR;EoEj1MM;IACE,uBAAA;EpEm1MR;EoEj1MM;;IAEE,2BAAA;EpEm1MR;EoEj1MM;;IAEE,6BAAA;EpEm1MR;EoEj1MM;;IAEE,8BAAA;EpEm1MR;EoEj1MM;;IAEE,4BAAA;EpEm1MR;EoEp2MM;IACE,yBAAA;EpEs2MR;EoEp2MM;;IAEE,6BAAA;EpEs2MR;EoEp2MM;;IAEE,+BAAA;EpEs2MR;EoEp2MM;;IAEE,gCAAA;EpEs2MR;EoEp2MM;;IAEE,8BAAA;EpEs2MR;EoEv3MM;IACE,uBAAA;EpEy3MR;EoEv3MM;;IAEE,2BAAA;EpEy3MR;EoEv3MM;;IAEE,6BAAA;EpEy3MR;EoEv3MM;;IAEE,8BAAA;EpEy3MR;EoEv3MM;;IAEE,4BAAA;EpEy3MR;EoE14MM;IACE,qBAAA;EpE44MR;EoE14MM;;IAEE,yBAAA;EpE44MR;EoE14MM;;IAEE,2BAAA;EpE44MR;EoE14MM;;IAEE,4BAAA;EpE44MR;EoE14MM;;IAEE,0BAAA;EpE44MR;EoE75MM;IACE,2BAAA;EpE+5MR;EoE75MM;;IAEE,+BAAA;EpE+5MR;EoE75MM;;IAEE,iCAAA;EpE+5MR;EoE75MM;;IAEE,kCAAA;EpE+5MR;EoE75MM;;IAEE,gCAAA;EpE+5MR;EoEh7MM;IACE,0BAAA;EpEk7MR;EoEh7MM;;IAEE,8BAAA;EpEk7MR;EoEh7MM;;IAEE,gCAAA;EpEk7MR;EoEh7MM;;IAEE,iCAAA;EpEk7MR;EoEh7MM;;IAEE,+BAAA;EpEk7MR;EoEn8MM;IACE,wBAAA;EpEq8MR;EoEn8MM;;IAEE,4BAAA;EpEq8MR;EoEn8MM;;IAEE,8BAAA;EpEq8MR;EoEn8MM;;IAEE,+BAAA;EpEq8MR;EoEn8MM;;IAEE,6BAAA;EpEq8MR;EoEt9MM;IACE,0BAAA;EpEw9MR;EoEt9MM;;IAEE,8BAAA;EpEw9MR;EoEt9MM;;IAEE,gCAAA;EpEw9MR;EoEt9MM;;IAEE,iCAAA;EpEw9MR;EoEt9MM;;IAEE,+BAAA;EpEw9MR;EoEz+MM;IACE,wBAAA;EpE2+MR;EoEz+MM;;IAEE,4BAAA;EpE2+MR;EoEz+MM;;IAEE,8BAAA;EpE2+MR;EoEz+MM;;IAEE,+BAAA;EpE2+MR;EoEz+MM;;IAEE,6BAAA;EpE2+MR;EoEr+ME;IACE,uBAAA;EpEu+MJ;EoEr+ME;;IAEE,2BAAA;EpEu+MJ;EoEr+ME;;IAEE,6BAAA;EpEu+MJ;EoEr+ME;;IAEE,8BAAA;EpEu+MJ;EoEr+ME;;IAEE,4BAAA;EpEu+MJ;AACF;AgB/9MI;EoDjDI;IACE,oBAAA;EpEmhNR;EoEjhNM;;IAEE,wBAAA;EpEmhNR;EoEjhNM;;IAEE,0BAAA;EpEmhNR;EoEjhNM;;IAEE,2BAAA;EpEmhNR;EoEjhNM;;IAEE,yBAAA;EpEmhNR;EoEpiNM;IACE,0BAAA;EpEsiNR;EoEpiNM;;IAEE,8BAAA;EpEsiNR;EoEpiNM;;IAEE,gCAAA;EpEsiNR;EoEpiNM;;IAEE,iCAAA;EpEsiNR;EoEpiNM;;IAEE,+BAAA;EpEsiNR;EoEvjNM;IACE,yBAAA;EpEyjNR;EoEvjNM;;IAEE,6BAAA;EpEyjNR;EoEvjNM;;IAEE,+BAAA;EpEyjNR;EoEvjNM;;IAEE,gCAAA;EpEyjNR;EoEvjNM;;IAEE,8BAAA;EpEyjNR;EoE1kNM;IACE,uBAAA;EpE4kNR;EoE1kNM;;IAEE,2BAAA;EpE4kNR;EoE1kNM;;IAEE,6BAAA;EpE4kNR;EoE1kNM;;IAEE,8BAAA;EpE4kNR;EoE1kNM;;IAEE,4BAAA;EpE4kNR;EoE7lNM;IACE,yBAAA;EpE+lNR;EoE7lNM;;IAEE,6BAAA;EpE+lNR;EoE7lNM;;IAEE,+BAAA;EpE+lNR;EoE7lNM;;IAEE,gCAAA;EpE+lNR;EoE7lNM;;IAEE,8BAAA;EpE+lNR;EoEhnNM;IACE,uBAAA;EpEknNR;EoEhnNM;;IAEE,2BAAA;EpEknNR;EoEhnNM;;IAEE,6BAAA;EpEknNR;EoEhnNM;;IAEE,8BAAA;EpEknNR;EoEhnNM;;IAEE,4BAAA;EpEknNR;EoEnoNM;IACE,qBAAA;EpEqoNR;EoEnoNM;;IAEE,yBAAA;EpEqoNR;EoEnoNM;;IAEE,2BAAA;EpEqoNR;EoEnoNM;;IAEE,4BAAA;EpEqoNR;EoEnoNM;;IAEE,0BAAA;EpEqoNR;EoEtpNM;IACE,2BAAA;EpEwpNR;EoEtpNM;;IAEE,+BAAA;EpEwpNR;EoEtpNM;;IAEE,iCAAA;EpEwpNR;EoEtpNM;;IAEE,kCAAA;EpEwpNR;EoEtpNM;;IAEE,gCAAA;EpEwpNR;EoEzqNM;IACE,0BAAA;EpE2qNR;EoEzqNM;;IAEE,8BAAA;EpE2qNR;EoEzqNM;;IAEE,gCAAA;EpE2qNR;EoEzqNM;;IAEE,iCAAA;EpE2qNR;EoEzqNM;;IAEE,+BAAA;EpE2qNR;EoE5rNM;IACE,wBAAA;EpE8rNR;EoE5rNM;;IAEE,4BAAA;EpE8rNR;EoE5rNM;;IAEE,8BAAA;EpE8rNR;EoE5rNM;;IAEE,+BAAA;EpE8rNR;EoE5rNM;;IAEE,6BAAA;EpE8rNR;EoE/sNM;IACE,0BAAA;EpEitNR;EoE/sNM;;IAEE,8BAAA;EpEitNR;EoE/sNM;;IAEE,gCAAA;EpEitNR;EoE/sNM;;IAEE,iCAAA;EpEitNR;EoE/sNM;;IAEE,+BAAA;EpEitNR;EoEluNM;IACE,wBAAA;EpEouNR;EoEluNM;;IAEE,4BAAA;EpEouNR;EoEluNM;;IAEE,8BAAA;EpEouNR;EoEluNM;;IAEE,+BAAA;EpEouNR;EoEluNM;;IAEE,6BAAA;EpEouNR;EoE9tNE;IACE,uBAAA;EpEguNJ;EoE9tNE;;IAEE,2BAAA;EpEguNJ;EoE9tNE;;IAEE,6BAAA;EpEguNJ;EoE9tNE;;IAEE,8BAAA;EpEguNJ;EoE9tNE;;IAEE,4BAAA;EpEguNJ;AACF;AgBxtNI;EoDjDI;IACE,oBAAA;EpE4wNR;EoE1wNM;;IAEE,wBAAA;EpE4wNR;EoE1wNM;;IAEE,0BAAA;EpE4wNR;EoE1wNM;;IAEE,2BAAA;EpE4wNR;EoE1wNM;;IAEE,yBAAA;EpE4wNR;EoE7xNM;IACE,0BAAA;EpE+xNR;EoE7xNM;;IAEE,8BAAA;EpE+xNR;EoE7xNM;;IAEE,gCAAA;EpE+xNR;EoE7xNM;;IAEE,iCAAA;EpE+xNR;EoE7xNM;;IAEE,+BAAA;EpE+xNR;EoEhzNM;IACE,yBAAA;EpEkzNR;EoEhzNM;;IAEE,6BAAA;EpEkzNR;EoEhzNM;;IAEE,+BAAA;EpEkzNR;EoEhzNM;;IAEE,gCAAA;EpEkzNR;EoEhzNM;;IAEE,8BAAA;EpEkzNR;EoEn0NM;IACE,uBAAA;EpEq0NR;EoEn0NM;;IAEE,2BAAA;EpEq0NR;EoEn0NM;;IAEE,6BAAA;EpEq0NR;EoEn0NM;;IAEE,8BAAA;EpEq0NR;EoEn0NM;;IAEE,4BAAA;EpEq0NR;EoEt1NM;IACE,yBAAA;EpEw1NR;EoEt1NM;;IAEE,6BAAA;EpEw1NR;EoEt1NM;;IAEE,+BAAA;EpEw1NR;EoEt1NM;;IAEE,gCAAA;EpEw1NR;EoEt1NM;;IAEE,8BAAA;EpEw1NR;EoEz2NM;IACE,uBAAA;EpE22NR;EoEz2NM;;IAEE,2BAAA;EpE22NR;EoEz2NM;;IAEE,6BAAA;EpE22NR;EoEz2NM;;IAEE,8BAAA;EpE22NR;EoEz2NM;;IAEE,4BAAA;EpE22NR;EoE53NM;IACE,qBAAA;EpE83NR;EoE53NM;;IAEE,yBAAA;EpE83NR;EoE53NM;;IAEE,2BAAA;EpE83NR;EoE53NM;;IAEE,4BAAA;EpE83NR;EoE53NM;;IAEE,0BAAA;EpE83NR;EoE/4NM;IACE,2BAAA;EpEi5NR;EoE/4NM;;IAEE,+BAAA;EpEi5NR;EoE/4NM;;IAEE,iCAAA;EpEi5NR;EoE/4NM;;IAEE,kCAAA;EpEi5NR;EoE/4NM;;IAEE,gCAAA;EpEi5NR;EoEl6NM;IACE,0BAAA;EpEo6NR;EoEl6NM;;IAEE,8BAAA;EpEo6NR;EoEl6NM;;IAEE,gCAAA;EpEo6NR;EoEl6NM;;IAEE,iCAAA;EpEo6NR;EoEl6NM;;IAEE,+BAAA;EpEo6NR;EoEr7NM;IACE,wBAAA;EpEu7NR;EoEr7NM;;IAEE,4BAAA;EpEu7NR;EoEr7NM;;IAEE,8BAAA;EpEu7NR;EoEr7NM;;IAEE,+BAAA;EpEu7NR;EoEr7NM;;IAEE,6BAAA;EpEu7NR;EoEx8NM;IACE,0BAAA;EpE08NR;EoEx8NM;;IAEE,8BAAA;EpE08NR;EoEx8NM;;IAEE,gCAAA;EpE08NR;EoEx8NM;;IAEE,iCAAA;EpE08NR;EoEx8NM;;IAEE,+BAAA;EpE08NR;EoE39NM;IACE,wBAAA;EpE69NR;EoE39NM;;IAEE,4BAAA;EpE69NR;EoE39NM;;IAEE,8BAAA;EpE69NR;EoE39NM;;IAEE,+BAAA;EpE69NR;EoE39NM;;IAEE,6BAAA;EpE69NR;EoEv9NE;IACE,uBAAA;EpEy9NJ;EoEv9NE;;IAEE,2BAAA;EpEy9NJ;EoEv9NE;;IAEE,6BAAA;EpEy9NJ;EoEv9NE;;IAEE,8BAAA;EpEy9NJ;EoEv9NE;;IAEE,4BAAA;EpEy9NJ;AACF;AgBj9NI;EoDjDI;IACE,oBAAA;EpEqgOR;EoEngOM;;IAEE,wBAAA;EpEqgOR;EoEngOM;;IAEE,0BAAA;EpEqgOR;EoEngOM;;IAEE,2BAAA;EpEqgOR;EoEngOM;;IAEE,yBAAA;EpEqgOR;EoEthOM;IACE,0BAAA;EpEwhOR;EoEthOM;;IAEE,8BAAA;EpEwhOR;EoEthOM;;IAEE,gCAAA;EpEwhOR;EoEthOM;;IAEE,iCAAA;EpEwhOR;EoEthOM;;IAEE,+BAAA;EpEwhOR;EoEziOM;IACE,yBAAA;EpE2iOR;EoEziOM;;IAEE,6BAAA;EpE2iOR;EoEziOM;;IAEE,+BAAA;EpE2iOR;EoEziOM;;IAEE,gCAAA;EpE2iOR;EoEziOM;;IAEE,8BAAA;EpE2iOR;EoE5jOM;IACE,uBAAA;EpE8jOR;EoE5jOM;;IAEE,2BAAA;EpE8jOR;EoE5jOM;;IAEE,6BAAA;EpE8jOR;EoE5jOM;;IAEE,8BAAA;EpE8jOR;EoE5jOM;;IAEE,4BAAA;EpE8jOR;EoE/kOM;IACE,yBAAA;EpEilOR;EoE/kOM;;IAEE,6BAAA;EpEilOR;EoE/kOM;;IAEE,+BAAA;EpEilOR;EoE/kOM;;IAEE,gCAAA;EpEilOR;EoE/kOM;;IAEE,8BAAA;EpEilOR;EoElmOM;IACE,uBAAA;EpEomOR;EoElmOM;;IAEE,2BAAA;EpEomOR;EoElmOM;;IAEE,6BAAA;EpEomOR;EoElmOM;;IAEE,8BAAA;EpEomOR;EoElmOM;;IAEE,4BAAA;EpEomOR;EoErnOM;IACE,qBAAA;EpEunOR;EoErnOM;;IAEE,yBAAA;EpEunOR;EoErnOM;;IAEE,2BAAA;EpEunOR;EoErnOM;;IAEE,4BAAA;EpEunOR;EoErnOM;;IAEE,0BAAA;EpEunOR;EoExoOM;IACE,2BAAA;EpE0oOR;EoExoOM;;IAEE,+BAAA;EpE0oOR;EoExoOM;;IAEE,iCAAA;EpE0oOR;EoExoOM;;IAEE,kCAAA;EpE0oOR;EoExoOM;;IAEE,gCAAA;EpE0oOR;EoE3pOM;IACE,0BAAA;EpE6pOR;EoE3pOM;;IAEE,8BAAA;EpE6pOR;EoE3pOM;;IAEE,gCAAA;EpE6pOR;EoE3pOM;;IAEE,iCAAA;EpE6pOR;EoE3pOM;;IAEE,+BAAA;EpE6pOR;EoE9qOM;IACE,wBAAA;EpEgrOR;EoE9qOM;;IAEE,4BAAA;EpEgrOR;EoE9qOM;;IAEE,8BAAA;EpEgrOR;EoE9qOM;;IAEE,+BAAA;EpEgrOR;EoE9qOM;;IAEE,6BAAA;EpEgrOR;EoEjsOM;IACE,0BAAA;EpEmsOR;EoEjsOM;;IAEE,8BAAA;EpEmsOR;EoEjsOM;;IAEE,gCAAA;EpEmsOR;EoEjsOM;;IAEE,iCAAA;EpEmsOR;EoEjsOM;;IAEE,+BAAA;EpEmsOR;EoEptOM;IACE,wBAAA;EpEstOR;EoEptOM;;IAEE,4BAAA;EpEstOR;EoEptOM;;IAEE,8BAAA;EpEstOR;EoEptOM;;IAEE,+BAAA;EpEstOR;EoEptOM;;IAEE,6BAAA;EpEstOR;EoEhtOE;IACE,uBAAA;EpEktOJ;EoEhtOE;;IAEE,2BAAA;EpEktOJ;EoEhtOE;;IAEE,6BAAA;EpEktOJ;EoEhtOE;;IAEE,8BAAA;EpEktOJ;EoEhtOE;;IAEE,4BAAA;EpEktOJ;AACF;AqE9vOA;EACE,8BAAA;ArEgwOF;;AqE7vOA;EACE,8BAAA;ArEgwOF;;AqE7vOA;ECZE,gBAAA;EACA,uBAAA;EACA,mBAAA;AtE6wOF;;AqEzvOI;EACE,2BAAA;ArE4vON;;AqE1vOI;EACE,4BAAA;ArE6vON;;AqE3vOI;EACE,6BAAA;ArE8vON;;AgBnuOI;EqDlCA;IACE,2BAAA;ErEywOJ;EqEvwOE;IACE,4BAAA;ErEywOJ;EqEvwOE;IACE,6BAAA;ErEywOJ;AACF;AgB/uOI;EqDlCA;IACE,2BAAA;ErEoxOJ;EqElxOE;IACE,4BAAA;ErEoxOJ;EqElxOE;IACE,6BAAA;ErEoxOJ;AACF;AgB1vOI;EqDlCA;IACE,2BAAA;ErE+xOJ;EqE7xOE;IACE,4BAAA;ErE+xOJ;EqE7xOE;IACE,6BAAA;ErE+xOJ;AACF;AgBrwOI;EqDlCA;IACE,2BAAA;ErE0yOJ;EqExyOE;IACE,4BAAA;ErE0yOJ;EqExyOE;IACE,6BAAA;ErE0yOJ;AACF;AqEpyOA;EACE,oCAAA;ArEsyOF;;AqEnyOA;EACE,oCAAA;ArEsyOF;;AqEnyOA;EACE,qCAAA;ArEsyOF;;AqEjyOA;EACE,2BAAA;ArEoyOF;;AqEjyOA;EACE,2BAAA;ArEoyOF;;AqEjyOA;EACE,2BAAA;ArEoyOF;;AqEjyOA;EACE,6BAAA;ArEoyOF;;AqE/xOA;EACE,sBAAA;ArEkyOF;;AuEt2OE;EACE,yBAAA;AvEy2OJ;;AM31OE;EiEVI,mEAAA;AvEy2ON;;AuE92OE;EACE,yBAAA;AvEi3OJ;;AMn2OE;EiEVI,mEAAA;AvEi3ON;;AuEt3OE;EACE,yBAAA;AvEy3OJ;;AM32OE;EiEVI,mEAAA;AvEy3ON;;AuE93OE;EACE,yBAAA;AvEi4OJ;;AMn3OE;EiEVI,6CAAA;AvEi4ON;;AuEt4OE;EACE,yBAAA;AvEy4OJ;;AM33OE;EiEVI,oCAAA;AvEy4ON;;AuE94OE;EACE,yBAAA;AvEi5OJ;;AMn4OE;EiEVI,mEAAA;AvEi5ON;;AuEt5OE;EACE,yBAAA;AvEy5OJ;;AM34OE;EiEVI,sDAAA;AvEy5ON;;AuE95OE;EACE,yBAAA;AvEi6OJ;;AMn5OE;EiEVI,yDAAA;AvEi6ON;;AqE31OA;EACE,yBAAA;ArE81OF;;AqEz1OA;EGnFE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;AxEg7OF;;AyEn7OA;ECCE,8BAAA;A1Es7OF;;AyEn7OA;ECHE,6BAAA;A1E07OF;;A2Ep7OE;EACE;;;IAKE,4BAAA;IAEA,2BAAA;E3Eo7OJ;E2Eh7OI;IACE,0BAAA;E3Ek7ON;E2Ez6OE;IACE,6BAAA;E3E26OJ;E2E75OE;IACE,gCAAA;E3E+5OJ;E2E75OE;;IAEE,sBAAA;IACA,wBAAA;E3E+5OJ;E2Ev5OE;IACE,2BAAA;E3Ey5OJ;E2Et5OE;;IAEE,wBAAA;E3Ew5OJ;E2Er5OE;;;IAGE,UAAA;IACA,SAAA;E3Eu5OJ;E2Ep5OE;;IAEE,uBAAA;E3Es5OJ;E2E94OE;IACE,QtEwwBY;ELwoNhB;E2E94OE;IACE,2BAAA;E3Eg5OJ;E2E94OE;IACE,2BAAA;E3Eg5OJ;E2E54OE;IACE,aAAA;E3E84OJ;E2E54OE;IACE,sBAAA;E3E84OJ;E2E34OE;IACE,oCAAA;E3E64OJ;E2E34OI;;IAEE,iCAAA;E3E64ON;E2Ez4OI;;IAEE,iCAAA;E3E24ON;AACF","sourcesContent":["@charset \"UTF-8\";\n@import url(\"https://fonts.googleapis.com/css?family=Roboto:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap\");\n@import url(\"https://fonts.googleapis.com/css?family=Poppins:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap\");\n@import url(\"https://fonts.googleapis.com/icon?family=Material+Icons\");\n/*!\n * Bootstrap v4.0.0 (https://getbootstrap.com)\n * Copyright 2011-2018 The Bootstrap Authors\n * Copyright 2011-2018 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n:root {\n  --blue: #007bff;\n  --indigo: #6610f2;\n  --purple: #6f42c1;\n  --pink: #e83e8c;\n  --red: #dc3545;\n  --orange: #fd7e14;\n  --yellow: #ffc107;\n  --green: #28a745;\n  --teal: #20c997;\n  --cyan: #17a2b8;\n  --white: #fff;\n  --gray: #6c757d;\n  --gray-dark: #343a40;\n  --primary: #3f51b5;\n  --secondary: #E91E63;\n  --success: #4caf50;\n  --info: #00bcd4;\n  --warning: #ff9800;\n  --danger: #f44336;\n  --light: #e8eaf6;\n  --dark: #343a40;\n  --breakpoint-xs: 0;\n  --breakpoint-sm: 576px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 992px;\n  --breakpoint-xl: 1200px;\n  --font-family-sans-serif: \"Roboto\", sans-serif;\n  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -ms-overflow-style: scrollbar;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n@-ms-viewport {\n  width: device-width;\n}\narticle, aside, dialog, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #5c5c5c;\n  text-align: left;\n  background-color: #fff;\n}\n\n[tabindex=\"-1\"]:focus {\n  outline: 0 !important;\n}\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: 12px;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n  cursor: help;\n  border-bottom: 0;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\ndfn {\n  font-style: italic;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: #3f51b5;\n  text-decoration: none;\n  background-color: transparent;\n  -webkit-text-decoration-skip: objects;\n}\na:hover {\n  color: rgb(49.8319672131, 64.0696721311, 143.1680327869);\n  text-decoration: underline;\n}\n\na:not([href]):not([tabindex]) {\n  color: inherit;\n  text-decoration: none;\n}\na:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus {\n  color: inherit;\n  text-decoration: none;\n}\na:not([href]):not([tabindex]):focus {\n  outline: 0;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\n\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  -ms-overflow-style: scrollbar;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\ntable {\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: #6c757d;\n  text-align: left;\n  caption-side: bottom;\n}\n\nth {\n  text-align: inherit;\n}\n\nlabel {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\nbutton,\nhtml [type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\n\nbutton::-moz-focus-inner,\n[type=button]::-moz-focus-inner,\n[type=reset]::-moz-focus-inner,\n[type=submit]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=radio],\ninput[type=checkbox] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\ninput[type=date],\ninput[type=time],\ninput[type=datetime-local],\ninput[type=month] {\n  -webkit-appearance: listbox;\n}\n\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit;\n  white-space: normal;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[type=number]::-webkit-inner-spin-button,\n[type=number]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\n\n[type=search]::-webkit-search-cancel-button,\n[type=search]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\ntemplate {\n  display: none;\n}\n\n[hidden] {\n  display: none !important;\n}\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: 12px;\n  font-family: inherit;\n  font-weight: 400;\n  line-height: 1.2;\n  color: inherit;\n}\n\nh1, .h1 {\n  font-size: 24px;\n}\n\nh2, .h2 {\n  font-size: 18px;\n}\n\nh3, .h3 {\n  font-size: 16px;\n}\n\nh4, .h4 {\n  font-size: 15px;\n}\n\nh5, .h5 {\n  font-size: 13px;\n}\n\nh6, .h6 {\n  font-size: 12px;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: 6rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.display-2 {\n  font-size: 5.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.display-3 {\n  font-size: 4.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\n.display-4 {\n  font-size: 3.5rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n\nhr {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\nsmall,\n.small {\n  font-size: 80%;\n  font-weight: 400;\n}\n\nmark,\n.mark {\n  padding: 0.2em;\n  background-color: #fcf8e3;\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n\n.blockquote-footer {\n  display: block;\n  font-size: 80%;\n  color: #6c757d;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.075);\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 90%;\n  color: #6c757d;\n}\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n\ncode {\n  font-size: 87.5%;\n  color: #e83e8c;\n  word-break: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 87.5%;\n  color: #fff;\n  background-color: #212529;\n  border-radius: 2px;\n  box-shadow: inset 0 -0.1rem 0 rgba(0, 0, 0, 0.25);\n}\nkbd kbd {\n  padding: 0;\n  font-size: 100%;\n  font-weight: 700;\n  box-shadow: none;\n}\n\npre {\n  display: block;\n  font-size: 87.5%;\n  color: #212529;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n\n.container {\n  width: 100%;\n  padding-right: 17px;\n  padding-left: 17px;\n  margin-right: auto;\n  margin-left: auto;\n}\n@media (min-width: 576px) {\n  .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container {\n    max-width: 1140px;\n  }\n}\n\n.container-fluid {\n  width: 100%;\n  padding-right: 17px;\n  padding-left: 17px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -17px;\n  margin-left: -17px;\n}\n\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n}\n.no-gutters > .col,\n.no-gutters > [class*=col-] {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.col-xl,\n.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,\n.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,\n.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,\n.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,\n.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {\n  position: relative;\n  width: 100%;\n  min-height: 1px;\n  padding-right: 17px;\n  padding-left: 17px;\n}\n\n.col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: none;\n}\n\n.col-1 {\n  flex: 0 0 8.3333333333%;\n  max-width: 8.3333333333%;\n}\n\n.col-2 {\n  flex: 0 0 16.6666666667%;\n  max-width: 16.6666666667%;\n}\n\n.col-3 {\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 33.3333333333%;\n  max-width: 33.3333333333%;\n}\n\n.col-5 {\n  flex: 0 0 41.6666666667%;\n  max-width: 41.6666666667%;\n}\n\n.col-6 {\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 58.3333333333%;\n  max-width: 58.3333333333%;\n}\n\n.col-8 {\n  flex: 0 0 66.6666666667%;\n  max-width: 66.6666666667%;\n}\n\n.col-9 {\n  flex: 0 0 75%;\n  max-width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 83.3333333333%;\n  max-width: 83.3333333333%;\n}\n\n.col-11 {\n  flex: 0 0 91.6666666667%;\n  max-width: 91.6666666667%;\n}\n\n.col-12 {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.order-first {\n  order: -1;\n}\n\n.order-last {\n  order: 13;\n}\n\n.order-0 {\n  order: 0;\n}\n\n.order-1 {\n  order: 1;\n}\n\n.order-2 {\n  order: 2;\n}\n\n.order-3 {\n  order: 3;\n}\n\n.order-4 {\n  order: 4;\n}\n\n.order-5 {\n  order: 5;\n}\n\n.order-6 {\n  order: 6;\n}\n\n.order-7 {\n  order: 7;\n}\n\n.order-8 {\n  order: 8;\n}\n\n.order-9 {\n  order: 9;\n}\n\n.order-10 {\n  order: 10;\n}\n\n.order-11 {\n  order: 11;\n}\n\n.order-12 {\n  order: 12;\n}\n\n.offset-1 {\n  margin-left: 8.3333333333%;\n}\n\n.offset-2 {\n  margin-left: 16.6666666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.3333333333%;\n}\n\n.offset-5 {\n  margin-left: 41.6666666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.3333333333%;\n}\n\n.offset-8 {\n  margin-left: 66.6666666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.3333333333%;\n}\n\n.offset-11 {\n  margin-left: 91.6666666667%;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n  .col-sm-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-sm-first {\n    order: -1;\n  }\n  .order-sm-last {\n    order: 13;\n  }\n  .order-sm-0 {\n    order: 0;\n  }\n  .order-sm-1 {\n    order: 1;\n  }\n  .order-sm-2 {\n    order: 2;\n  }\n  .order-sm-3 {\n    order: 3;\n  }\n  .order-sm-4 {\n    order: 4;\n  }\n  .order-sm-5 {\n    order: 5;\n  }\n  .order-sm-6 {\n    order: 6;\n  }\n  .order-sm-7 {\n    order: 7;\n  }\n  .order-sm-8 {\n    order: 8;\n  }\n  .order-sm-9 {\n    order: 9;\n  }\n  .order-sm-10 {\n    order: 10;\n  }\n  .order-sm-11 {\n    order: 11;\n  }\n  .order-sm-12 {\n    order: 12;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.3333333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.6666666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.3333333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.6666666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.3333333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.6666666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.3333333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n  .col-md-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-md-first {\n    order: -1;\n  }\n  .order-md-last {\n    order: 13;\n  }\n  .order-md-0 {\n    order: 0;\n  }\n  .order-md-1 {\n    order: 1;\n  }\n  .order-md-2 {\n    order: 2;\n  }\n  .order-md-3 {\n    order: 3;\n  }\n  .order-md-4 {\n    order: 4;\n  }\n  .order-md-5 {\n    order: 5;\n  }\n  .order-md-6 {\n    order: 6;\n  }\n  .order-md-7 {\n    order: 7;\n  }\n  .order-md-8 {\n    order: 8;\n  }\n  .order-md-9 {\n    order: 9;\n  }\n  .order-md-10 {\n    order: 10;\n  }\n  .order-md-11 {\n    order: 11;\n  }\n  .order-md-12 {\n    order: 12;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.3333333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.6666666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.3333333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.6666666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.3333333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.6666666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.3333333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n  .col-lg-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-lg-first {\n    order: -1;\n  }\n  .order-lg-last {\n    order: 13;\n  }\n  .order-lg-0 {\n    order: 0;\n  }\n  .order-lg-1 {\n    order: 1;\n  }\n  .order-lg-2 {\n    order: 2;\n  }\n  .order-lg-3 {\n    order: 3;\n  }\n  .order-lg-4 {\n    order: 4;\n  }\n  .order-lg-5 {\n    order: 5;\n  }\n  .order-lg-6 {\n    order: 6;\n  }\n  .order-lg-7 {\n    order: 7;\n  }\n  .order-lg-8 {\n    order: 8;\n  }\n  .order-lg-9 {\n    order: 9;\n  }\n  .order-lg-10 {\n    order: 10;\n  }\n  .order-lg-11 {\n    order: 11;\n  }\n  .order-lg-12 {\n    order: 12;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.3333333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.6666666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.3333333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.6666666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.3333333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.6666666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.3333333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n  .col-xl-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-xl-first {\n    order: -1;\n  }\n  .order-xl-last {\n    order: 13;\n  }\n  .order-xl-0 {\n    order: 0;\n  }\n  .order-xl-1 {\n    order: 1;\n  }\n  .order-xl-2 {\n    order: 2;\n  }\n  .order-xl-3 {\n    order: 3;\n  }\n  .order-xl-4 {\n    order: 4;\n  }\n  .order-xl-5 {\n    order: 5;\n  }\n  .order-xl-6 {\n    order: 6;\n  }\n  .order-xl-7 {\n    order: 7;\n  }\n  .order-xl-8 {\n    order: 8;\n  }\n  .order-xl-9 {\n    order: 9;\n  }\n  .order-xl-10 {\n    order: 10;\n  }\n  .order-xl-11 {\n    order: 11;\n  }\n  .order-xl-12 {\n    order: 12;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.3333333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.6666666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.3333333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.6666666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.3333333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.6666666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.3333333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n.table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 1rem;\n  background-color: transparent;\n}\n.table th,\n.table td {\n  padding: 0.75rem;\n  vertical-align: top;\n  border-top: 1px solid #dee2e6;\n}\n.table thead th {\n  vertical-align: bottom;\n  border-bottom: 2px solid #dee2e6;\n}\n.table tbody + tbody {\n  border-top: 2px solid #dee2e6;\n}\n.table .table {\n  background-color: #fff;\n}\n\n.table-sm th,\n.table-sm td {\n  padding: 0.3rem;\n}\n\n.table-bordered {\n  border: 1px solid #dee2e6;\n}\n.table-bordered th,\n.table-bordered td {\n  border: 1px solid #dee2e6;\n}\n.table-bordered thead th,\n.table-bordered thead td {\n  border-bottom-width: 2px;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.table-hover tbody tr:hover {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n\n.table-primary,\n.table-primary > th,\n.table-primary > td {\n  background-color: rgb(201.24, 206.28, 234.28);\n}\n\n.table-hover .table-primary:hover {\n  background-color: rgb(182.8339849624, 189.5995488722, 227.1860150376);\n}\n.table-hover .table-primary:hover > td,\n.table-hover .table-primary:hover > th {\n  background-color: rgb(182.8339849624, 189.5995488722, 227.1860150376);\n}\n\n.table-secondary,\n.table-secondary > th,\n.table-secondary > td {\n  background-color: rgb(248.84, 192, 211.32);\n}\n\n.table-hover .table-secondary:hover {\n  background-color: rgb(246.5687449393, 168.7712550607, 195.2147368421);\n}\n.table-hover .table-secondary:hover > td,\n.table-hover .table-secondary:hover > th {\n  background-color: rgb(246.5687449393, 168.7712550607, 195.2147368421);\n}\n\n.table-success,\n.table-success > th,\n.table-success > td {\n  background-color: rgb(204.88, 232.6, 206);\n}\n\n.table-hover .table-success:hover {\n  background-color: rgb(187.2564478764, 224.7235521236, 188.7702702703);\n}\n.table-hover .table-success:hover > td,\n.table-hover .table-success:hover > th {\n  background-color: rgb(187.2564478764, 224.7235521236, 188.7702702703);\n}\n\n.table-info,\n.table-info > th,\n.table-info > td {\n  background-color: rgb(183.6, 236.24, 242.96);\n}\n\n.table-hover .table-info:hover {\n  background-color: rgb(161.7795302013, 230.5067785235, 239.2804697987);\n}\n.table-hover .table-info:hover > td,\n.table-hover .table-info:hover > th {\n  background-color: rgb(161.7795302013, 230.5067785235, 239.2804697987);\n}\n\n.table-warning,\n.table-warning > th,\n.table-warning > td {\n  background-color: rgb(255, 226.16, 183.6);\n}\n\n.table-hover .table-warning:hover {\n  background-color: rgb(255, 215.86, 158.1);\n}\n.table-hover .table-warning:hover > td,\n.table-hover .table-warning:hover > th {\n  background-color: rgb(255, 215.86, 158.1);\n}\n\n.table-danger,\n.table-danger > th,\n.table-danger > td {\n  background-color: rgb(251.92, 202.36, 198.72);\n}\n\n.table-hover .table-danger:hover {\n  background-color: rgb(250.5968867925, 179.7467924528, 174.5431132075);\n}\n.table-hover .table-danger:hover > td,\n.table-hover .table-danger:hover > th {\n  background-color: rgb(250.5968867925, 179.7467924528, 174.5431132075);\n}\n\n.table-light,\n.table-light > th,\n.table-light > td {\n  background-color: rgb(248.56, 249.12, 252.48);\n}\n\n.table-hover .table-light:hover {\n  background-color: rgb(230.231875, 232.385625, 245.308125);\n}\n.table-hover .table-light:hover > td,\n.table-hover .table-light:hover > th {\n  background-color: rgb(230.231875, 232.385625, 245.308125);\n}\n\n.table-dark,\n.table-dark > th,\n.table-dark > td {\n  background-color: rgb(198.16, 199.84, 201.52);\n}\n\n.table-hover .table-dark:hover {\n  background-color: rgb(185.0216751269, 187.09, 189.1583248731);\n}\n.table-hover .table-dark:hover > td,\n.table-hover .table-dark:hover > th {\n  background-color: rgb(185.0216751269, 187.09, 189.1583248731);\n}\n\n.table-active,\n.table-active > th,\n.table-active > td {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n\n.table-hover .table-active:hover {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n.table-hover .table-active:hover > td,\n.table-hover .table-active:hover > th {\n  background-color: rgba(0, 0, 0, 0.075);\n}\n\n.table .thead-dark th {\n  color: #fff;\n  background-color: #212529;\n  border-color: rgb(50.0574324324, 56.125, 62.1925675676);\n}\n.table .thead-light th {\n  color: #495057;\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n}\n\n.table-dark {\n  color: #fff;\n  background-color: #212529;\n}\n.table-dark th,\n.table-dark td,\n.table-dark thead th {\n  border-color: rgb(50.0574324324, 56.125, 62.1925675676);\n}\n.table-dark.table-bordered {\n  border: 0;\n}\n.table-dark.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n.table-dark.table-hover tbody tr:hover {\n  background-color: rgba(255, 255, 255, 0.075);\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n  }\n  .table-responsive-sm > .table-bordered {\n    border: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n  }\n  .table-responsive-md > .table-bordered {\n    border: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n  }\n  .table-responsive-lg > .table-bordered {\n    border: 0;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n  }\n  .table-responsive-xl > .table-bordered {\n    border: 0;\n  }\n}\n.table-responsive {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n.table-responsive > .table-bordered {\n  border: 0;\n}\n\n.table-middle td,\n.table-middle thead th {\n  vertical-align: middle;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n.form-control::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.form-control:focus {\n  color: #495057;\n  background-color: #fff;\n  border-color: rgb(127.5, 189, 255);\n  outline: 0;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.form-control::placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.form-control:disabled, .form-control[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n\nselect.form-control:not([size]):not([multiple]) {\n  height: calc(2.25rem + 2px);\n}\nselect.form-control:focus::-ms-value {\n  color: #495057;\n  background-color: #fff;\n}\n\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n.col-form-label {\n  padding-top: calc(0.375rem + 1px);\n  padding-bottom: calc(0.375rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 17px;\n  line-height: 1.5;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + 1px);\n  padding-bottom: calc(0.25rem + 1px);\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  margin-bottom: 0;\n  line-height: 1.5;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext.form-control-sm, .input-group-sm > .form-control-plaintext.form-control,\n.input-group-sm > .input-group-prepend > .form-control-plaintext.input-group-text,\n.input-group-sm > .input-group-append > .form-control-plaintext.input-group-text,\n.input-group-sm > .input-group-prepend > .form-control-plaintext.btn,\n.input-group-sm > .input-group-append > .form-control-plaintext.btn, .form-control-plaintext.form-control-lg, .input-group-lg > .form-control-plaintext.form-control,\n.input-group-lg > .input-group-prepend > .form-control-plaintext.input-group-text,\n.input-group-lg > .input-group-append > .form-control-plaintext.input-group-text,\n.input-group-lg > .input-group-prepend > .form-control-plaintext.btn,\n.input-group-lg > .input-group-append > .form-control-plaintext.btn {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm, .input-group-sm > .form-control,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 13px;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n\nselect.form-control-sm:not([size]):not([multiple]), .input-group-sm > select.form-control:not([size]):not([multiple]),\n.input-group-sm > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),\n.input-group-sm > .input-group-append > select.input-group-text:not([size]):not([multiple]),\n.input-group-sm > .input-group-prepend > select.btn:not([size]):not([multiple]),\n.input-group-sm > .input-group-append > select.btn:not([size]):not([multiple]) {\n  height: calc(1.8125rem + 2px);\n}\n\n.form-control-lg, .input-group-lg > .form-control,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 17px;\n  line-height: 1.5;\n  border-radius: 0.3rem;\n}\n\nselect.form-control-lg:not([size]):not([multiple]), .input-group-lg > select.form-control:not([size]):not([multiple]),\n.input-group-lg > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),\n.input-group-lg > .input-group-append > select.input-group-text:not([size]):not([multiple]),\n.input-group-lg > .input-group-prepend > select.btn:not([size]):not([multiple]),\n.input-group-lg > .input-group-append > select.btn:not([size]):not([multiple]) {\n  height: calc(2.875rem + 2px);\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-text {\n  display: block;\n  margin-top: 0.25rem;\n}\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n}\n.form-row > .col,\n.form-row > [class*=col-] {\n  padding-right: 5px;\n  padding-left: 5px;\n}\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: 1.25rem;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: 0.3rem;\n  margin-left: -1.25rem;\n}\n.form-check-input:disabled ~ .form-check-label {\n  color: #6c757d;\n}\n\n.form-check-label {\n  margin-bottom: 0;\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0;\n  margin-right: 0.75rem;\n}\n.form-check-inline .form-check-input {\n  position: static;\n  margin-top: 0;\n  margin-right: 0.3125rem;\n  margin-left: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #28a745;\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  line-height: 1;\n  color: #fff;\n  background-color: rgba(40, 167, 69, 0.8);\n  border-radius: 0.2rem;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid,\n.was-validated .custom-select:valid,\n.custom-select.is-valid {\n  border-color: #28a745;\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus,\n.was-validated .custom-select:valid:focus,\n.custom-select.is-valid:focus {\n  border-color: #28a745;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n.was-validated .form-control:valid ~ .valid-feedback,\n.was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,\n.form-control.is-valid ~ .valid-tooltip,\n.was-validated .custom-select:valid ~ .valid-feedback,\n.was-validated .custom-select:valid ~ .valid-tooltip,\n.custom-select.is-valid ~ .valid-feedback,\n.custom-select.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: #28a745;\n}\n.was-validated .form-check-input:valid ~ .valid-feedback,\n.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,\n.form-check-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {\n  color: #28a745;\n}\n.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {\n  background-color: rgb(113.4130434783, 221.0869565217, 138);\n}\n.was-validated .custom-control-input:valid ~ .valid-feedback,\n.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,\n.custom-control-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {\n  background-color: rgb(51.6956521739, 206.3043478261, 87);\n}\n.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n\n.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {\n  border-color: #28a745;\n}\n.was-validated .custom-file-input:valid ~ .custom-file-label::before, .custom-file-input.is-valid ~ .custom-file-label::before {\n  border-color: inherit;\n}\n.was-validated .custom-file-input:valid ~ .valid-feedback,\n.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,\n.custom-file-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #dc3545;\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  line-height: 1;\n  color: #fff;\n  background-color: rgba(220, 53, 69, 0.8);\n  border-radius: 0.2rem;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid,\n.was-validated .custom-select:invalid,\n.custom-select.is-invalid {\n  border-color: #dc3545;\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus,\n.was-validated .custom-select:invalid:focus,\n.custom-select.is-invalid:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n.was-validated .form-control:invalid ~ .invalid-feedback,\n.was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,\n.form-control.is-invalid ~ .invalid-tooltip,\n.was-validated .custom-select:invalid ~ .invalid-feedback,\n.was-validated .custom-select:invalid ~ .invalid-tooltip,\n.custom-select.is-invalid ~ .invalid-feedback,\n.custom-select.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: #dc3545;\n}\n.was-validated .form-check-input:invalid ~ .invalid-feedback,\n.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,\n.form-check-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {\n  color: #dc3545;\n}\n.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {\n  background-color: rgb(238.8291139241, 161.6708860759, 169.0632911392);\n}\n.was-validated .custom-control-input:invalid ~ .invalid-feedback,\n.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,\n.custom-control-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {\n  background-color: rgb(227.5316455696, 96.4683544304, 109.0253164557);\n}\n.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n\n.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {\n  border-color: #dc3545;\n}\n.was-validated .custom-file-input:invalid ~ .custom-file-label::before, .custom-file-input.is-invalid ~ .custom-file-label::before {\n  border-color: inherit;\n}\n.was-validated .custom-file-input:invalid ~ .invalid-feedback,\n.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,\n.custom-file-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n}\n.form-inline .form-check {\n  width: 100%;\n}\n@media (min-width: 576px) {\n  .form-inline label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 0;\n  }\n  .form-inline .form-group {\n    display: flex;\n    flex: 0 0 auto;\n    flex-flow: row wrap;\n    align-items: center;\n    margin-bottom: 0;\n  }\n  .form-inline .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n  .form-inline .form-control-plaintext {\n    display: inline-block;\n  }\n  .form-inline .input-group {\n    width: auto;\n  }\n  .form-inline .form-check {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: auto;\n    padding-left: 0;\n  }\n  .form-inline .form-check-input {\n    position: relative;\n    margin-top: 0;\n    margin-right: 0.25rem;\n    margin-left: 0;\n  }\n  .form-inline .custom-control {\n    align-items: center;\n    justify-content: center;\n  }\n  .form-inline .custom-control-label {\n    margin-bottom: 0;\n  }\n}\n\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  user-select: none;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 13px;\n  line-height: 1.2;\n  border-radius: 0.25rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n.btn:hover, .btn:focus {\n  text-decoration: none;\n}\n.btn:focus, .btn.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.btn.disabled, .btn:disabled {\n  opacity: 0.65;\n  box-shadow: none;\n}\n.btn:not(:disabled):not(.disabled) {\n  cursor: pointer;\n}\n.btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {\n  background-image: none;\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n.btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus {\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25), inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #3f51b5;\n  border-color: #3f51b5;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.btn-primary:hover {\n  color: #fff;\n  background-color: rgb(53.1239754098, 68.3022540984, 152.6260245902);\n  border-color: rgb(49.8319672131, 64.0696721311, 143.1680327869);\n}\n.btn-primary:focus, .btn-primary.focus {\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(63, 81, 181, 0.5);\n}\n.btn-primary.disabled, .btn-primary:disabled {\n  color: #fff;\n  background-color: #3f51b5;\n  border-color: #3f51b5;\n}\n.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(49.8319672131, 64.0696721311, 143.1680327869);\n  border-color: rgb(46.5399590164, 59.8370901639, 133.7100409836);\n}\n.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(63, 81, 181, 0.5);\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: #E91E63;\n  border-color: #E91E63;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.btn-secondary:hover {\n  color: #fff;\n  background-color: rgb(204.7317813765, 20.0182186235, 82.8026315789);\n  border-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);\n}\n.btn-secondary:focus, .btn-secondary.focus {\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);\n}\n.btn-secondary.disabled, .btn-secondary:disabled {\n  color: #fff;\n  background-color: #E91E63;\n  border-color: #E91E63;\n}\n.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);\n  border-color: rgb(181.5030364372, 17.7469635628, 73.4078947368);\n}\n.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);\n}\n\n.btn-success {\n  color: #fff;\n  background-color: #4caf50;\n  border-color: #4caf50;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.btn-success:hover {\n  color: #fff;\n  background-color: rgb(64.4183266932, 148.3316733068, 67.8087649402);\n  border-color: rgb(60.5577689243, 139.4422310757, 63.7450199203);\n}\n.btn-success:focus, .btn-success.focus {\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(76, 175, 80, 0.5);\n}\n.btn-success.disabled, .btn-success:disabled {\n  color: #fff;\n  background-color: #4caf50;\n  border-color: #4caf50;\n}\n.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(60.5577689243, 139.4422310757, 63.7450199203);\n  border-color: rgb(56.6972111554, 130.5527888446, 59.6812749004);\n}\n.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(76, 175, 80, 0.5);\n}\n\n.btn-info {\n  color: #fff;\n  background-color: #00bcd4;\n  border-color: #00bcd4;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.btn-info:hover {\n  color: #fff;\n  background-color: rgb(0, 154.0801886792, 173.75);\n  border-color: rgb(0, 142.7735849057, 161);\n}\n.btn-info:focus, .btn-info.focus {\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);\n}\n.btn-info.disabled, .btn-info:disabled {\n  color: #fff;\n  background-color: #00bcd4;\n  border-color: #00bcd4;\n}\n.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(0, 142.7735849057, 161);\n  border-color: rgb(0, 131.4669811321, 148.25);\n}\n.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);\n}\n\n.btn-warning {\n  color: #212529;\n  background-color: #ff9800;\n  border-color: #ff9800;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.btn-warning:hover {\n  color: #fff;\n  background-color: rgb(216.75, 129.2, 0);\n  border-color: rgb(204, 121.6, 0);\n}\n.btn-warning:focus, .btn-warning.focus {\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(255, 152, 0, 0.5);\n}\n.btn-warning.disabled, .btn-warning:disabled {\n  color: #212529;\n  background-color: #ff9800;\n  border-color: #ff9800;\n}\n.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(204, 121.6, 0);\n  border-color: rgb(191.25, 114, 0);\n}\n.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(255, 152, 0, 0.5);\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #f44336;\n  border-color: #f44336;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.btn-danger:hover {\n  color: #fff;\n  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);\n  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);\n}\n.btn-danger:focus, .btn-danger.focus {\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);\n}\n.btn-danger.disabled, .btn-danger:disabled {\n  color: #fff;\n  background-color: #f44336;\n  border-color: #f44336;\n}\n.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);\n  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);\n}\n.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);\n}\n\n.btn-light {\n  color: #212529;\n  background-color: #e8eaf6;\n  border-color: #e8eaf6;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.btn-light:hover {\n  color: #212529;\n  background-color: rgb(204.5078125, 208.8984375, 235.2421875);\n  border-color: rgb(195.34375, 200.53125, 231.65625);\n}\n.btn-light:focus, .btn-light.focus {\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);\n}\n.btn-light.disabled, .btn-light:disabled {\n  color: #212529;\n  background-color: #e8eaf6;\n  border-color: #e8eaf6;\n}\n.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {\n  color: #212529;\n  background-color: rgb(195.34375, 200.53125, 231.65625);\n  border-color: rgb(186.1796875, 192.1640625, 228.0703125);\n}\n.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);\n}\n\n.btn-dark {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.btn-dark:hover {\n  color: #fff;\n  background-color: rgb(34.8534482759, 38.875, 42.8965517241);\n  border-color: rgb(29.1379310345, 32.5, 35.8620689655);\n}\n.btn-dark:focus, .btn-dark.focus {\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\n}\n.btn-dark.disabled, .btn-dark:disabled {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(29.1379310345, 32.5, 35.8620689655);\n  border-color: rgb(23.4224137931, 26.125, 28.8275862069);\n}\n.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\n}\n\n.btn-outline-primary {\n  color: #3f51b5;\n  background-color: transparent;\n  background-image: none;\n  border-color: #3f51b5;\n}\n.btn-outline-primary:hover {\n  color: #fff;\n  background-color: #3f51b5;\n  border-color: #3f51b5;\n}\n.btn-outline-primary:focus, .btn-outline-primary.focus {\n  box-shadow: 0 0 0 0.2rem rgba(63, 81, 181, 0.5);\n}\n.btn-outline-primary.disabled, .btn-outline-primary:disabled {\n  color: #3f51b5;\n  background-color: transparent;\n}\n.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #3f51b5;\n  border-color: #3f51b5;\n}\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(63, 81, 181, 0.5);\n}\n\n.btn-outline-secondary {\n  color: #E91E63;\n  background-color: transparent;\n  background-image: none;\n  border-color: #E91E63;\n}\n.btn-outline-secondary:hover {\n  color: #fff;\n  background-color: #E91E63;\n  border-color: #E91E63;\n}\n.btn-outline-secondary:focus, .btn-outline-secondary.focus {\n  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.5);\n}\n.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {\n  color: #E91E63;\n  background-color: transparent;\n}\n.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #E91E63;\n  border-color: #E91E63;\n}\n.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(233, 30, 99, 0.5);\n}\n\n.btn-outline-success {\n  color: #4caf50;\n  background-color: transparent;\n  background-image: none;\n  border-color: #4caf50;\n}\n.btn-outline-success:hover {\n  color: #fff;\n  background-color: #4caf50;\n  border-color: #4caf50;\n}\n.btn-outline-success:focus, .btn-outline-success.focus {\n  box-shadow: 0 0 0 0.2rem rgba(76, 175, 80, 0.5);\n}\n.btn-outline-success.disabled, .btn-outline-success:disabled {\n  color: #4caf50;\n  background-color: transparent;\n}\n.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {\n  color: #fff;\n  background-color: #4caf50;\n  border-color: #4caf50;\n}\n.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(76, 175, 80, 0.5);\n}\n\n.btn-outline-info {\n  color: #00bcd4;\n  background-color: transparent;\n  background-image: none;\n  border-color: #00bcd4;\n}\n.btn-outline-info:hover {\n  color: #fff;\n  background-color: #00bcd4;\n  border-color: #00bcd4;\n}\n.btn-outline-info:focus, .btn-outline-info.focus {\n  box-shadow: 0 0 0 0.2rem rgba(0, 188, 212, 0.5);\n}\n.btn-outline-info.disabled, .btn-outline-info:disabled {\n  color: #00bcd4;\n  background-color: transparent;\n}\n.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {\n  color: #fff;\n  background-color: #00bcd4;\n  border-color: #00bcd4;\n}\n.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(0, 188, 212, 0.5);\n}\n\n.btn-outline-warning {\n  color: #ff9800;\n  background-color: transparent;\n  background-image: none;\n  border-color: #ff9800;\n}\n.btn-outline-warning:hover {\n  color: #212529;\n  background-color: #ff9800;\n  border-color: #ff9800;\n}\n.btn-outline-warning:focus, .btn-outline-warning.focus {\n  box-shadow: 0 0 0 0.2rem rgba(255, 152, 0, 0.5);\n}\n.btn-outline-warning.disabled, .btn-outline-warning:disabled {\n  color: #ff9800;\n  background-color: transparent;\n}\n.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {\n  color: #212529;\n  background-color: #ff9800;\n  border-color: #ff9800;\n}\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(255, 152, 0, 0.5);\n}\n\n.btn-outline-danger {\n  color: #f44336;\n  background-color: transparent;\n  background-image: none;\n  border-color: #f44336;\n}\n.btn-outline-danger:hover {\n  color: #fff;\n  background-color: #f44336;\n  border-color: #f44336;\n}\n.btn-outline-danger:focus, .btn-outline-danger.focus {\n  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);\n}\n.btn-outline-danger.disabled, .btn-outline-danger:disabled {\n  color: #f44336;\n  background-color: transparent;\n}\n.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #f44336;\n  border-color: #f44336;\n}\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(244, 67, 54, 0.5);\n}\n\n.btn-outline-light {\n  color: #e8eaf6;\n  background-color: transparent;\n  background-image: none;\n  border-color: #e8eaf6;\n}\n.btn-outline-light:hover {\n  color: #212529;\n  background-color: #e8eaf6;\n  border-color: #e8eaf6;\n}\n.btn-outline-light:focus, .btn-outline-light.focus {\n  box-shadow: 0 0 0 0.2rem rgba(232, 234, 246, 0.5);\n}\n.btn-outline-light.disabled, .btn-outline-light:disabled {\n  color: #e8eaf6;\n  background-color: transparent;\n}\n.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {\n  color: #212529;\n  background-color: #e8eaf6;\n  border-color: #e8eaf6;\n}\n.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(232, 234, 246, 0.5);\n}\n\n.btn-outline-dark {\n  color: #343a40;\n  background-color: transparent;\n  background-image: none;\n  border-color: #343a40;\n}\n.btn-outline-dark:hover {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-outline-dark:focus, .btn-outline-dark.focus {\n  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\n}\n.btn-outline-dark.disabled, .btn-outline-dark:disabled {\n  color: #343a40;\n  background-color: transparent;\n}\n.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125), 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\n}\n\n.btn-link {\n  font-weight: 400;\n  color: #3f51b5;\n  background-color: transparent;\n}\n.btn-link:hover {\n  color: rgb(49.8319672131, 64.0696721311, 143.1680327869);\n  text-decoration: underline;\n  background-color: transparent;\n  border-color: transparent;\n}\n.btn-link:focus, .btn-link.focus {\n  text-decoration: underline;\n  border-color: transparent;\n  box-shadow: none;\n}\n.btn-link:disabled, .btn-link.disabled {\n  color: #6c757d;\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 17px;\n  line-height: 1.5;\n  border-radius: 0.3rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 13px;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n}\n\n.btn-block {\n  display: block;\n  width: 100%;\n}\n.btn-block + .btn-block {\n  margin-top: 0.5rem;\n}\n\ninput[type=submit].btn-block,\ninput[type=reset].btn-block,\ninput[type=button].btn-block {\n  width: 100%;\n}\n\n.fade {\n  opacity: 0;\n  transition: opacity 0.15s linear;\n}\n.fade.show {\n  opacity: 1;\n}\n\n.collapse {\n  display: none;\n}\n.collapse.show {\n  display: block;\n}\n\ntr.collapse.show {\n  display: table-row;\n}\n\ntbody.collapse.show {\n  display: table-row-group;\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n\n.dropup,\n.dropdown {\n  position: relative;\n}\n\n.dropdown-toggle::after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: 0.5rem 0;\n  margin: 0.125rem 0 0;\n  font-size: 13px;\n  color: #5c5c5c;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);\n}\n\n.dropup .dropdown-menu {\n  margin-top: 0;\n  margin-bottom: 0.125rem;\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropright .dropdown-menu {\n  margin-top: 0;\n  margin-left: 0.125rem;\n}\n.dropright .dropdown-toggle::after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropright .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropright .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropleft .dropdown-menu {\n  margin-top: 0;\n  margin-right: 0.125rem;\n}\n.dropleft .dropdown-toggle::after {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropleft .dropdown-toggle::after {\n  display: none;\n}\n.dropleft .dropdown-toggle::before {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropleft .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropleft .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: 0.5rem 0;\n  overflow: hidden;\n  border-top: 1px solid #e9ecef;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.25rem 1.5rem;\n  clear: both;\n  font-weight: 400;\n  color: #212529;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: rgb(21.6283783784, 24.25, 26.8716216216);\n  text-decoration: none;\n  background-color: #f8f9fa;\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: #fff;\n  text-decoration: none;\n  background-color: #007bff;\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: #6c757d;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: 0.5rem 1.5rem;\n  margin-bottom: 0;\n  font-size: 13px;\n  color: #6c757d;\n  white-space: nowrap;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 0 1 auto;\n}\n.btn-group > .btn:hover,\n.btn-group-vertical > .btn:hover {\n  z-index: 1;\n}\n.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n.btn-group .btn + .btn,\n.btn-group .btn + .btn-group,\n.btn-group .btn-group + .btn,\n.btn-group .btn-group + .btn-group,\n.btn-group-vertical .btn + .btn,\n.btn-group-vertical .btn + .btn-group,\n.btn-group-vertical .btn-group + .btn,\n.btn-group-vertical .btn-group + .btn-group {\n  margin-left: -1px;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group > .btn:first-child {\n  margin-left: 0;\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem;\n}\n.dropdown-toggle-split::after {\n  margin-left: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group.show .dropdown-toggle {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n.btn-group.show .dropdown-toggle.btn-link {\n  box-shadow: none;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical .btn,\n.btn-group-vertical .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn + .btn,\n.btn-group-vertical > .btn + .btn-group,\n.btn-group-vertical > .btn-group + .btn,\n.btn-group-vertical > .btn-group + .btn-group {\n  margin-top: -1px;\n  margin-left: 0;\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.btn-group-toggle > .btn,\n.btn-group-toggle > .btn-group > .btn {\n  margin-bottom: 0;\n}\n.btn-group-toggle > .btn input[type=radio],\n.btn-group-toggle > .btn input[type=checkbox],\n.btn-group-toggle > .btn-group > .btn input[type=radio],\n.btn-group-toggle > .btn-group > .btn input[type=checkbox] {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .custom-select,\n.input-group > .custom-file {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  margin-bottom: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .custom-select:focus,\n.input-group > .custom-file:focus {\n  z-index: 3;\n}\n.input-group > .form-control + .form-control,\n.input-group > .form-control + .custom-select,\n.input-group > .form-control + .custom-file,\n.input-group > .custom-select + .form-control,\n.input-group > .custom-select + .custom-select,\n.input-group > .custom-select + .custom-file,\n.input-group > .custom-file + .form-control,\n.input-group > .custom-file + .custom-select,\n.input-group > .custom-file + .custom-file {\n  margin-left: -1px;\n}\n.input-group > .form-control:not(:last-child),\n.input-group > .custom-select:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > .form-control:not(:first-child),\n.input-group > .custom-select:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .custom-file {\n  display: flex;\n  align-items: center;\n}\n.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::before {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > .custom-file:not(:first-child) .custom-file-label, .input-group > .custom-file:not(:first-child) .custom-file-label::before {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n}\n.input-group-prepend .btn,\n.input-group-append .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group-prepend .btn + .btn,\n.input-group-prepend .btn + .input-group-text,\n.input-group-prepend .input-group-text + .input-group-text,\n.input-group-prepend .input-group-text + .btn,\n.input-group-append .btn + .btn,\n.input-group-append .btn + .input-group-text,\n.input-group-append .input-group-text + .input-group-text,\n.input-group-append .input-group-text + .btn {\n  margin-left: -1px;\n}\n\n.input-group-prepend {\n  margin-right: -1px;\n}\n\n.input-group-append {\n  margin-left: -1px;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #e9ecef;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n.input-group-text input[type=radio],\n.input-group-text input[type=checkbox] {\n  margin-top: 0;\n}\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group > .input-group-append:not(:last-child) > .btn,\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.custom-control {\n  position: relative;\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.5rem;\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: 1rem;\n}\n\n.custom-control-input {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n}\n.custom-control-input:checked ~ .custom-control-label::before {\n  color: #fff;\n  background-color: #007bff;\n  box-shadow: none;\n}\n.custom-control-input:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.custom-control-input:active ~ .custom-control-label::before {\n  color: #fff;\n  background-color: rgb(178.5, 215.4, 255);\n  box-shadow: none;\n}\n.custom-control-input:disabled ~ .custom-control-label {\n  color: #6c757d;\n}\n.custom-control-input:disabled ~ .custom-control-label::before {\n  background-color: #e9ecef;\n}\n\n.custom-control-label {\n  margin-bottom: 0;\n}\n.custom-control-label::before {\n  position: absolute;\n  top: 0.25rem;\n  left: 0;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  pointer-events: none;\n  content: \"\";\n  user-select: none;\n  background-color: #dee2e6;\n  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);\n}\n.custom-control-label::after {\n  position: absolute;\n  top: 0.25rem;\n  left: 0;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  content: \"\";\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 50% 50%;\n}\n\n.custom-checkbox .custom-control-label::before {\n  border-radius: 0.25rem;\n}\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #007bff;\n}\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\");\n}\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {\n  background-color: #007bff;\n  box-shadow: none;\n}\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='%23fff' d='M0 2h4'/%3E%3C/svg%3E\");\n}\n.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(0, 123, 255, 0.5);\n}\n.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {\n  background-color: rgba(0, 123, 255, 0.5);\n}\n\n.custom-radio .custom-control-label::before {\n  border-radius: 50%;\n}\n.custom-radio .custom-control-input:checked ~ .custom-control-label::before {\n  background-color: #007bff;\n}\n.custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\");\n}\n.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(0, 123, 255, 0.5);\n}\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: calc(2.25rem + 2px);\n  padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n  line-height: 1.5;\n  color: #495057;\n  vertical-align: middle;\n  background: #fff url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat right 0.75rem center;\n  background-size: 8px 10px;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  appearance: none;\n}\n.custom-select:focus {\n  border-color: rgb(127.5, 189, 255);\n  outline: 0;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 5px rgba(127.5, 189, 255, 0.5);\n}\n.custom-select:focus::-ms-value {\n  color: #495057;\n  background-color: #fff;\n}\n.custom-select[multiple], .custom-select[size]:not([size=\"1\"]) {\n  height: auto;\n  padding-right: 0.75rem;\n  background-image: none;\n}\n.custom-select:disabled {\n  color: #6c757d;\n  background-color: #e9ecef;\n}\n.custom-select::-ms-expand {\n  opacity: 0;\n}\n\n.custom-select-sm {\n  height: calc(1.8125rem + 2px);\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  font-size: 75%;\n}\n\n.custom-select-lg {\n  height: calc(2.875rem + 2px);\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  font-size: 125%;\n}\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: calc(2.25rem + 2px);\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: calc(2.25rem + 2px);\n  margin: 0;\n  opacity: 0;\n}\n.custom-file-input:focus ~ .custom-file-control {\n  border-color: rgb(127.5, 189, 255);\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.custom-file-input:focus ~ .custom-file-control::before {\n  border-color: rgb(127.5, 189, 255);\n}\n.custom-file-input:lang(en) ~ .custom-file-label::after {\n  content: \"Browse\";\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: calc(2.25rem + 2px);\n  padding: 0.375rem 0.75rem;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.custom-file-label::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 3;\n  display: block;\n  height: calc(calc(2.25rem + 2px) - 1px * 2);\n  padding: 0.375rem 0.75rem;\n  line-height: 1.5;\n  color: #495057;\n  content: \"Browse\";\n  background-color: #e9ecef;\n  border-left: 1px solid #ced4da;\n  border-radius: 0 0.25rem 0.25rem 0;\n}\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: 0.5rem 1rem;\n}\n.nav-link:hover, .nav-link:focus {\n  text-decoration: none;\n}\n.nav-link.disabled {\n  color: #6c757d;\n}\n\n.nav-tabs {\n  border-bottom: 1px solid #dee2e6;\n}\n.nav-tabs .nav-item {\n  margin-bottom: -1px;\n}\n.nav-tabs .nav-link {\n  border: 1px solid transparent;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  border-color: #e9ecef #e9ecef #dee2e6;\n}\n.nav-tabs .nav-link.disabled {\n  color: #6c757d;\n  background-color: transparent;\n  border-color: transparent;\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: #495057;\n  background-color: #fff;\n  border-color: #dee2e6 #dee2e6 #fff;\n}\n.nav-tabs .dropdown-menu {\n  margin-top: -1px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills .nav-link {\n  border-radius: 0.25rem;\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #007bff;\n}\n\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 1rem;\n}\n.navbar > .container,\n.navbar > .container-fluid {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: 0.3125rem;\n  padding-bottom: 0.3125rem;\n  margin-right: 1rem;\n  font-size: 1.25rem;\n  line-height: inherit;\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  text-decoration: none;\n}\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n  float: none;\n}\n\n.navbar-text {\n  display: inline-block;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 1.25rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n.navbar-toggler:hover, .navbar-toggler:focus {\n  text-decoration: none;\n}\n.navbar-toggler:not(:disabled):not(.disabled) {\n  cursor: pointer;\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: no-repeat center center;\n  background-size: 100% 100%;\n}\n\n@media (max-width: 575.98px) {\n  .navbar-expand-sm > .container,\n  .navbar-expand-sm > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu-right {\n    right: 0;\n    left: auto;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-sm > .container,\n  .navbar-expand-sm > .container-fluid {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-sm .dropup .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n  }\n}\n@media (max-width: 767.98px) {\n  .navbar-expand-md > .container,\n  .navbar-expand-md > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu-right {\n    right: 0;\n    left: auto;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-md > .container,\n  .navbar-expand-md > .container-fluid {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-md .dropup .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n  }\n}\n@media (max-width: 991.98px) {\n  .navbar-expand-lg > .container,\n  .navbar-expand-lg > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu-right {\n    right: 0;\n    left: auto;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-lg > .container,\n  .navbar-expand-lg > .container-fluid {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-lg .dropup .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n  }\n}\n@media (max-width: 1199.98px) {\n  .navbar-expand-xl > .container,\n  .navbar-expand-xl > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu-right {\n    right: 0;\n    left: auto;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-xl > .container,\n  .navbar-expand-xl > .container-fluid {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xl .dropup .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n  }\n}\n.navbar-expand {\n  flex-flow: row nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand > .container,\n.navbar-expand > .container-fluid {\n  padding-right: 0;\n  padding-left: 0;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .dropdown-menu-right {\n  right: 0;\n  left: auto;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n.navbar-expand > .container,\n.navbar-expand > .container-fluid {\n  flex-wrap: nowrap;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n.navbar-expand .dropup .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n}\n\n.navbar-light .navbar-brand {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(0, 0, 0, 0.5);\n}\n.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {\n  color: rgba(0, 0, 0, 0.7);\n}\n.navbar-light .navbar-nav .nav-link.disabled {\n  color: rgba(0, 0, 0, 0.3);\n}\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-nav .active > .nav-link,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .nav-link.active {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.5);\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\");\n}\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.5);\n}\n.navbar-light .navbar-text a {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-dark .navbar-brand {\n  color: #fff;\n}\n.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {\n  color: #fff;\n}\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.5);\n}\n.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {\n  color: rgba(255, 255, 255, 0.75);\n}\n.navbar-dark .navbar-nav .nav-link.disabled {\n  color: rgba(255, 255, 255, 0.25);\n}\n.navbar-dark .navbar-nav .show > .nav-link,\n.navbar-dark .navbar-nav .active > .nav-link,\n.navbar-dark .navbar-nav .nav-link.show,\n.navbar-dark .navbar-nav .nav-link.active {\n  color: #fff;\n}\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.5);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\");\n}\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.5);\n}\n.navbar-dark .navbar-text a {\n  color: #fff;\n}\n.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {\n  color: #fff;\n}\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group:first-child .list-group-item:first-child {\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n.card > .list-group:last-child .list-group-item:last-child {\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: 30px;\n}\n\n.card-title {\n  margin-bottom: 24px;\n}\n\n.card-subtitle {\n  margin-top: -12px;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link:hover {\n  text-decoration: none;\n}\n.card-link + .card-link {\n  margin-left: 30px;\n}\n\n.card-header {\n  padding: 24px 30px;\n  margin-bottom: 0;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid #dee2e6;\n}\n.card-header:first-child {\n  border-radius: 8px 8px 0 0;\n}\n.card-header + .list-group .list-group-item:first-child {\n  border-top: 0;\n}\n\n.card-footer {\n  padding: 24px 30px;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-top: 1px solid #dee2e6;\n}\n.card-footer:last-child {\n  border-radius: 0 0 8px 8px;\n}\n\n.card-header-tabs {\n  margin-right: -15px;\n  margin-bottom: -24px;\n  margin-left: -15px;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1.25rem;\n}\n\n.card-img {\n  width: 100%;\n  border-radius: 8px;\n}\n\n.card-img-top {\n  width: 100%;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n.card-img-bottom {\n  width: 100%;\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n.card-deck {\n  display: flex;\n  flex-direction: column;\n}\n.card-deck .card {\n  margin-bottom: 15px;\n}\n@media (min-width: 576px) {\n  .card-deck {\n    flex-flow: row wrap;\n    margin-right: -15px;\n    margin-left: -15px;\n  }\n  .card-deck .card {\n    display: flex;\n    flex: 1 0 0%;\n    flex-direction: column;\n    margin-right: 15px;\n    margin-bottom: 0;\n    margin-left: 15px;\n  }\n}\n\n.card-group {\n  display: flex;\n  flex-direction: column;\n}\n.card-group > .card {\n  margin-bottom: 15px;\n}\n@media (min-width: 576px) {\n  .card-group {\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:first-child {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:first-child .card-img-top,\n  .card-group > .card:first-child .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:first-child .card-img-bottom,\n  .card-group > .card:first-child .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:last-child {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:last-child .card-img-top,\n  .card-group > .card:last-child .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:last-child .card-img-bottom,\n  .card-group > .card:last-child .card-footer {\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:only-child {\n    border-radius: 8px;\n  }\n  .card-group > .card:only-child .card-img-top,\n  .card-group > .card:only-child .card-header {\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n  }\n  .card-group > .card:only-child .card-img-bottom,\n  .card-group > .card:only-child .card-footer {\n    border-bottom-right-radius: 8px;\n    border-bottom-left-radius: 8px;\n  }\n  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) {\n    border-radius: 0;\n  }\n  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-top,\n  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,\n  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-header,\n  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-footer {\n    border-radius: 0;\n  }\n}\n\n.card-columns .card {\n  margin-bottom: 0.75rem;\n}\n@media (min-width: 576px) {\n  .card-columns {\n    column-count: 3;\n    column-gap: 1.25rem;\n  }\n  .card-columns .card {\n    display: inline-block;\n    width: 100%;\n  }\n}\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  list-style: none;\n  background-color: #e9ecef;\n  border-radius: 4px;\n}\n\n.breadcrumb-item + .breadcrumb-item::before {\n  display: inline-block;\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n  color: #6c757d;\n  content: \"/\";\n}\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: underline;\n}\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: none;\n}\n.breadcrumb-item.active {\n  color: #6c757d;\n}\n\n.pagination {\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n  border-radius: 4px;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: 0.5rem 0.75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #007bff;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n}\n.page-link:hover {\n  color: rgb(0, 86.1, 178.5);\n  text-decoration: none;\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n}\n.page-link:focus {\n  z-index: 2;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.page-link:not(:disabled):not(.disabled) {\n  cursor: pointer;\n}\n\n.page-item:first-child .page-link {\n  margin-left: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.page-item.active .page-link {\n  z-index: 1;\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff;\n}\n.page-item.disabled .page-link {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff;\n  border-color: #dee2e6;\n}\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 17px;\n  line-height: 1.5;\n}\n.pagination-lg .page-item:first-child .page-link {\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n.pagination-lg .page-item:last-child .page-link {\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 13px;\n  line-height: 1.5;\n}\n.pagination-sm .page-item:first-child .page-link {\n  border-top-left-radius: 2px;\n  border-bottom-left-radius: 2px;\n}\n.pagination-sm .page-item:last-child .page-link {\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.badge-pill {\n  padding-right: 0.6em;\n  padding-left: 0.6em;\n  border-radius: 10rem;\n}\n\n.badge-primary {\n  color: #fff;\n  background-color: #3f51b5;\n}\n.badge-primary[href]:hover, .badge-primary[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: rgb(49.8319672131, 64.0696721311, 143.1680327869);\n}\n\n.badge-secondary {\n  color: #fff;\n  background-color: #E91E63;\n}\n.badge-secondary[href]:hover, .badge-secondary[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579);\n}\n\n.badge-success {\n  color: #fff;\n  background-color: #4caf50;\n}\n.badge-success[href]:hover, .badge-success[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: rgb(60.5577689243, 139.4422310757, 63.7450199203);\n}\n\n.badge-info {\n  color: #fff;\n  background-color: #00bcd4;\n}\n.badge-info[href]:hover, .badge-info[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: rgb(0, 142.7735849057, 161);\n}\n\n.badge-warning {\n  color: #212529;\n  background-color: #ff9800;\n}\n.badge-warning[href]:hover, .badge-warning[href]:focus {\n  color: #212529;\n  text-decoration: none;\n  background-color: rgb(204, 121.6, 0);\n}\n\n.badge-danger {\n  color: #fff;\n  background-color: #f44336;\n}\n.badge-danger[href]:hover, .badge-danger[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);\n}\n\n.badge-light {\n  color: #212529;\n  background-color: #e8eaf6;\n}\n.badge-light[href]:hover, .badge-light[href]:focus {\n  color: #212529;\n  text-decoration: none;\n  background-color: rgb(195.34375, 200.53125, 231.65625);\n}\n\n.badge-dark {\n  color: #fff;\n  background-color: #343a40;\n}\n.badge-dark[href]:hover, .badge-dark[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: rgb(29.1379310345, 32.5, 35.8620689655);\n}\n\n.jumbotron {\n  padding: 2rem 1rem;\n  margin-bottom: 2rem;\n  background-color: #e9ecef;\n  border-radius: 8px;\n}\n@media (min-width: 576px) {\n  .jumbotron {\n    padding: 4rem 2rem;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  border-radius: 0;\n}\n\n.alert {\n  position: relative;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n}\n\n.alert-dismissible {\n  padding-right: 4rem;\n}\n.alert-dismissible .close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 0.75rem 1.25rem;\n  color: inherit;\n}\n\n.alert-primary {\n  color: rgb(32.76, 42.12, 94.12);\n  background-color: rgb(216.6, 220.2, 240.2);\n  border-color: rgb(201.24, 206.28, 234.28);\n}\n.alert-primary hr {\n  border-top-color: rgb(182.8339849624, 189.5995488722, 227.1860150376);\n}\n.alert-primary .alert-link {\n  color: rgb(19.5919672131, 25.1896721311, 56.2880327869);\n}\n\n.alert-secondary {\n  color: rgb(121.16, 15.6, 51.48);\n  background-color: rgb(250.6, 210, 223.8);\n  border-color: rgb(248.84, 192, 211.32);\n}\n.alert-secondary hr {\n  border-top-color: rgb(246.5687449393, 168.7712550607, 195.2147368421);\n}\n.alert-secondary .alert-link {\n  color: rgb(75.9774904943, 9.7825095057, 32.2822813688);\n}\n\n.alert-success {\n  color: rgb(39.52, 91, 41.6);\n  background-color: rgb(219.2, 239, 220);\n  border-color: rgb(204.88, 232.6, 206);\n}\n.alert-success hr {\n  border-top-color: rgb(187.2564478764, 224.7235521236, 188.7702702703);\n}\n.alert-success .alert-link {\n  color: rgb(24.0777689243, 55.4422310757, 25.3450199203);\n}\n\n.alert-info {\n  color: rgb(0, 97.76, 110.24);\n  background-color: rgb(204, 241.6, 246.4);\n  border-color: rgb(183.6, 236.24, 242.96);\n}\n.alert-info hr {\n  border-top-color: rgb(161.7795302013, 230.5067785235, 239.2804697987);\n}\n.alert-info .alert-link {\n  color: rgb(0, 52.5335849057, 59.24);\n}\n\n.alert-warning {\n  color: rgb(132.6, 79.04, 0);\n  background-color: rgb(255, 234.4, 204);\n  border-color: rgb(255, 226.16, 183.6);\n}\n.alert-warning hr {\n  border-top-color: rgb(255, 215.86, 158.1);\n}\n.alert-warning .alert-link {\n  color: rgb(81.6, 48.64, 0);\n}\n\n.alert-danger {\n  color: rgb(126.88, 34.84, 28.08);\n  background-color: rgb(252.8, 217.4, 214.8);\n  border-color: rgb(251.92, 202.36, 198.72);\n}\n.alert-danger hr {\n  border-top-color: rgb(250.5968867925, 179.7467924528, 174.5431132075);\n}\n.alert-danger .alert-link {\n  color: rgb(85.1216107383, 23.373557047, 18.8383892617);\n}\n\n.alert-light {\n  color: rgb(120.64, 121.68, 127.92);\n  background-color: rgb(250.4, 250.8, 253.2);\n  border-color: rgb(248.56, 249.12, 252.48);\n}\n.alert-light hr {\n  border-top-color: rgb(230.231875, 232.385625, 245.308125);\n}\n.alert-light .alert-link {\n  color: rgb(95.8868619247, 96.7134728033, 101.6731380753);\n}\n\n.alert-dark {\n  color: rgb(27.04, 30.16, 33.28);\n  background-color: rgb(214.4, 215.6, 216.8);\n  border-color: rgb(198.16, 199.84, 201.52);\n}\n.alert-dark hr {\n  border-top-color: rgb(185.0216751269, 187.09, 189.1583248731);\n}\n.alert-dark .alert-link {\n  color: rgb(4.1779310345, 4.66, 5.1420689655);\n}\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 1rem 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n.progress {\n  display: flex;\n  height: 1rem;\n  overflow: hidden;\n  font-size: 0.75rem;\n  background-color: #e9ecef;\n  border-radius: 0.25rem;\n  box-shadow: inset 0 0.1rem 0.1rem rgba(0, 0, 0, 0.1);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: #fff;\n  text-align: center;\n  background-color: #007bff;\n  transition: width 0.6s ease;\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 1rem 1rem;\n}\n\n.progress-bar-animated {\n  animation: progress-bar-stripes 1s linear infinite;\n}\n\n.media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n\n.social-list-line:not(:last-child) {\n  padding-bottom: 25px;\n}\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: #495057;\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  color: #495057;\n  text-decoration: none;\n  background-color: #f8f9fa;\n}\n.list-group-item-action:active {\n  color: #212529;\n  background-color: #e9ecef;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: -1px;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n}\n.list-group-item:first-child {\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n.list-group-item:last-child {\n  margin-bottom: 0;\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n.list-group-item:hover, .list-group-item:focus {\n  z-index: 1;\n  text-decoration: none;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: #6c757d;\n  background-color: #fff;\n}\n.list-group-item.active {\n  z-index: 2;\n  color: #fff;\n  background-color: #007bff;\n  border-color: #007bff;\n}\n\n.list-group-flush .list-group-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.list-group-flush:first-child .list-group-item:first-child {\n  border-top: 0;\n}\n.list-group-flush:last-child .list-group-item:last-child {\n  border-bottom: 0;\n}\n\n.list-group-item-primary {\n  color: rgb(32.76, 42.12, 94.12);\n  background-color: rgb(201.24, 206.28, 234.28);\n}\n.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n  color: rgb(32.76, 42.12, 94.12);\n  background-color: rgb(182.8339849624, 189.5995488722, 227.1860150376);\n}\n.list-group-item-primary.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(32.76, 42.12, 94.12);\n  border-color: rgb(32.76, 42.12, 94.12);\n}\n\n.list-group-item-secondary {\n  color: rgb(121.16, 15.6, 51.48);\n  background-color: rgb(248.84, 192, 211.32);\n}\n.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n  color: rgb(121.16, 15.6, 51.48);\n  background-color: rgb(246.5687449393, 168.7712550607, 195.2147368421);\n}\n.list-group-item-secondary.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(121.16, 15.6, 51.48);\n  border-color: rgb(121.16, 15.6, 51.48);\n}\n\n.list-group-item-success {\n  color: rgb(39.52, 91, 41.6);\n  background-color: rgb(204.88, 232.6, 206);\n}\n.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n  color: rgb(39.52, 91, 41.6);\n  background-color: rgb(187.2564478764, 224.7235521236, 188.7702702703);\n}\n.list-group-item-success.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(39.52, 91, 41.6);\n  border-color: rgb(39.52, 91, 41.6);\n}\n\n.list-group-item-info {\n  color: rgb(0, 97.76, 110.24);\n  background-color: rgb(183.6, 236.24, 242.96);\n}\n.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n  color: rgb(0, 97.76, 110.24);\n  background-color: rgb(161.7795302013, 230.5067785235, 239.2804697987);\n}\n.list-group-item-info.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(0, 97.76, 110.24);\n  border-color: rgb(0, 97.76, 110.24);\n}\n\n.list-group-item-warning {\n  color: rgb(132.6, 79.04, 0);\n  background-color: rgb(255, 226.16, 183.6);\n}\n.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n  color: rgb(132.6, 79.04, 0);\n  background-color: rgb(255, 215.86, 158.1);\n}\n.list-group-item-warning.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(132.6, 79.04, 0);\n  border-color: rgb(132.6, 79.04, 0);\n}\n\n.list-group-item-danger {\n  color: rgb(126.88, 34.84, 28.08);\n  background-color: rgb(251.92, 202.36, 198.72);\n}\n.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n  color: rgb(126.88, 34.84, 28.08);\n  background-color: rgb(250.5968867925, 179.7467924528, 174.5431132075);\n}\n.list-group-item-danger.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(126.88, 34.84, 28.08);\n  border-color: rgb(126.88, 34.84, 28.08);\n}\n\n.list-group-item-light {\n  color: rgb(120.64, 121.68, 127.92);\n  background-color: rgb(248.56, 249.12, 252.48);\n}\n.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n  color: rgb(120.64, 121.68, 127.92);\n  background-color: rgb(230.231875, 232.385625, 245.308125);\n}\n.list-group-item-light.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(120.64, 121.68, 127.92);\n  border-color: rgb(120.64, 121.68, 127.92);\n}\n\n.list-group-item-dark {\n  color: rgb(27.04, 30.16, 33.28);\n  background-color: rgb(198.16, 199.84, 201.52);\n}\n.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n  color: rgb(27.04, 30.16, 33.28);\n  background-color: rgb(185.0216751269, 187.09, 189.1583248731);\n}\n.list-group-item-dark.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(27.04, 30.16, 33.28);\n  border-color: rgb(27.04, 30.16, 33.28);\n}\n\n.close {\n  float: right;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n  opacity: 0.5;\n}\n.close:hover, .close:focus {\n  text-decoration: none;\n  opacity: 0.75;\n}\n.close:not(:disabled):not(.disabled) {\n  cursor: pointer;\n}\n\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n  -webkit-appearance: none;\n}\n\n.modal-open {\n  overflow: hidden;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  outline: 0;\n}\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -25%);\n}\n.modal.show .modal-dialog {\n  transform: translate(0, 0);\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - 0.5rem * 2);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.5);\n  outline: 0;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #000;\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: 0.5;\n}\n\n.modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1rem;\n  border-bottom: 1px solid #e9ecef;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n.modal-header .close {\n  padding: 1rem;\n  margin: -1rem -1rem -1rem auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 1rem;\n}\n\n.modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 1rem;\n  border-top: 1px solid #e9ecef;\n}\n.modal-footer > :not(:first-child) {\n  margin-left: 0.25rem;\n}\n.modal-footer > :not(:last-child) {\n  margin-right: 0.25rem;\n}\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin: 1.75rem auto;\n  }\n  .modal-dialog-centered {\n    min-height: calc(100% - 1.75rem * 2);\n  }\n  .modal-content {\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5);\n  }\n  .modal-sm {\n    max-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg {\n    max-width: 800px;\n  }\n}\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  margin: 0;\n  font-family: \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: 0.9;\n}\n.tooltip .arrow {\n  position: absolute;\n  display: block;\n  width: 0.8rem;\n  height: 0.4rem;\n}\n.tooltip .arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {\n  bottom: 0;\n}\n.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {\n  top: 0;\n  border-width: 0.4rem 0.4rem 0;\n  border-top-color: #000;\n}\n\n.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {\n  left: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {\n  right: 0;\n  border-width: 0.4rem 0.4rem 0.4rem 0;\n  border-right-color: #000;\n}\n\n.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {\n  top: 0;\n}\n.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {\n  bottom: 0;\n  border-width: 0 0.4rem 0.4rem;\n  border-bottom-color: #000;\n}\n\n.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {\n  right: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {\n  left: 0;\n  border-width: 0.4rem 0 0.4rem 0.4rem;\n  border-left-color: #000;\n}\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 0.25rem 0.5rem;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 0.25rem;\n}\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: block;\n  max-width: 276px;\n  font-family: \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.2);\n}\n.popover .arrow {\n  position: absolute;\n  display: block;\n  width: 1rem;\n  height: 0.5rem;\n  margin: 0 8px;\n}\n.popover .arrow::before, .popover .arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-popover-top, .bs-popover-auto[x-placement^=top] {\n  margin-bottom: 0.5rem;\n}\n.bs-popover-top .arrow, .bs-popover-auto[x-placement^=top] .arrow {\n  bottom: calc((0.5rem + 1px) * -1);\n}\n.bs-popover-top .arrow::before, .bs-popover-auto[x-placement^=top] .arrow::before,\n.bs-popover-top .arrow::after,\n.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-width: 0.5rem 0.5rem 0;\n}\n.bs-popover-top .arrow::before, .bs-popover-auto[x-placement^=top] .arrow::before {\n  bottom: 0;\n  border-top-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-top .arrow::after, .bs-popover-auto[x-placement^=top] .arrow::after {\n  bottom: 1px;\n  border-top-color: #fff;\n}\n\n.bs-popover-right, .bs-popover-auto[x-placement^=right] {\n  margin-left: 0.5rem;\n}\n.bs-popover-right .arrow, .bs-popover-auto[x-placement^=right] .arrow {\n  left: calc((0.5rem + 1px) * -1);\n  width: 0.5rem;\n  height: 1rem;\n  margin: 8px 0;\n}\n.bs-popover-right .arrow::before, .bs-popover-auto[x-placement^=right] .arrow::before,\n.bs-popover-right .arrow::after,\n.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n}\n.bs-popover-right .arrow::before, .bs-popover-auto[x-placement^=right] .arrow::before {\n  left: 0;\n  border-right-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-right .arrow::after, .bs-popover-auto[x-placement^=right] .arrow::after {\n  left: 1px;\n  border-right-color: #fff;\n}\n\n.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {\n  margin-top: 0.5rem;\n}\n.bs-popover-bottom .arrow, .bs-popover-auto[x-placement^=bottom] .arrow {\n  top: calc((0.5rem + 1px) * -1);\n}\n.bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^=bottom] .arrow::before,\n.bs-popover-bottom .arrow::after,\n.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n}\n.bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^=bottom] .arrow::before {\n  top: 0;\n  border-bottom-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-bottom .arrow::after, .bs-popover-auto[x-placement^=bottom] .arrow::after {\n  top: 1px;\n  border-bottom-color: #fff;\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: 1rem;\n  margin-left: -0.5rem;\n  content: \"\";\n  border-bottom: 1px solid rgb(247.35, 247.35, 247.35);\n}\n\n.bs-popover-left, .bs-popover-auto[x-placement^=left] {\n  margin-right: 0.5rem;\n}\n.bs-popover-left .arrow, .bs-popover-auto[x-placement^=left] .arrow {\n  right: calc((0.5rem + 1px) * -1);\n  width: 0.5rem;\n  height: 1rem;\n  margin: 8px 0;\n}\n.bs-popover-left .arrow::before, .bs-popover-auto[x-placement^=left] .arrow::before,\n.bs-popover-left .arrow::after,\n.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n}\n.bs-popover-left .arrow::before, .bs-popover-auto[x-placement^=left] .arrow::before {\n  right: 0;\n  border-left-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-left .arrow::after, .bs-popover-auto[x-placement^=left] .arrow::after {\n  right: 1px;\n  border-left-color: #fff;\n}\n\n.popover-header {\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 13px;\n  color: inherit;\n  background-color: rgb(247.35, 247.35, 247.35);\n  border-bottom: 1px solid rgb(234.6, 234.6, 234.6);\n  border-top-left-radius: calc(8px - 1px);\n  border-top-right-radius: calc(8px - 1px);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: 0.5rem 0.75rem;\n  color: #212529;\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  align-items: center;\n  width: 100%;\n  transition: transform 0.6s ease;\n  backface-visibility: hidden;\n  perspective: 1000px;\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next,\n.carousel-item-prev {\n  position: absolute;\n  top: 0;\n}\n\n.carousel-item-next.carousel-item-left,\n.carousel-item-prev.carousel-item-right {\n  transform: translateX(0);\n}\n@supports (transform-style: preserve-3d) {\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n.carousel-item-next,\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n@supports (transform-style: preserve-3d) {\n  .carousel-item-next,\n  .active.carousel-item-right {\n    transform: translate3d(100%, 0, 0);\n  }\n}\n\n.carousel-item-prev,\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n@supports (transform-style: preserve-3d) {\n  .carousel-item-prev,\n  .active.carousel-item-left {\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  color: #fff;\n  text-align: center;\n  opacity: 0.5;\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: transparent no-repeat center center;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 10px;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0;\n  margin-right: 15%;\n  margin-left: 15%;\n  list-style: none;\n}\n.carousel-indicators li {\n  position: relative;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.carousel-indicators li::before {\n  position: absolute;\n  top: -10px;\n  left: 0;\n  display: inline-block;\n  width: 100%;\n  height: 10px;\n  content: \"\";\n}\n.carousel-indicators li::after {\n  position: absolute;\n  bottom: -10px;\n  left: 0;\n  display: inline-block;\n  width: 100%;\n  height: 10px;\n  content: \"\";\n}\n.carousel-indicators .active {\n  background-color: #fff;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.bg-primary {\n  background-color: #3f51b5 !important;\n}\n\na.bg-primary:hover, a.bg-primary:focus,\nbutton.bg-primary:hover,\nbutton.bg-primary:focus {\n  background-color: rgb(49.8319672131, 64.0696721311, 143.1680327869) !important;\n}\n\n.bg-secondary {\n  background-color: #E91E63 !important;\n}\n\na.bg-secondary:hover, a.bg-secondary:focus,\nbutton.bg-secondary:hover,\nbutton.bg-secondary:focus {\n  background-color: rgb(193.1174089069, 18.8825910931, 78.1052631579) !important;\n}\n\n.bg-success {\n  background-color: #4caf50 !important;\n}\n\na.bg-success:hover, a.bg-success:focus,\nbutton.bg-success:hover,\nbutton.bg-success:focus {\n  background-color: rgb(60.5577689243, 139.4422310757, 63.7450199203) !important;\n}\n\n.bg-info {\n  background-color: #00bcd4 !important;\n}\n\na.bg-info:hover, a.bg-info:focus,\nbutton.bg-info:hover,\nbutton.bg-info:focus {\n  background-color: rgb(0, 142.7735849057, 161) !important;\n}\n\n.bg-warning {\n  background-color: #ff9800 !important;\n}\n\na.bg-warning:hover, a.bg-warning:focus,\nbutton.bg-warning:hover,\nbutton.bg-warning:focus {\n  background-color: rgb(204, 121.6, 0) !important;\n}\n\n.bg-danger {\n  background-color: #f44336 !important;\n}\n\na.bg-danger:hover, a.bg-danger:focus,\nbutton.bg-danger:hover,\nbutton.bg-danger:focus {\n  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358) !important;\n}\n\n.bg-light {\n  background-color: #e8eaf6 !important;\n}\n\na.bg-light:hover, a.bg-light:focus,\nbutton.bg-light:hover,\nbutton.bg-light:focus {\n  background-color: rgb(195.34375, 200.53125, 231.65625) !important;\n}\n\n.bg-dark {\n  background-color: #343a40 !important;\n}\n\na.bg-dark:hover, a.bg-dark:focus,\nbutton.bg-dark:hover,\nbutton.bg-dark:focus {\n  background-color: rgb(29.1379310345, 32.5, 35.8620689655) !important;\n}\n\n.bg-white {\n  background-color: #fff !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n\n.border {\n  border: 1px solid #dee2e6 !important;\n}\n\n.border-top {\n  border-top: 1px solid #dee2e6 !important;\n}\n\n.border-right {\n  border-right: 1px solid #dee2e6 !important;\n}\n\n.border-bottom {\n  border-bottom: 1px solid #dee2e6 !important;\n}\n\n.border-left {\n  border-left: 1px solid #dee2e6 !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-right-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-left-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  border-color: #3f51b5 !important;\n}\n\n.border-secondary {\n  border-color: #E91E63 !important;\n}\n\n.border-success {\n  border-color: #4caf50 !important;\n}\n\n.border-info {\n  border-color: #00bcd4 !important;\n}\n\n.border-warning {\n  border-color: #ff9800 !important;\n}\n\n.border-danger {\n  border-color: #f44336 !important;\n}\n\n.border-light {\n  border-color: #e8eaf6 !important;\n}\n\n.border-dark {\n  border-color: #343a40 !important;\n}\n\n.border-white {\n  border-color: #fff !important;\n}\n\n.rounded {\n  border-radius: 4px !important;\n}\n\n.rounded-top {\n  border-top-left-radius: 4px !important;\n  border-top-right-radius: 4px !important;\n}\n\n.rounded-right {\n  border-top-right-radius: 4px !important;\n  border-bottom-right-radius: 4px !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: 4px !important;\n  border-bottom-left-radius: 4px !important;\n}\n\n.rounded-left {\n  border-top-left-radius: 4px !important;\n  border-bottom-left-radius: 4px !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.d-none {\n  display: none !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n@media (min-width: 576px) {\n  .d-sm-none {\n    display: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 768px) {\n  .d-md-none {\n    display: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 992px) {\n  .d-lg-none {\n    display: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 1200px) {\n  .d-xl-none {\n    display: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media print {\n  .d-print-none {\n    display: none !important;\n  }\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n}\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n}\n.embed-responsive::before {\n  display: block;\n  content: \"\";\n}\n.embed-responsive .embed-responsive-item,\n.embed-responsive iframe,\n.embed-responsive embed,\n.embed-responsive object,\n.embed-responsive video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.embed-responsive-21by9::before {\n  padding-top: 42.8571428571%;\n}\n\n.embed-responsive-16by9::before {\n  padding-top: 56.25%;\n}\n\n.embed-responsive-4by3::before {\n  padding-top: 75%;\n}\n\n.embed-responsive-1by1::before {\n  padding-top: 100%;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n@media (min-width: 576px) {\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 768px) {\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 992px) {\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 1200px) {\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n}\n.float-left {\n  float: left !important;\n}\n\n.float-right {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-left {\n    float: left !important;\n  }\n  .float-sm-right {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-left {\n    float: left !important;\n  }\n  .float-md-right {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-left {\n    float: left !important;\n  }\n  .float-lg-right {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-left {\n    float: left !important;\n  }\n  .float-xl-right {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n}\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n@supports (position: sticky) {\n  .sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  clip-path: inset(50%);\n  border: 0;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n  clip-path: none;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.mt-0,\n.my-0 {\n  margin-top: 0 !important;\n}\n\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important;\n}\n\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important;\n}\n\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.mt-1,\n.my-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mr-1,\n.mx-1 {\n  margin-right: 0.25rem !important;\n}\n\n.mb-1,\n.my-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.ml-1,\n.mx-1 {\n  margin-left: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.mt-2,\n.my-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mr-2,\n.mx-2 {\n  margin-right: 0.5rem !important;\n}\n\n.mb-2,\n.my-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.ml-2,\n.mx-2 {\n  margin-left: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.mt-3,\n.my-3 {\n  margin-top: 1rem !important;\n}\n\n.mr-3,\n.mx-3 {\n  margin-right: 1rem !important;\n}\n\n.mb-3,\n.my-3 {\n  margin-bottom: 1rem !important;\n}\n\n.ml-3,\n.mx-3 {\n  margin-left: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.mt-4,\n.my-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mr-4,\n.mx-4 {\n  margin-right: 1.5rem !important;\n}\n\n.mb-4,\n.my-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.ml-4,\n.mx-4 {\n  margin-left: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 3rem !important;\n}\n\n.mt-5,\n.my-5 {\n  margin-top: 3rem !important;\n}\n\n.mr-5,\n.mx-5 {\n  margin-right: 3rem !important;\n}\n\n.mb-5,\n.my-5 {\n  margin-bottom: 3rem !important;\n}\n\n.ml-5,\n.mx-5 {\n  margin-left: 3rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.pt-0,\n.py-0 {\n  padding-top: 0 !important;\n}\n\n.pr-0,\n.px-0 {\n  padding-right: 0 !important;\n}\n\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important;\n}\n\n.pl-0,\n.px-0 {\n  padding-left: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.pt-1,\n.py-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pr-1,\n.px-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pb-1,\n.py-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pl-1,\n.px-1 {\n  padding-left: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.pt-2,\n.py-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pr-2,\n.px-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pb-2,\n.py-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pl-2,\n.px-2 {\n  padding-left: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.pt-3,\n.py-3 {\n  padding-top: 1rem !important;\n}\n\n.pr-3,\n.px-3 {\n  padding-right: 1rem !important;\n}\n\n.pb-3,\n.py-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pl-3,\n.px-3 {\n  padding-left: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.pt-4,\n.py-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pr-4,\n.px-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pb-4,\n.py-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pl-4,\n.px-4 {\n  padding-left: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.pt-5,\n.py-5 {\n  padding-top: 3rem !important;\n}\n\n.pr-5,\n.px-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-5,\n.py-5 {\n  padding-bottom: 3rem !important;\n}\n\n.pl-5,\n.px-5 {\n  padding-left: 3rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mt-auto,\n.my-auto {\n  margin-top: auto !important;\n}\n\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important;\n}\n\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important;\n}\n\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important;\n}\n\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mr-sm-0,\n  .mx-sm-0 {\n    margin-right: 0 !important;\n  }\n  .mb-sm-0,\n  .my-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-sm-0,\n  .mx-sm-0 {\n    margin-left: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-sm-1,\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-sm-1,\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-sm-1,\n  .my-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-sm-1,\n  .mx-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-sm-2,\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-sm-2,\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-sm-2,\n  .my-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-sm-2,\n  .mx-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n  .mt-sm-3,\n  .my-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-sm-3,\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-sm-3,\n  .my-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-sm-3,\n  .mx-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-sm-4,\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-sm-4,\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-sm-4,\n  .my-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-sm-4,\n  .mx-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-sm-5 {\n    margin: 3rem !important;\n  }\n  .mt-sm-5,\n  .my-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-sm-5,\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-sm-5,\n  .my-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-sm-5,\n  .mx-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .pt-sm-0,\n  .py-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pr-sm-0,\n  .px-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pb-sm-0,\n  .py-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-sm-0,\n  .px-sm-0 {\n    padding-left: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-sm-1,\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-sm-1,\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-sm-1,\n  .py-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-sm-1,\n  .px-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-sm-2,\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-sm-2,\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-sm-2,\n  .py-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-sm-2,\n  .px-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n  .pt-sm-3,\n  .py-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-sm-3,\n  .px-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-sm-3,\n  .py-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-sm-3,\n  .px-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-sm-4,\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-sm-4,\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-sm-4,\n  .py-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-sm-4,\n  .px-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-sm-5 {\n    padding: 3rem !important;\n  }\n  .pt-sm-5,\n  .py-sm-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-sm-5,\n  .px-sm-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-sm-5,\n  .px-sm-5 {\n    padding-left: 3rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mt-sm-auto,\n  .my-sm-auto {\n    margin-top: auto !important;\n  }\n  .mr-sm-auto,\n  .mx-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-auto,\n  .my-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-sm-auto,\n  .mx-sm-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .mt-md-0,\n  .my-md-0 {\n    margin-top: 0 !important;\n  }\n  .mr-md-0,\n  .mx-md-0 {\n    margin-right: 0 !important;\n  }\n  .mb-md-0,\n  .my-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-md-0,\n  .mx-md-0 {\n    margin-left: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-md-1,\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-md-1,\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-md-1,\n  .my-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-md-1,\n  .mx-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-md-2,\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-md-2,\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-md-2,\n  .my-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-md-2,\n  .mx-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n  .mt-md-3,\n  .my-md-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-md-3,\n  .mx-md-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-md-3,\n  .my-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-md-3,\n  .mx-md-3 {\n    margin-left: 1rem !important;\n  }\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-md-4,\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-md-4,\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-md-4,\n  .my-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-md-4,\n  .mx-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-md-5 {\n    margin: 3rem !important;\n  }\n  .mt-md-5,\n  .my-md-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-md-5,\n  .mx-md-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-md-5,\n  .my-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-md-5,\n  .mx-md-5 {\n    margin-left: 3rem !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .pt-md-0,\n  .py-md-0 {\n    padding-top: 0 !important;\n  }\n  .pr-md-0,\n  .px-md-0 {\n    padding-right: 0 !important;\n  }\n  .pb-md-0,\n  .py-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-md-0,\n  .px-md-0 {\n    padding-left: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-md-1,\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-md-1,\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-md-1,\n  .py-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-md-1,\n  .px-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-md-2,\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-md-2,\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-md-2,\n  .py-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-md-2,\n  .px-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n  .pt-md-3,\n  .py-md-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-md-3,\n  .px-md-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-md-3,\n  .py-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-md-3,\n  .px-md-3 {\n    padding-left: 1rem !important;\n  }\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-md-4,\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-md-4,\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-md-4,\n  .py-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-md-4,\n  .px-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-md-5 {\n    padding: 3rem !important;\n  }\n  .pt-md-5,\n  .py-md-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-md-5,\n  .px-md-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-md-5,\n  .py-md-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-md-5,\n  .px-md-5 {\n    padding-left: 3rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mt-md-auto,\n  .my-md-auto {\n    margin-top: auto !important;\n  }\n  .mr-md-auto,\n  .mx-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-auto,\n  .my-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-md-auto,\n  .mx-md-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .mt-lg-0,\n  .my-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mr-lg-0,\n  .mx-lg-0 {\n    margin-right: 0 !important;\n  }\n  .mb-lg-0,\n  .my-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-lg-0,\n  .mx-lg-0 {\n    margin-left: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-lg-1,\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-lg-1,\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-lg-1,\n  .my-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-lg-1,\n  .mx-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-lg-2,\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-lg-2,\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-lg-2,\n  .my-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-lg-2,\n  .mx-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n  .mt-lg-3,\n  .my-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-lg-3,\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-lg-3,\n  .my-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-lg-3,\n  .mx-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-lg-4,\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-lg-4,\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-lg-4,\n  .my-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-lg-4,\n  .mx-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-lg-5 {\n    margin: 3rem !important;\n  }\n  .mt-lg-5,\n  .my-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-lg-5,\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-lg-5,\n  .my-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-lg-5,\n  .mx-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pr-lg-0,\n  .px-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pb-lg-0,\n  .py-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-lg-0,\n  .px-lg-0 {\n    padding-left: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-lg-1,\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-lg-1,\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-lg-1,\n  .py-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-lg-1,\n  .px-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-lg-2,\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-lg-2,\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-lg-2,\n  .py-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-lg-2,\n  .px-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n  .pt-lg-3,\n  .py-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-lg-3,\n  .px-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-lg-3,\n  .py-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-lg-3,\n  .px-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-lg-4,\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-lg-4,\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-lg-4,\n  .py-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-lg-4,\n  .px-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-lg-5 {\n    padding: 3rem !important;\n  }\n  .pt-lg-5,\n  .py-lg-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-lg-5,\n  .px-lg-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-lg-5,\n  .py-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-lg-5,\n  .px-lg-5 {\n    padding-left: 3rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mt-lg-auto,\n  .my-lg-auto {\n    margin-top: auto !important;\n  }\n  .mr-lg-auto,\n  .mx-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-auto,\n  .my-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-lg-auto,\n  .mx-lg-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .mt-xl-0,\n  .my-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mr-xl-0,\n  .mx-xl-0 {\n    margin-right: 0 !important;\n  }\n  .mb-xl-0,\n  .my-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-xl-0,\n  .mx-xl-0 {\n    margin-left: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-xl-1,\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-xl-1,\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-xl-1,\n  .my-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-xl-1,\n  .mx-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-xl-2,\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-xl-2,\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-xl-2,\n  .my-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-xl-2,\n  .mx-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n  .mt-xl-3,\n  .my-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-xl-3,\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-xl-3,\n  .my-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-xl-3,\n  .mx-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-xl-4,\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-xl-4,\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-xl-4,\n  .my-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-xl-4,\n  .mx-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-xl-5 {\n    margin: 3rem !important;\n  }\n  .mt-xl-5,\n  .my-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-xl-5,\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-xl-5,\n  .my-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-xl-5,\n  .mx-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .pt-xl-0,\n  .py-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pr-xl-0,\n  .px-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pb-xl-0,\n  .py-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-xl-0,\n  .px-xl-0 {\n    padding-left: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-xl-1,\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-xl-1,\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-xl-1,\n  .py-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-xl-1,\n  .px-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-xl-2,\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-xl-2,\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-xl-2,\n  .py-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-xl-2,\n  .px-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n  .pt-xl-3,\n  .py-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-xl-3,\n  .px-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-xl-3,\n  .py-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-xl-3,\n  .px-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-xl-4,\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-xl-4,\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-xl-4,\n  .py-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-xl-4,\n  .px-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-xl-5 {\n    padding: 3rem !important;\n  }\n  .pt-xl-5,\n  .py-xl-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-xl-5,\n  .px-xl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xl-5,\n  .py-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-xl-5,\n  .px-xl-5 {\n    padding-left: 3rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mt-xl-auto,\n  .my-xl-auto {\n    margin-top: auto !important;\n  }\n  .mr-xl-auto,\n  .mx-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-auto,\n  .my-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-xl-auto,\n  .mx-xl-auto {\n    margin-left: auto !important;\n  }\n}\n.text-justify {\n  text-align: justify !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-left {\n  text-align: left !important;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n@media (min-width: 576px) {\n  .text-sm-left {\n    text-align: left !important;\n  }\n  .text-sm-right {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .text-md-left {\n    text-align: left !important;\n  }\n  .text-md-right {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .text-lg-left {\n    text-align: left !important;\n  }\n  .text-lg-right {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .text-xl-left {\n    text-align: left !important;\n  }\n  .text-xl-right {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.font-weight-light {\n  font-weight: 300 !important;\n}\n\n.font-weight-normal {\n  font-weight: 400 !important;\n}\n\n.font-weight-bold {\n  font-weight: 700 !important;\n}\n\n.font-italic {\n  font-style: italic !important;\n}\n\n.text-white {\n  color: #fff !important;\n}\n\n.text-primary {\n  color: #3f51b5 !important;\n}\n\na.text-primary:hover, a.text-primary:focus {\n  color: rgb(49.8319672131, 64.0696721311, 143.1680327869) !important;\n}\n\n.text-secondary {\n  color: #E91E63 !important;\n}\n\na.text-secondary:hover, a.text-secondary:focus {\n  color: rgb(193.1174089069, 18.8825910931, 78.1052631579) !important;\n}\n\n.text-success {\n  color: #4caf50 !important;\n}\n\na.text-success:hover, a.text-success:focus {\n  color: rgb(60.5577689243, 139.4422310757, 63.7450199203) !important;\n}\n\n.text-info {\n  color: #00bcd4 !important;\n}\n\na.text-info:hover, a.text-info:focus {\n  color: rgb(0, 142.7735849057, 161) !important;\n}\n\n.text-warning {\n  color: #ff9800 !important;\n}\n\na.text-warning:hover, a.text-warning:focus {\n  color: rgb(204, 121.6, 0) !important;\n}\n\n.text-danger {\n  color: #f44336 !important;\n}\n\na.text-danger:hover, a.text-danger:focus {\n  color: rgb(234.1839622642, 27.9622641509, 12.8160377358) !important;\n}\n\n.text-light {\n  color: #e8eaf6 !important;\n}\n\na.text-light:hover, a.text-light:focus {\n  color: rgb(195.34375, 200.53125, 231.65625) !important;\n}\n\n.text-dark {\n  color: #343a40 !important;\n}\n\na.text-dark:hover, a.text-dark:focus {\n  color: rgb(29.1379310345, 32.5, 35.8620689655) !important;\n}\n\n.text-muted {\n  color: #6c757d !important;\n}\n\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n@media print {\n  *,\n  *::before,\n  *::after {\n    text-shadow: none !important;\n    box-shadow: none !important;\n  }\n  a:not(.btn) {\n    text-decoration: underline;\n  }\n  abbr[title]::after {\n    content: \" (\" attr(title) \")\";\n  }\n  pre {\n    white-space: pre-wrap !important;\n  }\n  pre,\n  blockquote {\n    border: 1px solid #999;\n    page-break-inside: avoid;\n  }\n  thead {\n    display: table-header-group;\n  }\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n  @page {\n    size: a3;\n  }\n  body {\n    min-width: 992px !important;\n  }\n  .container {\n    min-width: 992px !important;\n  }\n  .navbar {\n    display: none;\n  }\n  .badge {\n    border: 1px solid #000;\n  }\n  .table {\n    border-collapse: collapse !important;\n  }\n  .table td,\n  .table th {\n    background-color: #fff !important;\n  }\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #ddd !important;\n  }\n}","/*!\r\n * Bootstrap v4.0.0 (https://getbootstrap.com)\r\n * Copyright 2011-2018 The Bootstrap Authors\r\n * Copyright 2011-2018 Twitter, Inc.\r\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\r\n */\r\n@import \"functions\";\r\n@import \"variables\";\r\n@import \"mixins\";\r\n@import \"root\";\r\n@import \"reboot\";\r\n@import \"type\";\r\n@import \"images\";\r\n@import \"code\";\r\n@import \"grid\";\r\n@import \"tables\";\r\n@import \"forms\";\r\n@import \"buttons\";\r\n@import \"transitions\";\r\n@import \"dropdown\";\r\n@import \"button-group\";\r\n@import \"input-group\";\r\n@import \"custom-forms\";\r\n@import \"nav\";\r\n@import \"navbar\";\r\n@import \"card\";\r\n@import \"breadcrumb\";\r\n@import \"pagination\";\r\n@import \"badge\";\r\n@import \"jumbotron\";\r\n@import \"alert\";\r\n@import \"progress\";\r\n@import \"media\";\r\n@import \"list-group\";\r\n@import \"close\";\r\n@import \"modal\";\r\n@import \"tooltip\";\r\n@import \"popover\";\r\n@import \"carousel\";\r\n@import \"utilities\";\r\n@import \"print\";\r\n",":root {\r\n  // Custom variable values only support SassScript inside `#{}`.\r\n  @each $color, $value in $colors {\r\n    --#{$color}: #{$value};\r\n  }\r\n\r\n  @each $color, $value in $theme-colors {\r\n    --#{$color}: #{$value};\r\n  }\r\n\r\n  @each $bp, $value in $grid-breakpoints {\r\n    --breakpoint-#{$bp}: #{$value};\r\n  }\r\n\r\n  // Use `inspect` for lists so that quoted items keep the quotes.\r\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\r\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\r\n  --font-family-monospace: #{inspect($font-family-monospace)};\r\n}\r\n","// stylelint-disable at-rule-no-vendor-prefix, declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\r\n\r\n// Reboot\r\n//\r\n// Normalization of HTML elements, manually forked from Normalize.css to remove\r\n// styles targeting irrelevant browsers while applying new styles.\r\n//\r\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\r\n\r\n// Document\r\n//\r\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\r\n// 2. Change the default font family in all browsers.\r\n// 3. Correct the line height in all browsers.\r\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\r\n// 5. Setting @viewport causes scrollbars to overlap content in IE11 and Edge, so\r\n//    we force a non-overlapping, non-auto-hiding scrollbar to counteract.\r\n// 6. Change the default tap highlight to be completely transparent in iOS.\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box; // 1\r\n}\r\n\r\nhtml {\r\n  font-family: sans-serif; // 2\r\n  line-height: 1.15; // 3\r\n  -webkit-text-size-adjust: 100%; // 4\r\n  -ms-text-size-adjust: 100%; // 4\r\n  -ms-overflow-style: scrollbar; // 5\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); // 6\r\n}\r\n\r\n// IE10+ doesn't honor `<meta name=\"viewport\">` in some cases.\r\n@at-root {\r\n  @-ms-viewport {\r\n    width: device-width;\r\n  }\r\n}\r\n\r\n// stylelint-disable selector-list-comma-newline-after\r\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\r\narticle, aside, dialog, figcaption, figure, footer, header, hgroup, main, nav, section {\r\n  display: block;\r\n}\r\n\r\n// stylelint-enable selector-list-comma-newline-after\r\n\r\n// Body\r\n//\r\n// 1. Remove the margin in all browsers.\r\n// 2. As a best practice, apply a default `background-color`.\r\n// 3. Set an explicit initial text-align value so that we can later use the\r\n//    the `inherit` value on things like `<th>` elements.\r\n\r\nbody {\r\n  margin: 0; // 1\r\n  font-family: $font-family-base;\r\n  font-size: $font-size-base;\r\n  font-weight: $font-weight-base;\r\n  line-height: $line-height-base;\r\n  color: $body-color;\r\n  text-align: left; // 3\r\n  background-color: $body-bg; // 2\r\n}\r\n\r\n// Suppress the focus outline on elements that cannot be accessed via keyboard.\r\n// This prevents an unwanted focus outline from appearing around elements that\r\n// might still respond to pointer events.\r\n//\r\n// Credit: https://github.com/suitcss/base\r\n[tabindex=\"-1\"]:focus {\r\n  outline: 0 !important;\r\n}\r\n\r\n// Content grouping\r\n//\r\n// 1. Add the correct box sizing in Firefox.\r\n// 2. Show the overflow in Edge and IE.\r\n\r\nhr {\r\n  box-sizing: content-box; // 1\r\n  height: 0; // 1\r\n  overflow: visible; // 2\r\n}\r\n\r\n//\r\n// Typography\r\n//\r\n\r\n// Remove top margins from headings\r\n//\r\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\r\n// margin for easier control within type scales as it avoids margin collapsing.\r\n// stylelint-disable selector-list-comma-newline-after\r\nh1, h2, h3, h4, h5, h6 {\r\n  margin-top: 0;\r\n  margin-bottom: $headings-margin-bottom;\r\n}\r\n\r\n// stylelint-enable selector-list-comma-newline-after\r\n\r\n// Reset margins on paragraphs\r\n//\r\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\r\n// bottom margin to use `rem` units instead of `em`.\r\np {\r\n  margin-top: 0;\r\n  margin-bottom: $paragraph-margin-bottom;\r\n}\r\n\r\n// Abbreviations\r\n//\r\n// 1. Remove the bottom border in Firefox 39-.\r\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\r\n// 3. Add explicit cursor to indicate changed behavior.\r\n// 4. Duplicate behavior to the data-* attribute for our tooltip plugin\r\n\r\nabbr[title],\r\nabbr[data-original-title] { // 4\r\n  text-decoration: underline; // 2\r\n  text-decoration: underline dotted; // 2\r\n  cursor: help; // 3\r\n  border-bottom: 0; // 1\r\n}\r\n\r\naddress {\r\n  margin-bottom: 1rem;\r\n  font-style: normal;\r\n  line-height: inherit;\r\n}\r\n\r\nol,\r\nul,\r\ndl {\r\n  margin-top: 0;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\nol ol,\r\nul ul,\r\nol ul,\r\nul ol {\r\n  margin-bottom: 0;\r\n}\r\n\r\ndt {\r\n  font-weight: $dt-font-weight;\r\n}\r\n\r\ndd {\r\n  margin-bottom: .5rem;\r\n  margin-left: 0; // Undo browser default\r\n}\r\n\r\nblockquote {\r\n  margin: 0 0 1rem;\r\n}\r\n\r\ndfn {\r\n  font-style: italic; // Add the correct font style in Android 4.3-\r\n}\r\n\r\n// stylelint-disable font-weight-notation\r\nb,\r\nstrong {\r\n  font-weight: bolder; // Add the correct font weight in Chrome, Edge, and Safari\r\n}\r\n\r\n// stylelint-enable font-weight-notation\r\n\r\nsmall {\r\n  font-size: 80%; // Add the correct font size in all browsers\r\n}\r\n\r\n//\r\n// Prevent `sub` and `sup` elements from affecting the line height in\r\n// all browsers.\r\n//\r\n\r\nsub,\r\nsup {\r\n  position: relative;\r\n  font-size: 75%;\r\n  line-height: 0;\r\n  vertical-align: baseline;\r\n}\r\n\r\nsub {\r\n  bottom: -.25em;\r\n}\r\n\r\nsup {\r\n  top: -.5em;\r\n}\r\n\r\n//\r\n// Links\r\n//\r\n\r\na {\r\n  color: $link-color;\r\n  text-decoration: $link-decoration;\r\n  background-color: transparent; // Remove the gray background on active links in IE 10.\r\n  -webkit-text-decoration-skip: objects; // Remove gaps in links underline in iOS 8+ and Safari 8+.\r\n\r\n  @include hover {\r\n    color: $link-hover-color;\r\n    text-decoration: $link-hover-decoration;\r\n  }\r\n}\r\n\r\n// And undo these styles for placeholder links/named anchors (without href)\r\n// which have not been made explicitly keyboard-focusable (without tabindex).\r\n// It would be more straightforward to just use a[href] in previous block, but that\r\n// causes specificity issues in many other styles that are too complex to fix.\r\n// See https://github.com/twbs/bootstrap/issues/19402\r\n\r\na:not([href]):not([tabindex]) {\r\n  color: inherit;\r\n  text-decoration: none;\r\n\r\n  @include hover-focus {\r\n    color: inherit;\r\n    text-decoration: none;\r\n  }\r\n\r\n  &:focus {\r\n    outline: 0;\r\n  }\r\n}\r\n\r\n//\r\n// Code\r\n//\r\n\r\n// stylelint-disable font-family-no-duplicate-names\r\npre,\r\ncode,\r\nkbd,\r\nsamp {\r\n  font-family: monospace, monospace; // Correct the inheritance and scaling of font size in all browsers.\r\n  font-size: 1em; // Correct the odd `em` font sizing in all browsers.\r\n}\r\n\r\n// stylelint-enable font-family-no-duplicate-names\r\n\r\npre {\r\n  // Remove browser default top margin\r\n  margin-top: 0;\r\n  // Reset browser default of `1em` to use `rem`s\r\n  margin-bottom: 1rem;\r\n  // Don't allow content to break outside\r\n  overflow: auto;\r\n  // We have @viewport set which causes scrollbars to overlap content in IE11 and Edge, so\r\n  // we force a non-overlapping, non-auto-hiding scrollbar to counteract.\r\n  -ms-overflow-style: scrollbar;\r\n}\r\n\r\n//\r\n// Figures\r\n//\r\n\r\nfigure {\r\n  // Apply a consistent margin strategy (matches our type styles).\r\n  margin: 0 0 1rem;\r\n}\r\n\r\n//\r\n// Images and content\r\n//\r\n\r\nimg {\r\n  vertical-align: middle;\r\n  border-style: none; // Remove the border on images inside links in IE 10-.\r\n}\r\n\r\nsvg:not(:root) {\r\n  overflow: hidden; // Hide the overflow in IE\r\n}\r\n\r\n//\r\n// Tables\r\n//\r\n\r\ntable {\r\n  border-collapse: collapse; // Prevent double borders\r\n}\r\n\r\ncaption {\r\n  padding-top: $table-cell-padding;\r\n  padding-bottom: $table-cell-padding;\r\n  color: $text-muted;\r\n  text-align: left;\r\n  caption-side: bottom;\r\n}\r\n\r\nth {\r\n  // Matches default `<td>` alignment by inheriting from the `<body>`, or the\r\n  // closest parent with a set `text-align`.\r\n  text-align: inherit;\r\n}\r\n\r\n//\r\n// Forms\r\n//\r\n\r\nlabel {\r\n  // Allow labels to use `margin` for spacing.\r\n  display: inline-block;\r\n  margin-bottom: .5rem;\r\n}\r\n\r\n// Remove the default `border-radius` that macOS Chrome adds.\r\n//\r\n// Details at https://github.com/twbs/bootstrap/issues/24093\r\nbutton {\r\n  border-radius: 0;\r\n}\r\n\r\n// Work around a Firefox/IE bug where the transparent `button` background\r\n// results in a loss of the default `button` focus styles.\r\n//\r\n// Credit: https://github.com/suitcss/base/\r\nbutton:focus {\r\n  outline: 1px dotted;\r\n  outline: 5px auto -webkit-focus-ring-color;\r\n}\r\n\r\ninput,\r\nbutton,\r\nselect,\r\noptgroup,\r\ntextarea {\r\n  margin: 0; // Remove the margin in Firefox and Safari\r\n  font-family: inherit;\r\n  font-size: inherit;\r\n  line-height: inherit;\r\n}\r\n\r\nbutton,\r\ninput {\r\n  overflow: visible; // Show the overflow in Edge\r\n}\r\n\r\nbutton,\r\nselect {\r\n  text-transform: none; // Remove the inheritance of text transform in Firefox\r\n}\r\n\r\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\r\n//    controls in Android 4.\r\n// 2. Correct the inability to style clickable types in iOS and Safari.\r\nbutton,\r\nhtml [type=\"button\"], // 1\r\n[type=\"reset\"],\r\n[type=\"submit\"] {\r\n  -webkit-appearance: button; // 2\r\n}\r\n\r\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\r\nbutton::-moz-focus-inner,\r\n[type=\"button\"]::-moz-focus-inner,\r\n[type=\"reset\"]::-moz-focus-inner,\r\n[type=\"submit\"]::-moz-focus-inner {\r\n  padding: 0;\r\n  border-style: none;\r\n}\r\n\r\ninput[type=\"radio\"],\r\ninput[type=\"checkbox\"] {\r\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\r\n  padding: 0; // 2. Remove the padding in IE 10-\r\n}\r\n\r\ninput[type=\"date\"],\r\ninput[type=\"time\"],\r\ninput[type=\"datetime-local\"],\r\ninput[type=\"month\"] {\r\n  // Remove the default appearance of temporal inputs to avoid a Mobile Safari\r\n  // bug where setting a custom line-height prevents text from being vertically\r\n  // centered within the input.\r\n  // See https://bugs.webkit.org/show_bug.cgi?id=139848\r\n  // and https://github.com/twbs/bootstrap/issues/11266\r\n  -webkit-appearance: listbox;\r\n}\r\n\r\ntextarea {\r\n  overflow: auto; // Remove the default vertical scrollbar in IE.\r\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\r\n  resize: vertical;\r\n}\r\n\r\nfieldset {\r\n  // Browsers set a default `min-width: min-content;` on fieldsets,\r\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\r\n  // So we reset that to ensure fieldsets behave more like a standard block element.\r\n  // See https://github.com/twbs/bootstrap/issues/12359\r\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\r\n  min-width: 0;\r\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\r\n  padding: 0;\r\n  margin: 0;\r\n  border: 0;\r\n}\r\n\r\n// 1. Correct the text wrapping in Edge and IE.\r\n// 2. Correct the color inheritance from `fieldset` elements in IE.\r\nlegend {\r\n  display: block;\r\n  width: 100%;\r\n  max-width: 100%; // 1\r\n  padding: 0;\r\n  margin-bottom: .5rem;\r\n  font-size: 1.5rem;\r\n  line-height: inherit;\r\n  color: inherit; // 2\r\n  white-space: normal; // 1\r\n}\r\n\r\nprogress {\r\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\r\n}\r\n\r\n// Correct the cursor style of increment and decrement buttons in Chrome.\r\n[type=\"number\"]::-webkit-inner-spin-button,\r\n[type=\"number\"]::-webkit-outer-spin-button {\r\n  height: auto;\r\n}\r\n\r\n[type=\"search\"] {\r\n  // This overrides the extra rounded corners on search inputs in iOS so that our\r\n  // `.form-control` class can properly style them. Note that this cannot simply\r\n  // be added to `.form-control` as it's not specific enough. For details, see\r\n  // https://github.com/twbs/bootstrap/issues/11586.\r\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\r\n  -webkit-appearance: none;\r\n}\r\n\r\n//\r\n// Remove the inner padding and cancel buttons in Chrome and Safari on macOS.\r\n//\r\n\r\n[type=\"search\"]::-webkit-search-cancel-button,\r\n[type=\"search\"]::-webkit-search-decoration {\r\n  -webkit-appearance: none;\r\n}\r\n\r\n//\r\n// 1. Correct the inability to style clickable types in iOS and Safari.\r\n// 2. Change font properties to `inherit` in Safari.\r\n//\r\n\r\n::-webkit-file-upload-button {\r\n  font: inherit; // 2\r\n  -webkit-appearance: button; // 1\r\n}\r\n\r\n//\r\n// Correct element displays\r\n//\r\n\r\noutput {\r\n  display: inline-block;\r\n}\r\n\r\nsummary {\r\n  display: list-item; // Add the correct display in all browsers\r\n  cursor: pointer;\r\n}\r\n\r\ntemplate {\r\n  display: none; // Add the correct display in IE\r\n}\r\n\r\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\r\n// Needed for proper display in IE 10-.\r\n[hidden] {\r\n  display: none !important;\r\n}\r\n","@import \"../bootstrap/functions\";\r\n@import \"../bootstrap/variables\";\r\n@import \"../bootstrap/mixins\";\r\n// Fonts\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n// @import url('https://fonts.googleapis.com/css?family=Nunito+Sans:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i');\r\n@import url(\"https://fonts.googleapis.com/css?family=Roboto:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css?family=Poppins:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap\");\r\n\r\n//# sourceMappingURL=roboto.css.map\r\n\r\n// import material icons\r\n@import url(\"https://fonts.googleapis.com/icon?family=Material+Icons\");\r\n\r\n// stylelint-disable value-keyword-case\r\n$font-family-sans-serif: 'Roboto', sans-serif;\r\n$font-family-base: $font-family-sans-serif;\r\n\r\n// stylelint-enable value-keyword-case\r\n$font-size-base: 13px; // Assumes the browser default, typically `16px`\r\n$font-size-lg: ($font-size-base + 4);\r\n$font-size-sm: $font-size-base;\r\n\r\n$h1-font-size: 24px;\r\n$h2-font-size: 18px;\r\n$h3-font-size: 16px;\r\n$h4-font-size: 15px;\r\n$h5-font-size: 13px;\r\n$h6-font-size: 12px;\r\n\r\n$headings-margin-bottom: ($h1-font-size / 2);\r\n$headings-font-family: inherit;\r\n$headings-font-weight: 400;\r\n$headings-line-height: 1.2;\r\n$headings-color: inherit;\r\n\r\n//Border Radius\r\n$border-radius-sm: 2px;\r\n$border-radius: 4px;\r\n$border-radius-lg: 8px;\r\n$border-radius-xl: 10px !default;\r\n$border-radius-circle: 50% !default;\r\n\r\n//Bootstrap Card Variables\r\n$card-spacer-y: 24px;\r\n$card-spacer-x: 30px;\r\n$card-border-color: $border-color;\r\n$card-border-radius: $border-radius-lg;\r\n$card-inner-border-radius: $border-radius-lg;\r\n$list-group-border-radius: $border-radius-lg;\r\n\r\n//Grid Gutter Space Between\r\n$grid-gutter-width: 34px;\r\n\r\n//Mixin Values True and False\r\n$enable-shadows: true;\r\n\r\n$app-primary: #3f51b5 !default;\r\n$primary: $app-primary;\r\n$secondary: #E91E63;\r\n$gray-default: #808080 !default;\r\n\r\n$sidebar-bg: #f5f7f9 !default;\r\n$sidebar-text-color: #868e96 !default;\r\n$sidebar-bg-darken: darken($sidebar-bg, 3%);\r\n$sidebar-hover-color: $app-primary;\r\n\r\n$top-nav-bg: $app-primary !default;\r\n\r\n//Default shadow\r\n$shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.15);\r\n$shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);\r\n$shadow-lg: 0 1px 8px -1px rgba(0, 0, 0, 0.20);\r\n$shadow-xl: 0 0 16px 0px rgba(0, 0, 0, 0.20);\r\n$avatar-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.50);\r\n\r\n//Custom Card Variables\r\n$jr-card-shadow: $shadow !default;\r\n$jr-card-margin: 34px !default;\r\n$jr-card-padding: 24px 30px !default;\r\n$jr-border: 1px solid $gray-400 !default;\r\n\r\n// Links\r\n$link-color: $app-primary;\r\n$link-hover-color: darken($app-primary, 10%);\r\n\r\n//Color Variables\r\n$success: #4caf50;\r\n$info: #00bcd4;\r\n$warning: #ff9800;\r\n$danger: #f44336;\r\n$light: #e8eaf6;\r\n$dark: $gray-800;\r\n$body-bg: #fff;\r\n$body-color: #5c5c5c;\r\n\r\n$theme-colors: (\r\n        \"primary\": $primary,\r\n        \"secondary\": $secondary,\r\n        \"success\": $success,\r\n        \"info\": $info,\r\n        \"warning\": $warning,\r\n        \"danger\": $danger,\r\n        \"light\": $light,\r\n        \"dark\": $dark\r\n);\r\n\r\n//Default Image Location\r\n$image_path: \"../assets/images\" !default;\r\n\r\n// Motion\r\n// https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves\r\n$transition-bezier: .05, .74, .27, .99 !default; // for nav, quickview\r\n\r\n$transition-ease: cubic-bezier(0.4, 0.0, 0.2, 1) !default;\r\n$transition-ease-out: cubic-bezier(0.0, 0.0, 0.2, 1) !default;\r\n$transition-ease-in: cubic-bezier(0.4, 0.0, 1, 1) !default;\r\n\r\n//Side Nav Width\r\n$side-nav-width: 200px !default;\r\n$mini-drawer-width: 80px !default;\r\n\r\n//App Bar Height\r\n$app-bar-height: 60px !default;\r\n\r\n//Footer Height\r\n$footer-height: 50px !default;\r\n\r\n//latter Spacing variables\r\n$letter-spacing-base: 3px !default;\r\n$letter-spacing-lg: 6px !default;\r\n$letter-spacing-xl: 8px !default;\r\n\r\n//Button Variables\r\n$btn-font-size-lg: $font-size-lg !default;\r\n$btn-font-size: $font-size-base !default;\r\n$btn-font-size-sm: $font-size-sm !default;\r\n$btn-font-size-xs: 10px !default;\r\n\r\n$btn-padding-lg: 16px 24px !default;\r\n$btn-padding: 12px 20px !default;\r\n$btn-padding-sm: 8px 15px !default;\r\n$btn-padding-xs: 6px 10px !default;\r\n\r\n$btn-fab-size-lg: 70px !default;\r\n$btn-fab-size-sm: 46px !default;\r\n$btn-fab-size-xs: 40px !default;\r\n\r\n$btn-line-height: 1.2;\r\n\r\n//Sizes Variables\r\n\r\n$size-20: 20px !default;\r\n$size-30: 30px !default;\r\n$size-40: 40px !default;\r\n$size-50: 50px !default;\r\n$size-60: 60px !default;\r\n$size-80: 80px !default;\r\n$size-100: 100px !default;\r\n$size-120: 120px !default;","// Variables\r\n//\r\n// Variables should follow the `$component-state-property-size` formula for\r\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\r\n\r\n//\r\n// Color system\r\n//\r\n\r\n// stylelint-disable\r\n$white: #fff !default;\r\n$gray-100: #f8f9fa !default;\r\n$gray-200: #e9ecef !default;\r\n$gray-300: #dee2e6 !default;\r\n$gray-400: #ced4da !default;\r\n$gray-500: #adb5bd !default;\r\n$gray-600: #6c757d !default;\r\n$gray-700: #495057 !default;\r\n$gray-800: #343a40 !default;\r\n$gray-900: #212529 !default;\r\n$black: #000 !default;\r\n\r\n$grays: () !default;\r\n$grays: map-merge((\r\n        \"100\": $gray-100,\r\n        \"200\": $gray-200,\r\n        \"300\": $gray-300,\r\n        \"400\": $gray-400,\r\n        \"500\": $gray-500,\r\n        \"600\": $gray-600,\r\n        \"700\": $gray-700,\r\n        \"800\": $gray-800,\r\n        \"900\": $gray-900\r\n), $grays);\r\n\r\n$blue: #007bff !default;\r\n$indigo: #6610f2 !default;\r\n$purple: #6f42c1 !default;\r\n$pink: #e83e8c !default;\r\n$red: #dc3545 !default;\r\n$orange: #fd7e14 !default;\r\n$yellow: #ffc107 !default;\r\n$green: #28a745 !default;\r\n$teal: #20c997 !default;\r\n$cyan: #17a2b8 !default;\r\n\r\n$colors: () !default;\r\n$colors: map-merge((\r\n        \"blue\": $blue,\r\n        \"indigo\": $indigo,\r\n        \"purple\": $purple,\r\n        \"pink\": $pink,\r\n        \"red\": $red,\r\n        \"orange\": $orange,\r\n        \"yellow\": $yellow,\r\n        \"green\": $green,\r\n        \"teal\": $teal,\r\n        \"cyan\": $cyan,\r\n        \"white\": $white,\r\n        \"gray\": $gray-600,\r\n        \"gray-dark\": $gray-800\r\n), $colors);\r\n\r\n$primary: $blue !default;\r\n$secondary: $gray-600 !default;\r\n$success: $green !default;\r\n$info: $cyan !default;\r\n$warning: $yellow !default;\r\n$danger: $red !default;\r\n$light: $gray-100 !default;\r\n$dark: $gray-800 !default;\r\n\r\n$theme-colors: () !default;\r\n$theme-colors: map-merge((\r\n        \"primary\": $primary,\r\n        \"secondary\": $secondary,\r\n        \"success\": $success,\r\n        \"info\": $info,\r\n        \"warning\": $warning,\r\n        \"danger\": $danger,\r\n        \"light\": $light,\r\n        \"dark\": $dark\r\n), $theme-colors);\r\n// stylelint-enable\r\n\r\n// Set a specific jump point for requesting color jumps\r\n$theme-color-interval: 8% !default;\r\n\r\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\r\n$yiq-contrasted-threshold: 150 !default;\r\n\r\n// Customize the light and dark text colors for use in our YIQ color contrast function.\r\n$yiq-text-dark: $gray-900 !default;\r\n$yiq-text-light: $white !default;\r\n\r\n// Options\r\n//\r\n// Quickly modify global styling by enabling or disabling optional features.\r\n\r\n$enable-caret: true !default;\r\n$enable-rounded: true !default;\r\n$enable-shadows: false !default;\r\n$enable-gradients: false !default;\r\n$enable-transitions: true !default;\r\n$enable-hover-media-query: false !default; // Deprecated, no longer affects any compiled CSS\r\n$enable-grid-classes: true !default;\r\n$enable-print-styles: true !default;\r\n\r\n// Spacing\r\n//\r\n// Control the default styling of most Bootstrap elements by modifying these\r\n// variables. Mostly focused on spacing.\r\n// You can add more entries to the $spacers map, should you need more variation.\r\n\r\n// stylelint-disable\r\n$spacer: 1rem !default;\r\n$spacers: () !default;\r\n$spacers: map-merge((\r\n        0: 0,\r\n        1: ($spacer * .25),\r\n        2: ($spacer * .5),\r\n        3: $spacer,\r\n        4: ($spacer * 1.5),\r\n        5: ($spacer * 3)\r\n), $spacers);\r\n\r\n// This variable affects the `.h-*` and `.w-*` classes.\r\n$sizes: () !default;\r\n$sizes: map-merge((\r\n        25: 25%,\r\n        50: 50%,\r\n        75: 75%,\r\n        100: 100%\r\n), $sizes);\r\n// stylelint-enable\r\n\r\n// Body\r\n//\r\n// Settings for the `<body>` element.\r\n\r\n$body-bg: $white !default;\r\n$body-color: $gray-900 !default;\r\n\r\n// Links\r\n//\r\n// Style anchor elements.\r\n\r\n$link-color: theme-color(\"primary\") !default;\r\n$link-decoration: none !default;\r\n$link-hover-color: darken($link-color, 15%) !default;\r\n$link-hover-decoration: underline !default;\r\n\r\n// Paragraphs\r\n//\r\n// Style p element.\r\n\r\n$paragraph-margin-bottom: 1rem !default;\r\n\r\n// Grid breakpoints\r\n//\r\n// Define the minimum dimensions at which your layout will change,\r\n// adapting to different screen sizes, for use in media queries.\r\n\r\n$grid-breakpoints: (\r\n        xs: 0,\r\n        sm: 576px,\r\n        md: 768px,\r\n        lg: 992px,\r\n        xl: 1200px\r\n) !default;\r\n\r\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\r\n@include _assert-starts-at-zero($grid-breakpoints);\r\n\r\n// Grid containers\r\n//\r\n// Define the maximum width of `.container` for different screen sizes.\r\n\r\n$container-max-widths: (\r\n        sm: 540px,\r\n        md: 720px,\r\n        lg: 960px,\r\n        xl: 1140px\r\n) !default;\r\n\r\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\r\n\r\n// Grid columns\r\n//\r\n// Set the number of columns and specify the width of the gutters.\r\n\r\n$grid-columns: 12 !default;\r\n$grid-gutter-width: 30px !default;\r\n\r\n// Components\r\n//\r\n// Define common padding and border radius sizes and more.\r\n\r\n$line-height-lg: 1.5 !default;\r\n$line-height-sm: 1.5 !default;\r\n\r\n$border-width: 1px !default;\r\n$border-color: $gray-300 !default;\r\n\r\n$border-radius: .25rem !default;\r\n$border-radius-lg: .3rem !default;\r\n$border-radius-sm: .2rem !default;\r\n\r\n$component-active-color: $white !default;\r\n$component-active-bg: theme-color(\"primary\") !default;\r\n\r\n$caret-width: .3em !default;\r\n\r\n$transition-base: all .2s ease-in-out !default;\r\n$transition-fade: opacity .15s linear !default;\r\n$transition-collapse: height .35s ease !default;\r\n\r\n// Fonts\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n\r\n// stylelint-disable value-keyword-case\r\n$font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\" !default;\r\n$font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\r\n$font-family-base: $font-family-sans-serif !default;\r\n// stylelint-enable value-keyword-case\r\n\r\n$font-size-base: 1rem !default; // Assumes the browser default, typically `16px`\r\n$font-size-lg: ($font-size-base * 1.25) !default;\r\n$font-size-sm: ($font-size-base * .875) !default;\r\n\r\n$font-weight-light: 300 !default;\r\n$font-weight-normal: 400 !default;\r\n$font-weight-bold: 700 !default;\r\n\r\n$font-weight-base: $font-weight-normal !default;\r\n$line-height-base: 1.5 !default;\r\n\r\n$h1-font-size: $font-size-base * 2.5 !default;\r\n$h2-font-size: $font-size-base * 2 !default;\r\n$h3-font-size: $font-size-base * 1.75 !default;\r\n$h4-font-size: $font-size-base * 1.5 !default;\r\n$h5-font-size: $font-size-base * 1.25 !default;\r\n$h6-font-size: $font-size-base !default;\r\n\r\n$headings-margin-bottom: ($spacer / 2) !default;\r\n$headings-font-family: inherit !default;\r\n$headings-font-weight: 500 !default;\r\n$headings-line-height: 1.2 !default;\r\n$headings-color: inherit !default;\r\n\r\n$display1-size: 6rem !default;\r\n$display2-size: 5.5rem !default;\r\n$display3-size: 4.5rem !default;\r\n$display4-size: 3.5rem !default;\r\n\r\n$display1-weight: 300 !default;\r\n$display2-weight: 300 !default;\r\n$display3-weight: 300 !default;\r\n$display4-weight: 300 !default;\r\n$display-line-height: $headings-line-height !default;\r\n\r\n$lead-font-size: ($font-size-base * 1.25) !default;\r\n$lead-font-weight: 300 !default;\r\n\r\n$small-font-size: 80% !default;\r\n\r\n$text-muted: $gray-600 !default;\r\n\r\n$blockquote-small-color: $gray-600 !default;\r\n$blockquote-font-size: ($font-size-base * 1.25) !default;\r\n\r\n$hr-border-color: rgba($black, .1) !default;\r\n$hr-border-width: $border-width !default;\r\n\r\n$mark-padding: .2em !default;\r\n\r\n$dt-font-weight: $font-weight-bold !default;\r\n\r\n$kbd-box-shadow: inset 0 -.1rem 0 rgba($black, .25) !default;\r\n$nested-kbd-font-weight: $font-weight-bold !default;\r\n\r\n$list-inline-padding: .5rem !default;\r\n\r\n$mark-bg: #fcf8e3 !default;\r\n\r\n$hr-margin-y: $spacer !default;\r\n\r\n// Tables\r\n//\r\n// Customizes the `.table` component with basic values, each used across all table variations.\r\n\r\n$table-cell-padding: .75rem !default;\r\n$table-cell-padding-sm: .3rem !default;\r\n\r\n$table-bg: transparent !default;\r\n$table-accent-bg: rgba($black, .05) !default;\r\n$table-hover-bg: rgba($black, .075) !default;\r\n$table-active-bg: $table-hover-bg !default;\r\n\r\n$table-border-width: $border-width !default;\r\n$table-border-color: $gray-300 !default;\r\n\r\n$table-head-bg: $gray-200 !default;\r\n$table-head-color: $gray-700 !default;\r\n\r\n$table-dark-bg: $gray-900 !default;\r\n$table-dark-accent-bg: rgba($white, .05) !default;\r\n$table-dark-hover-bg: rgba($white, .075) !default;\r\n$table-dark-border-color: lighten($gray-900, 7.5%) !default;\r\n$table-dark-color: $body-bg !default;\r\n\r\n// Buttons + Forms\r\n//\r\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\r\n\r\n$input-btn-padding-y: .375rem !default;\r\n$input-btn-padding-x: .75rem !default;\r\n$input-btn-line-height: $line-height-base !default;\r\n\r\n$input-btn-focus-width: .2rem !default;\r\n$input-btn-focus-color: rgba($component-active-bg, .25) !default;\r\n$input-btn-focus-box-shadow: 0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\r\n\r\n$input-btn-padding-y-sm: .25rem !default;\r\n$input-btn-padding-x-sm: .5rem !default;\r\n$input-btn-line-height-sm: $line-height-sm !default;\r\n\r\n$input-btn-padding-y-lg: .5rem !default;\r\n$input-btn-padding-x-lg: 1rem !default;\r\n$input-btn-line-height-lg: $line-height-lg !default;\r\n\r\n$input-btn-border-width: $border-width !default;\r\n\r\n// Buttons\r\n//\r\n// For each of Bootstrap's buttons, define text, background, and border color.\r\n\r\n$btn-padding-y: $input-btn-padding-y !default;\r\n$btn-padding-x: $input-btn-padding-x !default;\r\n$btn-line-height: $input-btn-line-height !default;\r\n\r\n$btn-padding-y-sm: $input-btn-padding-y-sm !default;\r\n$btn-padding-x-sm: $input-btn-padding-x-sm !default;\r\n$btn-line-height-sm: $input-btn-line-height-sm !default;\r\n\r\n$btn-padding-y-lg: $input-btn-padding-y-lg !default;\r\n$btn-padding-x-lg: $input-btn-padding-x-lg !default;\r\n$btn-line-height-lg: $input-btn-line-height-lg !default;\r\n\r\n$btn-border-width: $input-btn-border-width !default;\r\n\r\n$btn-font-weight: $font-weight-normal !default;\r\n$btn-box-shadow: inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\r\n$btn-focus-width: $input-btn-focus-width !default;\r\n$btn-focus-box-shadow: $input-btn-focus-box-shadow !default;\r\n$btn-disabled-opacity: .65 !default;\r\n$btn-active-box-shadow: inset 0 3px 5px rgba($black, .125) !default;\r\n\r\n$btn-link-disabled-color: $gray-600 !default;\r\n\r\n$btn-block-spacing-y: .5rem !default;\r\n\r\n// Allows for customizing button radius independently from global border radius\r\n$btn-border-radius: $border-radius !default;\r\n$btn-border-radius-lg: $border-radius-lg !default;\r\n$btn-border-radius-sm: $border-radius-sm !default;\r\n\r\n$btn-transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\r\n\r\n// Forms\r\n\r\n$input-padding-y: $input-btn-padding-y !default;\r\n$input-padding-x: $input-btn-padding-x !default;\r\n$input-line-height: $input-btn-line-height !default;\r\n\r\n$input-padding-y-sm: $input-btn-padding-y-sm !default;\r\n$input-padding-x-sm: $input-btn-padding-x-sm !default;\r\n$input-line-height-sm: $input-btn-line-height-sm !default;\r\n\r\n$input-padding-y-lg: $input-btn-padding-y-lg !default;\r\n$input-padding-x-lg: $input-btn-padding-x-lg !default;\r\n$input-line-height-lg: $input-btn-line-height-lg !default;\r\n\r\n$input-bg: $white !default;\r\n$input-disabled-bg: $gray-200 !default;\r\n\r\n$input-color: $gray-700 !default;\r\n$input-border-color: $gray-400 !default;\r\n$input-border-width: $input-btn-border-width !default;\r\n$input-box-shadow: inset 0 1px 1px rgba($black, .075) !default;\r\n\r\n$input-border-radius: $border-radius !default;\r\n$input-border-radius-lg: $border-radius-lg !default;\r\n$input-border-radius-sm: $border-radius-sm !default;\r\n\r\n$input-focus-bg: $input-bg !default;\r\n$input-focus-border-color: lighten($component-active-bg, 25%) !default;\r\n$input-focus-color: $input-color !default;\r\n$input-focus-width: $input-btn-focus-width !default;\r\n$input-focus-box-shadow: $input-btn-focus-box-shadow !default;\r\n\r\n$input-placeholder-color: $gray-600 !default;\r\n\r\n$input-height-border: $input-border-width * 2 !default;\r\n\r\n$input-height-inner: ($font-size-base * $input-btn-line-height) + ($input-btn-padding-y * 2) !default;\r\n$input-height: calc(#{$input-height-inner} + #{$input-height-border}) !default;\r\n\r\n$input-height-inner-sm: ($font-size-sm * $input-btn-line-height-sm) + ($input-btn-padding-y-sm * 2) !default;\r\n$input-height-sm: calc(#{$input-height-inner-sm} + #{$input-height-border}) !default;\r\n\r\n$input-height-inner-lg: ($font-size-lg * $input-btn-line-height-lg) + ($input-btn-padding-y-lg * 2) !default;\r\n$input-height-lg: calc(#{$input-height-inner-lg} + #{$input-height-border}) !default;\r\n\r\n$input-transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\r\n\r\n$form-text-margin-top: .25rem !default;\r\n\r\n$form-check-input-gutter: 1.25rem !default;\r\n$form-check-input-margin-y: .3rem !default;\r\n$form-check-input-margin-x: .25rem !default;\r\n\r\n$form-check-inline-margin-x: .75rem !default;\r\n$form-check-inline-input-margin-x: .3125rem !default;\r\n\r\n$form-group-margin-bottom: 1rem !default;\r\n\r\n$input-group-addon-color: $input-color !default;\r\n$input-group-addon-bg: $gray-200 !default;\r\n$input-group-addon-border-color: $input-border-color !default;\r\n\r\n$custom-control-gutter: 1.5rem !default;\r\n$custom-control-spacer-x: 1rem !default;\r\n\r\n$custom-control-indicator-size: 1rem !default;\r\n$custom-control-indicator-bg: $gray-300 !default;\r\n$custom-control-indicator-bg-size: 50% 50% !default;\r\n$custom-control-indicator-box-shadow: inset 0 .25rem .25rem rgba($black, .1) !default;\r\n\r\n$custom-control-indicator-disabled-bg: $gray-200 !default;\r\n$custom-control-label-disabled-color: $gray-600 !default;\r\n\r\n$custom-control-indicator-checked-color: $component-active-color !default;\r\n$custom-control-indicator-checked-bg: $component-active-bg !default;\r\n$custom-control-indicator-checked-disabled-bg: rgba(theme-color(\"primary\"), .5) !default;\r\n$custom-control-indicator-checked-box-shadow: none !default;\r\n\r\n$custom-control-indicator-focus-box-shadow: 0 0 0 1px $body-bg, $input-btn-focus-box-shadow !default;\r\n\r\n$custom-control-indicator-active-color: $component-active-color !default;\r\n$custom-control-indicator-active-bg: lighten($component-active-bg, 35%) !default;\r\n$custom-control-indicator-active-box-shadow: none !default;\r\n\r\n$custom-checkbox-indicator-border-radius: $border-radius !default;\r\n$custom-checkbox-indicator-icon-checked: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n\r\n$custom-checkbox-indicator-indeterminate-bg: $component-active-bg !default;\r\n$custom-checkbox-indicator-indeterminate-color: $custom-control-indicator-checked-color !default;\r\n$custom-checkbox-indicator-icon-indeterminate: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$custom-checkbox-indicator-indeterminate-box-shadow: none !default;\r\n\r\n$custom-radio-indicator-border-radius: 50% !default;\r\n$custom-radio-indicator-icon-checked: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='#{$custom-control-indicator-checked-color}'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n\r\n$custom-select-padding-y: .375rem !default;\r\n$custom-select-padding-x: .75rem !default;\r\n$custom-select-height: $input-height !default;\r\n$custom-select-indicator-padding: 1rem !default; // Extra padding to account for the presence of the background-image based indicator\r\n$custom-select-line-height: $input-btn-line-height !default;\r\n$custom-select-color: $input-color !default;\r\n$custom-select-disabled-color: $gray-600 !default;\r\n$custom-select-bg: $white !default;\r\n$custom-select-disabled-bg: $gray-200 !default;\r\n$custom-select-bg-size: 8px 10px !default; // In pixels because image dimensions\r\n$custom-select-indicator-color: $gray-800 !default;\r\n$custom-select-indicator: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$custom-select-border-width: $input-btn-border-width !default;\r\n$custom-select-border-color: $input-border-color !default;\r\n$custom-select-border-radius: $border-radius !default;\r\n\r\n$custom-select-focus-border-color: $input-focus-border-color !default;\r\n$custom-select-focus-box-shadow: inset 0 1px 2px rgba($black, .075), 0 0 5px rgba($custom-select-focus-border-color, .5) !default;\r\n\r\n$custom-select-font-size-sm: 75% !default;\r\n$custom-select-height-sm: $input-height-sm !default;\r\n\r\n$custom-select-font-size-lg: 125% !default;\r\n$custom-select-height-lg: $input-height-lg !default;\r\n\r\n$custom-file-height: $input-height !default;\r\n$custom-file-focus-border-color: $input-focus-border-color !default;\r\n$custom-file-focus-box-shadow: $input-btn-focus-box-shadow !default;\r\n\r\n$custom-file-padding-y: $input-btn-padding-y !default;\r\n$custom-file-padding-x: $input-btn-padding-x !default;\r\n$custom-file-line-height: $input-btn-line-height !default;\r\n$custom-file-color: $input-color !default;\r\n$custom-file-bg: $input-bg !default;\r\n$custom-file-border-width: $input-btn-border-width !default;\r\n$custom-file-border-color: $input-border-color !default;\r\n$custom-file-border-radius: $input-border-radius !default;\r\n$custom-file-box-shadow: $input-box-shadow !default;\r\n$custom-file-button-color: $custom-file-color !default;\r\n$custom-file-button-bg: $input-group-addon-bg !default;\r\n$custom-file-text: (\r\n        en: \"Browse\"\r\n) !default;\r\n\r\n// Form validation\r\n$form-feedback-margin-top: $form-text-margin-top !default;\r\n$form-feedback-font-size: $small-font-size !default;\r\n$form-feedback-valid-color: theme-color(\"success\") !default;\r\n$form-feedback-invalid-color: theme-color(\"danger\") !default;\r\n\r\n// Dropdowns\r\n//\r\n// Dropdown menu container and contents.\r\n\r\n$dropdown-min-width: 10rem !default;\r\n$dropdown-padding-y: .5rem !default;\r\n$dropdown-spacer: .125rem !default;\r\n$dropdown-bg: $white !default;\r\n$dropdown-border-color: rgba($black, .15) !default;\r\n$dropdown-border-radius: $border-radius !default;\r\n$dropdown-border-width: $border-width !default;\r\n$dropdown-divider-bg: $gray-200 !default;\r\n$dropdown-box-shadow: 0 .5rem 1rem rgba($black, .175) !default;\r\n\r\n$dropdown-link-color: $gray-900 !default;\r\n$dropdown-link-hover-color: darken($gray-900, 5%) !default;\r\n$dropdown-link-hover-bg: $gray-100 !default;\r\n\r\n$dropdown-link-active-color: $component-active-color !default;\r\n$dropdown-link-active-bg: $component-active-bg !default;\r\n\r\n$dropdown-link-disabled-color: $gray-600 !default;\r\n\r\n$dropdown-item-padding-y: .25rem !default;\r\n$dropdown-item-padding-x: 1.5rem !default;\r\n\r\n$dropdown-header-color: $gray-600 !default;\r\n\r\n// Z-index master list\r\n//\r\n// Warning: Avoid customizing these values. They're used for a bird's eye view\r\n// of components dependent on the z-axis and are designed to all work together.\r\n\r\n$zindex-dropdown: 1000 !default;\r\n$zindex-sticky: 1020 !default;\r\n$zindex-fixed: 1030 !default;\r\n$zindex-modal-backdrop: 1040 !default;\r\n$zindex-modal: 1050 !default;\r\n$zindex-popover: 1060 !default;\r\n$zindex-tooltip: 1070 !default;\r\n\r\n// Navs\r\n\r\n$nav-link-padding-y: .5rem !default;\r\n$nav-link-padding-x: 1rem !default;\r\n$nav-link-disabled-color: $gray-600 !default;\r\n\r\n$nav-tabs-border-color: $gray-300 !default;\r\n$nav-tabs-border-width: $border-width !default;\r\n$nav-tabs-border-radius: $border-radius !default;\r\n$nav-tabs-link-hover-border-color: $gray-200 $gray-200 $nav-tabs-border-color !default;\r\n$nav-tabs-link-active-color: $gray-700 !default;\r\n$nav-tabs-link-active-bg: $body-bg !default;\r\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\r\n\r\n$nav-pills-border-radius: $border-radius !default;\r\n$nav-pills-link-active-color: $component-active-color !default;\r\n$nav-pills-link-active-bg: $component-active-bg !default;\r\n\r\n// Navbar\r\n\r\n$navbar-padding-y: ($spacer / 2) !default;\r\n$navbar-padding-x: $spacer !default;\r\n\r\n$navbar-nav-link-padding-x: .5rem !default;\r\n\r\n$navbar-brand-font-size: $font-size-lg !default;\r\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\r\n$nav-link-height: ($font-size-base * $line-height-base + $nav-link-padding-y * 2) !default;\r\n$navbar-brand-height: $navbar-brand-font-size * $line-height-base !default;\r\n$navbar-brand-padding-y: ($nav-link-height - $navbar-brand-height) / 2 !default;\r\n\r\n$navbar-toggler-padding-y: .25rem !default;\r\n$navbar-toggler-padding-x: .75rem !default;\r\n$navbar-toggler-font-size: $font-size-lg !default;\r\n$navbar-toggler-border-radius: $btn-border-radius !default;\r\n\r\n$navbar-dark-color: rgba($white, .5) !default;\r\n$navbar-dark-hover-color: rgba($white, .75) !default;\r\n$navbar-dark-active-color: $white !default;\r\n$navbar-dark-disabled-color: rgba($white, .25) !default;\r\n$navbar-dark-toggler-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$navbar-dark-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$navbar-dark-toggler-border-color: rgba($white, .1) !default;\r\n\r\n$navbar-light-color: rgba($black, .5) !default;\r\n$navbar-light-hover-color: rgba($black, .7) !default;\r\n$navbar-light-active-color: rgba($black, .9) !default;\r\n$navbar-light-disabled-color: rgba($black, .3) !default;\r\n$navbar-light-toggler-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$navbar-light-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\r\n\r\n// Pagination\r\n\r\n$pagination-padding-y: .5rem !default;\r\n$pagination-padding-x: .75rem !default;\r\n$pagination-padding-y-sm: .25rem !default;\r\n$pagination-padding-x-sm: .5rem !default;\r\n$pagination-padding-y-lg: .75rem !default;\r\n$pagination-padding-x-lg: 1.5rem !default;\r\n$pagination-line-height: 1.25 !default;\r\n\r\n$pagination-color: $link-color !default;\r\n$pagination-bg: $white !default;\r\n$pagination-border-width: $border-width !default;\r\n$pagination-border-color: $gray-300 !default;\r\n\r\n$pagination-focus-box-shadow: $input-btn-focus-box-shadow !default;\r\n\r\n$pagination-hover-color: $link-hover-color !default;\r\n$pagination-hover-bg: $gray-200 !default;\r\n$pagination-hover-border-color: $gray-300 !default;\r\n\r\n$pagination-active-color: $component-active-color !default;\r\n$pagination-active-bg: $component-active-bg !default;\r\n$pagination-active-border-color: $pagination-active-bg !default;\r\n\r\n$pagination-disabled-color: $gray-600 !default;\r\n$pagination-disabled-bg: $white !default;\r\n$pagination-disabled-border-color: $gray-300 !default;\r\n\r\n// Jumbotron\r\n\r\n$jumbotron-padding: 2rem !default;\r\n$jumbotron-bg: $gray-200 !default;\r\n\r\n// Cards\r\n\r\n$card-spacer-y: .75rem !default;\r\n$card-spacer-x: 1.25rem !default;\r\n$card-border-width: $border-width !default;\r\n$card-border-radius: $border-radius !default;\r\n$card-border-color: rgba($black, .125) !default;\r\n$card-inner-border-radius: calc(#{$card-border-radius} - #{$card-border-width}) !default;\r\n$card-cap-bg: rgba($black, .03) !default;\r\n$card-bg: $white !default;\r\n\r\n$card-img-overlay-padding: 1.25rem !default;\r\n\r\n$card-group-margin: ($grid-gutter-width / 2) !default;\r\n$card-deck-margin: $card-group-margin !default;\r\n\r\n$card-columns-count: 3 !default;\r\n$card-columns-gap: 1.25rem !default;\r\n$card-columns-margin: $card-spacer-y !default;\r\n\r\n// Tooltips\r\n\r\n$tooltip-font-size: $font-size-sm !default;\r\n$tooltip-max-width: 200px !default;\r\n$tooltip-color: $white !default;\r\n$tooltip-bg: $black !default;\r\n$tooltip-border-radius: $border-radius !default;\r\n$tooltip-opacity: .9 !default;\r\n$tooltip-padding-y: .25rem !default;\r\n$tooltip-padding-x: .5rem !default;\r\n$tooltip-margin: 0 !default;\r\n\r\n$tooltip-arrow-width: .8rem !default;\r\n$tooltip-arrow-height: .4rem !default;\r\n$tooltip-arrow-color: $tooltip-bg !default;\r\n\r\n// Popovers\r\n\r\n$popover-font-size: $font-size-sm !default;\r\n$popover-bg: $white !default;\r\n$popover-max-width: 276px !default;\r\n$popover-border-width: $border-width !default;\r\n$popover-border-color: rgba($black, .2) !default;\r\n$popover-border-radius: $border-radius-lg !default;\r\n$popover-box-shadow: 0 .25rem .5rem rgba($black, .2) !default;\r\n\r\n$popover-header-bg: darken($popover-bg, 3%) !default;\r\n$popover-header-color: $headings-color !default;\r\n$popover-header-padding-y: .5rem !default;\r\n$popover-header-padding-x: .75rem !default;\r\n\r\n$popover-body-color: $body-color !default;\r\n$popover-body-padding-y: $popover-header-padding-y !default;\r\n$popover-body-padding-x: $popover-header-padding-x !default;\r\n\r\n$popover-arrow-width: 1rem !default;\r\n$popover-arrow-height: .5rem !default;\r\n$popover-arrow-color: $popover-bg !default;\r\n\r\n$popover-arrow-outer-color: fade-in($popover-border-color, .05) !default;\r\n\r\n// Badges\r\n\r\n$badge-font-size: 75% !default;\r\n$badge-font-weight: $font-weight-bold !default;\r\n$badge-padding-y: .25em !default;\r\n$badge-padding-x: .4em !default;\r\n$badge-border-radius: $border-radius !default;\r\n\r\n$badge-pill-padding-x: .6em !default;\r\n// Use a higher than normal value to ensure completely rounded edges when\r\n// customizing padding or font-size on labels.\r\n$badge-pill-border-radius: 10rem !default;\r\n\r\n// Modals\r\n\r\n// Padding applied to the modal body\r\n$modal-inner-padding: 1rem !default;\r\n\r\n$modal-dialog-margin: .5rem !default;\r\n$modal-dialog-margin-y-sm-up: 1.75rem !default;\r\n\r\n$modal-title-line-height: $line-height-base !default;\r\n\r\n$modal-content-bg: $white !default;\r\n$modal-content-border-color: rgba($black, .2) !default;\r\n$modal-content-border-width: $border-width !default;\r\n$modal-content-box-shadow-xs: 0 .25rem .5rem rgba($black, .5) !default;\r\n$modal-content-box-shadow-sm-up: 0 .5rem 1rem rgba($black, .5) !default;\r\n\r\n$modal-backdrop-bg: $black !default;\r\n$modal-backdrop-opacity: .5 !default;\r\n$modal-header-border-color: $gray-200 !default;\r\n$modal-footer-border-color: $modal-header-border-color !default;\r\n$modal-header-border-width: $modal-content-border-width !default;\r\n$modal-footer-border-width: $modal-header-border-width !default;\r\n$modal-header-padding: 1rem !default;\r\n\r\n$modal-lg: 800px !default;\r\n$modal-md: 500px !default;\r\n$modal-sm: 300px !default;\r\n\r\n$modal-transition: transform .3s ease-out !default;\r\n\r\n// Alerts\r\n//\r\n// Define alert colors, border radius, and padding.\r\n\r\n$alert-padding-y: .75rem !default;\r\n$alert-padding-x: 1.25rem !default;\r\n$alert-margin-bottom: 1rem !default;\r\n$alert-border-radius: $border-radius !default;\r\n$alert-link-font-weight: $font-weight-bold !default;\r\n$alert-border-width: $border-width !default;\r\n\r\n$alert-bg-level: -10 !default;\r\n$alert-border-level: -9 !default;\r\n$alert-color-level: 6 !default;\r\n\r\n// Progress bars\r\n\r\n$progress-height: 1rem !default;\r\n$progress-font-size: ($font-size-base * .75) !default;\r\n$progress-bg: $gray-200 !default;\r\n$progress-border-radius: $border-radius !default;\r\n$progress-box-shadow: inset 0 .1rem .1rem rgba($black, .1) !default;\r\n$progress-bar-color: $white !default;\r\n$progress-bar-bg: theme-color(\"primary\") !default;\r\n$progress-bar-animation-timing: 1s linear infinite !default;\r\n$progress-bar-transition: width .6s ease !default;\r\n\r\n// List group\r\n\r\n$list-group-bg: $white !default;\r\n$list-group-border-color: rgba($black, .125) !default;\r\n$list-group-border-width: $border-width !default;\r\n$list-group-border-radius: $border-radius !default;\r\n\r\n$list-group-item-padding-y: .75rem !default;\r\n$list-group-item-padding-x: 1.25rem !default;\r\n\r\n$list-group-hover-bg: $gray-100 !default;\r\n$list-group-active-color: $component-active-color !default;\r\n$list-group-active-bg: $component-active-bg !default;\r\n$list-group-active-border-color: $list-group-active-bg !default;\r\n\r\n$list-group-disabled-color: $gray-600 !default;\r\n$list-group-disabled-bg: $list-group-bg !default;\r\n\r\n$list-group-action-color: $gray-700 !default;\r\n$list-group-action-hover-color: $list-group-action-color !default;\r\n\r\n$list-group-action-active-color: $body-color !default;\r\n$list-group-action-active-bg: $gray-200 !default;\r\n\r\n// Image thumbnails\r\n\r\n$thumbnail-padding: .25rem !default;\r\n$thumbnail-bg: $body-bg !default;\r\n$thumbnail-border-width: $border-width !default;\r\n$thumbnail-border-color: $gray-300 !default;\r\n$thumbnail-border-radius: $border-radius !default;\r\n$thumbnail-box-shadow: 0 1px 2px rgba($black, .075) !default;\r\n\r\n// Figures\r\n\r\n$figure-caption-font-size: 90% !default;\r\n$figure-caption-color: $gray-600 !default;\r\n\r\n// Breadcrumbs\r\n\r\n$breadcrumb-padding-y: .75rem !default;\r\n$breadcrumb-padding-x: 1rem !default;\r\n$breadcrumb-item-padding: .5rem !default;\r\n\r\n$breadcrumb-margin-bottom: 1rem !default;\r\n\r\n$breadcrumb-bg: $gray-200 !default;\r\n$breadcrumb-divider-color: $gray-600 !default;\r\n$breadcrumb-active-color: $gray-600 !default;\r\n$breadcrumb-divider: \"/\" !default;\r\n\r\n// Carousel\r\n\r\n$carousel-control-color: $white !default;\r\n$carousel-control-width: 15% !default;\r\n$carousel-control-opacity: .5 !default;\r\n\r\n$carousel-indicator-width: 30px !default;\r\n$carousel-indicator-height: 3px !default;\r\n$carousel-indicator-spacer: 3px !default;\r\n$carousel-indicator-active-bg: $white !default;\r\n\r\n$carousel-caption-width: 70% !default;\r\n$carousel-caption-color: $white !default;\r\n\r\n$carousel-control-icon-width: 20px !default;\r\n\r\n$carousel-control-prev-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$carousel-control-next-icon-bg: str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n\r\n$carousel-transition: transform .6s ease !default;\r\n\r\n// Close\r\n\r\n$close-font-size: $font-size-base * 1.5 !default;\r\n$close-font-weight: $font-weight-bold !default;\r\n//$close-color: $black !default;\r\n//$close-text-shadow: 0 1px 0 $white !default;\r\n\r\n// Code\r\n\r\n$code-font-size: 87.5% !default;\r\n$code-color: $pink !default;\r\n\r\n$kbd-padding-y: .2rem !default;\r\n$kbd-padding-x: .4rem !default;\r\n$kbd-font-size: $code-font-size !default;\r\n$kbd-color: $white !default;\r\n$kbd-bg: $gray-900 !default;\r\n\r\n$pre-color: $gray-900 !default;\r\n$pre-scrollable-max-height: 340px !default;\r\n\r\n// Printing\r\n$print-page-size: a3 !default;\r\n$print-body-min-width: map-get($grid-breakpoints, \"lg\") !default;\r\n","// stylelint-disable indentation\r\n\r\n// Hover mixin and `$enable-hover-media-query` are deprecated.\r\n//\r\n// Origally added during our alphas and maintained during betas, this mixin was\r\n// designed to prevent `:hover` stickiness on iOS—an issue where hover styles\r\n// would persist after initial touch.\r\n//\r\n// For backward compatibility, we've kept these mixins and updated them to\r\n// always return their regular psuedo-classes instead of a shimmed media query.\r\n//\r\n// Issue: https://github.com/twbs/bootstrap/issues/25195\r\n\r\n@mixin hover {\r\n  &:hover {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin hover-focus {\r\n  &:hover,\r\n  &:focus {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin plain-hover-focus {\r\n  &,\r\n  &:hover,\r\n  &:focus {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin hover-focus-active {\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    @content;\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important, selector-list-comma-newline-after\r\n\r\n//\r\n// Headings\r\n//\r\n\r\nh1, h2, h3, h4, h5, h6,\r\n.h1, .h2, .h3, .h4, .h5, .h6 {\r\n  margin-bottom: $headings-margin-bottom;\r\n  font-family: $headings-font-family;\r\n  font-weight: $headings-font-weight;\r\n  line-height: $headings-line-height;\r\n  color: $headings-color;\r\n}\r\n\r\nh1, .h1 {\r\n  font-size: $h1-font-size;\r\n}\r\n\r\nh2, .h2 {\r\n  font-size: $h2-font-size;\r\n}\r\n\r\nh3, .h3 {\r\n  font-size: $h3-font-size;\r\n}\r\n\r\nh4, .h4 {\r\n  font-size: $h4-font-size;\r\n}\r\n\r\nh5, .h5 {\r\n  font-size: $h5-font-size;\r\n}\r\n\r\nh6, .h6 {\r\n  font-size: $h6-font-size;\r\n}\r\n\r\n.lead {\r\n  font-size: $lead-font-size;\r\n  font-weight: $lead-font-weight;\r\n}\r\n\r\n// Type display classes\r\n.display-1 {\r\n  font-size: $display1-size;\r\n  font-weight: $display1-weight;\r\n  line-height: $display-line-height;\r\n}\r\n\r\n.display-2 {\r\n  font-size: $display2-size;\r\n  font-weight: $display2-weight;\r\n  line-height: $display-line-height;\r\n}\r\n\r\n.display-3 {\r\n  font-size: $display3-size;\r\n  font-weight: $display3-weight;\r\n  line-height: $display-line-height;\r\n}\r\n\r\n.display-4 {\r\n  font-size: $display4-size;\r\n  font-weight: $display4-weight;\r\n  line-height: $display-line-height;\r\n}\r\n\r\n//\r\n// Horizontal rules\r\n//\r\n\r\nhr {\r\n  margin-top: $hr-margin-y;\r\n  margin-bottom: $hr-margin-y;\r\n  border: 0;\r\n  border-top: $hr-border-width solid $hr-border-color;\r\n}\r\n\r\n//\r\n// Emphasis\r\n//\r\n\r\nsmall,\r\n.small {\r\n  font-size: $small-font-size;\r\n  font-weight: $font-weight-normal;\r\n}\r\n\r\nmark,\r\n.mark {\r\n  padding: $mark-padding;\r\n  background-color: $mark-bg;\r\n}\r\n\r\n//\r\n// Lists\r\n//\r\n\r\n.list-unstyled {\r\n  @include list-unstyled;\r\n}\r\n\r\n// Inline turns list items into inline-block\r\n.list-inline {\r\n  @include list-unstyled;\r\n}\r\n\r\n.list-inline-item {\r\n  display: inline-block;\r\n\r\n  &:not(:last-child) {\r\n    margin-right: $list-inline-padding;\r\n  }\r\n}\r\n\r\n//\r\n// Misc\r\n//\r\n\r\n// Builds on `abbr`\r\n.initialism {\r\n  font-size: 90%;\r\n  text-transform: uppercase;\r\n}\r\n\r\n// Blockquotes\r\n.blockquote {\r\n  margin-bottom: $spacer;\r\n  font-size: $blockquote-font-size;\r\n}\r\n\r\n.blockquote-footer {\r\n  display: block;\r\n  font-size: 80%; // back to default font-size\r\n  color: $blockquote-small-color;\r\n\r\n  &::before {\r\n    content: \"\\2014 \\00A0\"; // em dash, nbsp\r\n  }\r\n}\r\n","// Lists\r\n\r\n// Unstyled keeps list items block level, just removes default browser padding and list-style\r\n@mixin list-unstyled {\r\n  padding-left: 0;\r\n  list-style: none;\r\n}\r\n","// Responsive images (ensure images don't scale beyond their parents)\r\n//\r\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\r\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\r\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\r\n// which weren't expecting the images within themselves to be involuntarily resized.\r\n// See also https://github.com/twbs/bootstrap/issues/18178\r\n.img-fluid {\r\n  @include img-fluid;\r\n}\r\n\r\n// Image thumbnails\r\n.img-thumbnail {\r\n  padding: $thumbnail-padding;\r\n  background-color: $thumbnail-bg;\r\n  border: $thumbnail-border-width solid $thumbnail-border-color;\r\n  @include border-radius($thumbnail-border-radius);\r\n  @include box-shadow($thumbnail-box-shadow);\r\n\r\n  // Keep them at most 100% wide\r\n  @include img-fluid;\r\n}\r\n\r\n//\r\n// Figures\r\n//\r\n\r\n.figure {\r\n  // Ensures the caption's text aligns with the image.\r\n  display: inline-block;\r\n}\r\n\r\n.figure-img {\r\n  margin-bottom: ($spacer / 2);\r\n  line-height: 1;\r\n}\r\n\r\n.figure-caption {\r\n  font-size: $figure-caption-font-size;\r\n  color: $figure-caption-color;\r\n}\r\n","// Image Mixins\r\n// - Responsive image\r\n// - Retina image\r\n\r\n// Responsive image\r\n//\r\n// Keep images from scaling beyond the width of their parents.\r\n\r\n@mixin img-fluid {\r\n  // Part 1: Set a maximum relative to the parent\r\n  max-width: 100%;\r\n  // Part 2: Override the height to auto, otherwise images will be stretched\r\n  // when setting a width and height attribute on the img element.\r\n  height: auto;\r\n}\r\n\r\n// Retina image\r\n//\r\n// Short retina mixin for setting background-image and -size.\r\n\r\n// stylelint-disable indentation, media-query-list-comma-newline-after\r\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\r\n  background-image: url($file-1x);\r\n\r\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\r\n  // but doesn't convert dppx=>dpi.\r\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\r\n  // Compatibility info: https://caniuse.com/#feat=css-media-resolution\r\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\r\n  only screen and (min-resolution: 2dppx) { // Standardized\r\n    background-image: url($file-2x);\r\n    background-size: $width-1x $height-1x;\r\n  }\r\n}\r\n","// Single side border-radius\r\n\r\n@mixin border-radius($radius: $border-radius) {\r\n  @if $enable-rounded {\r\n    border-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-top-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-left-radius: $radius;\r\n    border-top-right-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-right-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-right-radius: $radius;\r\n    border-bottom-right-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-bottom-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-bottom-right-radius: $radius;\r\n    border-bottom-left-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-left-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-left-radius: $radius;\r\n    border-bottom-left-radius: $radius;\r\n  }\r\n}\r\n","@mixin box-shadow($shadow...) {\r\n  @if $enable-shadows {\r\n    box-shadow: $shadow;\r\n  }\r\n}\r\n","// Inline and block code styles\r\ncode,\r\nkbd,\r\npre,\r\nsamp {\r\n  font-family: $font-family-monospace;\r\n}\r\n\r\n// Inline code\r\ncode {\r\n  font-size: $code-font-size;\r\n  color: $code-color;\r\n  word-break: break-word;\r\n\r\n  // Streamline the style when inside anchors to avoid broken underline and more\r\n  a > & {\r\n    color: inherit;\r\n  }\r\n}\r\n\r\n// User input typically entered via keyboard\r\nkbd {\r\n  padding: $kbd-padding-y $kbd-padding-x;\r\n  font-size: $kbd-font-size;\r\n  color: $kbd-color;\r\n  background-color: $kbd-bg;\r\n  @include border-radius($border-radius-sm);\r\n  @include box-shadow($kbd-box-shadow);\r\n\r\n  kbd {\r\n    padding: 0;\r\n    font-size: 100%;\r\n    font-weight: $nested-kbd-font-weight;\r\n    @include box-shadow(none);\r\n  }\r\n}\r\n\r\n// Blocks of code\r\npre {\r\n  display: block;\r\n  font-size: $code-font-size;\r\n  color: $pre-color;\r\n\r\n  // Account for some code outputs that place code tags in pre tags\r\n  code {\r\n    font-size: inherit;\r\n    color: inherit;\r\n    word-break: normal;\r\n  }\r\n}\r\n\r\n// Enable scrollable blocks of code\r\n.pre-scrollable {\r\n  max-height: $pre-scrollable-max-height;\r\n  overflow-y: scroll;\r\n}\r\n","// Container widths\r\n//\r\n// Set the container width, and override it for fixed navbars in media queries.\r\n\r\n@if $enable-grid-classes {\r\n  .container {\r\n    @include make-container();\r\n    @include make-container-max-widths();\r\n  }\r\n}\r\n\r\n// Fluid container\r\n//\r\n// Utilizes the mixin meant for fixed width containers, but with 100% width for\r\n// fluid, full width layouts.\r\n\r\n@if $enable-grid-classes {\r\n  .container-fluid {\r\n    @include make-container();\r\n  }\r\n}\r\n\r\n// Row\r\n//\r\n// Rows contain and clear the floats of your columns.\r\n\r\n@if $enable-grid-classes {\r\n  .row {\r\n    @include make-row();\r\n  }\r\n\r\n  // Remove the negative margin from default .row, then the horizontal padding\r\n  // from all immediate children columns (to prevent runaway style inheritance).\r\n  .no-gutters {\r\n    margin-right: 0;\r\n    margin-left: 0;\r\n\r\n    > .col,\r\n    > [class*=\"col-\"] {\r\n      padding-right: 0;\r\n      padding-left: 0;\r\n    }\r\n  }\r\n}\r\n\r\n// Columns\r\n//\r\n// Common styles for small and large grid columns\r\n\r\n@if $enable-grid-classes {\r\n  @include make-grid-columns();\r\n}\r\n","/// Grid system\r\n//\r\n// Generate semantic grid columns with these mixins.\r\n\r\n@mixin make-container() {\r\n  width: 100%;\r\n  padding-right: ($grid-gutter-width / 2);\r\n  padding-left: ($grid-gutter-width / 2);\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n}\r\n\r\n// For each breakpoint, define the maximum width of the container in a media query\r\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\r\n  @each $breakpoint, $container-max-width in $max-widths {\r\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\r\n      max-width: $container-max-width;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin make-row() {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin-right: ($grid-gutter-width / -2);\r\n  margin-left: ($grid-gutter-width / -2);\r\n}\r\n\r\n@mixin make-col-ready() {\r\n  position: relative;\r\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\r\n  // always setting `width: 100%;`. This works because we use `flex` values\r\n  // later on to override this initial width.\r\n  width: 100%;\r\n  min-height: 1px; // Prevent collapsing\r\n  padding-right: ($grid-gutter-width / 2);\r\n  padding-left: ($grid-gutter-width / 2);\r\n}\r\n\r\n@mixin make-col($size, $columns: $grid-columns) {\r\n  flex: 0 0 percentage($size / $columns);\r\n  // Add a `max-width` to ensure content within each column does not blow out\r\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\r\n  // do not appear to require this.\r\n  max-width: percentage($size / $columns);\r\n}\r\n\r\n@mixin make-col-offset($size, $columns: $grid-columns) {\r\n  $num: $size / $columns;\r\n  margin-left: if($num == 0, 0, percentage($num));\r\n}\r\n","// Breakpoint viewport sizes and media queries.\r\n//\r\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\r\n//\r\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\r\n//\r\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\r\n\r\n// Name of the next breakpoint, or null for the last breakpoint.\r\n//\r\n//    >> breakpoint-next(sm)\r\n//    md\r\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    md\r\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\r\n//    md\r\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\r\n  $n: index($breakpoint-names, $name);\r\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\r\n}\r\n\r\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\r\n//\r\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    576px\r\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\r\n  $min: map-get($breakpoints, $name);\r\n  @return if($min != 0, $min, null);\r\n}\r\n\r\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\r\n// The maximum value is calculated as the minimum of the next one less 0.02px\r\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\r\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\r\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\r\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\r\n//\r\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    767.98px\r\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\r\n  $next: breakpoint-next($name, $breakpoints);\r\n  @return if($next, breakpoint-min($next, $breakpoints) - .02px, null);\r\n}\r\n\r\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash infront.\r\n// Useful for making responsive utilities.\r\n//\r\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    \"\"  (Returns a blank string)\r\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    \"-sm\"\r\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\r\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\r\n}\r\n\r\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\r\n// Makes the @content apply to the given breakpoint and wider.\r\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\r\n  $min: breakpoint-min($name, $breakpoints);\r\n  @if $min {\r\n    @media (min-width: $min) {\r\n      @content;\r\n    }\r\n  } @else {\r\n    @content;\r\n  }\r\n}\r\n\r\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\r\n// Makes the @content apply to the given breakpoint and narrower.\r\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\r\n  $max: breakpoint-max($name, $breakpoints);\r\n  @if $max {\r\n    @media (max-width: $max) {\r\n      @content;\r\n    }\r\n  } @else {\r\n    @content;\r\n  }\r\n}\r\n\r\n// Media that spans multiple breakpoint widths.\r\n// Makes the @content apply between the min and max breakpoints\r\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\r\n  $min: breakpoint-min($lower, $breakpoints);\r\n  $max: breakpoint-max($upper, $breakpoints);\r\n\r\n  @if $min != null and $max != null {\r\n    @media (min-width: $min) and (max-width: $max) {\r\n      @content;\r\n    }\r\n  } @else if $max == null {\r\n    @include media-breakpoint-up($lower, $breakpoints) {\r\n      @content;\r\n    }\r\n  } @else if $min == null {\r\n    @include media-breakpoint-down($upper, $breakpoints) {\r\n      @content;\r\n    }\r\n  }\r\n}\r\n\r\n// Media between the breakpoint's minimum and maximum widths.\r\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\r\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\r\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\r\n  $min: breakpoint-min($name, $breakpoints);\r\n  $max: breakpoint-max($name, $breakpoints);\r\n\r\n  @if $min != null and $max != null {\r\n    @media (min-width: $min) and (max-width: $max) {\r\n      @content;\r\n    }\r\n  } @else if $max == null {\r\n    @include media-breakpoint-up($name, $breakpoints) {\r\n      @content;\r\n    }\r\n  } @else if $min == null {\r\n    @include media-breakpoint-down($name, $breakpoints) {\r\n      @content;\r\n    }\r\n  }\r\n}\r\n","// Framework grid generation\r\n//\r\n// Used only by Bootstrap to generate the correct number of grid classes given\r\n// any value of `$grid-columns`.\r\n\r\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\r\n  // Common properties for all breakpoints\r\n  %grid-column {\r\n    position: relative;\r\n    width: 100%;\r\n    min-height: 1px; // Prevent columns from collapsing when empty\r\n    padding-right: ($gutter / 2);\r\n    padding-left: ($gutter / 2);\r\n  }\r\n\r\n  @each $breakpoint in map-keys($breakpoints) {\r\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\r\n\r\n    // Allow columns to stretch full width below their breakpoints\r\n    @for $i from 1 through $columns {\r\n      .col#{$infix}-#{$i} {\r\n        @extend %grid-column;\r\n      }\r\n    }\r\n    .col#{$infix},\r\n    .col#{$infix}-auto {\r\n      @extend %grid-column;\r\n    }\r\n\r\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\r\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\r\n      .col#{$infix} {\r\n        flex-basis: 0;\r\n        flex-grow: 1;\r\n        max-width: 100%;\r\n      }\r\n      .col#{$infix}-auto {\r\n        flex: 0 0 auto;\r\n        width: auto;\r\n        max-width: none; // Reset earlier grid tiers\r\n      }\r\n\r\n      @for $i from 1 through $columns {\r\n        .col#{$infix}-#{$i} {\r\n          @include make-col($i, $columns);\r\n        }\r\n      }\r\n\r\n      .order#{$infix}-first {\r\n        order: -1;\r\n      }\r\n\r\n      .order#{$infix}-last {\r\n        order: $columns + 1;\r\n      }\r\n\r\n      @for $i from 0 through $columns {\r\n        .order#{$infix}-#{$i} {\r\n          order: $i;\r\n        }\r\n      }\r\n\r\n      // `$columns - 1` because offsetting by the width of an entire row isn't possible\r\n      @for $i from 0 through ($columns - 1) {\r\n        @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\r\n          .offset#{$infix}-#{$i} {\r\n            @include make-col-offset($i, $columns);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","//\r\n// Basic Bootstrap table\r\n//\r\n\r\n.table {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  margin-bottom: $spacer;\r\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\r\n\r\n  th,\r\n  td {\r\n    padding: $table-cell-padding;\r\n    vertical-align: top;\r\n    border-top: $table-border-width solid $table-border-color;\r\n  }\r\n\r\n  thead th {\r\n    vertical-align: bottom;\r\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\r\n  }\r\n\r\n  tbody + tbody {\r\n    border-top: (2 * $table-border-width) solid $table-border-color;\r\n  }\r\n\r\n  .table {\r\n    background-color: $body-bg;\r\n  }\r\n}\r\n\r\n//\r\n// Condensed table w/ half padding\r\n//\r\n\r\n.table-sm {\r\n  th,\r\n  td {\r\n    padding: $table-cell-padding-sm;\r\n  }\r\n}\r\n\r\n// Bordered version\r\n//\r\n// Add borders all around the table and between all the columns.\r\n\r\n.table-bordered {\r\n  border: $table-border-width solid $table-border-color;\r\n\r\n  th,\r\n  td {\r\n    border: $table-border-width solid $table-border-color;\r\n  }\r\n\r\n  thead {\r\n    th,\r\n    td {\r\n      border-bottom-width: (2 * $table-border-width);\r\n    }\r\n  }\r\n}\r\n\r\n// Zebra-striping\r\n//\r\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\r\n\r\n.table-striped {\r\n  tbody tr:nth-of-type(odd) {\r\n    background-color: $table-accent-bg;\r\n  }\r\n}\r\n\r\n// Hover effect\r\n//\r\n// Placed here since it has to come after the potential zebra striping\r\n\r\n.table-hover {\r\n  tbody tr {\r\n    @include hover {\r\n      background-color: $table-hover-bg;\r\n    }\r\n  }\r\n}\r\n\r\n// Table backgrounds\r\n//\r\n// Exact selectors below required to override `.table-striped` and prevent\r\n// inheritance to nested tables.\r\n\r\n@each $color, $value in $theme-colors {\r\n  @include table-row-variant($color, theme-color-level($color, -9));\r\n}\r\n\r\n@include table-row-variant(active, $table-active-bg);\r\n\r\n// Dark styles\r\n//\r\n// Same table markup, but inverted color scheme: dark background and light text.\r\n\r\n// stylelint-disable-next-line no-duplicate-selectors\r\n.table {\r\n  .thead-dark {\r\n    th {\r\n      color: $table-dark-color;\r\n      background-color: $table-dark-bg;\r\n      border-color: $table-dark-border-color;\r\n    }\r\n  }\r\n\r\n  .thead-light {\r\n    th {\r\n      color: $table-head-color;\r\n      background-color: $table-head-bg;\r\n      border-color: $table-border-color;\r\n    }\r\n  }\r\n}\r\n\r\n.table-dark {\r\n  color: $table-dark-color;\r\n  background-color: $table-dark-bg;\r\n\r\n  th,\r\n  td,\r\n  thead th {\r\n    border-color: $table-dark-border-color;\r\n  }\r\n\r\n  &.table-bordered {\r\n    border: 0;\r\n  }\r\n\r\n  &.table-striped {\r\n    tbody tr:nth-of-type(odd) {\r\n      background-color: $table-dark-accent-bg;\r\n    }\r\n  }\r\n\r\n  &.table-hover {\r\n    tbody tr {\r\n      @include hover {\r\n        background-color: $table-dark-hover-bg;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Responsive tables\r\n//\r\n// Generate series of `.table-responsive-*` classes for configuring the screen\r\n// size of where your table will overflow.\r\n\r\n.table-responsive {\r\n  @each $breakpoint in map-keys($grid-breakpoints) {\r\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\r\n    $infix: breakpoint-infix($next, $grid-breakpoints);\r\n\r\n    &#{$infix} {\r\n      @include media-breakpoint-down($breakpoint) {\r\n        display: block;\r\n        width: 100%;\r\n        overflow-x: auto;\r\n        -webkit-overflow-scrolling: touch;\r\n        -ms-overflow-style: -ms-autohiding-scrollbar; // See https://github.com/twbs/bootstrap/pull/10057\r\n\r\n        // Prevent double border on horizontal scroll due to use of `display: block;`\r\n        > .table-bordered {\r\n          border: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.table-middle td,\r\n.table-middle thead th {\r\n  vertical-align: middle;\r\n}\r\n","// Tables\r\n\r\n@mixin table-row-variant($state, $background) {\r\n  // Exact selectors below required to override `.table-striped` and prevent\r\n  // inheritance to nested tables.\r\n  .table-#{$state} {\r\n    &,\r\n    > th,\r\n    > td {\r\n      background-color: $background;\r\n    }\r\n  }\r\n\r\n  // Hover states for `.table-hover`\r\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\r\n  .table-hover {\r\n    $hover-background: darken($background, 5%);\r\n\r\n    .table-#{$state} {\r\n      @include hover {\r\n        background-color: $hover-background;\r\n\r\n        > td,\r\n        > th {\r\n          background-color: $hover-background;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// stylelint-disable selector-no-qualifying-type\r\n\r\n//\r\n// Textual form controls\r\n//\r\n\r\n.form-control {\r\n  display: block;\r\n  width: 100%;\r\n  padding: $input-padding-y $input-padding-x;\r\n  font-size: $font-size-base;\r\n  line-height: $input-line-height;\r\n  color: $input-color;\r\n  background-color: $input-bg;\r\n  background-clip: padding-box;\r\n  border: $input-border-width solid $input-border-color;\r\n\r\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\r\n  @if $enable-rounded {\r\n    // Manually use the if/else instead of the mixin to account for iOS override\r\n    border-radius: $input-border-radius;\r\n  } @else {\r\n    // Otherwise undo the iOS default\r\n    border-radius: 0;\r\n  }\r\n\r\n  @include box-shadow($input-box-shadow);\r\n  @include transition($input-transition);\r\n\r\n  // Unstyle the caret on `<select>`s in IE10+.\r\n  &::-ms-expand {\r\n    background-color: transparent;\r\n    border: 0;\r\n  }\r\n\r\n  // Customize the `:focus` state to imitate native WebKit styles.\r\n  @include form-control-focus();\r\n\r\n  // Placeholder\r\n  &::placeholder {\r\n    color: $input-placeholder-color;\r\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\r\n    opacity: 1;\r\n  }\r\n\r\n  // Disabled and read-only inputs\r\n  //\r\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\r\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\r\n  // don't honor that edge case; we style them as disabled anyway.\r\n  &:disabled,\r\n  &[readonly] {\r\n    background-color: $input-disabled-bg;\r\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\nselect.form-control {\r\n  &:not([size]):not([multiple]) {\r\n    height: $input-height;\r\n  }\r\n\r\n  &:focus::-ms-value {\r\n    // Suppress the nested default white text on blue background highlight given to\r\n    // the selected option text when the (still closed) <select> receives focus\r\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\r\n    // match the appearance of the native widget.\r\n    // See https://github.com/twbs/bootstrap/issues/19398.\r\n    color: $input-color;\r\n    background-color: $input-bg;\r\n  }\r\n}\r\n\r\n// Make file inputs better match text inputs by forcing them to new lines.\r\n.form-control-file,\r\n.form-control-range {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n//\r\n// Labels\r\n//\r\n\r\n// For use with horizontal and inline forms, when you need the label (or legend)\r\n// text to align with the form controls.\r\n.col-form-label {\r\n  padding-top: calc(#{$input-padding-y} + #{$input-border-width});\r\n  padding-bottom: calc(#{$input-padding-y} + #{$input-border-width});\r\n  margin-bottom: 0; // Override the `<label>/<legend>` default\r\n  font-size: inherit; // Override the `<legend>` default\r\n  line-height: $input-line-height;\r\n}\r\n\r\n.col-form-label-lg {\r\n  padding-top: calc(#{$input-padding-y-lg} + #{$input-border-width});\r\n  padding-bottom: calc(#{$input-padding-y-lg} + #{$input-border-width});\r\n  font-size: $font-size-lg;\r\n  line-height: $input-line-height-lg;\r\n}\r\n\r\n.col-form-label-sm {\r\n  padding-top: calc(#{$input-padding-y-sm} + #{$input-border-width});\r\n  padding-bottom: calc(#{$input-padding-y-sm} + #{$input-border-width});\r\n  font-size: $font-size-sm;\r\n  line-height: $input-line-height-sm;\r\n}\r\n\r\n// Readonly controls as plain text\r\n//\r\n// Apply class to a readonly input to make it appear like regular plain\r\n// text (without any border, background color, focus indicator)\r\n\r\n.form-control-plaintext {\r\n  display: block;\r\n  width: 100%;\r\n  padding-top: $input-padding-y;\r\n  padding-bottom: $input-padding-y;\r\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\r\n  line-height: $input-line-height;\r\n  background-color: transparent;\r\n  border: solid transparent;\r\n  border-width: $input-border-width 0;\r\n\r\n  &.form-control-sm,\r\n  &.form-control-lg {\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n// Form control sizing\r\n//\r\n// Build on `.form-control` with modifier classes to decrease or increase the\r\n// height and font-size of form controls.\r\n//\r\n// The `.form-group-* form-control` variations are sadly duplicated to avoid the\r\n// issue documented in https://github.com/twbs/bootstrap/issues/15074.\r\n\r\n.form-control-sm {\r\n  padding: $input-padding-y-sm $input-padding-x-sm;\r\n  font-size: $font-size-sm;\r\n  line-height: $input-line-height-sm;\r\n  @include border-radius($input-border-radius-sm);\r\n}\r\n\r\nselect.form-control-sm {\r\n  &:not([size]):not([multiple]) {\r\n    height: $input-height-sm;\r\n  }\r\n}\r\n\r\n.form-control-lg {\r\n  padding: $input-padding-y-lg $input-padding-x-lg;\r\n  font-size: $font-size-lg;\r\n  line-height: $input-line-height-lg;\r\n  @include border-radius($input-border-radius-lg);\r\n}\r\n\r\nselect.form-control-lg {\r\n  &:not([size]):not([multiple]) {\r\n    height: $input-height-lg;\r\n  }\r\n}\r\n\r\n// Form groups\r\n//\r\n// Designed to help with the organization and spacing of vertical forms. For\r\n// horizontal forms, use the predefined grid classes.\r\n\r\n.form-group {\r\n  margin-bottom: $form-group-margin-bottom;\r\n}\r\n\r\n.form-text {\r\n  display: block;\r\n  margin-top: $form-text-margin-top;\r\n}\r\n\r\n// Form grid\r\n//\r\n// Special replacement for our grid system's `.row` for tighter form layouts.\r\n\r\n.form-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin-right: -5px;\r\n  margin-left: -5px;\r\n\r\n  > .col,\r\n  > [class*=\"col-\"] {\r\n    padding-right: 5px;\r\n    padding-left: 5px;\r\n  }\r\n}\r\n\r\n// Checkboxes and radios\r\n//\r\n// Indent the labels to position radios/checkboxes as hanging controls.\r\n\r\n.form-check {\r\n  position: relative;\r\n  display: block;\r\n  padding-left: $form-check-input-gutter;\r\n}\r\n\r\n.form-check-input {\r\n  position: absolute;\r\n  margin-top: $form-check-input-margin-y;\r\n  margin-left: -$form-check-input-gutter;\r\n\r\n  &:disabled ~ .form-check-label {\r\n    color: $text-muted;\r\n  }\r\n}\r\n\r\n.form-check-label {\r\n  margin-bottom: 0; // Override default `<label>` bottom margin\r\n}\r\n\r\n.form-check-inline {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding-left: 0; // Override base .form-check\r\n  margin-right: $form-check-inline-margin-x;\r\n\r\n  // Undo .form-check-input defaults and add some `margin-right`.\r\n  .form-check-input {\r\n    position: static;\r\n    margin-top: 0;\r\n    margin-right: $form-check-inline-input-margin-x;\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n// Form validation\r\n//\r\n// Provide feedback to users when form field values are valid or invalid. Works\r\n// primarily for client-side validation via scoped `:invalid` and `:valid`\r\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\r\n// server side validation.\r\n\r\n@include form-validation-state(\"valid\", $form-feedback-valid-color);\r\n@include form-validation-state(\"invalid\", $form-feedback-invalid-color);\r\n\r\n// Inline forms\r\n//\r\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\r\n// forms begin stacked on extra small (mobile) devices and then go inline when\r\n// viewports reach <768px.\r\n//\r\n// Requires wrapping inputs and labels with `.form-group` for proper display of\r\n// default HTML form controls and our custom form controls (e.g., input groups).\r\n\r\n.form-inline {\r\n  display: flex;\r\n  flex-flow: row wrap;\r\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\r\n\r\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\r\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\r\n  // so we force that here.\r\n  .form-check {\r\n    width: 100%;\r\n  }\r\n\r\n  // Kick in the inline\r\n  @include media-breakpoint-up(sm) {\r\n    label {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    // Inline-block all the things for \"inline\"\r\n    .form-group {\r\n      display: flex;\r\n      flex: 0 0 auto;\r\n      flex-flow: row wrap;\r\n      align-items: center;\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    // Allow folks to *not* use `.form-group`\r\n    .form-control {\r\n      display: inline-block;\r\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\r\n      vertical-align: middle;\r\n    }\r\n\r\n    // Make static controls behave like regular ones\r\n    .form-control-plaintext {\r\n      display: inline-block;\r\n    }\r\n\r\n    .input-group {\r\n      width: auto;\r\n    }\r\n\r\n    // Remove default margin on radios/checkboxes that were used for stacking, and\r\n    // then undo the floating of radios and checkboxes to match.\r\n    .form-check {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      width: auto;\r\n      padding-left: 0;\r\n    }\r\n    .form-check-input {\r\n      position: relative;\r\n      margin-top: 0;\r\n      margin-right: $form-check-input-margin-x;\r\n      margin-left: 0;\r\n    }\r\n\r\n    .custom-control {\r\n      align-items: center;\r\n      justify-content: center;\r\n    }\r\n    .custom-control-label {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n}\r\n","@mixin transition($transition...) {\r\n  @if $enable-transitions {\r\n    @if length($transition) == 0 {\r\n      transition: $transition-base;\r\n    } @else {\r\n      transition: $transition;\r\n    }\r\n  }\r\n}\r\n","// Form control focus state\r\n//\r\n// Generate a customized focus state and for any input with the specified color,\r\n// which defaults to the `$input-focus-border-color` variable.\r\n//\r\n// We highly encourage you to not customize the default value, but instead use\r\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\r\n// WebKit's default styles, but applicable to a wider range of browsers. Its\r\n// usability and accessibility should be taken into account with any change.\r\n//\r\n// Example usage: change the default blue border and shadow to white for better\r\n// contrast against a dark gray background.\r\n@mixin form-control-focus() {\r\n  &:focus {\r\n    color: $input-focus-color;\r\n    background-color: $input-focus-bg;\r\n    border-color: $input-focus-border-color;\r\n    outline: 0;\r\n    // Avoid using mixin so we can pass custom focus shadow properly\r\n    @if $enable-shadows {\r\n      box-shadow: $input-box-shadow, $input-focus-box-shadow;\r\n    } @else {\r\n      box-shadow: $input-focus-box-shadow;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin form-validation-state($state, $color) {\r\n  .#{$state}-feedback {\r\n    display: none;\r\n    width: 100%;\r\n    margin-top: $form-feedback-margin-top;\r\n    font-size: $form-feedback-font-size;\r\n    color: $color;\r\n  }\r\n\r\n  .#{$state}-tooltip {\r\n    position: absolute;\r\n    top: 100%;\r\n    z-index: 5;\r\n    display: none;\r\n    max-width: 100%; // Contain to parent when possible\r\n    padding: .5rem;\r\n    margin-top: .1rem;\r\n    font-size: .875rem;\r\n    line-height: 1;\r\n    color: #fff;\r\n    background-color: rgba($color, .8);\r\n    border-radius: .2rem;\r\n  }\r\n\r\n  .form-control,\r\n  .custom-select {\r\n    .was-validated &:#{$state},\r\n    &.is-#{$state} {\r\n      border-color: $color;\r\n\r\n      &:focus {\r\n        border-color: $color;\r\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\r\n      }\r\n\r\n      ~ .#{$state}-feedback,\r\n      ~ .#{$state}-tooltip {\r\n        display: block;\r\n      }\r\n    }\r\n  }\r\n\r\n  .form-check-input {\r\n    .was-validated &:#{$state},\r\n    &.is-#{$state} {\r\n      ~ .form-check-label {\r\n        color: $color;\r\n      }\r\n\r\n      ~ .#{$state}-feedback,\r\n      ~ .#{$state}-tooltip {\r\n        display: block;\r\n      }\r\n    }\r\n  }\r\n\r\n  .custom-control-input {\r\n    .was-validated &:#{$state},\r\n    &.is-#{$state} {\r\n      ~ .custom-control-label {\r\n        color: $color;\r\n\r\n        &::before {\r\n          background-color: lighten($color, 25%);\r\n        }\r\n      }\r\n\r\n      ~ .#{$state}-feedback,\r\n      ~ .#{$state}-tooltip {\r\n        display: block;\r\n      }\r\n\r\n      &:checked {\r\n        ~ .custom-control-label::before {\r\n          @include gradient-bg(lighten($color, 10%));\r\n        }\r\n      }\r\n\r\n      &:focus {\r\n        ~ .custom-control-label::before {\r\n          box-shadow: 0 0 0 1px $body-bg, 0 0 0 $input-focus-width rgba($color, .25);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // custom file\r\n  .custom-file-input {\r\n    .was-validated &:#{$state},\r\n    &.is-#{$state} {\r\n      ~ .custom-file-label {\r\n        border-color: $color;\r\n\r\n        &::before {\r\n          border-color: inherit;\r\n        }\r\n      }\r\n\r\n      ~ .#{$state}-feedback,\r\n      ~ .#{$state}-tooltip {\r\n        display: block;\r\n      }\r\n\r\n      &:focus {\r\n        ~ .custom-file-label {\r\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Gradients\r\n\r\n@mixin gradient-bg($color) {\r\n  @if $enable-gradients {\r\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\r\n  } @else {\r\n    background-color: $color;\r\n  }\r\n}\r\n\r\n// Horizontal gradient, from left to right\r\n//\r\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\r\n@mixin gradient-x($start-color: #555, $end-color: #333, $start-percent: 0%, $end-percent: 100%) {\r\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\r\n  background-repeat: repeat-x;\r\n}\r\n\r\n// Vertical gradient, from top to bottom\r\n//\r\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\r\n@mixin gradient-y($start-color: #555, $end-color: #333, $start-percent: 0%, $end-percent: 100%) {\r\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\r\n  background-repeat: repeat-x;\r\n}\r\n\r\n@mixin gradient-directional($start-color: #555, $end-color: #333, $deg: 45deg) {\r\n  background-image: linear-gradient($deg, $start-color, $end-color);\r\n  background-repeat: repeat-x;\r\n}\r\n\r\n@mixin gradient-x-three-colors($start-color: #00b3ee, $mid-color: #7a43b6, $color-stop: 50%, $end-color: #c3325f) {\r\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n@mixin gradient-y-three-colors($start-color: #00b3ee, $mid-color: #7a43b6, $color-stop: 50%, $end-color: #c3325f) {\r\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n@mixin gradient-radial($inner-color: #555, $outer-color: #333) {\r\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n@mixin gradient-striped($color: rgba(255,255,255,.15), $angle: 45deg) {\r\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\r\n}\r\n","// stylelint-disable selector-no-qualifying-type\r\n\r\n//\r\n// Base styles\r\n//\r\n\r\n.btn {\r\n  display: inline-block;\r\n  font-weight: $btn-font-weight;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  vertical-align: middle;\r\n  user-select: none;\r\n  border: $btn-border-width solid transparent;\r\n  @include button-size($btn-padding-y, $btn-padding-x, $font-size-base, $btn-line-height, $btn-border-radius);\r\n  @include transition($btn-transition);\r\n\r\n  // Share hover and focus styles\r\n  @include hover-focus {\r\n    text-decoration: none;\r\n  }\r\n\r\n  &:focus,\r\n  &.focus {\r\n    outline: 0;\r\n    box-shadow: $btn-focus-box-shadow;\r\n  }\r\n\r\n  // Disabled comes first so active can properly restyle\r\n  &.disabled,\r\n  &:disabled {\r\n    opacity: $btn-disabled-opacity;\r\n    @include box-shadow(none);\r\n  }\r\n\r\n  // Opinionated: add \"hand\" cursor to non-disabled .btn elements\r\n  &:not(:disabled):not(.disabled) {\r\n    cursor: pointer;\r\n  }\r\n\r\n  &:not(:disabled):not(.disabled):active,\r\n  &:not(:disabled):not(.disabled).active {\r\n    background-image: none;\r\n    @include box-shadow($btn-active-box-shadow);\r\n\r\n    &:focus {\r\n      @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\r\n    }\r\n  }\r\n}\r\n\r\n// Future-proof disabling of clicks on `<a>` elements\r\na.btn.disabled,\r\nfieldset:disabled a.btn {\r\n  pointer-events: none;\r\n}\r\n\r\n//\r\n// Alternate buttons\r\n//\r\n\r\n@each $color, $value in $theme-colors {\r\n  .btn-#{$color} {\r\n    @include button-variant($value, $value);\r\n  }\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  .btn-outline-#{$color} {\r\n    @include button-outline-variant($value);\r\n  }\r\n}\r\n\r\n//\r\n// Link buttons\r\n//\r\n\r\n// Make a button look and behave like a link\r\n.btn-link {\r\n  font-weight: $font-weight-normal;\r\n  color: $link-color;\r\n  background-color: transparent;\r\n\r\n  @include hover {\r\n    color: $link-hover-color;\r\n    text-decoration: $link-hover-decoration;\r\n    background-color: transparent;\r\n    border-color: transparent;\r\n  }\r\n\r\n  &:focus,\r\n  &.focus {\r\n    text-decoration: $link-hover-decoration;\r\n    border-color: transparent;\r\n    box-shadow: none;\r\n  }\r\n\r\n  &:disabled,\r\n  &.disabled {\r\n    color: $btn-link-disabled-color;\r\n  }\r\n\r\n  // No need for an active state here\r\n}\r\n\r\n//\r\n// Button Sizes\r\n//\r\n\r\n.btn-lg {\r\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\r\n}\r\n\r\n.btn-sm {\r\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\r\n}\r\n\r\n//\r\n// Block button\r\n//\r\n\r\n.btn-block {\r\n  display: block;\r\n  width: 100%;\r\n\r\n  // Vertically space out multiple block buttons\r\n  + .btn-block {\r\n    margin-top: $btn-block-spacing-y;\r\n  }\r\n}\r\n\r\n// Specificity overrides\r\ninput[type=\"submit\"],\r\ninput[type=\"reset\"],\r\ninput[type=\"button\"] {\r\n  &.btn-block {\r\n    width: 100%;\r\n  }\r\n}\r\n","// Button variants\r\n//\r\n// Easily pump out default styles, as well as :hover, :focus, :active,\r\n// and disabled options for all buttons\r\n\r\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\r\n  color: color-yiq($background);\r\n  @include gradient-bg($background);\r\n  border-color: $border;\r\n  @include box-shadow($btn-box-shadow);\r\n\r\n  @include hover {\r\n    color: color-yiq($hover-background);\r\n    @include gradient-bg($hover-background);\r\n    border-color: $hover-border;\r\n  }\r\n\r\n  &:focus,\r\n  &.focus {\r\n    // Avoid using mixin so we can pass custom focus shadow properly\r\n    @if $enable-shadows {\r\n      box-shadow: $btn-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\r\n    } @else {\r\n      box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\r\n    }\r\n  }\r\n\r\n  // Disabled comes first so active can properly restyle\r\n  &.disabled,\r\n  &:disabled {\r\n    color: color-yiq($background);\r\n    background-color: $background;\r\n    border-color: $border;\r\n  }\r\n\r\n  &:not(:disabled):not(.disabled):active,\r\n  &:not(:disabled):not(.disabled).active,\r\n  .show > &.dropdown-toggle {\r\n    color: color-yiq($active-background);\r\n    background-color: $active-background;\r\n    @if $enable-gradients {\r\n      background-image: none; // Remove the gradient for the pressed/active state\r\n    }\r\n    border-color: $active-border;\r\n\r\n    &:focus {\r\n      // Avoid using mixin so we can pass custom focus shadow properly\r\n      @if $enable-shadows {\r\n        box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\r\n      } @else {\r\n        box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\r\n  color: $color;\r\n  background-color: transparent;\r\n  background-image: none;\r\n  border-color: $color;\r\n\r\n  &:hover {\r\n    color: $color-hover;\r\n    background-color: $active-background;\r\n    border-color: $active-border;\r\n  }\r\n\r\n  &:focus,\r\n  &.focus {\r\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\r\n  }\r\n\r\n  &.disabled,\r\n  &:disabled {\r\n    color: $color;\r\n    background-color: transparent;\r\n  }\r\n\r\n  &:not(:disabled):not(.disabled):active,\r\n  &:not(:disabled):not(.disabled).active,\r\n  .show > &.dropdown-toggle {\r\n    color: color-yiq($active-background);\r\n    background-color: $active-background;\r\n    border-color: $active-border;\r\n\r\n    &:focus {\r\n      // Avoid using mixin so we can pass custom focus shadow properly\r\n      @if $enable-shadows and $btn-active-box-shadow != none {\r\n        box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5);\r\n      } @else {\r\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Button sizes\r\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\r\n  padding: $padding-y $padding-x;\r\n  font-size: $font-size;\r\n  line-height: $line-height;\r\n  // Manually declare to provide an override to the browser default\r\n  @if $enable-rounded {\r\n    border-radius: $border-radius;\r\n  } @else {\r\n    border-radius: 0;\r\n  }\r\n}\r\n","// stylelint-disable selector-no-qualifying-type\r\n\r\n.fade {\r\n  opacity: 0;\r\n  @include transition($transition-fade);\r\n\r\n  &.show {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.collapse {\r\n  display: none;\r\n  &.show {\r\n    display: block;\r\n  }\r\n}\r\n\r\ntr {\r\n  &.collapse.show {\r\n    display: table-row;\r\n  }\r\n}\r\n\r\ntbody {\r\n  &.collapse.show {\r\n    display: table-row-group;\r\n  }\r\n}\r\n\r\n.collapsing {\r\n  position: relative;\r\n  height: 0;\r\n  overflow: hidden;\r\n  @include transition($transition-collapse);\r\n}\r\n","// The dropdown wrapper (`<div>`)\r\n.dropup,\r\n.dropdown {\r\n  position: relative;\r\n}\r\n\r\n.dropdown-toggle {\r\n  // Generate the caret automatically\r\n  @include caret;\r\n}\r\n\r\n// The dropdown menu\r\n.dropdown-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  z-index: $zindex-dropdown;\r\n  display: none; // none by default, but block on \"open\" of the menu\r\n  float: left;\r\n  min-width: $dropdown-min-width;\r\n  padding: $dropdown-padding-y 0;\r\n  margin: $dropdown-spacer 0 0; // override default ul\r\n  font-size: $font-size-base; // Redeclare because nesting can cause inheritance issues\r\n  color: $body-color;\r\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\r\n  list-style: none;\r\n  background-color: $dropdown-bg;\r\n  background-clip: padding-box;\r\n  border: $dropdown-border-width solid $dropdown-border-color;\r\n  @include border-radius($dropdown-border-radius);\r\n  @include box-shadow($dropdown-box-shadow);\r\n}\r\n\r\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\r\n// Just add .dropup after the standard .dropdown class and you're set.\r\n.dropup {\r\n  .dropdown-menu {\r\n    margin-top: 0;\r\n    margin-bottom: $dropdown-spacer;\r\n  }\r\n\r\n  .dropdown-toggle {\r\n    @include caret(up);\r\n  }\r\n}\r\n\r\n.dropright {\r\n  .dropdown-menu {\r\n    margin-top: 0;\r\n    margin-left: $dropdown-spacer;\r\n  }\r\n\r\n  .dropdown-toggle {\r\n    @include caret(right);\r\n    &::after {\r\n      vertical-align: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.dropleft {\r\n  .dropdown-menu {\r\n    margin-top: 0;\r\n    margin-right: $dropdown-spacer;\r\n  }\r\n\r\n  .dropdown-toggle {\r\n    @include caret(left);\r\n    &::before {\r\n      vertical-align: 0;\r\n    }\r\n  }\r\n}\r\n\r\n// Dividers (basically an `<hr>`) within the dropdown\r\n.dropdown-divider {\r\n  @include nav-divider($dropdown-divider-bg);\r\n}\r\n\r\n// Links, buttons, and more within the dropdown menu\r\n//\r\n// `<button>`-specific styles are denoted with `// For <button>s`\r\n.dropdown-item {\r\n  display: block;\r\n  width: 100%; // For `<button>`s\r\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\r\n  clear: both;\r\n  font-weight: $font-weight-normal;\r\n  color: $dropdown-link-color;\r\n  text-align: inherit; // For `<button>`s\r\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\r\n  background-color: transparent; // For `<button>`s\r\n  border: 0; // For `<button>`s\r\n\r\n  @include hover-focus {\r\n    color: $dropdown-link-hover-color;\r\n    text-decoration: none;\r\n    @include gradient-bg($dropdown-link-hover-bg);\r\n  }\r\n\r\n  &.active,\r\n  &:active {\r\n    color: $dropdown-link-active-color;\r\n    text-decoration: none;\r\n    @include gradient-bg($dropdown-link-active-bg);\r\n  }\r\n\r\n  &.disabled,\r\n  &:disabled {\r\n    color: $dropdown-link-disabled-color;\r\n    background-color: transparent;\r\n    // Remove CSS gradients if they're enabled\r\n    @if $enable-gradients {\r\n      background-image: none;\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown-menu.show {\r\n  display: block;\r\n}\r\n\r\n// Dropdown section headers\r\n.dropdown-header {\r\n  display: block;\r\n  padding: $dropdown-padding-y $dropdown-item-padding-x;\r\n  margin-bottom: 0; // for use with heading elements\r\n  font-size: $font-size-sm;\r\n  color: $dropdown-header-color;\r\n  white-space: nowrap; // as with > li > a\r\n}\r\n","@mixin caret-down {\r\n  border-top: $caret-width solid;\r\n  border-right: $caret-width solid transparent;\r\n  border-bottom: 0;\r\n  border-left: $caret-width solid transparent;\r\n}\r\n\r\n@mixin caret-up {\r\n  border-top: 0;\r\n  border-right: $caret-width solid transparent;\r\n  border-bottom: $caret-width solid;\r\n  border-left: $caret-width solid transparent;\r\n}\r\n\r\n@mixin caret-right {\r\n  border-top: $caret-width solid transparent;\r\n  border-bottom: $caret-width solid transparent;\r\n  border-left: $caret-width solid;\r\n}\r\n\r\n@mixin caret-left {\r\n  border-top: $caret-width solid transparent;\r\n  border-right: $caret-width solid;\r\n  border-bottom: $caret-width solid transparent;\r\n}\r\n\r\n@mixin caret($direction: down) {\r\n  @if $enable-caret {\r\n    &::after {\r\n      display: inline-block;\r\n      width: 0;\r\n      height: 0;\r\n      margin-left: $caret-width * .85;\r\n      vertical-align: $caret-width * .85;\r\n      content: \"\";\r\n      @if $direction == down {\r\n        @include caret-down;\r\n      } @else if $direction == up {\r\n        @include caret-up;\r\n      } @else if $direction == right {\r\n        @include caret-right;\r\n      }\r\n    }\r\n\r\n    @if $direction == left {\r\n      &::after {\r\n        display: none;\r\n      }\r\n\r\n      &::before {\r\n        display: inline-block;\r\n        width: 0;\r\n        height: 0;\r\n        margin-right: $caret-width * .85;\r\n        vertical-align: $caret-width * .85;\r\n        content: \"\";\r\n        @include caret-left;\r\n      }\r\n    }\r\n\r\n    &:empty::after {\r\n      margin-left: 0;\r\n    }\r\n  }\r\n}\r\n","// Horizontal dividers\r\n//\r\n// Dividers (basically an hr) within dropdowns and nav lists\r\n\r\n@mixin nav-divider($color: #e5e5e5) {\r\n  height: 0;\r\n  margin: ($spacer / 2) 0;\r\n  overflow: hidden;\r\n  border-top: 1px solid $color;\r\n}\r\n","// stylelint-disable selector-no-qualifying-type\r\n\r\n// Make the div behave like a button\r\n.btn-group,\r\n.btn-group-vertical {\r\n  position: relative;\r\n  display: inline-flex;\r\n  vertical-align: middle; // match .btn alignment given font-size hack above\r\n\r\n  > .btn {\r\n    position: relative;\r\n    flex: 0 1 auto;\r\n\r\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\r\n    // the borders properly\r\n    @include hover {\r\n      z-index: 1;\r\n    }\r\n    &:focus,\r\n    &:active,\r\n    &.active {\r\n      z-index: 1;\r\n    }\r\n  }\r\n\r\n  // Prevent double borders when buttons are next to each other\r\n  .btn + .btn,\r\n  .btn + .btn-group,\r\n  .btn-group + .btn,\r\n  .btn-group + .btn-group {\r\n    margin-left: -$btn-border-width;\r\n  }\r\n}\r\n\r\n// Optional: Group multiple button groups together for a toolbar\r\n.btn-toolbar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-start;\r\n\r\n  .input-group {\r\n    width: auto;\r\n  }\r\n}\r\n\r\n.btn-group {\r\n  > .btn:first-child {\r\n    margin-left: 0;\r\n  }\r\n\r\n  // Reset rounded corners\r\n  > .btn:not(:last-child):not(.dropdown-toggle),\r\n  > .btn-group:not(:last-child) > .btn {\r\n    @include border-right-radius(0);\r\n  }\r\n\r\n  > .btn:not(:first-child),\r\n  > .btn-group:not(:first-child) > .btn {\r\n    @include border-left-radius(0);\r\n  }\r\n}\r\n\r\n// Sizing\r\n//\r\n// Remix the default button sizing classes into new ones for easier manipulation.\r\n\r\n.btn-group-sm > .btn {\r\n  @extend .btn-sm;\r\n}\r\n\r\n.btn-group-lg > .btn {\r\n  @extend .btn-lg;\r\n}\r\n\r\n//\r\n// Split button dropdowns\r\n//\r\n\r\n.dropdown-toggle-split {\r\n  padding-right: $btn-padding-x * .75;\r\n  padding-left: $btn-padding-x * .75;\r\n\r\n  &::after {\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n.btn-sm + .dropdown-toggle-split {\r\n  padding-right: $btn-padding-x-sm * .75;\r\n  padding-left: $btn-padding-x-sm * .75;\r\n}\r\n\r\n.btn-lg + .dropdown-toggle-split {\r\n  padding-right: $btn-padding-x-lg * .75;\r\n  padding-left: $btn-padding-x-lg * .75;\r\n}\r\n\r\n// The clickable button for toggling the menu\r\n// Set the same inset shadow as the :active state\r\n.btn-group.show .dropdown-toggle {\r\n  @include box-shadow($btn-active-box-shadow);\r\n\r\n  // Show no shadow for `.btn-link` since it has no other button styles.\r\n  &.btn-link {\r\n    @include box-shadow(none);\r\n  }\r\n}\r\n\r\n//\r\n// Vertical button groups\r\n//\r\n\r\n.btn-group-vertical {\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n\r\n  .btn,\r\n  .btn-group {\r\n    width: 100%;\r\n  }\r\n\r\n  > .btn + .btn,\r\n  > .btn + .btn-group,\r\n  > .btn-group + .btn,\r\n  > .btn-group + .btn-group {\r\n    margin-top: -$btn-border-width;\r\n    margin-left: 0;\r\n  }\r\n\r\n  // Reset rounded corners\r\n  > .btn:not(:last-child):not(.dropdown-toggle),\r\n  > .btn-group:not(:last-child) > .btn {\r\n    @include border-bottom-radius(0);\r\n  }\r\n\r\n  > .btn:not(:first-child),\r\n  > .btn-group:not(:first-child) > .btn {\r\n    @include border-top-radius(0);\r\n  }\r\n}\r\n\r\n// Checkbox and radio options\r\n//\r\n// In order to support the browser's form validation feedback, powered by the\r\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\r\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\r\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\r\n// certain cases which is prevented by using `clip` and `pointer-events`.\r\n// This way, we ensure a DOM element is visible to position the popover from.\r\n//\r\n// See https://github.com/twbs/bootstrap/pull/12794 and\r\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\r\n\r\n.btn-group-toggle {\r\n  > .btn,\r\n  > .btn-group > .btn {\r\n    margin-bottom: 0; // Override default `<label>` value\r\n\r\n    input[type=\"radio\"],\r\n    input[type=\"checkbox\"] {\r\n      position: absolute;\r\n      clip: rect(0, 0, 0, 0);\r\n      pointer-events: none;\r\n    }\r\n  }\r\n}\r\n","// stylelint-disable selector-no-qualifying-type\r\n\r\n//\r\n// Base styles\r\n//\r\n\r\n.input-group {\r\n  position: relative;\r\n  display: flex;\r\n  flex-wrap: wrap; // For form validation feedback\r\n  align-items: stretch;\r\n  width: 100%;\r\n\r\n  > .form-control,\r\n  > .custom-select,\r\n  > .custom-file {\r\n    position: relative; // For focus state's z-index\r\n    flex: 1 1 auto;\r\n    // Add width 1% and flex-basis auto to ensure that button will not wrap out\r\n    // the column. Applies to IE Edge+ and Firefox. Chrome does not require this.\r\n    width: 1%;\r\n    margin-bottom: 0;\r\n\r\n    // Bring the \"active\" form control to the top of surrounding elements\r\n    &:focus {\r\n      z-index: 3;\r\n    }\r\n\r\n    + .form-control,\r\n    + .custom-select,\r\n    + .custom-file {\r\n      margin-left: -$input-border-width;\r\n    }\r\n  }\r\n\r\n  > .form-control,\r\n  > .custom-select {\r\n    &:not(:last-child) {\r\n      @include border-right-radius(0);\r\n    }\r\n    &:not(:first-child) {\r\n      @include border-left-radius(0);\r\n    }\r\n  }\r\n\r\n  // Custom file inputs have more complex markup, thus requiring different\r\n  // border-radius overrides.\r\n  > .custom-file {\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    &:not(:last-child) .custom-file-label,\r\n    &:not(:last-child) .custom-file-label::before {\r\n      @include border-right-radius(0);\r\n    }\r\n    &:not(:first-child) .custom-file-label,\r\n    &:not(:first-child) .custom-file-label::before {\r\n      @include border-left-radius(0);\r\n    }\r\n  }\r\n}\r\n\r\n// Prepend and append\r\n//\r\n// While it requires one extra layer of HTML for each, dedicated prepend and\r\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\r\n// 3) support HTML5 form validation.\r\n\r\n.input-group-prepend,\r\n.input-group-append {\r\n  display: flex;\r\n\r\n  // Ensure buttons are always above inputs for more visually pleasing borders.\r\n  // This isn't needed for `.input-group-text` since it shares the same border-color\r\n  // as our inputs.\r\n  .btn {\r\n    position: relative;\r\n    z-index: 2;\r\n  }\r\n\r\n  .btn + .btn,\r\n  .btn + .input-group-text,\r\n  .input-group-text + .input-group-text,\r\n  .input-group-text + .btn {\r\n    margin-left: -$input-border-width;\r\n  }\r\n}\r\n\r\n.input-group-prepend {\r\n  margin-right: -$input-border-width;\r\n}\r\n\r\n.input-group-append {\r\n  margin-left: -$input-border-width;\r\n}\r\n\r\n// Textual addons\r\n//\r\n// Serves as a catch-all element for any text or radio/checkbox input you wish\r\n// to prepend or append to an input.\r\n\r\n.input-group-text {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: $input-padding-y $input-padding-x;\r\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\r\n  font-size: $font-size-base; // Match inputs\r\n  font-weight: $font-weight-normal;\r\n  line-height: $input-line-height;\r\n  color: $input-group-addon-color;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  background-color: $input-group-addon-bg;\r\n  border: $input-border-width solid $input-group-addon-border-color;\r\n  @include border-radius($input-border-radius);\r\n\r\n  // Nuke default margins from checkboxes and radios to vertically center within.\r\n  input[type=\"radio\"],\r\n  input[type=\"checkbox\"] {\r\n    margin-top: 0;\r\n  }\r\n}\r\n\r\n// Sizing\r\n//\r\n// Remix the default form control sizing classes into new ones for easier\r\n// manipulation.\r\n\r\n.input-group-lg > .form-control,\r\n.input-group-lg > .input-group-prepend > .input-group-text,\r\n.input-group-lg > .input-group-append > .input-group-text,\r\n.input-group-lg > .input-group-prepend > .btn,\r\n.input-group-lg > .input-group-append > .btn {\r\n  @extend .form-control-lg;\r\n}\r\n\r\n.input-group-sm > .form-control,\r\n.input-group-sm > .input-group-prepend > .input-group-text,\r\n.input-group-sm > .input-group-append > .input-group-text,\r\n.input-group-sm > .input-group-prepend > .btn,\r\n.input-group-sm > .input-group-append > .btn {\r\n  @extend .form-control-sm;\r\n}\r\n\r\n// Prepend and append rounded corners\r\n//\r\n// These rulesets must come after the sizing ones to properly override sm and lg\r\n// border-radius values when extending. They're more specific than we'd like\r\n// with the `.input-group >` part, but without it, we cannot override the sizing.\r\n\r\n.input-group > .input-group-prepend > .btn,\r\n.input-group > .input-group-prepend > .input-group-text,\r\n.input-group > .input-group-append:not(:last-child) > .btn,\r\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\r\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\r\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\r\n  @include border-right-radius(0);\r\n}\r\n\r\n.input-group > .input-group-append > .btn,\r\n.input-group > .input-group-append > .input-group-text,\r\n.input-group > .input-group-prepend:not(:first-child) > .btn,\r\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\r\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\r\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\r\n  @include border-left-radius(0);\r\n}\r\n","// Embedded icons from Open Iconic.\r\n// Released under MIT and copyright 2014 Waybury.\r\n// https://useiconic.com/open\r\n\r\n// Checkboxes and radios\r\n//\r\n// Base class takes care of all the key behavioral aspects.\r\n\r\n.custom-control {\r\n  position: relative;\r\n  display: block;\r\n  min-height: (1rem * $line-height-base);\r\n  padding-left: $custom-control-gutter;\r\n}\r\n\r\n.custom-control-inline {\r\n  display: inline-flex;\r\n  margin-right: $custom-control-spacer-x;\r\n}\r\n\r\n.custom-control-input {\r\n  position: absolute;\r\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\r\n  opacity: 0;\r\n\r\n  &:checked ~ .custom-control-label::before {\r\n    color: $custom-control-indicator-checked-color;\r\n    @include gradient-bg($custom-control-indicator-checked-bg);\r\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\r\n  }\r\n\r\n  &:focus ~ .custom-control-label::before {\r\n    // the mixin is not used here to make sure there is feedback\r\n    box-shadow: $custom-control-indicator-focus-box-shadow;\r\n  }\r\n\r\n  &:active ~ .custom-control-label::before {\r\n    color: $custom-control-indicator-active-color;\r\n    background-color: $custom-control-indicator-active-bg;\r\n    @include box-shadow($custom-control-indicator-active-box-shadow);\r\n  }\r\n\r\n  &:disabled {\r\n    ~ .custom-control-label {\r\n      color: $custom-control-label-disabled-color;\r\n\r\n      &::before {\r\n        background-color: $custom-control-indicator-disabled-bg;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Custom control indicators\r\n//\r\n// Build the custom controls out of psuedo-elements.\r\n\r\n.custom-control-label {\r\n  margin-bottom: 0;\r\n\r\n  // Background-color and (when enabled) gradient\r\n  &::before {\r\n    position: absolute;\r\n    top: (($line-height-base - $custom-control-indicator-size) / 2);\r\n    left: 0;\r\n    display: block;\r\n    width: $custom-control-indicator-size;\r\n    height: $custom-control-indicator-size;\r\n    pointer-events: none;\r\n    content: \"\";\r\n    user-select: none;\r\n    background-color: $custom-control-indicator-bg;\r\n    @include box-shadow($custom-control-indicator-box-shadow);\r\n  }\r\n\r\n  // Foreground (icon)\r\n  &::after {\r\n    position: absolute;\r\n    top: (($line-height-base - $custom-control-indicator-size) / 2);\r\n    left: 0;\r\n    display: block;\r\n    width: $custom-control-indicator-size;\r\n    height: $custom-control-indicator-size;\r\n    content: \"\";\r\n    background-repeat: no-repeat;\r\n    background-position: center center;\r\n    background-size: $custom-control-indicator-bg-size;\r\n  }\r\n}\r\n\r\n// Checkboxes\r\n//\r\n// Tweak just a few things for checkboxes.\r\n\r\n.custom-checkbox {\r\n  .custom-control-label::before {\r\n    @include border-radius($custom-checkbox-indicator-border-radius);\r\n  }\r\n\r\n  .custom-control-input:checked ~ .custom-control-label {\r\n    &::before {\r\n      @include gradient-bg($custom-control-indicator-checked-bg);\r\n    }\r\n    &::after {\r\n      background-image: $custom-checkbox-indicator-icon-checked;\r\n    }\r\n  }\r\n\r\n  .custom-control-input:indeterminate ~ .custom-control-label {\r\n    &::before {\r\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\r\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\r\n    }\r\n    &::after {\r\n      background-image: $custom-checkbox-indicator-icon-indeterminate;\r\n    }\r\n  }\r\n\r\n  .custom-control-input:disabled {\r\n    &:checked ~ .custom-control-label::before {\r\n      background-color: $custom-control-indicator-checked-disabled-bg;\r\n    }\r\n    &:indeterminate ~ .custom-control-label::before {\r\n      background-color: $custom-control-indicator-checked-disabled-bg;\r\n    }\r\n  }\r\n}\r\n\r\n// Radios\r\n//\r\n// Tweak just a few things for radios.\r\n\r\n.custom-radio {\r\n  .custom-control-label::before {\r\n    border-radius: $custom-radio-indicator-border-radius;\r\n  }\r\n\r\n  .custom-control-input:checked ~ .custom-control-label {\r\n    &::before {\r\n      @include gradient-bg($custom-control-indicator-checked-bg);\r\n    }\r\n    &::after {\r\n      background-image: $custom-radio-indicator-icon-checked;\r\n    }\r\n  }\r\n\r\n  .custom-control-input:disabled {\r\n    &:checked ~ .custom-control-label::before {\r\n      background-color: $custom-control-indicator-checked-disabled-bg;\r\n    }\r\n  }\r\n}\r\n\r\n// Select\r\n//\r\n// Replaces the browser default select with a custom one, mostly pulled from\r\n// http://primercss.io.\r\n//\r\n\r\n.custom-select {\r\n  display: inline-block;\r\n  width: 100%;\r\n  height: $custom-select-height;\r\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\r\n  line-height: $custom-select-line-height;\r\n  color: $custom-select-color;\r\n  vertical-align: middle;\r\n  background: $custom-select-bg $custom-select-indicator no-repeat right $custom-select-padding-x center;\r\n  background-size: $custom-select-bg-size;\r\n  border: $custom-select-border-width solid $custom-select-border-color;\r\n  @if $enable-rounded {\r\n    border-radius: $custom-select-border-radius;\r\n  } @else {\r\n    border-radius: 0;\r\n  }\r\n  appearance: none;\r\n\r\n  &:focus {\r\n    border-color: $custom-select-focus-border-color;\r\n    outline: 0;\r\n    box-shadow: $custom-select-focus-box-shadow;\r\n\r\n    &::-ms-value {\r\n      // For visual consistency with other platforms/browsers,\r\n      // suppress the default white text on blue background highlight given to\r\n      // the selected option text when the (still closed) <select> receives focus\r\n      // in IE and (under certain conditions) Edge.\r\n      // See https://github.com/twbs/bootstrap/issues/19398.\r\n      color: $input-color;\r\n      background-color: $input-bg;\r\n    }\r\n  }\r\n\r\n  &[multiple],\r\n  &[size]:not([size=\"1\"]) {\r\n    height: auto;\r\n    padding-right: $custom-select-padding-x;\r\n    background-image: none;\r\n  }\r\n\r\n  &:disabled {\r\n    color: $custom-select-disabled-color;\r\n    background-color: $custom-select-disabled-bg;\r\n  }\r\n\r\n  // Hides the default caret in IE11\r\n  &::-ms-expand {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.custom-select-sm {\r\n  height: $custom-select-height-sm;\r\n  padding-top: $custom-select-padding-y;\r\n  padding-bottom: $custom-select-padding-y;\r\n  font-size: $custom-select-font-size-sm;\r\n}\r\n\r\n.custom-select-lg {\r\n  height: $custom-select-height-lg;\r\n  padding-top: $custom-select-padding-y;\r\n  padding-bottom: $custom-select-padding-y;\r\n  font-size: $custom-select-font-size-lg;\r\n}\r\n\r\n// File\r\n//\r\n// Custom file input.\r\n\r\n.custom-file {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 100%;\r\n  height: $custom-file-height;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.custom-file-input {\r\n  position: relative;\r\n  z-index: 2;\r\n  width: 100%;\r\n  height: $custom-file-height;\r\n  margin: 0;\r\n  opacity: 0;\r\n\r\n  &:focus ~ .custom-file-control {\r\n    border-color: $custom-file-focus-border-color;\r\n    box-shadow: $custom-file-focus-box-shadow;\r\n\r\n    &::before {\r\n      border-color: $custom-file-focus-border-color;\r\n    }\r\n  }\r\n\r\n  @each $lang, $value in $custom-file-text {\r\n    &:lang(#{$lang}) ~ .custom-file-label::after {\r\n      content: $value;\r\n    }\r\n  }\r\n}\r\n\r\n.custom-file-label {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  z-index: 1;\r\n  height: $custom-file-height;\r\n  padding: $custom-file-padding-y $custom-file-padding-x;\r\n  line-height: $custom-file-line-height;\r\n  color: $custom-file-color;\r\n  background-color: $custom-file-bg;\r\n  border: $custom-file-border-width solid $custom-file-border-color;\r\n  @include border-radius($custom-file-border-radius);\r\n  @include box-shadow($custom-file-box-shadow);\r\n\r\n  &::after {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    z-index: 3;\r\n    display: block;\r\n    height: calc(#{$custom-file-height} - #{$custom-file-border-width} * 2);\r\n    padding: $custom-file-padding-y $custom-file-padding-x;\r\n    line-height: $custom-file-line-height;\r\n    color: $custom-file-button-color;\r\n    content: \"Browse\";\r\n    @include gradient-bg($custom-file-button-bg);\r\n    border-left: $custom-file-border-width solid $custom-file-border-color;\r\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\r\n  }\r\n}\r\n","// Base class\r\n//\r\n// Kickstart any navigation component with a set of style resets. Works with\r\n// `<nav>`s or `<ul>`s.\r\n\r\n.nav {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  list-style: none;\r\n}\r\n\r\n.nav-link {\r\n  display: block;\r\n  padding: $nav-link-padding-y $nav-link-padding-x;\r\n\r\n  @include hover-focus {\r\n    text-decoration: none;\r\n  }\r\n\r\n  // Disabled state lightens text\r\n  &.disabled {\r\n    color: $nav-link-disabled-color;\r\n  }\r\n}\r\n\r\n//\r\n// Tabs\r\n//\r\n\r\n.nav-tabs {\r\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\r\n\r\n  .nav-item {\r\n    margin-bottom: -$nav-tabs-border-width;\r\n  }\r\n\r\n  .nav-link {\r\n    border: $nav-tabs-border-width solid transparent;\r\n    @include border-top-radius($nav-tabs-border-radius);\r\n\r\n    @include hover-focus {\r\n      border-color: $nav-tabs-link-hover-border-color;\r\n    }\r\n\r\n    &.disabled {\r\n      color: $nav-link-disabled-color;\r\n      background-color: transparent;\r\n      border-color: transparent;\r\n    }\r\n  }\r\n\r\n  .nav-link.active,\r\n  .nav-item.show .nav-link {\r\n    color: $nav-tabs-link-active-color;\r\n    background-color: $nav-tabs-link-active-bg;\r\n    border-color: $nav-tabs-link-active-border-color;\r\n  }\r\n\r\n  .dropdown-menu {\r\n    // Make dropdown border overlap tab border\r\n    margin-top: -$nav-tabs-border-width;\r\n    // Remove the top rounded corners here since there is a hard edge above the menu\r\n    @include border-top-radius(0);\r\n  }\r\n}\r\n\r\n//\r\n// Pills\r\n//\r\n\r\n.nav-pills {\r\n  .nav-link {\r\n    @include border-radius($nav-pills-border-radius);\r\n  }\r\n\r\n  .nav-link.active,\r\n  .show > .nav-link {\r\n    color: $nav-pills-link-active-color;\r\n    background-color: $nav-pills-link-active-bg;\r\n  }\r\n}\r\n\r\n//\r\n// Justified variants\r\n//\r\n\r\n.nav-fill {\r\n  .nav-item {\r\n    flex: 1 1 auto;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.nav-justified {\r\n  .nav-item {\r\n    flex-basis: 0;\r\n    flex-grow: 1;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n// Tabbable tabs\r\n//\r\n// Hide tabbable panes to start, show them when `.active`\r\n\r\n.tab-content {\r\n  > .tab-pane {\r\n    display: none;\r\n  }\r\n  > .active {\r\n    display: block;\r\n  }\r\n}\r\n","// Contents\r\n//\r\n// Navbar\r\n// Navbar brand\r\n// Navbar nav\r\n// Navbar text\r\n// Navbar divider\r\n// Responsive navbar\r\n// Navbar position\r\n// Navbar themes\r\n\r\n// Navbar\r\n//\r\n// Provide a static navbar from which we expand to create full-width, fixed, and\r\n// other navbar variations.\r\n\r\n.navbar {\r\n  position: relative;\r\n  display: flex;\r\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\r\n  align-items: center;\r\n  justify-content: space-between; // space out brand from logo\r\n  padding: $navbar-padding-y $navbar-padding-x;\r\n\r\n  // Because flex properties aren't inherited, we need to redeclare these first\r\n  // few properities so that content nested within behave properly.\r\n  > .container,\r\n  > .container-fluid {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n  }\r\n}\r\n\r\n// Navbar brand\r\n//\r\n// Used for brand, project, or site names.\r\n\r\n.navbar-brand {\r\n  display: inline-block;\r\n  padding-top: $navbar-brand-padding-y;\r\n  padding-bottom: $navbar-brand-padding-y;\r\n  margin-right: $navbar-padding-x;\r\n  font-size: $navbar-brand-font-size;\r\n  line-height: inherit;\r\n  white-space: nowrap;\r\n\r\n  @include hover-focus {\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n// Navbar nav\r\n//\r\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\r\n\r\n.navbar-nav {\r\n  display: flex;\r\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  list-style: none;\r\n\r\n  .nav-link {\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n\r\n  .dropdown-menu {\r\n    position: static;\r\n    float: none;\r\n  }\r\n}\r\n\r\n// Navbar text\r\n//\r\n//\r\n\r\n.navbar-text {\r\n  display: inline-block;\r\n  padding-top: $nav-link-padding-y;\r\n  padding-bottom: $nav-link-padding-y;\r\n}\r\n\r\n// Responsive navbar\r\n//\r\n// Custom styles for responsive collapsing and toggling of navbar contents.\r\n// Powered by the collapse Bootstrap JavaScript plugin.\r\n\r\n// When collapsed, prevent the toggleable navbar contents from appearing in\r\n// the default flexbox row orienation. Requires the use of `flex-wrap: wrap`\r\n// on the `.navbar` parent.\r\n.navbar-collapse {\r\n  flex-basis: 100%;\r\n  flex-grow: 1;\r\n  // For always expanded or extra full navbars, ensure content aligns itself\r\n  // properly vertically. Can be easily overridden with flex utilities.\r\n  align-items: center;\r\n}\r\n\r\n// Button for toggling the navbar when in its collapsed state\r\n.navbar-toggler {\r\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\r\n  font-size: $navbar-toggler-font-size;\r\n  line-height: 1;\r\n  background-color: transparent; // remove default button style\r\n  border: $border-width solid transparent; // remove default button style\r\n  @include border-radius($navbar-toggler-border-radius);\r\n\r\n  @include hover-focus {\r\n    text-decoration: none;\r\n  }\r\n\r\n  // Opinionated: add \"hand\" cursor to non-disabled .navbar-toggler elements\r\n  &:not(:disabled):not(.disabled) {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n// Keep as a separate element so folks can easily override it with another icon\r\n// or image file as needed.\r\n.navbar-toggler-icon {\r\n  display: inline-block;\r\n  width: 1.5em;\r\n  height: 1.5em;\r\n  vertical-align: middle;\r\n  content: \"\";\r\n  background: no-repeat center center;\r\n  background-size: 100% 100%;\r\n}\r\n\r\n// Generate series of `.navbar-expand-*` responsive classes for configuring\r\n// where your navbar collapses.\r\n.navbar-expand {\r\n  @each $breakpoint in map-keys($grid-breakpoints) {\r\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\r\n    $infix: breakpoint-infix($next, $grid-breakpoints);\r\n\r\n    &#{$infix} {\r\n      @include media-breakpoint-down($breakpoint) {\r\n        > .container,\r\n        > .container-fluid {\r\n          padding-right: 0;\r\n          padding-left: 0;\r\n        }\r\n      }\r\n\r\n      @include media-breakpoint-up($next) {\r\n        flex-flow: row nowrap;\r\n        justify-content: flex-start;\r\n\r\n        .navbar-nav {\r\n          flex-direction: row;\r\n\r\n          .dropdown-menu {\r\n            position: absolute;\r\n          }\r\n\r\n          .dropdown-menu-right {\r\n            right: 0;\r\n            left: auto; // Reset the default from `.dropdown-menu`\r\n          }\r\n\r\n          .nav-link {\r\n            padding-right: $navbar-nav-link-padding-x;\r\n            padding-left: $navbar-nav-link-padding-x;\r\n          }\r\n        }\r\n\r\n        // For nesting containers, have to redeclare for alignment purposes\r\n        > .container,\r\n        > .container-fluid {\r\n          flex-wrap: nowrap;\r\n        }\r\n\r\n        .navbar-collapse {\r\n          display: flex !important; // stylelint-disable-line declaration-no-important\r\n\r\n          // Changes flex-bases to auto because of an IE10 bug\r\n          flex-basis: auto;\r\n        }\r\n\r\n        .navbar-toggler {\r\n          display: none;\r\n        }\r\n\r\n        .dropup {\r\n          .dropdown-menu {\r\n            top: auto;\r\n            bottom: 100%;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Navbar themes\r\n//\r\n// Styles for switching between navbars with light or dark background.\r\n\r\n// Dark links against a light background\r\n.navbar-light {\r\n  .navbar-brand {\r\n    color: $navbar-light-active-color;\r\n\r\n    @include hover-focus {\r\n      color: $navbar-light-active-color;\r\n    }\r\n  }\r\n\r\n  .navbar-nav {\r\n    .nav-link {\r\n      color: $navbar-light-color;\r\n\r\n      @include hover-focus {\r\n        color: $navbar-light-hover-color;\r\n      }\r\n\r\n      &.disabled {\r\n        color: $navbar-light-disabled-color;\r\n      }\r\n    }\r\n\r\n    .show > .nav-link,\r\n    .active > .nav-link,\r\n    .nav-link.show,\r\n    .nav-link.active {\r\n      color: $navbar-light-active-color;\r\n    }\r\n  }\r\n\r\n  .navbar-toggler {\r\n    color: $navbar-light-color;\r\n    border-color: $navbar-light-toggler-border-color;\r\n  }\r\n\r\n  .navbar-toggler-icon {\r\n    background-image: $navbar-light-toggler-icon-bg;\r\n  }\r\n\r\n  .navbar-text {\r\n    color: $navbar-light-color;\r\n    a {\r\n      color: $navbar-light-active-color;\r\n\r\n      @include hover-focus {\r\n        color: $navbar-light-active-color;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// White links against a dark background\r\n.navbar-dark {\r\n  .navbar-brand {\r\n    color: $navbar-dark-active-color;\r\n\r\n    @include hover-focus {\r\n      color: $navbar-dark-active-color;\r\n    }\r\n  }\r\n\r\n  .navbar-nav {\r\n    .nav-link {\r\n      color: $navbar-dark-color;\r\n\r\n      @include hover-focus {\r\n        color: $navbar-dark-hover-color;\r\n      }\r\n\r\n      &.disabled {\r\n        color: $navbar-dark-disabled-color;\r\n      }\r\n    }\r\n\r\n    .show > .nav-link,\r\n    .active > .nav-link,\r\n    .nav-link.show,\r\n    .nav-link.active {\r\n      color: $navbar-dark-active-color;\r\n    }\r\n  }\r\n\r\n  .navbar-toggler {\r\n    color: $navbar-dark-color;\r\n    border-color: $navbar-dark-toggler-border-color;\r\n  }\r\n\r\n  .navbar-toggler-icon {\r\n    background-image: $navbar-dark-toggler-icon-bg;\r\n  }\r\n\r\n  .navbar-text {\r\n    color: $navbar-dark-color;\r\n    a {\r\n      color: $navbar-dark-active-color;\r\n\r\n      @include hover-focus {\r\n        color: $navbar-dark-active-color;\r\n      }\r\n    }\r\n  }\r\n}\r\n","//\r\n// Base styles\r\n//\r\n\r\n.card {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  word-wrap: break-word;\r\n  background-color: $card-bg;\r\n  background-clip: border-box;\r\n  border: $card-border-width solid $card-border-color;\r\n  @include border-radius($card-border-radius);\r\n\r\n  > hr {\r\n    margin-right: 0;\r\n    margin-left: 0;\r\n  }\r\n\r\n  > .list-group:first-child {\r\n    .list-group-item:first-child {\r\n      @include border-top-radius($card-border-radius);\r\n    }\r\n  }\r\n\r\n  > .list-group:last-child {\r\n    .list-group-item:last-child {\r\n      @include border-bottom-radius($card-border-radius);\r\n    }\r\n  }\r\n}\r\n\r\n.card-body {\r\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\r\n  // as much space as possible, ensuring footers are aligned to the bottom.\r\n  flex: 1 1 auto;\r\n  padding: $card-spacer-x;\r\n}\r\n\r\n.card-title {\r\n  margin-bottom: $card-spacer-y;\r\n}\r\n\r\n.card-subtitle {\r\n  margin-top: -($card-spacer-y / 2);\r\n  margin-bottom: 0;\r\n}\r\n\r\n.card-text:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.card-link {\r\n  @include hover {\r\n    text-decoration: none;\r\n  }\r\n\r\n  + .card-link {\r\n    margin-left: $card-spacer-x;\r\n  }\r\n}\r\n\r\n//\r\n// Optional textual caps\r\n//\r\n\r\n.card-header {\r\n  padding: $card-spacer-y $card-spacer-x;\r\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\r\n  background-color: $card-cap-bg;\r\n  border-bottom: $card-border-width solid $card-border-color;\r\n\r\n  &:first-child {\r\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\r\n  }\r\n\r\n  + .list-group {\r\n    .list-group-item:first-child {\r\n      border-top: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.card-footer {\r\n  padding: $card-spacer-y $card-spacer-x;\r\n  background-color: $card-cap-bg;\r\n  border-top: $card-border-width solid $card-border-color;\r\n\r\n  &:last-child {\r\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\r\n  }\r\n}\r\n\r\n//\r\n// Header navs\r\n//\r\n\r\n.card-header-tabs {\r\n  margin-right: -($card-spacer-x / 2);\r\n  margin-bottom: -$card-spacer-y;\r\n  margin-left: -($card-spacer-x / 2);\r\n  border-bottom: 0;\r\n}\r\n\r\n.card-header-pills {\r\n  margin-right: -($card-spacer-x / 2);\r\n  margin-left: -($card-spacer-x / 2);\r\n}\r\n\r\n// Card image\r\n.card-img-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  padding: $card-img-overlay-padding;\r\n}\r\n\r\n.card-img {\r\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\r\n  @include border-radius($card-inner-border-radius);\r\n}\r\n\r\n// Card image caps\r\n.card-img-top {\r\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\r\n  @include border-top-radius($card-inner-border-radius);\r\n}\r\n\r\n.card-img-bottom {\r\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\r\n  @include border-bottom-radius($card-inner-border-radius);\r\n}\r\n\r\n// Card deck\r\n\r\n.card-deck {\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  .card {\r\n    margin-bottom: $card-deck-margin;\r\n  }\r\n\r\n  @include media-breakpoint-up(sm) {\r\n    flex-flow: row wrap;\r\n    margin-right: -$card-deck-margin;\r\n    margin-left: -$card-deck-margin;\r\n\r\n    .card {\r\n      display: flex;\r\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#4-flex-shorthand-declarations-with-unitless-flex-basis-values-are-ignored\r\n      flex: 1 0 0%;\r\n      flex-direction: column;\r\n      margin-right: $card-deck-margin;\r\n      margin-bottom: 0; // Override the default\r\n      margin-left: $card-deck-margin;\r\n    }\r\n  }\r\n}\r\n\r\n//\r\n// Card groups\r\n//\r\n\r\n.card-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  // The child selector allows nested `.card` within `.card-group`\r\n  // to display properly.\r\n  > .card {\r\n    margin-bottom: $card-group-margin;\r\n  }\r\n\r\n  @include media-breakpoint-up(sm) {\r\n    flex-flow: row wrap;\r\n    // The child selector allows nested `.card` within `.card-group`\r\n    // to display properly.\r\n    > .card {\r\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#4-flex-shorthand-declarations-with-unitless-flex-basis-values-are-ignored\r\n      flex: 1 0 0%;\r\n      margin-bottom: 0;\r\n\r\n      + .card {\r\n        margin-left: 0;\r\n        border-left: 0;\r\n      }\r\n\r\n      // Handle rounded corners\r\n      @if $enable-rounded {\r\n        &:first-child {\r\n          @include border-right-radius(0);\r\n\r\n          .card-img-top,\r\n          .card-header {\r\n            border-top-right-radius: 0;\r\n          }\r\n          .card-img-bottom,\r\n          .card-footer {\r\n            border-bottom-right-radius: 0;\r\n          }\r\n        }\r\n\r\n        &:last-child {\r\n          @include border-left-radius(0);\r\n\r\n          .card-img-top,\r\n          .card-header {\r\n            border-top-left-radius: 0;\r\n          }\r\n          .card-img-bottom,\r\n          .card-footer {\r\n            border-bottom-left-radius: 0;\r\n          }\r\n        }\r\n\r\n        &:only-child {\r\n          @include border-radius($card-border-radius);\r\n\r\n          .card-img-top,\r\n          .card-header {\r\n            @include border-top-radius($card-border-radius);\r\n          }\r\n          .card-img-bottom,\r\n          .card-footer {\r\n            @include border-bottom-radius($card-border-radius);\r\n          }\r\n        }\r\n\r\n        &:not(:first-child):not(:last-child):not(:only-child) {\r\n          @include border-radius(0);\r\n\r\n          .card-img-top,\r\n          .card-img-bottom,\r\n          .card-header,\r\n          .card-footer {\r\n            @include border-radius(0);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n//\r\n// Columns\r\n//\r\n\r\n.card-columns {\r\n  .card {\r\n    margin-bottom: $card-columns-margin;\r\n  }\r\n\r\n  @include media-breakpoint-up(sm) {\r\n    column-count: $card-columns-count;\r\n    column-gap: $card-columns-gap;\r\n\r\n    .card {\r\n      display: inline-block; // Don't let them vertically span multiple columns\r\n      width: 100%; // Don't let their width change\r\n    }\r\n  }\r\n}\r\n",".breadcrumb {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\r\n  margin-bottom: $breadcrumb-margin-bottom;\r\n  list-style: none;\r\n  background-color: $breadcrumb-bg;\r\n  @include border-radius($border-radius);\r\n}\r\n\r\n.breadcrumb-item {\r\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\r\n  + .breadcrumb-item::before {\r\n    display: inline-block; // Suppress underlining of the separator in modern browsers\r\n    padding-right: $breadcrumb-item-padding;\r\n    padding-left: $breadcrumb-item-padding;\r\n    color: $breadcrumb-divider-color;\r\n    content: \"#{$breadcrumb-divider}\";\r\n  }\r\n\r\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\r\n  // without `<ul>`s. The `::before` pseudo-element generates an element\r\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\r\n  //\r\n  // To trick IE into suppressing the underline, we give the pseudo-element an\r\n  // underline and then immediately remove it.\r\n  + .breadcrumb-item:hover::before {\r\n    text-decoration: underline;\r\n  }\r\n  // stylelint-disable-next-line no-duplicate-selectors\r\n  + .breadcrumb-item:hover::before {\r\n    text-decoration: none;\r\n  }\r\n\r\n  &.active {\r\n    color: $breadcrumb-active-color;\r\n  }\r\n}\r\n",".pagination {\r\n  display: flex;\r\n  @include list-unstyled();\r\n  @include border-radius();\r\n}\r\n\r\n.page-link {\r\n  position: relative;\r\n  display: block;\r\n  padding: $pagination-padding-y $pagination-padding-x;\r\n  margin-left: -$pagination-border-width;\r\n  line-height: $pagination-line-height;\r\n  color: $pagination-color;\r\n  background-color: $pagination-bg;\r\n  border: $pagination-border-width solid $pagination-border-color;\r\n\r\n  &:hover {\r\n    color: $pagination-hover-color;\r\n    text-decoration: none;\r\n    background-color: $pagination-hover-bg;\r\n    border-color: $pagination-hover-border-color;\r\n  }\r\n\r\n  &:focus {\r\n    z-index: 2;\r\n    outline: 0;\r\n    box-shadow: $pagination-focus-box-shadow;\r\n  }\r\n\r\n  // Opinionated: add \"hand\" cursor to non-disabled .page-link elements\r\n  &:not(:disabled):not(.disabled) {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.page-item {\r\n  &:first-child {\r\n    .page-link {\r\n      margin-left: 0;\r\n      @include border-left-radius($border-radius);\r\n    }\r\n  }\r\n  &:last-child {\r\n    .page-link {\r\n      @include border-right-radius($border-radius);\r\n    }\r\n  }\r\n\r\n  &.active .page-link {\r\n    z-index: 1;\r\n    color: $pagination-active-color;\r\n    background-color: $pagination-active-bg;\r\n    border-color: $pagination-active-border-color;\r\n  }\r\n\r\n  &.disabled .page-link {\r\n    color: $pagination-disabled-color;\r\n    pointer-events: none;\r\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\r\n    cursor: auto;\r\n    background-color: $pagination-disabled-bg;\r\n    border-color: $pagination-disabled-border-color;\r\n  }\r\n}\r\n\r\n//\r\n// Sizing\r\n//\r\n\r\n.pagination-lg {\r\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $border-radius-lg);\r\n}\r\n\r\n.pagination-sm {\r\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $border-radius-sm);\r\n}\r\n","// Pagination\r\n\r\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\r\n  .page-link {\r\n    padding: $padding-y $padding-x;\r\n    font-size: $font-size;\r\n    line-height: $line-height;\r\n  }\r\n\r\n  .page-item {\r\n    &:first-child {\r\n      .page-link {\r\n        @include border-left-radius($border-radius);\r\n      }\r\n    }\r\n    &:last-child {\r\n      .page-link {\r\n        @include border-right-radius($border-radius);\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Base class\r\n//\r\n// Requires one of the contextual, color modifier classes for `color` and\r\n// `background-color`.\r\n\r\n.badge {\r\n  display: inline-block;\r\n  padding: $badge-padding-y $badge-padding-x;\r\n  font-size: $badge-font-size;\r\n  font-weight: $badge-font-weight;\r\n  line-height: 1;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  vertical-align: baseline;\r\n  @include border-radius($badge-border-radius);\r\n\r\n  // Empty badges collapse automatically\r\n  &:empty {\r\n    display: none;\r\n  }\r\n}\r\n\r\n// Quick fix for badges in buttons\r\n.btn .badge {\r\n  position: relative;\r\n  top: -1px;\r\n}\r\n\r\n// Pill badges\r\n//\r\n// Make them extra rounded with a modifier to replace v3's badges.\r\n\r\n.badge-pill {\r\n  padding-right: $badge-pill-padding-x;\r\n  padding-left: $badge-pill-padding-x;\r\n  @include border-radius($badge-pill-border-radius);\r\n}\r\n\r\n// Colors\r\n//\r\n// Contextual variations (linked badges get darker on :hover).\r\n\r\n@each $color, $value in $theme-colors {\r\n  .badge-#{$color} {\r\n    @include badge-variant($value);\r\n  }\r\n}\r\n","@mixin badge-variant($bg) {\r\n  color: color-yiq($bg);\r\n  background-color: $bg;\r\n\r\n  &[href] {\r\n    @include hover-focus {\r\n      color: color-yiq($bg);\r\n      text-decoration: none;\r\n      background-color: darken($bg, 10%);\r\n    }\r\n  }\r\n}\r\n",".jumbotron {\r\n  padding: $jumbotron-padding ($jumbotron-padding / 2);\r\n  margin-bottom: $jumbotron-padding;\r\n  background-color: $jumbotron-bg;\r\n  @include border-radius($border-radius-lg);\r\n\r\n  @include media-breakpoint-up(sm) {\r\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\r\n  }\r\n}\r\n\r\n.jumbotron-fluid {\r\n  padding-right: 0;\r\n  padding-left: 0;\r\n  @include border-radius(0);\r\n}\r\n","//\r\n// Base styles\r\n//\r\n\r\n.alert {\r\n  position: relative;\r\n  padding: $alert-padding-y $alert-padding-x;\r\n  margin-bottom: $alert-margin-bottom;\r\n  border: $alert-border-width solid transparent;\r\n  @include border-radius($alert-border-radius);\r\n}\r\n\r\n// Headings for larger alerts\r\n.alert-heading {\r\n  // Specified to prevent conflicts of changing $headings-color\r\n  color: inherit;\r\n}\r\n\r\n// Provide class for links that match alerts\r\n.alert-link {\r\n  font-weight: $alert-link-font-weight;\r\n}\r\n\r\n// Dismissible alerts\r\n//\r\n// Expand the right padding and account for the close button's positioning.\r\n\r\n.alert-dismissible {\r\n  padding-right: ($close-font-size + $alert-padding-x * 2);\r\n\r\n  // Adjust close link position\r\n  .close {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    padding: $alert-padding-y $alert-padding-x;\r\n    color: inherit;\r\n  }\r\n}\r\n\r\n// Alternate styles\r\n//\r\n// Generate contextual modifier classes for colorizing the alert.\r\n\r\n@each $color, $value in $theme-colors {\r\n  .alert-#{$color} {\r\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\r\n  }\r\n}\r\n","@mixin alert-variant($background, $border, $color) {\r\n  color: $color;\r\n  @include gradient-bg($background);\r\n  border-color: $border;\r\n\r\n  hr {\r\n    border-top-color: darken($border, 5%);\r\n  }\r\n\r\n  .alert-link {\r\n    color: darken($color, 10%);\r\n  }\r\n}\r\n","@keyframes progress-bar-stripes {\r\n  from {\r\n    background-position: $progress-height 0;\r\n  }\r\n  to {\r\n    background-position: 0 0;\r\n  }\r\n}\r\n\r\n.progress {\r\n  display: flex;\r\n  height: $progress-height;\r\n  overflow: hidden; // force rounded corners by cropping it\r\n  font-size: $progress-font-size;\r\n  background-color: $progress-bg;\r\n  @include border-radius($progress-border-radius);\r\n  @include box-shadow($progress-box-shadow);\r\n}\r\n\r\n.progress-bar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  color: $progress-bar-color;\r\n  text-align: center;\r\n  background-color: $progress-bar-bg;\r\n  @include transition($progress-bar-transition);\r\n}\r\n\r\n.progress-bar-striped {\r\n  @include gradient-striped();\r\n  background-size: $progress-height $progress-height;\r\n}\r\n\r\n.progress-bar-animated {\r\n  animation: progress-bar-stripes $progress-bar-animation-timing;\r\n}\r\n",".media {\r\n  display: flex;\r\n  align-items: flex-start;\r\n}\r\n\r\n.media-body {\r\n  flex: 1;\r\n}\r\n\r\n.social-list-line:not(:last-child) {\r\n  padding-bottom: 25px;\r\n}\r\n\r\n","// Base class\r\n//\r\n// Easily usable on <ul>, <ol>, or <div>.\r\n\r\n.list-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  // No need to set list-style: none; since .list-group-item is block level\r\n  padding-left: 0; // reset padding because ul and ol\r\n  margin-bottom: 0;\r\n}\r\n\r\n// Interactive list items\r\n//\r\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\r\n// list items. Includes an extra `.active` modifier class for selected items.\r\n\r\n.list-group-item-action {\r\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\r\n  color: $list-group-action-color;\r\n  text-align: inherit; // For `<button>`s (anchors inherit)\r\n\r\n  // Hover state\r\n  @include hover-focus {\r\n    color: $list-group-action-hover-color;\r\n    text-decoration: none;\r\n    background-color: $list-group-hover-bg;\r\n  }\r\n\r\n  &:active {\r\n    color: $list-group-action-active-color;\r\n    background-color: $list-group-action-active-bg;\r\n  }\r\n}\r\n\r\n// Individual list items\r\n//\r\n// Use on `li`s or `div`s within the `.list-group` parent.\r\n\r\n.list-group-item {\r\n  position: relative;\r\n  display: block;\r\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\r\n  // Place the border on the list items and negative margin up for better styling\r\n  margin-bottom: -$list-group-border-width;\r\n  background-color: $list-group-bg;\r\n  border: $list-group-border-width solid $list-group-border-color;\r\n\r\n  &:first-child {\r\n    @include border-top-radius($list-group-border-radius);\r\n  }\r\n\r\n  &:last-child {\r\n    margin-bottom: 0;\r\n    @include border-bottom-radius($list-group-border-radius);\r\n  }\r\n\r\n  @include hover-focus {\r\n    z-index: 1; // Place hover/active items above their siblings for proper border styling\r\n    text-decoration: none;\r\n  }\r\n\r\n  &.disabled,\r\n  &:disabled {\r\n    color: $list-group-disabled-color;\r\n    background-color: $list-group-disabled-bg;\r\n  }\r\n\r\n  // Include both here for `<a>`s and `<button>`s\r\n  &.active {\r\n    z-index: 2; // Place active items above their siblings for proper border styling\r\n    color: $list-group-active-color;\r\n    background-color: $list-group-active-bg;\r\n    border-color: $list-group-active-border-color;\r\n  }\r\n}\r\n\r\n// Flush list items\r\n//\r\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\r\n// useful within other components (e.g., cards).\r\n\r\n.list-group-flush {\r\n  .list-group-item {\r\n    border-right: 0;\r\n    border-left: 0;\r\n    @include border-radius(0);\r\n  }\r\n\r\n  &:first-child {\r\n    .list-group-item:first-child {\r\n      border-top: 0;\r\n    }\r\n  }\r\n\r\n  &:last-child {\r\n    .list-group-item:last-child {\r\n      border-bottom: 0;\r\n    }\r\n  }\r\n}\r\n\r\n// Contextual variants\r\n//\r\n// Add modifier classes to change text and background color on individual items.\r\n// Organizationally, this must come after the `:hover` states.\r\n\r\n@each $color, $value in $theme-colors {\r\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\r\n}\r\n","// List Groups\r\n\r\n@mixin list-group-item-variant($state, $background, $color) {\r\n  .list-group-item-#{$state} {\r\n    color: $color;\r\n    background-color: $background;\r\n\r\n    &.list-group-item-action {\r\n      @include hover-focus {\r\n        color: $color;\r\n        background-color: darken($background, 5%);\r\n      }\r\n\r\n      &.active {\r\n        color: #fff;\r\n        background-color: $color;\r\n        border-color: $color;\r\n      }\r\n    }\r\n  }\r\n}\r\n",".close {\r\n  float: right;\r\n  font-size: $close-font-size;\r\n  font-weight: $close-font-weight;\r\n  line-height: 1;\r\n  //color: $close-color;\r\n // text-shadow: $close-text-shadow;\r\n  opacity: .5;\r\n\r\n  @include hover-focus {\r\n    //color: $close-color;\r\n    text-decoration: none;\r\n    opacity: .75;\r\n  }\r\n\r\n  // Opinionated: add \"hand\" cursor to non-disabled .close elements\r\n  &:not(:disabled):not(.disabled) {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n// Additional properties for button version\r\n// iOS requires the button element instead of an anchor tag.\r\n// If you want the anchor version, it requires `href=\"#\"`.\r\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\r\n\r\n// stylelint-disable property-no-vendor-prefix, selector-no-qualifying-type\r\nbutton.close {\r\n  padding: 0;\r\n  background-color: transparent;\r\n  border: 0;\r\n  -webkit-appearance: none;\r\n}\r\n\r\n// stylelint-enable\r\n","// .modal-open      - body class for killing the scroll\r\n// .modal           - container to scroll within\r\n// .modal-dialog    - positioning shell for the actual modal\r\n// .modal-content   - actual modal w/ bg and corners and stuff\r\n\r\n// Kill the scroll on the body\r\n.modal-open {\r\n  overflow: hidden;\r\n}\r\n\r\n// Container that the modal scrolls within\r\n.modal {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: $zindex-modal;\r\n  display: none;\r\n  overflow: hidden;\r\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\r\n  // https://github.com/twbs/bootstrap/pull/10951.\r\n  outline: 0;\r\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\r\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\r\n  // See also https://github.com/twbs/bootstrap/issues/17695\r\n\r\n  .modal-open & {\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n  }\r\n}\r\n\r\n// Shell div to position the modal with bottom padding\r\n.modal-dialog {\r\n  position: relative;\r\n  width: auto;\r\n  margin: $modal-dialog-margin;\r\n  // allow clicks to pass through for custom click handling to close modal\r\n  pointer-events: none;\r\n\r\n  // When fading in the modal, animate it to slide down\r\n  .modal.fade & {\r\n    @include transition($modal-transition);\r\n    transform: translate(0, -25%);\r\n  }\r\n  .modal.show & {\r\n    transform: translate(0, 0);\r\n  }\r\n}\r\n\r\n.modal-dialog-centered {\r\n  display: flex;\r\n  align-items: center;\r\n  min-height: calc(100% - (#{$modal-dialog-margin} * 2));\r\n}\r\n\r\n// Actual modal\r\n.modal-content {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\r\n  // counteract the pointer-events: none; in the .modal-dialog\r\n  pointer-events: auto;\r\n  background-color: $modal-content-bg;\r\n  background-clip: padding-box;\r\n  border: $modal-content-border-width solid $modal-content-border-color;\r\n  @include border-radius($border-radius-lg);\r\n  @include box-shadow($modal-content-box-shadow-xs);\r\n  // Remove focus outline from opened modal\r\n  outline: 0;\r\n}\r\n\r\n// Modal background\r\n.modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: $zindex-modal-backdrop;\r\n  background-color: $modal-backdrop-bg;\r\n\r\n  // Fade for backdrop\r\n  &.fade {\r\n    opacity: 0;\r\n  }\r\n  &.show {\r\n    opacity: $modal-backdrop-opacity;\r\n  }\r\n}\r\n\r\n// Modal header\r\n// Top section of the modal w/ title and dismiss\r\n.modal-header {\r\n  display: flex;\r\n  align-items: flex-start; // so the close btn always stays on the upper right corner\r\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\r\n  padding: $modal-header-padding;\r\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\r\n  @include border-top-radius($border-radius-lg);\r\n\r\n  .close {\r\n    padding: $modal-header-padding;\r\n    // auto on the left force icon to the right even when there is no .modal-title\r\n    margin: (-$modal-header-padding) (-$modal-header-padding) (-$modal-header-padding) auto;\r\n  }\r\n}\r\n\r\n// Title text within header\r\n.modal-title {\r\n  margin-bottom: 0;\r\n  line-height: $modal-title-line-height;\r\n}\r\n\r\n// Modal body\r\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\r\n.modal-body {\r\n  position: relative;\r\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\r\n  // when should there be a fixed height on `.modal-dialog`.\r\n  flex: 1 1 auto;\r\n  padding: $modal-inner-padding;\r\n}\r\n\r\n// Footer (for actions)\r\n.modal-footer {\r\n  display: flex;\r\n  align-items: center; // vertically center\r\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\r\n  padding: $modal-inner-padding;\r\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\r\n\r\n  // Easily place margin between footer elements\r\n  > :not(:first-child) {\r\n    margin-left: .25rem;\r\n  }\r\n  > :not(:last-child) {\r\n    margin-right: .25rem;\r\n  }\r\n}\r\n\r\n// Measure scrollbar width for padding body during modal show/hide\r\n.modal-scrollbar-measure {\r\n  position: absolute;\r\n  top: -9999px;\r\n  width: 50px;\r\n  height: 50px;\r\n  overflow: scroll;\r\n}\r\n\r\n// Scale up the modal\r\n@include media-breakpoint-up(sm) {\r\n  // Automatically set modal's width for larger viewports\r\n  .modal-dialog {\r\n    max-width: $modal-md;\r\n    margin: $modal-dialog-margin-y-sm-up auto;\r\n  }\r\n\r\n  .modal-dialog-centered {\r\n    min-height: calc(100% - (#{$modal-dialog-margin-y-sm-up} * 2));\r\n  }\r\n\r\n  .modal-content {\r\n    @include box-shadow($modal-content-box-shadow-sm-up);\r\n  }\r\n\r\n  .modal-sm {\r\n    max-width: $modal-sm;\r\n  }\r\n\r\n}\r\n\r\n@include media-breakpoint-up(lg) {\r\n  .modal-lg {\r\n    max-width: $modal-lg;\r\n  }\r\n}\r\n","// Base class\r\n.tooltip {\r\n  position: absolute;\r\n  z-index: $zindex-tooltip;\r\n  display: block;\r\n  margin: $tooltip-margin;\r\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\r\n  // So reset our font and text properties to avoid inheriting weird values.\r\n  @include reset-text();\r\n  font-size: $tooltip-font-size;\r\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\r\n  word-wrap: break-word;\r\n  opacity: 0;\r\n\r\n  &.show {\r\n    opacity: $tooltip-opacity;\r\n  }\r\n\r\n  .arrow {\r\n    position: absolute;\r\n    display: block;\r\n    width: $tooltip-arrow-width;\r\n    height: $tooltip-arrow-height;\r\n\r\n    &::before {\r\n      position: absolute;\r\n      content: \"\";\r\n      border-color: transparent;\r\n      border-style: solid;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-top {\r\n  padding: $tooltip-arrow-height 0;\r\n\r\n  .arrow {\r\n    bottom: 0;\r\n\r\n    &::before {\r\n      top: 0;\r\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\r\n      border-top-color: $tooltip-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-right {\r\n  padding: 0 $tooltip-arrow-height;\r\n\r\n  .arrow {\r\n    left: 0;\r\n    width: $tooltip-arrow-height;\r\n    height: $tooltip-arrow-width;\r\n\r\n    &::before {\r\n      right: 0;\r\n      border-width: ($tooltip-arrow-width / 2) $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\r\n      border-right-color: $tooltip-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-bottom {\r\n  padding: $tooltip-arrow-height 0;\r\n\r\n  .arrow {\r\n    top: 0;\r\n\r\n    &::before {\r\n      bottom: 0;\r\n      border-width: 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\r\n      border-bottom-color: $tooltip-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-left {\r\n  padding: 0 $tooltip-arrow-height;\r\n\r\n  .arrow {\r\n    right: 0;\r\n    width: $tooltip-arrow-height;\r\n    height: $tooltip-arrow-width;\r\n\r\n    &::before {\r\n      left: 0;\r\n      border-width: ($tooltip-arrow-width / 2) 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\r\n      border-left-color: $tooltip-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-auto {\r\n  &[x-placement^=\"top\"] {\r\n    @extend .bs-tooltip-top;\r\n  }\r\n  &[x-placement^=\"right\"] {\r\n    @extend .bs-tooltip-right;\r\n  }\r\n  &[x-placement^=\"bottom\"] {\r\n    @extend .bs-tooltip-bottom;\r\n  }\r\n  &[x-placement^=\"left\"] {\r\n    @extend .bs-tooltip-left;\r\n  }\r\n}\r\n\r\n// Wrapper for the tooltip content\r\n.tooltip-inner {\r\n  max-width: $tooltip-max-width;\r\n  padding: $tooltip-padding-y $tooltip-padding-x;\r\n  color: $tooltip-color;\r\n  text-align: center;\r\n  background-color: $tooltip-bg;\r\n  @include border-radius($tooltip-border-radius);\r\n}\r\n","@mixin reset-text {\r\n  font-family: $font-family-base;\r\n  // We deliberately do NOT reset font-size or word-wrap.\r\n  font-style: normal;\r\n  font-weight: $font-weight-normal;\r\n  line-height: $line-height-base;\r\n  text-align: left; // Fallback for where `start` is not supported\r\n  text-align: start; // stylelint-disable-line declaration-block-no-duplicate-properties\r\n  text-decoration: none;\r\n  text-shadow: none;\r\n  text-transform: none;\r\n  letter-spacing: normal;\r\n  word-break: normal;\r\n  word-spacing: normal;\r\n  white-space: normal;\r\n  line-break: auto;\r\n}\r\n",".popover {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: $zindex-popover;\r\n  display: block;\r\n  max-width: $popover-max-width;\r\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\r\n  // So reset our font and text properties to avoid inheriting weird values.\r\n  @include reset-text();\r\n  font-size: $popover-font-size;\r\n  // Allow breaking very long words so they don't overflow the popover's bounds\r\n  word-wrap: break-word;\r\n  background-color: $popover-bg;\r\n  background-clip: padding-box;\r\n  border: $popover-border-width solid $popover-border-color;\r\n  @include border-radius($popover-border-radius);\r\n  @include box-shadow($popover-box-shadow);\r\n\r\n  .arrow {\r\n    position: absolute;\r\n    display: block;\r\n    width: $popover-arrow-width;\r\n    height: $popover-arrow-height;\r\n    margin: 0 $border-radius-lg;\r\n\r\n    &::before,\r\n    &::after {\r\n      position: absolute;\r\n      display: block;\r\n      content: \"\";\r\n      border-color: transparent;\r\n      border-style: solid;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-popover-top {\r\n  margin-bottom: $popover-arrow-height;\r\n\r\n  .arrow {\r\n    bottom: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\r\n  }\r\n\r\n  .arrow::before,\r\n  .arrow::after {\r\n    border-width: $popover-arrow-height ($popover-arrow-width / 2) 0;\r\n  }\r\n\r\n  .arrow::before {\r\n    bottom: 0;\r\n    border-top-color: $popover-arrow-outer-color;\r\n  }\r\n\r\n  .arrow::after {\r\n    bottom: $popover-border-width;\r\n    border-top-color: $popover-arrow-color;\r\n  }\r\n}\r\n\r\n.bs-popover-right {\r\n  margin-left: $popover-arrow-height;\r\n\r\n  .arrow {\r\n    left: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\r\n    width: $popover-arrow-height;\r\n    height: $popover-arrow-width;\r\n    margin: $border-radius-lg 0; // make sure the arrow does not touch the popover's rounded corners\r\n  }\r\n\r\n  .arrow::before,\r\n  .arrow::after {\r\n    border-width: ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2) 0;\r\n  }\r\n\r\n  .arrow::before {\r\n    left: 0;\r\n    border-right-color: $popover-arrow-outer-color;\r\n  }\r\n\r\n  .arrow::after {\r\n    left: $popover-border-width;\r\n    border-right-color: $popover-arrow-color;\r\n  }\r\n}\r\n\r\n.bs-popover-bottom {\r\n  margin-top: $popover-arrow-height;\r\n\r\n  .arrow {\r\n    top: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\r\n  }\r\n\r\n  .arrow::before,\r\n  .arrow::after {\r\n    border-width: 0 ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2);\r\n  }\r\n\r\n  .arrow::before {\r\n    top: 0;\r\n    border-bottom-color: $popover-arrow-outer-color;\r\n  }\r\n\r\n  .arrow::after {\r\n    top: $popover-border-width;\r\n    border-bottom-color: $popover-arrow-color;\r\n  }\r\n\r\n  // This will remove the popover-header's border just below the arrow\r\n  .popover-header::before {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 50%;\r\n    display: block;\r\n    width: $popover-arrow-width;\r\n    margin-left: ($popover-arrow-width / -2);\r\n    content: \"\";\r\n    border-bottom: $popover-border-width solid $popover-header-bg;\r\n  }\r\n}\r\n\r\n.bs-popover-left {\r\n  margin-right: $popover-arrow-height;\r\n\r\n  .arrow {\r\n    right: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\r\n    width: $popover-arrow-height;\r\n    height: $popover-arrow-width;\r\n    margin: $border-radius-lg 0; // make sure the arrow does not touch the popover's rounded corners\r\n  }\r\n\r\n  .arrow::before,\r\n  .arrow::after {\r\n    border-width: ($popover-arrow-width / 2) 0 ($popover-arrow-width / 2) $popover-arrow-height;\r\n  }\r\n\r\n  .arrow::before {\r\n    right: 0;\r\n    border-left-color: $popover-arrow-outer-color;\r\n  }\r\n\r\n  .arrow::after {\r\n    right: $popover-border-width;\r\n    border-left-color: $popover-arrow-color;\r\n  }\r\n}\r\n\r\n.bs-popover-auto {\r\n  &[x-placement^=\"top\"] {\r\n    @extend .bs-popover-top;\r\n  }\r\n  &[x-placement^=\"right\"] {\r\n    @extend .bs-popover-right;\r\n  }\r\n  &[x-placement^=\"bottom\"] {\r\n    @extend .bs-popover-bottom;\r\n  }\r\n  &[x-placement^=\"left\"] {\r\n    @extend .bs-popover-left;\r\n  }\r\n}\r\n\r\n// Offset the popover to account for the popover arrow\r\n.popover-header {\r\n  padding: $popover-header-padding-y $popover-header-padding-x;\r\n  margin-bottom: 0; // Reset the default from Reboot\r\n  font-size: $font-size-base;\r\n  color: $popover-header-color;\r\n  background-color: $popover-header-bg;\r\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\r\n  $offset-border-width: calc(#{$border-radius-lg} - #{$popover-border-width});\r\n  @include border-top-radius($offset-border-width);\r\n\r\n  &:empty {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.popover-body {\r\n  padding: $popover-body-padding-y $popover-body-padding-x;\r\n  color: $popover-body-color;\r\n}\r\n","// Wrapper for the slide container and indicators\r\n.carousel {\r\n  position: relative;\r\n}\r\n\r\n.carousel-inner {\r\n  position: relative;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.carousel-item {\r\n  position: relative;\r\n  display: none;\r\n  align-items: center;\r\n  width: 100%;\r\n  @include transition($carousel-transition);\r\n  backface-visibility: hidden;\r\n  perspective: 1000px;\r\n}\r\n\r\n.carousel-item.active,\r\n.carousel-item-next,\r\n.carousel-item-prev {\r\n  display: block;\r\n}\r\n\r\n.carousel-item-next,\r\n.carousel-item-prev {\r\n  position: absolute;\r\n  top: 0;\r\n}\r\n\r\n// CSS3 transforms when supported by the browser\r\n.carousel-item-next.carousel-item-left,\r\n.carousel-item-prev.carousel-item-right {\r\n  transform: translateX(0);\r\n\r\n  @supports (transform-style: preserve-3d) {\r\n    transform: translate3d(0, 0, 0);\r\n  }\r\n}\r\n\r\n.carousel-item-next,\r\n.active.carousel-item-right {\r\n  transform: translateX(100%);\r\n\r\n  @supports (transform-style: preserve-3d) {\r\n    transform: translate3d(100%, 0, 0);\r\n  }\r\n}\r\n\r\n.carousel-item-prev,\r\n.active.carousel-item-left {\r\n  transform: translateX(-100%);\r\n\r\n  @supports (transform-style: preserve-3d) {\r\n    transform: translate3d(-100%, 0, 0);\r\n  }\r\n}\r\n\r\n//\r\n// Left/right controls for nav\r\n//\r\n\r\n.carousel-control-prev,\r\n.carousel-control-next {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  // Use flex for alignment (1-3)\r\n  display: flex; // 1. allow flex styles\r\n  align-items: center; // 2. vertically center contents\r\n  justify-content: center; // 3. horizontally center contents\r\n  width: $carousel-control-width;\r\n  color: $carousel-control-color;\r\n  text-align: center;\r\n  opacity: $carousel-control-opacity;\r\n  // We can't have a transition here because WebKit cancels the carousel\r\n  // animation if you trip this while in the middle of another animation.\r\n\r\n  // Hover/focus state\r\n  @include hover-focus {\r\n    color: $carousel-control-color;\r\n    text-decoration: none;\r\n    outline: 0;\r\n    opacity: .9;\r\n  }\r\n}\r\n\r\n.carousel-control-prev {\r\n  left: 0;\r\n  @if $enable-gradients {\r\n    background: linear-gradient(90deg, rgba(0, 0, 0, .25), rgba(0, 0, 0, .001));\r\n  }\r\n}\r\n\r\n.carousel-control-next {\r\n  right: 0;\r\n  @if $enable-gradients {\r\n    background: linear-gradient(270deg, rgba(0, 0, 0, .25), rgba(0, 0, 0, .001));\r\n  }\r\n}\r\n\r\n// Icons for within\r\n.carousel-control-prev-icon,\r\n.carousel-control-next-icon {\r\n  display: inline-block;\r\n  width: $carousel-control-icon-width;\r\n  height: $carousel-control-icon-width;\r\n  background: transparent no-repeat center center;\r\n  background-size: 100% 100%;\r\n}\r\n\r\n.carousel-control-prev-icon {\r\n  background-image: $carousel-control-prev-icon-bg;\r\n}\r\n\r\n.carousel-control-next-icon {\r\n  background-image: $carousel-control-next-icon-bg;\r\n}\r\n\r\n// Optional indicator pips\r\n//\r\n// Add an ordered list with the following class and add a list item for each\r\n// slide your carousel holds.\r\n\r\n.carousel-indicators {\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 10px;\r\n  left: 0;\r\n  z-index: 15;\r\n  display: flex;\r\n  justify-content: center;\r\n  padding-left: 0; // override <ol> default\r\n  // Use the .carousel-control's width as margin so we don't overlay those\r\n  margin-right: $carousel-control-width;\r\n  margin-left: $carousel-control-width;\r\n  list-style: none;\r\n\r\n  li {\r\n    position: relative;\r\n    flex: 0 1 auto;\r\n    width: $carousel-indicator-width;\r\n    height: $carousel-indicator-height;\r\n    margin-right: $carousel-indicator-spacer;\r\n    margin-left: $carousel-indicator-spacer;\r\n    text-indent: -999px;\r\n    background-color: rgba($carousel-indicator-active-bg, .5);\r\n\r\n    // Use pseudo classes to increase the hit area by 10px on top and bottom.\r\n    &::before {\r\n      position: absolute;\r\n      top: -10px;\r\n      left: 0;\r\n      display: inline-block;\r\n      width: 100%;\r\n      height: 10px;\r\n      content: \"\";\r\n    }\r\n    &::after {\r\n      position: absolute;\r\n      bottom: -10px;\r\n      left: 0;\r\n      display: inline-block;\r\n      width: 100%;\r\n      height: 10px;\r\n      content: \"\";\r\n    }\r\n  }\r\n\r\n  .active {\r\n    background-color: $carousel-indicator-active-bg;\r\n  }\r\n}\r\n\r\n// Optional captions\r\n//\r\n//\r\n\r\n.carousel-caption {\r\n  position: absolute;\r\n  right: ((100% - $carousel-caption-width) / 2);\r\n  bottom: 20px;\r\n  left: ((100% - $carousel-caption-width) / 2);\r\n  z-index: 10;\r\n  padding-top: 20px;\r\n  padding-bottom: 20px;\r\n  color: $carousel-caption-color;\r\n  text-align: center;\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n.align-baseline {\r\n  vertical-align: baseline !important;\r\n}\r\n\r\n// Browser default\r\n.align-top {\r\n  vertical-align: top !important;\r\n}\r\n\r\n.align-middle {\r\n  vertical-align: middle !important;\r\n}\r\n\r\n.align-bottom {\r\n  vertical-align: bottom !important;\r\n}\r\n\r\n.align-text-bottom {\r\n  vertical-align: text-bottom !important;\r\n}\r\n\r\n.align-text-top {\r\n  vertical-align: text-top !important;\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Contextual backgrounds\r\n\r\n@mixin bg-variant($parent, $color) {\r\n  #{$parent} {\r\n    background-color: $color !important;\r\n  }\r\n  a#{$parent},\r\n  button#{$parent} {\r\n    @include hover-focus {\r\n      background-color: darken($color, 10%) !important;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin bg-gradient-variant($parent, $color) {\r\n  #{$parent} {\r\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n@each $color, $value in $theme-colors {\r\n  @include bg-variant(\".bg-#{$color}\", $value);\r\n}\r\n\r\n@if $enable-gradients {\r\n  @each $color, $value in $theme-colors {\r\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\r\n  }\r\n}\r\n\r\n.bg-white {\r\n  background-color: $white !important;\r\n}\r\n\r\n.bg-transparent {\r\n  background-color: transparent !important;\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n//\r\n// Border\r\n//\r\n\r\n.border {\r\n  border: $border-width solid $border-color !important;\r\n}\r\n\r\n.border-top {\r\n  border-top: $border-width solid $border-color !important;\r\n}\r\n\r\n.border-right {\r\n  border-right: $border-width solid $border-color !important;\r\n}\r\n\r\n.border-bottom {\r\n  border-bottom: $border-width solid $border-color !important;\r\n}\r\n\r\n.border-left {\r\n  border-left: $border-width solid $border-color !important;\r\n}\r\n\r\n.border-0 {\r\n  border: 0 !important;\r\n}\r\n\r\n.border-top-0 {\r\n  border-top: 0 !important;\r\n}\r\n\r\n.border-right-0 {\r\n  border-right: 0 !important;\r\n}\r\n\r\n.border-bottom-0 {\r\n  border-bottom: 0 !important;\r\n}\r\n\r\n.border-left-0 {\r\n  border-left: 0 !important;\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  .border-#{$color} {\r\n    border-color: $value !important;\r\n  }\r\n}\r\n\r\n.border-white {\r\n  border-color: $white !important;\r\n}\r\n\r\n//\r\n// Border-radius\r\n//\r\n\r\n.rounded {\r\n  border-radius: $border-radius !important;\r\n}\r\n\r\n.rounded-top {\r\n  border-top-left-radius: $border-radius !important;\r\n  border-top-right-radius: $border-radius !important;\r\n}\r\n\r\n.rounded-right {\r\n  border-top-right-radius: $border-radius !important;\r\n  border-bottom-right-radius: $border-radius !important;\r\n}\r\n\r\n.rounded-bottom {\r\n  border-bottom-right-radius: $border-radius !important;\r\n  border-bottom-left-radius: $border-radius !important;\r\n}\r\n\r\n.rounded-left {\r\n  border-top-left-radius: $border-radius !important;\r\n  border-bottom-left-radius: $border-radius !important;\r\n}\r\n\r\n.rounded-circle {\r\n  border-radius: 50% !important;\r\n}\r\n\r\n.rounded-0 {\r\n  border-radius: 0 !important;\r\n}\r\n","@mixin clearfix() {\r\n  &::after {\r\n    display: block;\r\n    clear: both;\r\n    content: \"\";\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n//\r\n// Utilities for common `display` values\r\n//\r\n\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    .d#{$infix}-none {\r\n      display: none !important;\r\n    }\r\n    .d#{$infix}-inline {\r\n      display: inline !important;\r\n    }\r\n    .d#{$infix}-inline-block {\r\n      display: inline-block !important;\r\n    }\r\n    .d#{$infix}-block {\r\n      display: block !important;\r\n    }\r\n    .d#{$infix}-table {\r\n      display: table !important;\r\n    }\r\n    .d#{$infix}-table-row {\r\n      display: table-row !important;\r\n    }\r\n    .d#{$infix}-table-cell {\r\n      display: table-cell !important;\r\n    }\r\n    .d#{$infix}-flex {\r\n      display: flex !important;\r\n    }\r\n    .d#{$infix}-inline-flex {\r\n      display: inline-flex !important;\r\n    }\r\n  }\r\n}\r\n\r\n//\r\n// Utilities for toggling `display` in print\r\n//\r\n\r\n@media print {\r\n  .d-print-none {\r\n    display: none !important;\r\n  }\r\n  .d-print-inline {\r\n    display: inline !important;\r\n  }\r\n  .d-print-inline-block {\r\n    display: inline-block !important;\r\n  }\r\n  .d-print-block {\r\n    display: block !important;\r\n  }\r\n  .d-print-table {\r\n    display: table !important;\r\n  }\r\n  .d-print-table-row {\r\n    display: table-row !important;\r\n  }\r\n  .d-print-table-cell {\r\n    display: table-cell !important;\r\n  }\r\n  .d-print-flex {\r\n    display: flex !important;\r\n  }\r\n  .d-print-inline-flex {\r\n    display: inline-flex !important;\r\n  }\r\n}\r\n","// Credit: Nicolas Gallagher and SUIT CSS.\r\n\r\n.embed-responsive {\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n  padding: 0;\r\n  overflow: hidden;\r\n\r\n  &::before {\r\n    display: block;\r\n    content: \"\";\r\n  }\r\n\r\n  .embed-responsive-item,\r\n  iframe,\r\n  embed,\r\n  object,\r\n  video {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    border: 0;\r\n  }\r\n}\r\n\r\n.embed-responsive-21by9 {\r\n  &::before {\r\n    padding-top: percentage(9 / 21);\r\n  }\r\n}\r\n\r\n.embed-responsive-16by9 {\r\n  &::before {\r\n    padding-top: percentage(9 / 16);\r\n  }\r\n}\r\n\r\n.embed-responsive-4by3 {\r\n  &::before {\r\n    padding-top: percentage(3 / 4);\r\n  }\r\n}\r\n\r\n.embed-responsive-1by1 {\r\n  &::before {\r\n    padding-top: percentage(1 / 1);\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Flex variation\r\n//\r\n// Custom styles for additional flex alignment options.\r\n\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    .flex#{$infix}-row {\r\n      flex-direction: row !important;\r\n    }\r\n    .flex#{$infix}-column {\r\n      flex-direction: column !important;\r\n    }\r\n    .flex#{$infix}-row-reverse {\r\n      flex-direction: row-reverse !important;\r\n    }\r\n    .flex#{$infix}-column-reverse {\r\n      flex-direction: column-reverse !important;\r\n    }\r\n\r\n    .flex#{$infix}-wrap {\r\n      flex-wrap: wrap !important;\r\n    }\r\n    .flex#{$infix}-nowrap {\r\n      flex-wrap: nowrap !important;\r\n    }\r\n    .flex#{$infix}-wrap-reverse {\r\n      flex-wrap: wrap-reverse !important;\r\n    }\r\n\r\n    .justify-content#{$infix}-start {\r\n      justify-content: flex-start !important;\r\n    }\r\n    .justify-content#{$infix}-end {\r\n      justify-content: flex-end !important;\r\n    }\r\n    .justify-content#{$infix}-center {\r\n      justify-content: center !important;\r\n    }\r\n    .justify-content#{$infix}-between {\r\n      justify-content: space-between !important;\r\n    }\r\n    .justify-content#{$infix}-around {\r\n      justify-content: space-around !important;\r\n    }\r\n\r\n    .align-items#{$infix}-start {\r\n      align-items: flex-start !important;\r\n    }\r\n    .align-items#{$infix}-end {\r\n      align-items: flex-end !important;\r\n    }\r\n    .align-items#{$infix}-center {\r\n      align-items: center !important;\r\n    }\r\n    .align-items#{$infix}-baseline {\r\n      align-items: baseline !important;\r\n    }\r\n    .align-items#{$infix}-stretch {\r\n      align-items: stretch !important;\r\n    }\r\n\r\n    .align-content#{$infix}-start {\r\n      align-content: flex-start !important;\r\n    }\r\n    .align-content#{$infix}-end {\r\n      align-content: flex-end !important;\r\n    }\r\n    .align-content#{$infix}-center {\r\n      align-content: center !important;\r\n    }\r\n    .align-content#{$infix}-between {\r\n      align-content: space-between !important;\r\n    }\r\n    .align-content#{$infix}-around {\r\n      align-content: space-around !important;\r\n    }\r\n    .align-content#{$infix}-stretch {\r\n      align-content: stretch !important;\r\n    }\r\n\r\n    .align-self#{$infix}-auto {\r\n      align-self: auto !important;\r\n    }\r\n    .align-self#{$infix}-start {\r\n      align-self: flex-start !important;\r\n    }\r\n    .align-self#{$infix}-end {\r\n      align-self: flex-end !important;\r\n    }\r\n    .align-self#{$infix}-center {\r\n      align-self: center !important;\r\n    }\r\n    .align-self#{$infix}-baseline {\r\n      align-self: baseline !important;\r\n    }\r\n    .align-self#{$infix}-stretch {\r\n      align-self: stretch !important;\r\n    }\r\n  }\r\n}\r\n","@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    .float#{$infix}-left {\r\n      @include float-left;\r\n    }\r\n    .float#{$infix}-right {\r\n      @include float-right;\r\n    }\r\n    .float#{$infix}-none {\r\n      @include float-none;\r\n    }\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n@mixin float-left {\r\n  float: left !important;\r\n}\r\n\r\n@mixin float-right {\r\n  float: right !important;\r\n}\r\n\r\n@mixin float-none {\r\n  float: none !important;\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Common values\r\n\r\n// Sass list not in variables since it's not intended for customization.\r\n$positions: static, relative, absolute, fixed, sticky;\r\n\r\n@each $position in $positions {\r\n  .position-#{$position} {\r\n    position: $position !important;\r\n  }\r\n}\r\n\r\n// Shorthand\r\n\r\n.fixed-top {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  z-index: $zindex-fixed;\r\n}\r\n\r\n.fixed-bottom {\r\n  position: fixed;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: $zindex-fixed;\r\n}\r\n\r\n.sticky-top {\r\n  @supports (position: sticky) {\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: $zindex-sticky;\r\n  }\r\n}\r\n","//\r\n// Screenreaders\r\n//\r\n\r\n.sr-only {\r\n  @include sr-only();\r\n}\r\n\r\n.sr-only-focusable {\r\n  @include sr-only-focusable();\r\n}\r\n","// Only display content to screen readers\r\n//\r\n// See: http://a11yproject.com/posts/how-to-hide-content/\r\n// See: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\r\n\r\n@mixin sr-only {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  white-space: nowrap;\r\n  clip-path: inset(50%);\r\n  border: 0;\r\n}\r\n\r\n// Use in conjunction with .sr-only to only display content when it's focused.\r\n//\r\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\r\n//\r\n// Credit: HTML5 Boilerplate\r\n\r\n@mixin sr-only-focusable {\r\n  &:active,\r\n  &:focus {\r\n    position: static;\r\n    width: auto;\r\n    height: auto;\r\n    overflow: visible;\r\n    clip: auto;\r\n    white-space: normal;\r\n    clip-path: none;\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Width and height\r\n\r\n@each $prop, $abbrev in (width: w, height: h) {\r\n  @each $size, $length in $sizes {\r\n    .#{$abbrev}-#{$size} {\r\n      #{$prop}: $length !important;\r\n    }\r\n  }\r\n}\r\n\r\n.mw-100 {\r\n  max-width: 100% !important;\r\n}\r\n\r\n.mh-100 {\r\n  max-height: 100% !important;\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Margin and Padding\r\n\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    @each $prop, $abbrev in (margin: m, padding: p) {\r\n      @each $size, $length in $spacers {\r\n\r\n        .#{$abbrev}#{$infix}-#{$size} {\r\n          #{$prop}: $length !important;\r\n        }\r\n        .#{$abbrev}t#{$infix}-#{$size},\r\n        .#{$abbrev}y#{$infix}-#{$size} {\r\n          #{$prop}-top: $length !important;\r\n        }\r\n        .#{$abbrev}r#{$infix}-#{$size},\r\n        .#{$abbrev}x#{$infix}-#{$size} {\r\n          #{$prop}-right: $length !important;\r\n        }\r\n        .#{$abbrev}b#{$infix}-#{$size},\r\n        .#{$abbrev}y#{$infix}-#{$size} {\r\n          #{$prop}-bottom: $length !important;\r\n        }\r\n        .#{$abbrev}l#{$infix}-#{$size},\r\n        .#{$abbrev}x#{$infix}-#{$size} {\r\n          #{$prop}-left: $length !important;\r\n        }\r\n      }\r\n    }\r\n\r\n    // Some special margin utils\r\n    .m#{$infix}-auto {\r\n      margin: auto !important;\r\n    }\r\n    .mt#{$infix}-auto,\r\n    .my#{$infix}-auto {\r\n      margin-top: auto !important;\r\n    }\r\n    .mr#{$infix}-auto,\r\n    .mx#{$infix}-auto {\r\n      margin-right: auto !important;\r\n    }\r\n    .mb#{$infix}-auto,\r\n    .my#{$infix}-auto {\r\n      margin-bottom: auto !important;\r\n    }\r\n    .ml#{$infix}-auto,\r\n    .mx#{$infix}-auto {\r\n      margin-left: auto !important;\r\n    }\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n//\r\n// Text\r\n//\r\n\r\n// Alignment\r\n\r\n.text-justify {\r\n  text-align: justify !important;\r\n}\r\n\r\n.text-nowrap {\r\n  white-space: nowrap !important;\r\n}\r\n\r\n.text-truncate {\r\n  @include text-truncate;\r\n}\r\n\r\n// Responsive alignment\r\n\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    .text#{$infix}-left {\r\n      text-align: left !important;\r\n    }\r\n    .text#{$infix}-right {\r\n      text-align: right !important;\r\n    }\r\n    .text#{$infix}-center {\r\n      text-align: center !important;\r\n    }\r\n  }\r\n}\r\n\r\n// Transformation\r\n\r\n.text-lowercase {\r\n  text-transform: lowercase !important;\r\n}\r\n\r\n.text-uppercase {\r\n  text-transform: uppercase !important;\r\n}\r\n\r\n.text-capitalize {\r\n  text-transform: capitalize !important;\r\n}\r\n\r\n// Weight and italics\r\n\r\n.font-weight-light {\r\n  font-weight: $font-weight-light !important;\r\n}\r\n\r\n.font-weight-normal {\r\n  font-weight: $font-weight-normal !important;\r\n}\r\n\r\n.font-weight-bold {\r\n  font-weight: $font-weight-bold !important;\r\n}\r\n\r\n.font-italic {\r\n  font-style: italic !important;\r\n}\r\n\r\n// Contextual colors\r\n\r\n.text-white {\r\n  color: #fff !important;\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  @include text-emphasis-variant(\".text-#{$color}\", $value);\r\n}\r\n\r\n.text-muted {\r\n  color: $text-muted !important;\r\n}\r\n\r\n// Misc\r\n\r\n.text-hide {\r\n  @include text-hide();\r\n}\r\n","// Text truncate\r\n// Requires inline-block or block for proper styling\r\n\r\n@mixin text-truncate() {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Typography\r\n\r\n@mixin text-emphasis-variant($parent, $color) {\r\n  #{$parent} {\r\n    color: $color !important;\r\n  }\r\n  a#{$parent} {\r\n    @include hover-focus {\r\n      color: darken($color, 10%) !important;\r\n    }\r\n  }\r\n}\r\n","// CSS image replacement\r\n@mixin text-hide() {\r\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\r\n  font: 0/0 a;\r\n  color: transparent;\r\n  text-shadow: none;\r\n  background-color: transparent;\r\n  border: 0;\r\n}\r\n","//\r\n// Visibility utilities\r\n//\r\n\r\n.visible {\r\n  @include invisible(visible);\r\n}\r\n\r\n.invisible {\r\n  @include invisible(hidden);\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Visibility\r\n\r\n@mixin invisible($visibility) {\r\n  visibility: $visibility !important;\r\n}\r\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\r\n\r\n// Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css\r\n\r\n// ==========================================================================\r\n// Print styles.\r\n// Inlined to avoid the additional HTTP request:\r\n// http://www.phpied.com/delay-loading-your-print-css/\r\n// ==========================================================================\r\n\r\n@if $enable-print-styles {\r\n  @media print {\r\n    *,\r\n    *::before,\r\n    *::after {\r\n      // Bootstrap specific; comment out `color` and `background`\r\n      //color: #000 !important; // Black prints faster: http://www.sanbeiji.com/archives/953\r\n      text-shadow: none !important;\r\n      //background: transparent !important;\r\n      box-shadow: none !important;\r\n    }\r\n\r\n    a {\r\n      &:not(.btn) {\r\n        text-decoration: underline;\r\n      }\r\n    }\r\n\r\n    // Bootstrap specific; comment the following selector out\r\n    //a[href]::after {\r\n    //  content: \" (\" attr(href) \")\";\r\n    //}\r\n\r\n    abbr[title]::after {\r\n      content: \" (\" attr(title) \")\";\r\n    }\r\n\r\n    // Bootstrap specific; comment the following selector out\r\n    //\r\n    // Don't show links that are fragment identifiers,\r\n    // or use the `javascript:` pseudo protocol\r\n    //\r\n\r\n    //a[href^=\"#\"]::after,\r\n    //a[href^=\"javascript:\"]::after {\r\n    // content: \"\";\r\n    //}\r\n\r\n    pre {\r\n      white-space: pre-wrap !important;\r\n    }\r\n    pre,\r\n    blockquote {\r\n      border: $border-width solid #999; // Bootstrap custom code; using `$border-width` instead of 1px\r\n      page-break-inside: avoid;\r\n    }\r\n\r\n    //\r\n    // Printing Tables:\r\n    // http://css-discuss.incutio.com/wiki/Printing_Tables\r\n    //\r\n\r\n    thead {\r\n      display: table-header-group;\r\n    }\r\n\r\n    tr,\r\n    img {\r\n      page-break-inside: avoid;\r\n    }\r\n\r\n    p,\r\n    h2,\r\n    h3 {\r\n      orphans: 3;\r\n      widows: 3;\r\n    }\r\n\r\n    h2,\r\n    h3 {\r\n      page-break-after: avoid;\r\n    }\r\n\r\n    // Bootstrap specific changes start\r\n\r\n    // Specify a size and min-width to make printing closer across browsers.\r\n    // We don't set margin here because it breaks `size` in Chrome. We also\r\n    // don't use `!important` on `size` as it breaks in Chrome.\r\n    @page {\r\n      size: $print-page-size;\r\n    }\r\n    body {\r\n      min-width: $print-body-min-width !important;\r\n    }\r\n    .container {\r\n      min-width: $print-body-min-width !important;\r\n    }\r\n\r\n    // Bootstrap components\r\n    .navbar {\r\n      display: none;\r\n    }\r\n    .badge {\r\n      border: $border-width solid #000;\r\n    }\r\n\r\n    .table {\r\n      border-collapse: collapse !important;\r\n\r\n      td,\r\n      th {\r\n        background-color: #fff !important;\r\n      }\r\n    }\r\n    .table-bordered {\r\n      th,\r\n      td {\r\n        border: 1px solid #ddd !important;\r\n      }\r\n    }\r\n\r\n    // Bootstrap specific changes end\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
